export const CHARS = {
	"0": [
		{
			id: "lYBaL6MyOhuFf1M4zkU1D",
			type: "freedraw",
			x: 234.27953540384516,
			y: 213.79641001210382,
			width: 55.514819018705055,
			height: 89.81516480094518,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1159715293,
			version: 81,
			versionNonce: 92861139,
			isDeleted: false,
			boundElements: null,
			updated: 1751811873992,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.39453378676557804, -0.7649739071638351],
				[0, -0.7649739071638351],
				[-0.7559387822760755, 0],
				[-1.5450063558072884, 1.156495985633569],
				[-2.300945138083364, 2.710537466328617],
				[-4.243496988952188, 5.791515053055377],
				[-5.7885033447594765, 8.869480931486294],
				[-7.333509700566765, 13.106954503846623],
				[-8.848398973414817, 16.579454169043117],
				[-10.032000333711608, 20.42540566293377],
				[-10.393405329222105, 21.976435435332917],
				[-11.543877898263815, 25.84648059559089],
				[-12.33595718009093, 29.692432089481542],
				[-13.486429749132583, 35.47792372594512],
				[-13.880963535898218, 37.405417035334324],
				[-14.242368531408658, 41.639878899398695],
				[-14.242368531408658, 47.036860165688495],
				[-14.242368531408658, 50.88281165957915],
				[-14.636902318174293, 55.90935280547069],
				[-14.636902318174293, 57.83082269826804],
				[-14.636902318174293, 61.67677419215869],
				[-14.242368531408658, 65.54380764412076],
				[-13.486429749132583, 69.78429292477705],
				[-13.088884254071104, 71.33231098888024],
				[-11.543877898263815, 75.17525077447499],
				[-10.032000333711608, 77.88578824080355],
				[-8.486993977904376, 79.81026984189685],
				[-4.9994357712282635, 82.49671364185804],
				[-3.8459514938906523, 83.28276950709335],
				[-0.39453378676557804, 84.04774341425718],
				[3.0930244199104777, 84.04774341425718],
				[6.93897591380113, 84.04774341425718],
				[10.423522412181285, 83.65320962749155],
				[13.87795182760226, 83.28276950709335],
				[16.21202575694076, 82.49671364185804],
				[19.27192138559616, 80.96676582753037],
				[21.970412018741, 79.41573605513122],
				[26.605431086162866, 75.56978456124057],
				[28.909387932542188, 71.7057628175744],
				[30.454394288349476, 69.01630730931726],
				[32.78545650939202, 63.99277787172167],
				[33.93894078672963, 61.67677419215869],
				[36.239885924812995, 56.27979292586889],
				[36.99883641538497, 53.984871204377384],
				[38.938376557957895, 47.43139395245407],
				[39.33291034472347, 43.19090867179784],
				[39.72443242319315, 38.55890131267188],
				[40.48338291376518, 33.92990566184187],
				[40.87791670053076, 29.692432089481542],
				[40.87791670053076, 25.451946808825312],
				[40.87791670053076, 20.42540566293377],
				[40.08884912699955, 16.18793209057344],
				[38.54384277119226, 12.341980596682788],
				[36.99883641538497, 8.104507024322459],
				[35.48394714253692, 4.632007359125964],
				[33.93894078672963, 1.551029772399147],
				[31.60486685739113, -0.7649739071638351],
				[29.300910011011865, -2.6864437999611823],
				[26.9999648729285, -3.8459514938906523],
				[24.66589094359, -5.0024474795241645],
				[23.12088458778271, -5.3969812662897425],
				[20.425405662933713, -5.7674213866879995],
				[18.121448816554448, -5.7674213866879995],
				[16.21202575694076, -5.7674213866879995],
				[13.87795182760226, -5.7674213866879995],
				[12.332945471794972, -5.7674213866879995],
				[10.787939115987683, -5.3969812662897425],
				[9.63746654694603, -5.0024474795241645],
				[7.728043487332343, -3.8459514938906523],
				[5.7885033447594765, -2.3160036795629253],
				[3.484546498380155, -0.7649739071638351],
				[1.9395401425728664, 0.3945337867656349],
				[0, 1.9425518508688242],
				[-1.1504725690417104, 3.080977586726817],
				[-3.454429415420975, 6.180025423229154],
				[-4.9994357712282635, 8.869480931486294],
				[-6.149908340269917, 11.947446809917153],
				[-6.544442127035552, 15.02842439664397],
				[-6.941987622097088, 16.18793209057344],
			],
			pressures: [
				0.0784313753247261, 0.0784313753247261, 0.15294118225574493, 0.1764705926179886,
				0.1882352977991104, 0.21568627655506134, 0.239215686917305, 0.250980406999588,
				0.2666666805744171, 0.27843138575553894, 0.29019609093666077, 0.29411765933036804,
				0.3019607961177826, 0.30588236451148987, 0.3137255012989044, 0.30980393290519714,
				0.3176470696926117, 0.32549020648002625, 0.34117648005485535, 0.3529411852359772,
				0.3490196168422699, 0.35686275362968445, 0.3686274588108063, 0.3764705955982208,
				0.3764705955982208, 0.3921568691730499, 0.3960784375667572, 0.40784314274787903,
				0.41960784792900085, 0.42352941632270813, 0.4274509847164154, 0.42352941632270813,
				0.40784314274787903, 0.4000000059604645, 0.3960784375667572, 0.3921568691730499,
				0.40784314274787903, 0.41960784792900085, 0.41960784792900085,
				0.41960784792900085, 0.4156862795352936, 0.40784314274787903, 0.40784314274787903,
				0.40784314274787903, 0.40784314274787903, 0.4156862795352936, 0.42352941632270813,
				0.41960784792900085, 0.4156862795352936, 0.40784314274787903, 0.40392157435417175,
				0.3803921639919281, 0.364705890417099, 0.3529411852359772, 0.3294117748737335,
				0.32549020648002625, 0.3176470696926117, 0.32156863808631897, 0.3294117748737335,
				0.3294117748737335, 0.34117648005485535, 0.3529411852359772, 0.3607843220233917,
				0.364705890417099, 0.364705890417099, 0.3607843220233917, 0.364705890417099,
				0.3686274588108063, 0.364705890417099, 0.3686274588108063, 0.35686275362968445,
				0.3529411852359772, 0.3529411852359772, 0.35686275362968445, 0.3529411852359772,
				0.3450980484485626, 0.29019609093666077, 0.1921568661928177, 0.10980392247438431,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-6.941987622097088, 16.18793209057344],
		},
	],
	"1": [
		{
			id: "fZjITNSE57f-z4r7qH02H",
			type: "freedraw",
			x: 226.9460257032784,
			y: 245.41031199438277,
			width: 22.756467883976313,
			height: 73.25679258997349,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1087990013,
			version: 45,
			versionNonce: 1003011891,
			isDeleted: false,
			boundElements: null,
			updated: 1751811879444,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, 0.39453378676557804],
				[1.9395401425729233, 0.39453378676557804],
				[3.8790802851457897, -0.370440120398257],
				[7.728043487332343, -2.316003679562982],
				[11.971540476284531, -5.002447479524221],
				[15.817491970175183, -8.083425066250982],
				[18.121448816554448, -10.793962532579599],
				[20.06098895912737, -13.874940119306359],
				[21.211461528169025, -17.35045149279881],
				[22.364945805506636, -21.193391278393506],
				[22.756467883976313, -24.274368865120323],
				[22.756467883976313, -26.590372544683305],
				[22.756467883976313, -28.141402317082452],
				[22.364945805506636, -29.297898302715964],
				[22.000529101700238, -30.0628722098798],
				[22.000529101700238, -30.457405996645377],
				[21.60599531493466, -29.671350131410122],
				[21.60599531493466, -27.749880238612775],
				[21.211461528169025, -25.433876559049793],
				[20.819939449699348, -22.352898972322976],
				[20.819939449699348, -18.506947478432323],
				[20.819939449699348, -13.874940119306359],
				[20.819939449699348, -11.558936439743434],
				[20.45552274589295, -4.632007359125964],
				[20.45552274589295, 0],
				[20.06098895912737, 4.237473572360329],
				[20.06098895912737, 7.31845115908709],
				[19.666455172361736, 12.71543242537689],
				[19.302038468555338, 16.973987955808695],
				[19.302038468555338, 21.214473236464926],
				[19.302038468555338, 23.135943129262273],
				[19.302038468555338, 26.611454502754725],
				[18.91051639008566, 29.297898302715907],
				[18.515982603320083, 32.7734096762083],
				[18.515982603320083, 35.85137555463922],
				[18.515982603320083, 38.55890131267188],
				[18.515982603320083, 40.09186083529545],
				[18.515982603320083, 41.63987889939864],
				[18.515982603320083, 42.40786451485843],
				[18.515982603320083, 42.79938659332811],
				[18.515982603320083, 41.63987889939864],
				[18.91051639008566, 38.932353141366036],
				[19.302038468555338, 37.77585715573247],
			],
			pressures: [
				0.0784313753247261, 0.21960784494876862, 0.25882354378700256, 0.27843138575553894,
				0.29411765933036804, 0.27450981736183167, 0.250980406999588, 0.23137255012989044,
				0.21960784494876862, 0.2078431397676468, 0.1921568661928177, 0.1725490242242813,
				0.1568627506494522, 0.14509804546833038, 0.15294118225574493, 0.1568627506494522,
				0.16078431904315948, 0.21176470816135406, 0.2549019753932953, 0.29411765933036804,
				0.32549020648002625, 0.3490196168422699, 0.37254902720451355, 0.3764705955982208,
				0.3921568691730499, 0.4000000059604645, 0.3921568691730499, 0.3960784375667572,
				0.3921568691730499, 0.3921568691730499, 0.3960784375667572, 0.38823530077934265,
				0.3843137323856354, 0.3843137323856354, 0.3764705955982208, 0.3764705955982208,
				0.35686275362968445, 0.3529411852359772, 0.3490196168422699, 0.33725491166114807,
				0.32549020648002625, 0.2235294133424759, 0.054901961237192154, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [19.302038468555338, 37.77585715573247],
		},
		{
			id: "17vj6w0vkcSpET1XHvKR6",
			type: "freedraw",
			x: 222.33811201051986,
			y: 287.4236427224756,
			width: 43.546290250716424,
			height: 0.7679856154597928,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 148965853,
			version: 25,
			versionNonce: 1993643987,
			isDeleted: false,
			boundElements: null,
			updated: 1751811880689,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, 0.39453378676557804],
				[0.39754549506147896, 0.39453378676557804],
				[1.9094230596136867, 0.39453378676557804],
				[3.848963202186553, 0],
				[6.547453835331453, -0.3734518286942148],
				[10.032000333711608, -0.3734518286942148],
				[14.275497322663796, -0.3734518286942148],
				[18.880399307126424, -0.3734518286942148],
				[23.123896296078613, -0.3734518286942148],
				[26.608442794458767, -0.3734518286942148],
				[28.91239964083809, 0],
				[31.213344778921453, 0],
				[33.5474187082599, 0],
				[35.456841767873584, 0],
				[37.39638191044651, 0],
				[38.941388266253796, 0],
				[40.09186083529545, 0],
				[41.24233340433716, 0],
				[42.001283894909136, 0],
				[42.79035146844035, 0],
				[43.181873546910026, 0],
				[43.546290250716424, 0],
				[43.546290250716424, 0],
			],
			pressures: [
				0.0784313753247261, 0.21568627655506134, 0.24705882370471954, 0.2980392277240753,
				0.35686275362968445, 0.4000000059604645, 0.4313725531101227, 0.45490196347236633,
				0.4745098054409027, 0.48235294222831726, 0.49803921580314636, 0.49803921580314636,
				0.5058823823928833, 0.5058823823928833, 0.501960813999176, 0.5137255191802979,
				0.5254902243614197, 0.529411792755127, 0.5176470875740051, 0.4941176474094391,
				0.4627451002597809, 0.40392157435417175, 0.3450980484485626, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [43.546290250716424, 0],
		},
	],
	"2": [
		{
			id: "z0BFtyoOth_YYDHwXbsQ7",
			type: "freedraw",
			x: 233.88500161707958,
			y: 236.16737923420231,
			width: 54.35832303307154,
			height: 70.15172133687935,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 256405405,
			version: 67,
			versionNonce: 1468630109,
			isDeleted: false,
			boundElements: null,
			updated: 1751811884922,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.36140499551049743, 0.7649739071638351],
				[-0.7559387822761323, 0.7649739071638351],
				[-1.1504725690417104, 0.7649739071638351],
				[-1.5148892728481087, 0.7649739071638351],
				[-2.3009451380834207, 0.7649739071638351],
				[-3.4514177071250742, 0.370440120398257],
				[-4.6049019844626855, -0.786055865235312],
				[-6.54745383533151, -3.080977586726817],
				[-7.697926404373163, -5.791515053055377],
				[-8.092460191138798, -8.869480931486294],
				[-8.092460191138798, -11.577006689518896],
				[-6.938975913801187, -14.657984276245713],
				[-4.9994357712282635, -16.973987955808695],
				[-2.6984906331448997, -18.898469556902],
				[0.39453378676557804, -20.42841737122967],
				[3.0930244199104777, -21.214473236464926],
				[7.333509700566708, -21.97643543533286],
				[12.72747925856055, -21.97643543533286],
				[16.21202575694076, -21.587925065159084],
				[19.302038468555338, -19.660431755769878],
				[22.36494580550658, -16.579454169043117],
				[24.304485948079503, -14.266462197776036],
				[26.605431086162866, -10.028988625415707],
				[27.758915363500478, -3.080977586726817],
				[27.758915363500478, 5.0024474795241645],
				[27.758915363500478, 6.5564889602192125],
				[26.605431086162866, 14.266462197776036],
				[25.454958517121156, 18.109401983370788],
				[23.15100167074189, 23.900917036426165],
				[19.666455172361736, 29.297898302715907],
				[14.272485614367838, 34.69487956900571],
				[11.182472902753261, 37.775857155732524],
				[5.424086640953021, 40.85683474245934],
				[0.7890675735311561, 42.016342436388754],
				[-1.9064113513177858, 42.40786451485843],
				[-4.210368197697051, 42.77830463525669],
				[-6.54745383533151, 43.17283842202227],
				[-8.453865186649239, 43.17283842202227],
				[-8.845387265118916, 42.40786451485843],
				[-8.453865186649239, 39.69732704852987],
				[-6.938975913801187, 37.38132336896689],
				[-4.210368197697051, 33.908823703770395],
				[-1.1504725690417104, 30.827846117043634],
				[2.7286077161040794, 28.90336451595033],
				[7.333509700566708, 28.141402317082395],
				[10.818056198946863, 29.668338423114164],
				[12.363062554754151, 31.984342102677147],
				[13.122013045326185, 35.065319689403964],
				[13.516546832091763, 37.38132336896689],
				[14.272485614367838, 40.462300955693706],
				[16.21202575694076, 43.5673722087879],
				[19.666455172361736, 46.253816008749084],
				[23.51541837454829, 47.80183407285233],
				[26.999964872928444, 48.17528590154649],
				[31.63498394035031, 47.413323702678554],
				[37.02895349834415, 44.33234611595174],
				[40.11896620995873, 42.016342436388754],
				[42.42292305633805, 39.305804970060194],
				[44.33234611595174, 35.85438726293518],
				[45.51293576795263, 30.457405996645377],
				[45.51293576795263, 26.981894623152982],
				[45.51293576795263, 23.11787287948681],
				[45.51293576795263, 22.744421050792653],
				[44.726879902717315, 22.744421050792653],
				[43.96792941214534, 23.11787287948681],
			],
			pressures: [
				0.0784313753247261, 0.13333334028720856, 0.16862745583057404, 0.21960784494876862,
				0.24313725531101227, 0.2705882489681244, 0.2823529541492462, 0.2823529541492462,
				0.2549019753932953, 0.23137255012989044, 0.21960784494876862, 0.2078431397676468,
				0.1764705926179886, 0.16862745583057404, 0.16470588743686676, 0.16470588743686676,
				0.16862745583057404, 0.2078431397676468, 0.250980406999588, 0.27450981736183167,
				0.30588236451148987, 0.33725491166114807, 0.3450980484485626, 0.35686275362968445,
				0.3529411852359772, 0.3607843220233917, 0.38823530077934265, 0.43529412150382996,
				0.4470588266849518, 0.4431372582912445, 0.4313725531101227, 0.4000000059604645,
				0.3764705955982208, 0.3294117748737335, 0.2980392277240753, 0.27843138575553894,
				0.2549019753932953, 0.22745098173618317, 0.20392157137393951, 0.1921568661928177,
				0.16470588743686676, 0.16078431904315948, 0.16862745583057404, 0.1764705926179886,
				0.2078431397676468, 0.23137255012989044, 0.25882354378700256, 0.29019609093666077,
				0.33725491166114807, 0.3686274588108063, 0.40392157435417175, 0.43921568989753723,
				0.4588235318660736, 0.47843137383461, 0.4901960790157318, 0.5058823823928833,
				0.501960813999176, 0.501960813999176, 0.4941176474094391, 0.4941176474094391,
				0.4745098054409027, 0.46666666865348816, 0.4156862795352936, 0.27843138575553894,
				0.2078431397676468, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [43.96792941214534, 23.11787287948681],
		},
	],
	"3": [
		{
			id: "mNGksMSbQR7fCMnjHFwGD",
			type: "freedraw",
			x: 224.24753507013355,
			y: 224.21692071598926,
			width: 53.60539595909137,
			height: 73.62723271037174,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1303951123,
			version: 75,
			versionNonce: 90862419,
			isDeleted: false,
			boundElements: null,
			updated: 1751811900091,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.39453378676557804, -0.786055865235312],
				[0.39453378676557804, -1.15950769392947],
				[0.39453378676557804, -1.551029772399147],
				[0.7920792818271138, -1.924481601093305],
				[1.5450063558072316, -2.7075257580326593],
				[3.09001271161452, -3.867033451962129],
				[5.427098349248979, -4.628995650830063],
				[10.426534120477186, -6.556488960219269],
				[15.42596989170545, -7.709973237556824],
				[20.81993944969929, -8.477958853016617],
				[26.24402609065237, -8.477958853016617],
				[29.303921719307766, -8.104507024322459],
				[33.94195249502553, -7.709973237556824],
				[38.18243777568176, -6.556488960219269],
				[42.03140097786837, -4.628995650830063],
				[43.181873546910026, -3.475511373492452],
				[45.12141368948289, -1.15950769392947],
				[45.880364180054926, 0.7619621988678773],
				[47.425370535862214, 4.237473572360329],
				[48.21142640109747, 7.318451159087147],
				[48.9703768916695, 10.004894959048329],
				[49.36491067843508, 12.320898638611311],
				[49.75643275690476, 15.031436104939871],
				[49.75643275690476, 17.347439784502853],
				[48.9703768916695, 18.877387598830524],
				[45.880364180054926, 22.349887264027018],
				[42.03140097786837, 25.430864850753835],
				[38.941388266253796, 28.138390608786437],
				[35.8784809293025, 30.05986050158384],
				[32.39393443092234, 31.61390198227889],
				[26.608442794458767, 33.14083808831066],
				[23.154013379037792, 34.30034578224007],
				[18.91051639008566, 35.456841767873584],
				[15.820503678471084, 35.85137555463922],
				[11.971540476284474, 35.85137555463922],
				[9.276061551435532, 35.85137555463922],
				[7.731055195628244, 35.85137555463922],
				[6.577570918290633, 35.85137555463922],
				[7.336521408862609, 35.456841767873584],
				[9.276061551435532, 34.69487956900571],
				[11.971540476284474, 33.53537187507624],
				[15.820503678471084, 32.7703979679124],
				[19.669466880657637, 31.987353810973048],
				[23.909952161313868, 31.61390198227889],
				[27.758915363500478, 31.61390198227889],
				[31.63799564864621, 32.7703979679124],
				[35.48695885083282, 33.53537187507624],
				[38.5769715624474, 35.068331397699865],
				[40.88092840882666, 36.22181567503742],
				[42.42593476463395, 37.01088324856863],
				[44.33535782424764, 38.5378193546004],
				[45.880364180054926, 40.462300955693706],
				[46.66642004529018, 42.77830463525669],
				[47.425370535862214, 45.48884210158525],
				[47.81990432262779, 48.569819688312066],
				[47.81990432262779, 51.647785566742925],
				[47.81990432262779, 54.72876315346974],
				[46.66642004529018, 57.044766833032725],
				[44.726879902717315, 59.36378222089161],
				[42.03140097786837, 60.9118002849948],
				[38.5769715624474, 62.44174809932247],
				[33.94195249502553, 63.60125579325194],
				[28.54798293703169, 63.992777871721614],
				[23.51843008284419, 64.75474007058955],
				[18.91051639008566, 65.14927385735513],
				[14.275497322663796, 65.14927385735513],
				[8.48699397790432, 64.36622970041577],
				[3.8820919934416906, 63.992777871721614],
				[1.183601360296791, 63.992777871721614],
				[-2.6954789248489988, 63.992777871721614],
				[-3.84896320218661, 63.992777871721614],
				[-0.7589504905720332, 63.60125579325194],
				[0.39453378676557804, 62.833270177792144],
			],
			pressures: [
				0.0784313753247261, 0.027450980618596077, 0.062745101749897, 0.08235294371843338,
				0.10588235408067703, 0.12941177189350128, 0.14901961386203766,
				0.16078431904315948, 0.18039216101169586, 0.1882352977991104, 0.20000000298023224,
				0.21176470816135406, 0.21960784494876862, 0.23137255012989044,
				0.24313725531101227, 0.250980406999588, 0.25882354378700256, 0.2666666805744171,
				0.27843138575553894, 0.29411765933036804, 0.3019607961177826, 0.30980393290519714,
				0.30980393290519714, 0.30980393290519714, 0.30980393290519714,
				0.30588236451148987, 0.30588236451148987, 0.2980392277240753, 0.3019607961177826,
				0.3019607961177826, 0.29411765933036804, 0.2862745225429535, 0.27843138575553894,
				0.26274511218070984, 0.26274511218070984, 0.25882354378700256, 0.250980406999588,
				0.23529411852359772, 0.23137255012989044, 0.20392157137393951,
				0.20000000298023224, 0.2235294133424759, 0.24313725531101227, 0.2705882489681244,
				0.27450981736183167, 0.29019609093666077, 0.3019607961177826, 0.30980393290519714,
				0.30980393290519714, 0.32156863808631897, 0.30980393290519714, 0.3019607961177826,
				0.30588236451148987, 0.3176470696926117, 0.32156863808631897, 0.32156863808631897,
				0.3294117748737335, 0.33725491166114807, 0.3490196168422699, 0.3686274588108063,
				0.3921568691730499, 0.4000000059604645, 0.3921568691730499, 0.4000000059604645,
				0.3960784375667572, 0.3921568691730499, 0.3921568691730499, 0.3803921639919281,
				0.3764705955982208, 0.3607843220233917, 0.32549020648002625, 0.27843138575553894,
				0.05098039284348488, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [0.39453378676557804, 62.833270177792144],
		},
	],
	"4": [
		{
			id: "dw63Juas8qzScs-t0uXu4",
			type: "freedraw",
			x: 244.31153573755677,
			y: 212.26646219777615,
			width: 56.27376950927703,
			height: 76.31668821862888,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 559082525,
			version: 44,
			versionNonce: 1216291901,
			isDeleted: false,
			boundElements: null,
			updated: 1751811904179,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.39453378676557804, 1.15950769392947],
				[-0.7589504905719764, 4.240485280656287],
				[-1.5480180641031893, 8.083425066250982],
				[-3.0930244199104777, 13.106954503846623],
				[-5.0024474795241645, 18.109401983370788],
				[-6.93897591380113, 22.744421050792653],
				[-9.242932760180395, 27.37642840991856],
				[-10.787939115987683, 31.61390198227889],
				[-13.486429749132583, 37.775857155732524],
				[-14.636902318174236, 41.621808649623176],
				[-16.973987955808695, 47.80183407285233],
				[-18.12446052485035, 50.88281165957915],
				[-19.2719213855961, 55.12329694023538],
				[-20.425405662933713, 58.96623672583013],
				[-21.214473236464926, 63.598244084956036],
				[-21.575878231975423, 64.7577517788855],
				[-21.973423727036902, 67.46828924521407],
				[-21.973423727036902, 69.76019925840967],
				[-21.575878231975423, 70.54625512364493],
				[-20.82295115799525, 71.31424073910472],
				[-19.2719213855961, 72.47073672473823],
				[-18.12446052485035, 72.86225880320791],
				[-13.87795182760226, 74.39220661753558],
				[-11.182472902753318, 74.78372869600526],
				[-6.93897591380113, 75.15718052469947],
				[-1.9395401425728664, 75.15718052469947],
				[3.090012711614577, 75.55171431146505],
				[6.180025423229154, 75.94323638993473],
				[10.784927407691839, 75.94323638993473],
				[16.17889696568568, 76.31668821862888],
				[19.268909677300257, 76.31668821862888],
				[23.11787287948681, 75.94323638993473],
				[26.207885591101387, 75.15718052469947],
				[28.147425733674254, 74.78372869600526],
				[30.05684879328794, 74.0006845390659],
				[31.210333070625552, 73.62723271037174],
				[31.60185514909523, 73.23571063190207],
				[32.39092272262644, 72.47073672473823],
				[33.14686150490252, 71.7027511092785],
				[33.90581199547455, 71.31424073910472],
				[33.90581199547455, 70.91970695233908],
				[34.30034578224013, 70.91970695233908],
			],
			pressures: [
				0.0784313753247261, 0.1882352977991104, 0.2235294133424759, 0.2549019753932953,
				0.2862745225429535, 0.3176470696926117, 0.3490196168422699, 0.3176470696926117,
				0.3137255012989044, 0.3176470696926117, 0.32156863808631897, 0.32156863808631897,
				0.3333333432674408, 0.33725491166114807, 0.3333333432674408, 0.3333333432674408,
				0.32549020648002625, 0.3137255012989044, 0.32156863808631897, 0.32156863808631897,
				0.3294117748737335, 0.3529411852359772, 0.364705890417099, 0.4156862795352936,
				0.4470588266849518, 0.47843137383461, 0.5098039507865906, 0.529411792755127,
				0.5490196347236633, 0.5686274766921997, 0.5960784554481506, 0.5960784554481506,
				0.6000000238418579, 0.6000000238418579, 0.5764706134796143, 0.5647059082984924,
				0.5529412031173706, 0.5372549295425415, 0.5058823823928833, 0.4000000059604645,
				0.3294117748737335, 0.13333334028720856, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [34.30034578224013, 70.91970695233908],
		},
		{
			id: "d-gb953MqRfFyiKx5K4zl",
			type: "freedraw",
			x: 276.7024584601832,
			y: 261.2278039645579,
			width: 2.698490633144843,
			height: 37.775857155732524,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 2141015987,
			version: 17,
			versionNonce: 123615901,
			isDeleted: false,
			boundElements: null,
			updated: 1751811904973,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.39453378676557804, 0.7649739071638351],
				[-0.39453378676557804, 2.686443799961239],
				[-0.39453378676557804, 6.923917372321569],
				[0, 11.950458518213111],
				[0.36441670380639835, 16.19094379886934],
				[0.7559387822760755, 21.193391278393506],
				[1.1504725690417104, 26.981894623152982],
				[1.5148892728481087, 30.454394288349476],
				[1.5148892728481087, 35.065319689403964],
				[1.9094230596136867, 36.221815675037476],
				[1.9094230596136867, 37.381323368966946],
				[2.303956846379265, 37.775857155732524],
				[2.303956846379265, 37.381323368966946],
				[2.303956846379265, 36.98678958220131],
				[1.9094230596136867, 36.61634946180311],
			],
			pressures: [
				0.0784313753247261, 0.1725490242242813, 0.22745098173618317, 0.27450981736183167,
				0.32156863808631897, 0.3450980484485626, 0.37254902720451355, 0.40392157435417175,
				0.43529412150382996, 0.48627451062202454, 0.5137255191802979, 0.5098039507865906,
				0.5254902243614197, 0.22745098173618317, 0.09019608050584793, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [1.9094230596136867, 36.61634946180311],
		},
	],
	"5": [
		{
			id: "48u4GYWpbTYM1AvFh4oe4",
			type: "freedraw",
			x: 270.51942132865815,
			y: 216.50694747843244,
			width: 53.18375679766251,
			height: 73.6272327103718,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 2101459251,
			version: 83,
			versionNonce: 2042539485,
			isDeleted: false,
			boundElements: null,
			updated: 1751811923736,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-1.1504725690417104, 0],
				[-1.1504725690417104, 0.3704401203982002],
				[-1.5450063558072884, 0.3704401203982002],
				[-1.9365284342769655, 0.3704401203982002],
				[-2.300945138083364, 0.3704401203982002],
				[-3.090012711614577, 0.3704401203982002],
				[-3.8459514938906523, 0.3704401203982002],
				[-4.9994357712282635, 0.3704401203982002],
				[-6.180025423229154, 0.3704401203982002],
				[-7.6949146960772055, 0.3704401203982002],
				[-9.634454838650129, 0],
				[-11.938411685029394, 0],
				[-15.02842439664397, 0],
				[-18.118437108258547, 0.3704401203982002],
				[-21.208449819873124, 0.7619621988678773],
				[-23.906940453018024, 0.7619621988678773],
				[-25.81636351263171, 0.3704401203982002],
				[-28.147425733674254, -0.3945337867656349],
				[-30.845916366819154, -0.7679856154597928],
				[-33.541395291668096, -0.7679856154597928],
				[-35.45081835128178, -0.7679856154597928],
				[-37.390358493854706, -0.7679856154597928],
				[-39.33291034472347, -1.15950769392947],
				[-40.08583741870365, -1.554041480695048],
				[-42.02838926957247, -1.927493309389206],
				[-43.57339562537976, -2.316003679562982],
				[-44.33234611595174, -2.710537466328617],
				[-45.08828489822781, -2.710537466328617],
				[-45.47980697669749, -2.710537466328617],
				[-45.47980697669749, -1.554041480695048],
				[-45.08828489822781, 0],
				[-45.08828489822781, 2.6864437999611823],
				[-44.33234611595174, 6.923917372321512],
				[-43.57339562537976, 11.552913023151518],
				[-42.78432805184855, 16.57945416904306],
				[-42.38979426508291, 20.819939449699348],
				[-42.02838926957247, 24.662879235294042],
				[-42.02838926957247, 27.373416701622602],
				[-42.02838926957247, 30.824834408747677],
				[-42.38979426508291, 33.53537187507624],
				[-43.18187354691008, 35.84836384634326],
				[-43.18187354691008, 37.38132336896689],
				[-43.57339562537976, 38.16436752590624],
				[-43.57339562537976, 38.5378193546004],
				[-43.18187354691008, 38.16436752590624],
				[-42.78432805184855, 37.769833739140665],
				[-41.23932169604126, 36.616349461803054],
				[-38.54083106289636, 35.06531968940391],
				[-33.905811995474494, 32.7673862596165],
				[-30.45138258005352, 31.61390198227889],
				[-25.81636351263171, 30.45439428834942],
				[-22.361934097210735, 30.45439428834942],
				[-19.2689096773002, 30.45439428834942],
				[-16.967964539216837, 30.824834408747677],
				[-12.724467550264706, 31.98434210267709],
				[-9.634454838650129, 33.53537187507624],
				[-6.93897591380113, 35.06531968940391],
				[-3.8459514938906523, 37.38132336896689],
				[-1.9365284342769655, 39.32387521983571],
				[-0.3915220784696771, 41.61879694132722],
				[0.39453378676557804, 44.32632269935988],
				[0.7589504905719764, 47.01276649932106],
				[1.1534842773376113, 50.48827787281351],
				[0.39453378676557804, 53.96077753801001],
				[-1.1504725690417104, 57.4362889115024],
				[-3.454429415420975, 60.9118002849948],
				[-6.544442127035552, 64.36321799211987],
				[-9.239921051884494, 66.30576984298864],
				[-14.269473906071994, 68.62177352255162],
				[-18.877387598830524, 69.38674742971546],
				[-23.11787287948681, 70.15172133687929],
				[-26.966836081673364, 70.54324341534897],
				[-31.996388935860807, 70.91669524404318],
				[-37.390358493854706, 70.91669524404318],
				[-42.38979426508291, 69.38674742971546],
				[-47.030836749096636, 67.46226582862221],
				[-49.72631567394558, 65.91424776451896],
				[-52.0302725203249, 63.598244084956036],
				[-51.27132202975287, 62.438736391026566],
				[-49.3287701788841, 61.282240405393054],
				[-48.18130931813829, 60.9118002849948],
			],
			pressures: [
				0.0784313753247261, 0.08627451211214066, 0.0941176488995552, 0.125490203499794,
				0.14901961386203766, 0.20392157137393951, 0.23529411852359772,
				0.25882354378700256, 0.2823529541492462, 0.2980392277240753, 0.32549020648002625,
				0.34117648005485535, 0.35686275362968445, 0.3607843220233917, 0.3450980484485626,
				0.33725491166114807, 0.33725491166114807, 0.34117648005485535,
				0.33725491166114807, 0.33725491166114807, 0.3294117748737335, 0.32156863808631897,
				0.3176470696926117, 0.30980393290519714, 0.2980392277240753, 0.2823529541492462,
				0.2705882489681244, 0.26274511218070984, 0.250980406999588, 0.239215686917305,
				0.21568627655506134, 0.23137255012989044, 0.23529411852359772,
				0.24313725531101227, 0.24705882370471954, 0.24705882370471954,
				0.25882354378700256, 0.2666666805744171, 0.2666666805744171, 0.26274511218070984,
				0.2666666805744171, 0.2666666805744171, 0.2705882489681244, 0.2666666805744171,
				0.2666666805744171, 0.23529411852359772, 0.25882354378700256, 0.27450981736183167,
				0.29019609093666077, 0.30588236451148987, 0.3176470696926117, 0.3333333432674408,
				0.3490196168422699, 0.3686274588108063, 0.3764705955982208, 0.3960784375667572,
				0.4000000059604645, 0.3960784375667572, 0.3921568691730499, 0.38823530077934265,
				0.4117647111415863, 0.43921568989753723, 0.4745098054409027, 0.4941176474094391,
				0.4941176474094391, 0.49803921580314636, 0.501960813999176, 0.4941176474094391,
				0.48627451062202454, 0.48627451062202454, 0.48627451062202454, 0.4901960790157318,
				0.4901960790157318, 0.4627451002597809, 0.43921568989753723, 0.4000000059604645,
				0.35686275362968445, 0.32156863808631897, 0.239215686917305, 0.18039216101169586,
				0.08627451211214066, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-48.18130931813829, 60.9118002849948],
		},
	],
	"6": [
		{
			id: "qjjLRb7uucZUj-a26sPeJ",
			type: "freedraw",
			x: 262.4299728458153,
			y: 208.39942874581408,
			width: 53.969812662897766,
			height: 90.20969858771076,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1089082717,
			version: 74,
			versionNonce: 189448179,
			isDeleted: false,
			boundElements: null,
			updated: 1751811933590,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7860558652352552, -0.370440120398257],
				[-0.7860558652352552, -0.7649739071638351],
				[-1.5450063558072884, -0.7649739071638351],
				[-2.303956846379265, -0.370440120398257],
				[-3.484546498380155, 0],
				[-4.24048528065623, 0.7860558652352552],
				[-7.333509700566708, 2.316003679562982],
				[-9.242932760180395, 3.4724996651964943],
				[-11.573994981222995, 5.026541145891542],
				[-13.87795182760226, 6.5534772519233115],
				[-16.18190867398158, 8.47795885301656],
				[-18.512970895024125, 11.577006689518896],
				[-20.057977250831414, 13.109966212142524],
				[-22.36193409721068, 15.422958183409548],
				[-24.3014742397836, 18.503935770136366],
				[-26.605431086162866, 21.584913356863183],
				[-28.544971228735733, 24.295450823191743],
				[-30.45138258005352, 27.37341670162266],
				[-31.60486685739113, 30.45439428834942],
				[-33.14987321319842, 33.53537187507624],
				[-34.69487956900571, 37.01088324856869],
				[-36.63743141987453, 41.24835682092902],
				[-38.54384277119226, 45.11539027289109],
				[-40.09186083529545, 49.35286384525142],
				[-40.09186083529545, 52.0393076452126],
				[-40.09186083529545, 56.27979292586889],
				[-40.09186083529545, 61.30633407176043],
				[-40.09186083529545, 67.07375545844843],
				[-40.09186083529545, 71.33532269717614],
				[-39.33291034472347, 74.78674040430116],
				[-37.39035849385465, 77.86771799102797],
				[-35.48394714253692, 80.96676582753031],
				[-33.544406999963996, 84.04774341425713],
				[-31.243461861880633, 86.73418721421837],
				[-28.90637622424623, 88.28822869491341],
				[-25.057413022059677, 89.44472468054693],
				[-20.81692774140339, 89.44472468054693],
				[-16.18190867398158, 89.05019089378129],
				[-11.938411685029394, 87.89369490814778],
				[-7.333509700566708, 85.96921330705447],
				[-5.393969557993842, 85.2072511081866],
				[0.3945337867656349, 82.49972535015394],
				[2.6984906331448997, 80.57223204076473],
				[4.243496988952188, 79.02421397666154],
				[6.93897591380113, 75.56978456124057],
				[9.63746654694603, 72.10029660433997],
				[11.573994981222995, 68.23025144408194],
				[12.727479258560606, 65.54380764412076],
				[13.877951827602317, 60.9118002849948],
				[13.877951827602317, 57.065848791104145],
				[13.877951827602317, 53.19881533914207],
				[13.091895962367005, 50.117837752415255],
				[11.573994981222995, 47.43139395245407],
				[8.848398973414817, 44.723868194421414],
				[6.544442127035552, 43.564360500491944],
				[3.454429415420975, 41.642890607694596],
				[1.1504725690417104, 40.486394622061084],
				[-3.090012711614577, 38.932353141366036],
				[-6.180025423229154, 38.56191302096778],
				[-10.423522412181285, 38.932353141366036],
				[-12.727479258560606, 39.326886928131614],
				[-15.422958183409548, 40.09186083529545],
				[-18.512970895024125, 40.87490499223486],
				[-21.9674003104451, 41.642890607694596],
				[-25.816363512631654, 43.17283842202227],
				[-29.695443797777443, 45.11539027289109],
				[-33.544406999963996, 49.72631567394558],
				[-33.93894078672963, 50.51237153918089],
				[-36.99883641538497, 57.4362889115024],
				[-37.787903988916185, 58.99033039219745],
				[-38.54384277119226, 62.8332701777922],
				[-38.54384277119226, 63.992777871721614],
			],
			pressures: [
				0.0784313753247261, 0.12941177189350128, 0.15294118225574493, 0.1882352977991104,
				0.21176470816135406, 0.23529411852359772, 0.24705882370471954, 0.239215686917305,
				0.250980406999588, 0.25882354378700256, 0.26274511218070984, 0.2666666805744171,
				0.2666666805744171, 0.27450981736183167, 0.27843138575553894, 0.27843138575553894,
				0.2823529541492462, 0.27843138575553894, 0.27843138575553894, 0.27843138575553894,
				0.27843138575553894, 0.2823529541492462, 0.2823529541492462, 0.2823529541492462,
				0.2823529541492462, 0.2823529541492462, 0.2823529541492462, 0.2862745225429535,
				0.29411765933036804, 0.30588236451148987, 0.32549020648002625, 0.3450980484485626,
				0.364705890417099, 0.3843137323856354, 0.3921568691730499, 0.3960784375667572,
				0.40392157435417175, 0.4156862795352936, 0.42352941632270813, 0.41960784792900085,
				0.4000000059604645, 0.3921568691730499, 0.3803921639919281, 0.38823530077934265,
				0.3960784375667572, 0.40784314274787903, 0.40784314274787903, 0.3960784375667572,
				0.3803921639919281, 0.3803921639919281, 0.3921568691730499, 0.3960784375667572,
				0.40392157435417175, 0.4117647111415863, 0.4156862795352936, 0.41960784792900085,
				0.42352941632270813, 0.42352941632270813, 0.4313725531101227, 0.43529412150382996,
				0.43529412150382996, 0.4431372582912445, 0.4431372582912445, 0.4470588266849518,
				0.45098039507865906, 0.4588235318660736, 0.4470588266849518, 0.4431372582912445,
				0.3686274588108063, 0.2078431397676468, 0.16470588743686676, 0.09019608050584793,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-38.54384277119226, 63.992777871721614],
		},
	],
	"7": [
		{
			id: "7iAvhUOMDXUpjmep-SzT9",
			type: "freedraw",
			x: 220.79310565471258,
			y: 213.79641001210382,
			width: 57.818775865084376,
			height: 83.28276950709335,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1557036605,
			version: 70,
			versionNonce: 1553305629,
			isDeleted: false,
			boundElements: null,
			updated: 1751811942156,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.3945337867656349, 0],
				[1.1504725690416535, 0],
				[3.454429415420975, 0.3945337867656349],
				[6.152920048565818, 0.7830441569394111],
				[9.242932760180395, 1.156495985633569],
				[12.335957180090872, 1.9425518508688242],
				[15.42596989170545, 2.316003679562982],
				[18.880399307126424, 2.710537466328617],
				[22.759479592272214, 3.080977586726817],
				[25.819375220927554, 3.080977586726817],
				[28.90938793254213, 3.080977586726817],
				[32.39393443092234, 2.710537466328617],
				[34.30335749053603, 2.316003679562982],
				[36.607314336915294, 2.316003679562982],
				[38.941388266253796, 2.316003679562982],
				[41.24233340433716, 2.316003679562982],
				[43.546290250716424, 1.9425518508688242],
				[45.48583039328935, 1.9425518508688242],
				[47.78978723966861, 1.9425518508688242],
				[49.72631567394558, 1.9425518508688242],
				[52.03027252032484, 1.9425518508688242],
				[53.969812662897766, 1.9425518508688242],
				[55.12028523193942, 1.551029772399147],
				[55.514819018705055, 1.551029772399147],
				[55.90935280547063, 1.156495985633569],
				[56.27376950927703, 1.156495985633569],
				[56.66529158774671, 1.156495985633569],
				[56.66529158774671, 0.7830441569394111],
				[57.05982537451234, 0.7830441569394111],
				[57.42424207831874, 0.7830441569394111],
				[57.05982537451234, 1.156495985633569],
				[55.90935280547063, 2.316003679562982],
				[53.969812662897766, 4.237473572360329],
				[52.42480630709048, 5.791515053055377],
				[50.485266164517554, 8.104507024322459],
				[47.03083674909658, 12.736514383448366],
				[45.09129660652371, 16.18793209057344],
				[43.546290250716424, 19.289991635371678],
				[42.03140097786837, 22.370969222098495],
				[40.85081132586748, 25.057413022059677],
				[39.33291034472347, 28.138390608786494],
				[38.54685447948816, 29.692432089481542],
				[36.242897633108896, 33.535371875076294],
				[35.456841767873584, 35.47792372594512],
				[34.30335749053603, 37.405417035334324],
				[32.75835113472874, 39.71840900660135],
				[30.457405996645377, 42.799386593328165],
				[28.153449150266056, 46.27188625852466],
				[26.972859498265166, 48.58788993808764],
				[25.819375220927554, 50.51237153918089],
				[23.909952161313868, 53.19881533914213],
				[21.970412018741, 55.90935280547069],
				[19.669466880657637, 58.99033039219751],
				[17.335392951319136, 62.462830057394],
				[15.031436104939871, 65.14927385735518],
				[12.730490966856507, 68.230251444082],
				[11.185484611049219, 70.94078891041056],
				[9.64047825524193, 73.6272327103718],
				[7.336521408862666, 77.49426616233387],
				[6.544442127035495, 78.2562283612018],
				[5.393969557993842, 79.41573605513122],
				[4.246508697248089, 80.96676582753037],
				[3.0930244199104777, 82.12627352145978],
				[2.695478924848942, 82.89124742862367],
				[2.695478924848942, 83.28276950709335],
				[3.0930244199104777, 83.28276950709335],
				[4.638030775717766, 82.49671364185804],
				[4.999435771228207, 81.7317397346942],
			],
			pressures: [
				0.0784313753247261, 0.15294118225574493, 0.1764705926179886, 0.21960784494876862,
				0.24313725531101227, 0.2549019753932953, 0.29411765933036804, 0.32549020648002625,
				0.3607843220233917, 0.3803921639919281, 0.3803921639919281, 0.37254902720451355,
				0.35686275362968445, 0.3529411852359772, 0.3607843220233917, 0.3607843220233917,
				0.3607843220233917, 0.3529411852359772, 0.3529411852359772, 0.3490196168422699,
				0.3333333432674408, 0.32156863808631897, 0.3176470696926117, 0.3137255012989044,
				0.32156863808631897, 0.3333333432674408, 0.3450980484485626, 0.34117648005485535,
				0.32156863808631897, 0.29411765933036804, 0.2705882489681244, 0.25882354378700256,
				0.23529411852359772, 0.21960784494876862, 0.20392157137393951,
				0.20000000298023224, 0.21176470816135406, 0.2235294133424759, 0.2235294133424759,
				0.21960784494876862, 0.21960784494876862, 0.21960784494876862,
				0.22745098173618317, 0.239215686917305, 0.24313725531101227, 0.239215686917305,
				0.2235294133424759, 0.2078431397676468, 0.20392157137393951, 0.20000000298023224,
				0.20392157137393951, 0.2078431397676468, 0.20392157137393951, 0.20000000298023224,
				0.19607843458652496, 0.20392157137393951, 0.2078431397676468, 0.21176470816135406,
				0.21176470816135406, 0.20000000298023224, 0.20000000298023224, 0.2078431397676468,
				0.2078431397676468, 0.20392157137393951, 0.1921568661928177, 0.16470588743686676,
				0.09803921729326248, 0.007843137718737125, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [4.999435771228207, 81.7317397346942],
		},
		{
			id: "j-n0-ciV3HaMLRrqNQGXT",
			type: "freedraw",
			x: 234.67406919061074,
			y: 253.1232969402355,
			width: 29.300910011011865,
			height: 11.185484611049219,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1786695123,
			version: 17,
			versionNonce: 1202743933,
			isDeleted: false,
			boundElements: null,
			updated: 1751811942869,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[1.1504725690417104, 0.7649739071638351],
				[3.84896320218661, 1.5480180641031893],
				[8.08944848284284, 2.7075257580326593],
				[12.727479258560606, 3.4724996651964943],
				[15.422958183409605, 4.6289956508300065],
				[19.666455172361736, 6.550465543627354],
				[22.726350801017134, 7.709973237556824],
				[25.451946808825312, 8.474947144720659],
				[27.361369868439, 8.869480931486237],
				[28.51485414577661, 9.26100300995597],
				[28.906376224246287, 9.26100300995597],
				[29.300910011011865, 9.631443130354171],
				[29.300910011011865, 10.025976917119806],
				[28.51485414577661, 10.790950824283641],
				[28.15043744197021, 11.185484611049219],
			],
			pressures: [
				0.0784313753247261, 0.2980392277240753, 0.34117648005485535, 0.3686274588108063,
				0.40392157435417175, 0.4156862795352936, 0.4431372582912445, 0.4274509847164154,
				0.3921568691730499, 0.3921568691730499, 0.38823530077934265, 0.37254902720451355,
				0.3019607961177826, 0.23137255012989044, 0.10980392247438431, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [28.15043744197021, 11.185484611049219],
		},
	],
	"8": [
		{
			id: "lbbT4LNBpVqReoZWf6SN2",
			type: "freedraw",
			x: 246.24806417183373,
			y: 208.79396253257966,
			width: 54.7287631534698,
			height: 88.65866881531167,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 246468765,
			version: 97,
			versionNonce: 636007581,
			isDeleted: false,
			boundElements: null,
			updated: 1751811951904,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.3915220784696771, -0.7649739071638351],
				[-1.5450063558072884, -0.7649739071638351],
				[-3.09001271161452, -0.39453378676557804],
				[-6.180025423229097, 0.7619621988679341],
				[-9.270038134843674, 2.316003679562982],
				[-12.724467550264649, 4.632007359125964],
				[-15.814480261879226, 6.944999330392989],
				[-17.75703211274805, 9.239921051884494],
				[-19.302038468555338, 10.793962532579542],
				[-21.208449819873067, 13.4984765823163],
				[-22.00052910170018, 15.422958183409605],
				[-23.15100167074189, 18.109401983370788],
				[-24.304485948079503, 21.190379570097605],
				[-25.454958517121156, 24.292439114895842],
				[-26.21089729939723, 28.138390608786494],
				[-26.21089729939723, 30.454394288349476],
				[-26.21089729939723, 33.14083808831066],
				[-25.454958517121156, 35.85137555463922],
				[-23.909952161313868, 38.1673792342022],
				[-22.759479592272214, 40.85382303416344],
				[-20.81692774140339, 43.169826713726366],
				[-18.11843710825849, 45.48281868499345],
				[-15.422958183409548, 47.036860165688495],
				[-12.363062554754151, 48.563796271720264],
				[-8.875504348078096, 50.11783775241531],
				[-5.029552854187443, 51.274333738048824],
				[-2.3310622210425436, 52.804281552376494],
				[0.36441670380639835, 54.72575144517384],
				[2.3039568463793216, 57.041755124736824],
				[4.243496988952188, 59.357758804299806],
				[6.152920048565875, 62.068296270628366],
				[7.303392617607585, 65.54380764412076],
				[8.45687689494514, 68.62478523084758],
				[9.63746654694603, 71.31122903080882],
				[10.001883250752428, 73.62723271037174],
				[10.001883250752428, 75.94323638993473],
				[9.63746654694603, 78.25622836120175],
				[8.45687689494514, 80.17769825399915],
				[6.54745383533151, 82.10519156338836],
				[3.84896320218661, 83.65320962749155],
				[0.7589504905720332, 84.81271732142102],
				[-2.3310622210425436, 85.5746795202889],
				[-5.785491636463519, 86.73418721421837],
				[-10.423522412181285, 87.89369490814784],
				[-12.724467550264649, 87.89369490814784],
				[-15.422958183409548, 87.89369490814784],
				[-18.11843710825849, 87.12872100098394],
				[-20.81692774140339, 85.5746795202889],
				[-23.909952161313868, 84.0266614561857],
				[-27.39449865969408, 82.10519156338836],
				[-28.939505015501368, 80.57223204076473],
				[-30.848928075115055, 78.62968018989596],
				[-31.999400644156708, 76.3347584684044],
				[-32.39393443092234, 73.62723271037174],
				[-32.39393443092234, 70.94078891041056],
				[-32.39393443092234, 67.07074375015253],
				[-24.304485948079503, 53.590337417611806],
				[-20.45552274589295, 51.644773858447024],
				[-19.66344346406578, 51.274333738048824],
				[-15.814480261879226, 48.95833005848584],
				[-10.815044490650962, 46.25080430045318],
				[-7.330497992270807, 44.72085648612551],
				[-3.484546498380155, 42.77830463525669],
				[0, 41.24835682092902],
				[2.6984906331448997, 39.32688692813167],
				[4.607913692758586, 37.381323368966946],
				[6.938975913801187, 35.45684176787364],
				[10.393405329222162, 32.375864181146824],
				[11.546889606559716, 31.21936819551331],
				[14.242368531408715, 28.53292439555213],
				[16.18190867398158, 26.216920715989147],
				[17.72691502978887, 24.292439114895842],
				[18.88039930712648, 22.346875555731117],
				[20.03087187616819, 20.42540566293377],
				[20.816927741403447, 18.503935770136366],
				[21.575878231975423, 16.184920382277483],
				[21.970412018741058, 13.871928411010458],
				[22.334828722547456, 11.947446809917153],
				[22.334828722547456, 9.634454838650129],
				[22.334828722547456, 8.083425066250982],
				[21.970412018741058, 6.5534772519233115],
				[20.816927741403447, 5.396981266289799],
				[19.27192138559616, 3.8429397855947514],
				[17.332381243023292, 2.686443799961239],
				[15.787374887216004, 1.921469892797404],
				[13.48642974913264, 0.7619621988679341],
				[11.546889606559716, 0],
				[8.092460191138741, -0.7649739071638351],
				[5.002447479524221, -0.7649739071638351],
				[1.9094230596136867, -0.39453378676557804],
				[-1.18058965200089, 0.7619621988679341],
				[-4.24048528065623, 2.316003679562982],
				[-7.330497992270807, 3.8429397855947514],
				[-10.028988625415707, 6.1589434651577335],
				[-10.815044490650962, 6.944999330392989],
			],
			pressures: [
				0.0784313753247261, 0.2078431397676468, 0.2235294133424759, 0.23137255012989044,
				0.24313725531101227, 0.250980406999588, 0.2666666805744171, 0.27843138575553894,
				0.29019609093666077, 0.3019607961177826, 0.30588236451148987, 0.30588236451148987,
				0.30980393290519714, 0.3137255012989044, 0.3294117748737335, 0.34117648005485535,
				0.3529411852359772, 0.3490196168422699, 0.3529411852359772, 0.3607843220233917,
				0.3686274588108063, 0.3803921639919281, 0.3960784375667572, 0.41960784792900085,
				0.4274509847164154, 0.43921568989753723, 0.45098039507865906, 0.45098039507865906,
				0.4588235318660736, 0.4745098054409027, 0.48235294222831726, 0.49803921580314636,
				0.5058823823928833, 0.501960813999176, 0.49803921580314636, 0.49803921580314636,
				0.501960813999176, 0.501960813999176, 0.49803921580314636, 0.48627451062202454,
				0.46666666865348816, 0.4431372582912445, 0.4274509847164154, 0.4117647111415863,
				0.3921568691730499, 0.3764705955982208, 0.3529411852359772, 0.32549020648002625,
				0.30588236451148987, 0.29411765933036804, 0.27843138575553894,
				0.26274511218070984, 0.24705882370471954, 0.22745098173618317,
				0.21568627655506134, 0.21176470816135406, 0.2078431397676468, 0.29019609093666077,
				0.30980393290519714, 0.3137255012989044, 0.3333333432674408, 0.34117648005485535,
				0.3529411852359772, 0.3686274588108063, 0.37254902720451355, 0.37254902720451355,
				0.3686274588108063, 0.364705890417099, 0.3607843220233917, 0.364705890417099,
				0.3294117748737335, 0.32549020648002625, 0.3294117748737335, 0.3176470696926117,
				0.32156863808631897, 0.32156863808631897, 0.32156863808631897, 0.3294117748737335,
				0.3294117748737335, 0.3490196168422699, 0.364705890417099, 0.3843137323856354,
				0.3960784375667572, 0.4000000059604645, 0.40392157435417175, 0.40784314274787903,
				0.40392157435417175, 0.40392157435417175, 0.4000000059604645, 0.4000000059604645,
				0.3921568691730499, 0.37254902720451355, 0.3294117748737335, 0.2666666805744171,
				0.14509804546833038, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-10.815044490650962, 6.944999330392989],
		},
	],
	"9": [
		{
			id: "70IeIvAHupL5IBNC1GKMj",
			type: "freedraw",
			x: 229.2800996326169,
			y: 216.87738759883064,
			width: 45.880364180054926,
			height: 33.14384979660656,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1365195635,
			version: 39,
			versionNonce: 888901405,
			isDeleted: false,
			boundElements: null,
			updated: 1751811960314,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7890675735312129, 0],
				[-1.1504725690416535, 0.7830441569393543],
				[-1.5450063558072884, 1.9425518508688242],
				[-2.3340739293385013, 4.632007359125964],
				[-2.3340739293385013, 7.7129849458527815],
				[-1.1504725690416535, 10.812032782355118],
				[0.3945337867656349, 13.4984765823163],
				[4.243496988952188, 16.579454169043117],
				[8.848398973414817, 17.73896186297253],
				[14.272485614367895, 18.133495649738165],
				[18.121448816554448, 18.503935770136366],
				[22.726350801017134, 18.503935770136366],
				[25.81636351263171, 18.503935770136366],
				[30.05986050158384, 18.133495649738165],
				[31.999400644156765, 16.973987955808695],
				[34.30034578224013, 14.65798427624577],
				[35.84836384634332, 11.577006689518953],
				[37.784892280620284, 6.5534772519233115],
				[38.54384277119226, 3.4724996651964943],
				[38.938376557957895, -1.138425735857993],
				[38.54384277119226, -3.8459514938906523],
				[36.239885924812995, -7.6919029877813045],
				[34.30034578224013, -10.00790666734423],
				[31.60486685739113, -12.323910346907212],
				[26.605431086162866, -13.874940119306359],
				[23.12088458778271, -14.24538023970456],
				[18.877387598830524, -14.639914026470194],
				[15.422958183409548, -14.639914026470194],
				[11.546889606559716, -13.480406332540724],
				[6.93897591380113, -11.558936439743377],
				[0.7559387822760755, -7.3214628673830475],
				[-2.3340739293385013, -4.24048528065623],
				[-5.393969557993842, 0],
				[-6.941987622097031, 4.632007359125964],
				[-5.393969557993842, 9.26100300995597],
				[1.5450063558072884, 15.052518063011348],
				[2.6984906331448997, 16.20901404864486],
			],
			pressures: [
				0.0784313753247261, 0.13725490868091583, 0.1764705926179886, 0.21176470816135406,
				0.2549019753932953, 0.27843138575553894, 0.3019607961177826, 0.30588236451148987,
				0.32156863808631897, 0.3176470696926117, 0.3019607961177826, 0.29411765933036804,
				0.2705882489681244, 0.2666666805744171, 0.26274511218070984, 0.25882354378700256,
				0.25882354378700256, 0.25882354378700256, 0.26274511218070984,
				0.26274511218070984, 0.25882354378700256, 0.25882354378700256, 0.2666666805744171,
				0.27450981736183167, 0.2823529541492462, 0.2823529541492462, 0.2823529541492462,
				0.2823529541492462, 0.2823529541492462, 0.2862745225429535, 0.2862745225429535,
				0.3137255012989044, 0.30980393290519714, 0.3176470696926117, 0.3019607961177826,
				0.24313725531101227, 0.0784313753247261, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [2.6984906331448997, 16.20901404864486],
		},
		{
			id: "SMsi81Ufk4AvzcTVmjVH1",
			type: "freedraw",
			x: 266.6734698347675,
			y: 217.26890967730031,
			width: 42.38979426508291,
			height: 71.68468085950298,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 199630547,
			version: 35,
			versionNonce: 1847424061,
			isDeleted: false,
			boundElements: null,
			updated: 1751811961207,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.39453378676557804, -1.1564959856335122],
				[-0.39453378676557804, -1.5299478143276701],
				[-0.7890675735312129, -1.5299478143276701],
				[-1.1534842773376113, -1.5299478143276701],
				[-1.5450063558072884, 0.7649739071638351],
				[-1.5450063558072884, 4.632007359125964],
				[-1.5450063558072884, 8.104507024322459],
				[-1.5450063558072884, 13.871928411010458],
				[-1.1534842773376113, 19.268909677300257],
				[-0.39453378676557804, 26.981894623152982],
				[0, 31.222379903809212],
				[0.7559387822760755, 38.1673792342022],
				[0.7559387822760755, 42.01634243638881],
				[0.7559387822760755, 47.80183407285233],
				[0.3915220784696771, 51.277345446344725],
				[-0.39453378676557804, 56.674326712634524],
				[-1.9395401425728664, 61.30633407176043],
				[-2.6984906331448997, 63.601255793251994],
				[-5.029552854187443, 65.91725947281492],
				[-9.273049843139631, 68.62478523084758],
				[-13.87795182760226, 69.78128121648109],
				[-16.970976247512795, 70.1547330451753],
				[-21.970412018741058, 70.1547330451753],
				[-24.66589094359, 70.1547330451753],
				[-29.300910011011865, 70.1547330451753],
				[-34.30335749053603, 68.62478523084758],
				[-37.39337020215061, 67.07375545844849],
				[-39.33592205301943, 65.91725947281492],
				[-41.24233340433716, 63.99277787172167],
				[-41.63385548280684, 62.83628188608816],
				[-41.63385548280684, 61.30633407176043],
				[-38.938376557957895, 58.99033039219751],
				[-37.787903988916185, 58.204274526962195],
			],
			pressures: [
				0.0784313753247261, 0.07450980693101883, 0.10588235408067703, 0.1411764770746231,
				0.1725490242242813, 0.239215686917305, 0.25882354378700256, 0.2823529541492462,
				0.30980393290519714, 0.32549020648002625, 0.32549020648002625, 0.3137255012989044,
				0.3137255012989044, 0.3176470696926117, 0.32156863808631897, 0.3294117748737335,
				0.3294117748737335, 0.3176470696926117, 0.32156863808631897, 0.3176470696926117,
				0.3294117748737335, 0.33725491166114807, 0.3490196168422699, 0.364705890417099,
				0.3686274588108063, 0.37254902720451355, 0.3686274588108063, 0.3450980484485626,
				0.3333333432674408, 0.3019607961177826, 0.2666666805744171, 0.18431372940540314,
				0.06666667014360428, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-37.787903988916185, 58.204274526962195],
		},
	],
	A: [
		{
			id: "JFIkrgzfXlnBtpZYfwR9s",
			type: "freedraw",
			x: 213.8541297409114,
			y: 299.0036611202904,
			width: 60.908788576698896,
			height: 97.92569524185939,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 802464861,
			version: 68,
			versionNonce: 1819599667,
			isDeleted: false,
			boundElements: null,
			updated: 1751811243949,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, -0.7890675735312129],
				[0, -1.159507693929413],
				[-0.39453378676557804, -2.71053746632856],
				[-0.7589504905719764, -7.3214628673830475],
				[-1.1504725690416535, -11.185484611049219],
				[-1.5450063558072884, -17.347439784502853],
				[-1.5450063558072884, -20.819939449699348],
				[-1.9395401425728664, -25.060424730355578],
				[-1.9395401425728664, -31.222379903809212],
				[-1.9395401425728664, -35.48394714253692],
				[-1.9395401425728664, -39.71840900660129],
				[-1.9395401425728664, -43.95889428725758],
				[-1.9395401425728664, -47.80183407285227],
				[-1.9395401425728664, -53.19881533914207],
				[-1.5450063558072884, -56.27979292586889],
				[-0.7589504905719764, -61.30633407176043],
				[-0.39453378676557804, -63.992777871721614],
				[0, -67.46828924521401],
				[0.7589504905720332, -72.10029660433997],
				[1.9395401425729233, -75.57279626953647],
				[2.6954789248489988, -79.02722568495744],
				[3.84896320218661, -81.7347514429901],
				[4.9994357712282635, -84.42420695124719],
				[6.183037131525111, -87.13173270927985],
				[7.697926404373163, -89.05320260207725],
				[10.393405329222162, -91.76374006840581],
				[12.332945471795028, -93.29067617443758],
				[15.031436104939928, -94.84471765513263],
				[17.72992673808477, -96.00121364076614],
				[20.819939449699348, -97.16072133469555],
				[23.518430082844247, -97.53116145509381],
				[29.303921719307823, -97.92569524185939],
				[31.213344778921453, -97.92569524185939],
				[34.697891277301665, -97.53116145509381],
				[37.00184812368093, -96.37165376116434],
				[40.486394622061084, -93.29067617443758],
				[43.94082403748206, -89.44773638884283],
				[45.88036418005498, -86.36675880211601],
				[47.78978723966867, -82.89124742862361],
				[49.33479359547596, -79.41573605513122],
				[50.879799951283246, -75.57279626953647],
				[52.0302725203249, -71.31424073910466],
				[52.81934009385611, -67.07375545844843],
				[53.57527887613219, -62.8362818860881],
				[54.3643464496634, -57.83383440656394],
				[54.7287631534698, -52.43685314027414],
				[55.514819018705055, -48.569819688312066],
				[56.665291587746765, -44.33234611595174],
				[57.05982537451234, -40.486394622061084],
				[57.42424207831874, -36.619361170098955],
				[57.42424207831874, -32.7734096762083],
				[57.818775865084376, -30.08696587624712],
				[57.818775865084376, -26.981894623152925],
				[58.213309651849954, -23.13895483755823],
				[58.213309651849954, -20.42841737122967],
				[58.60483173031963, -18.503935770136366],
				[58.60483173031963, -15.034447813235772],
				[58.60483173031963, -13.109966212142524],
				[58.60483173031963, -11.580018397814797],
				[58.60483173031963, -10.032000333711608],
				[58.96924843412603, -8.47795885301656],
				[58.96924843412603, -7.3214628673830475],
				[58.96924843412603, -6.1830371315250545],
				[58.96924843412603, -4.635019067421865],
				[58.96924843412603, -4.24048528065623],
				[58.96924843412603, -4.24048528065623],
			],
			pressures: [
				0.0784313753247261, 0.19607843458652496, 0.20000000298023224, 0.21176470816135406,
				0.22745098173618317, 0.23137255012989044, 0.24313725531101227, 0.239215686917305,
				0.23529411852359772, 0.23529411852359772, 0.23529411852359772,
				0.23529411852359772, 0.239215686917305, 0.239215686917305, 0.239215686917305,
				0.23529411852359772, 0.23529411852359772, 0.23529411852359772,
				0.23529411852359772, 0.23137255012989044, 0.2235294133424759, 0.21568627655506134,
				0.21568627655506134, 0.21568627655506134, 0.21568627655506134,
				0.21960784494876862, 0.2235294133424759, 0.239215686917305, 0.250980406999588,
				0.27450981736183167, 0.27843138575553894, 0.2862745225429535, 0.29411765933036804,
				0.2980392277240753, 0.3137255012989044, 0.32549020648002625, 0.3294117748737335,
				0.3607843220233917, 0.3764705955982208, 0.3921568691730499, 0.40392157435417175,
				0.40784314274787903, 0.41960784792900085, 0.4274509847164154, 0.4274509847164154,
				0.43529412150382996, 0.43529412150382996, 0.43529412150382996,
				0.43529412150382996, 0.4313725531101227, 0.4313725531101227, 0.4313725531101227,
				0.4156862795352936, 0.40392157435417175, 0.3921568691730499, 0.3843137323856354,
				0.3764705955982208, 0.3686274588108063, 0.3607843220233917, 0.35686275362968445,
				0.35686275362968445, 0.3490196168422699, 0.3490196168422699, 0.3490196168422699,
				0.3490196168422699, 0.3450980484485626, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [58.96924843412603, -4.24048528065623],
		},
		{
			id: "QEfxAI_x4FgCciNoTbYJR",
			type: "freedraw",
			x: 213.4595959541458,
			y: 258.51726649822933,
			width: 52.81934009385611,
			height: 1.554041480695048,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1377150429,
			version: 33,
			versionNonce: 1428025821,
			isDeleted: false,
			boundElements: null,
			updated: 1751811245051,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, 0.3945337867656349],
				[0.7890675735312129, 0.3945337867656349],
				[2.3340739293385013, 0],
				[5.7885033447594765, 0],
				[10.028988625415707, -0.3915220784696771],
				[15.031436104939871, -0.7649739071638351],
				[19.27493309389206, -1.159507693929413],
				[21.97342372703696, -1.159507693929413],
				[23.912963869609825, -0.7649739071638351],
				[27.002976581224402, -0.3915220784696771],
				[29.303921719307766, -0.3915220784696771],
				[32.002412352452666, -0.3915220784696771],
				[33.94195249502553, -0.7649739071638351],
				[36.242897633108896, -1.159507693929413],
				[38.18243777568182, -1.159507693929413],
				[39.72744413148911, -1.159507693929413],
				[40.88092840882666, -1.159507693929413],
				[42.79035146844035, -1.159507693929413],
				[44.33535782424764, -1.159507693929413],
				[45.48583039328935, -1.159507693929413],
				[47.425370535862214, -1.159507693929413],
				[48.18432102643425, -0.7649739071638351],
				[49.729327382241536, -0.3915220784696771],
				[50.12084946071121, -0.3915220784696771],
				[50.87979995128319, -0.3915220784696771],
				[50.87979995128319, 0],
				[51.274333738048824, 0],
				[51.6688675248144, 0],
				[52.42480630709048, 0],
				[52.81934009385611, 0],
				[52.81934009385611, 0.3945337867656349],
			],
			pressures: [
				0.0784313753247261, 0.239215686917305, 0.30980393290519714, 0.35686275362968445,
				0.40392157435417175, 0.4274509847164154, 0.4431372582912445, 0.4431372582912445,
				0.43529412150382996, 0.42352941632270813, 0.40784314274787903, 0.4117647111415863,
				0.43529412150382996, 0.4431372582912445, 0.4431372582912445, 0.4313725531101227,
				0.42352941632270813, 0.4274509847164154, 0.4431372582912445, 0.4470588266849518,
				0.4627451002597809, 0.46666666865348816, 0.4627451002597809, 0.4470588266849518,
				0.43529412150382996, 0.4313725531101227, 0.4313725531101227, 0.43921568989753723,
				0.43921568989753723, 0.43921568989753723, 0.4274509847164154, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [52.81934009385611, 0.3945337867656349],
		},
	],
	B: [
		{
			id: "4fF0kTHQonIsMJ31rZw3I",
			type: "freedraw",
			x: 218.85356551213965,
			y: 207.63445483865024,
			width: 2.3370856376344022,
			height: 88.65866881531161,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 669713149,
			version: 42,
			versionNonce: 644917331,
			isDeleted: false,
			boundElements: null,
			updated: 1751811250873,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.3945337867656349, 0.7649739071638351],
				[0.3945337867656349, 1.9214698927973473],
				[0.3945337867656349, 3.8459514938906523],
				[0.3945337867656349, 6.161955173453578],
				[0, 9.242932760180395],
				[0, 12.341980596682731],
				[0, 16.58246587733902],
				[0, 20.819939449699348],
				[0, 24.66589094359],
				[0.3945337867656349, 28.532924395552072],
				[1.1836013602968478, 32.00843576904447],
				[1.5450063558072884, 35.45985347616954],
				[1.5450063558072884, 38.932353141366036],
				[1.9395401425729233, 42.79938659332811],
				[1.9395401425729233, 45.880364180054926],
				[1.9395401425729233, 49.72330396564968],
				[1.9395401425729233, 53.19881533914207],
				[1.9395401425729233, 55.885259139103255],
				[2.3370856376344022, 58.59579660543187],
				[2.3370856376344022, 61.67677419215863],
				[2.3370856376344022, 63.992777871721614],
				[2.3370856376344022, 66.70331533805017],
				[2.3370856376344022, 68.62478523084758],
				[2.3370856376344022, 71.31122903080876],
				[1.9395401425729233, 73.62723271037174],
				[1.9395401425729233, 75.55171431146499],
				[1.9395401425729233, 77.49426616233382],
				[1.5450063558072884, 79.41573605513116],
				[1.1836013602968478, 81.33720594792857],
				[1.1836013602968478, 83.26469925731777],
				[1.1836013602968478, 84.41818353465538],
				[1.1836013602968478, 85.18616915011512],
				[1.1836013602968478, 85.97222501535043],
				[1.5450063558072884, 86.73418721421831],
				[1.5450063558072884, 87.12872100098394],
				[1.5450063558072884, 87.89369490814778],
				[1.5450063558072884, 88.28822869491336],
				[1.5450063558072884, 88.65866881531161],
				[1.5450063558072884, 87.89369490814778],
				[1.5450063558072884, 87.12872100098394],
			],
			pressures: [
				0.0784313753247261, 0.125490203499794, 0.1725490242242813, 0.21568627655506134,
				0.2549019753932953, 0.29019609093666077, 0.30980393290519714, 0.3333333432674408,
				0.3490196168422699, 0.3333333432674408, 0.3294117748737335, 0.32549020648002625,
				0.32156863808631897, 0.32156863808631897, 0.32156863808631897, 0.3176470696926117,
				0.30588236451148987, 0.2980392277240753, 0.29411765933036804, 0.29411765933036804,
				0.29411765933036804, 0.29411765933036804, 0.29019609093666077,
				0.29019609093666077, 0.2862745225429535, 0.2862745225429535, 0.27843138575553894,
				0.27450981736183167, 0.27450981736183167, 0.2705882489681244, 0.27450981736183167,
				0.27450981736183167, 0.27450981736183167, 0.27450981736183167,
				0.27450981736183167, 0.2823529541492462, 0.2862745225429535, 0.2823529541492462,
				0.24705882370471954, 0.027450980618596077, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [1.5450063558072884, 87.12872100098394],
		},
		{
			id: "l8Iu4l_aXfQ4-KcG-F63i",
			type: "freedraw",
			x: 216.5496086657604,
			y: 212.26646219777615,
			width: 59.36378222089161,
			height: 90.58013870810902,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 290825917,
			version: 94,
			versionNonce: 2060021011,
			isDeleted: false,
			boundElements: null,
			updated: 1751811252953,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.3915220784696771, -0.7860558652352552],
				[-0.3915220784696771, -1.1564959856335122],
				[0.7589504905719764, -2.316003679562982],
				[3.4875582066761126, -3.4724996651964943],
				[6.93897591380113, -5.3969812662897425],
				[10.396417037518006, -6.1830371315250545],
				[15.428981600001407, -6.94801103868889],
				[20.064000667423272, -6.94801103868889],
				[25.063436438651536, -7.318451159087147],
				[29.306933427603667, -6.5534772519233115],
				[33.15288492149432, -5.791515053055377],
				[37.00184812368093, -3.8670334519620724],
				[38.54685447948822, -3.4724996651964943],
				[42.39581768167477, -1.1564959856335122],
				[44.33535782424764, 0.7649739071638351],
				[46.63931467062696, 3.4724996651964943],
				[47.425370535862214, 5.0024474795241645],
				[49.3347935954759, 8.083425066250982],
				[50.51538324747679, 11.164402652977799],
				[51.6688675248144, 14.266462197776036],
				[52.0332842286208, 17.347439784502853],
				[52.42480630709048, 20.819939449699348],
				[52.0332842286208, 23.900917036426165],
				[50.87979995128319, 26.981894623152982],
				[49.3347935954759, 30.0628722098798],
				[47.030836749096636, 33.14384979660662],
				[44.72989161101327, 35.85438726293518],
				[41.639878899398695, 37.381323368966946],
				[38.155332401018484, 38.54083106289636],
				[34.700902985597565, 39.69732704852987],
				[31.216356487217354, 40.85683474245934],
				[28.91239964083809, 42.01031901979695],
				[25.457970225417114, 43.169826713726366],
				[22.759479592272214, 43.93781232918616],
				[19.669466880657637, 45.09129660652377],
				[16.57945416904306, 46.64533808721882],
				[14.275497322663796, 47.407300286086695],
				[12.33595718009093, 48.17227419325053],
				[10.787939115987683, 48.96134176678174],
				[9.63746654694603, 49.33178188718],
				[9.242932760180395, 49.33178188718],
				[8.881527764669954, 49.33178188718],
				[9.63746654694603, 49.33178188718],
				[11.185484611049219, 48.566807980016165],
				[13.883975244194119, 47.407300286086695],
				[16.57945416904306, 46.64533808721882],
				[21.97342372703696, 45.48583039328935],
				[27.3673932850308, 44.72085648612551],
				[31.60787856568703, 44.329334407655836],
				[33.547418708259954, 44.329334407655836],
				[37.39638191044651, 44.329334407655836],
				[40.091860835295506, 44.329334407655836],
				[43.57640733367566, 44.329334407655836],
				[46.63931467062696, 44.72085648612551],
				[48.9703768916695, 45.859282221983506],
				[50.87979995128319, 47.018789915912976],
				[52.819340093856056, 48.566807980016165],
				[54.72876315346974, 50.11783775241531],
				[56.668303296042666, 52.41275947390682],
				[57.81877586508432, 54.7287631534698],
				[58.60784343861553, 56.65023304626715],
				[58.97226014242193, 58.96623672583013],
				[58.97226014242193, 62.441748099322524],
				[58.97226014242193, 64.7577517788855],
				[58.213309651849954, 66.67922167168285],
				[57.45435916127792, 68.2332631523779],
				[55.12329694023538, 70.54625512364493],
				[52.819340093856056, 72.07620293797265],
				[50.123861169007114, 74.0006845390659],
				[47.78978723966861, 75.15718052469947],
				[44.72989161101327, 76.70519858880266],
				[41.639878899398695, 77.4731842042624],
				[38.54685447948822, 78.25924006949771],
				[35.09242506406724, 78.63269189819187],
				[32.002412352452666, 79.41573605513122],
				[29.306933427603667, 80.55416179098921],
				[27.3673932850308, 81.34021765622452],
				[24.6689026518859, 82.1021798550924],
				[21.97342372703696, 82.8671537622563],
				[19.27493309389206, 82.8671537622563],
				[16.973987955808695, 83.26168754902187],
				[13.883975244194119, 83.26168754902187],
				[11.941423393325294, 82.8671537622563],
				[9.63746654694603, 82.8671537622563],
				[6.93897591380113, 82.8671537622563],
				[5.0024474795241645, 82.1021798550924],
				[3.4875582066761126, 81.71366948491868],
				[2.6984906331448997, 80.94568386945889],
				[2.303956846379265, 80.55416179098921],
				[2.6984906331448997, 80.55416179098921],
				[2.6984906331448997, 80.18070996229505],
				[3.0930244199104777, 80.18070996229505],
			],
			pressures: [
				0.0784313753247261, 0.11764705926179886, 0.1882352977991104, 0.2235294133424759,
				0.25882354378700256, 0.29019609093666077, 0.3019607961177826, 0.32549020648002625,
				0.3529411852359772, 0.37254902720451355, 0.38823530077934265, 0.4000000059604645,
				0.4000000059604645, 0.4156862795352936, 0.4313725531101227, 0.4470588266849518,
				0.4470588266849518, 0.45490196347236633, 0.4470588266849518, 0.4470588266849518,
				0.4431372582912445, 0.4431372582912445, 0.4431372582912445, 0.4431372582912445,
				0.4431372582912445, 0.43921568989753723, 0.43529412150382996, 0.43529412150382996,
				0.43921568989753723, 0.43921568989753723, 0.43921568989753723, 0.4274509847164154,
				0.41960784792900085, 0.40784314274787903, 0.4117647111415863, 0.4000000059604645,
				0.3843137323856354, 0.3686274588108063, 0.364705890417099, 0.35686275362968445,
				0.3607843220233917, 0.3686274588108063, 0.37254902720451355, 0.35686275362968445,
				0.3686274588108063, 0.3921568691730499, 0.4000000059604645, 0.3960784375667572,
				0.3960784375667572, 0.3921568691730499, 0.40784314274787903, 0.43529412150382996,
				0.4431372582912445, 0.4470588266849518, 0.45098039507865906, 0.43921568989753723,
				0.4313725531101227, 0.41960784792900085, 0.40784314274787903, 0.40392157435417175,
				0.4000000059604645, 0.4000000059604645, 0.40784314274787903, 0.4313725531101227,
				0.4470588266849518, 0.43921568989753723, 0.4313725531101227, 0.41960784792900085,
				0.40784314274787903, 0.40392157435417175, 0.3921568691730499, 0.3764705955982208,
				0.37254902720451355, 0.3764705955982208, 0.37254902720451355, 0.3764705955982208,
				0.3764705955982208, 0.37254902720451355, 0.37254902720451355, 0.3686274588108063,
				0.3607843220233917, 0.3490196168422699, 0.34117648005485535, 0.34117648005485535,
				0.3450980484485626, 0.3450980484485626, 0.34117648005485535, 0.34117648005485535,
				0.34117648005485535, 0.34117648005485535, 0.09803921729326248,
				0.019607843831181526, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [3.0930244199104777, 80.18070996229505],
		},
	],
	C: [
		{
			id: "-K3rSHj5EaLsp-T6miKDd",
			type: "freedraw",
			x: 263.580445414857,
			y: 229.98434210267726,
			width: 55.48470193574582,
			height: 75.17525077447493,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 221098237,
			version: 50,
			versionNonce: 1178467165,
			isDeleted: false,
			boundElements: null,
			updated: 1751811268025,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.39453378676557804, -0.7649739071638351],
				[0.7589504905719764, -1.5299478143276701],
				[1.5480180641031893, -1.924481601093305],
				[2.303956846379265, -3.4514177071250742],
				[2.6984906331448997, -4.240485280656287],
				[3.0930244199104777, -5.7674213866879995],
				[2.6984906331448997, -7.318451159087147],
				[1.1534842773376113, -8.848398973414817],
				[-1.1504725690417104, -10.396417037518063],
				[-4.635019067421865, -10.790950824283641],
				[-8.483982269608418, -10.790950824283641],
				[-13.088884254071104, -10.007906667344287],
				[-16.57343075245126, -8.848398973414817],
				[-20.027860167872234, -7.318451159087147],
				[-24.271357156824422, -4.610925401054487],
				[-27.361369868439, -2.686443799961239],
				[-31.996388935860864, 0.7860558652352552],
				[-34.69487956900571, 3.8670334519620724],
				[-36.99582470708907, 7.3425448254545245],
				[-38.938376557957895, 10.028988625415707],
				[-41.636867191102795, 14.266462197776036],
				[-43.93781232918616, 18.506947478432267],
				[-45.48281868499345, 22.370969222098438],
				[-46.63630296233106, 26.611454502754725],
				[-47.42235882756631, 32.3999578475142],
				[-47.78677553137271, 35.48093543424096],
				[-47.030836749096636, 40.48338291376518],
				[-45.48281868499345, 45.48884210158525],
				[-42.78733976014445, 49.35587555354732],
				[-40.091860835295506, 53.20182704743797],
				[-36.99582470708907, 56.28280463416479],
				[-34.30034578224013, 59.38185247066713],
				[-31.60185514909523, 61.69785615023011],
				[-28.147425733674254, 63.22780396455778],
				[-23.906940453018024, 63.99578958001757],
				[-18.87738759883058, 64.38429995019129],
				[-13.483418040836682, 64.38429995019129],
				[-8.875504348078152, 63.22780396455778],
				[-4.240485280656287, 62.068296270628366],
				[-1.1504725690417104, 61.30633407176043],
				[1.1534842773376113, 60.5413601645966],
				[3.0930244199104777, 60.14682637783096],
				[5.393969557993842, 58.98731868390155],
				[6.1830371315250545, 58.225356485033615],
				[7.333509700566708, 57.065848791104145],
				[7.697926404373106, 56.67432671263447],
				[7.697926404373106, 56.28280463416479],
				[6.93897591380113, 55.90935280547063],
			],
			pressures: [
				0.0784313753247261, 0.22745098173618317, 0.26274511218070984, 0.27450981736183167,
				0.30980393290519714, 0.3294117748737335, 0.3490196168422699, 0.35686275362968445,
				0.3686274588108063, 0.3686274588108063, 0.3686274588108063, 0.3686274588108063,
				0.37254902720451355, 0.3764705955982208, 0.37254902720451355, 0.3803921639919281,
				0.3803921639919281, 0.3843137323856354, 0.3921568691730499, 0.3921568691730499,
				0.4000000059604645, 0.40784314274787903, 0.4156862795352936, 0.41960784792900085,
				0.4274509847164154, 0.4470588266849518, 0.45490196347236633, 0.47843137383461,
				0.4745098054409027, 0.47843137383461, 0.47843137383461, 0.4745098054409027,
				0.47843137383461, 0.48235294222831726, 0.4901960790157318, 0.5058823823928833,
				0.5333333611488342, 0.5686274766921997, 0.5764706134796143, 0.5882353186607361,
				0.6000000238418579, 0.615686297416687, 0.6235294342041016, 0.6078431606292725,
				0.5843137502670288, 0.5333333611488342, 0.40784314274787903, 0.2235294133424759,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [6.93897591380113, 55.90935280547063],
		},
	],
	D: [
		{
			id: "LiKdbbKMJxQZECBWScx8y",
			type: "freedraw",
			x: 230.82510598842418,
			y: 211.87192841101057,
			width: 1.1504725690416535,
			height: 88.28822869491336,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 821062685,
			version: 27,
			versionNonce: 362047699,
			isDeleted: false,
			boundElements: null,
			updated: 1751811277708,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.3915220784696771, 0.7649739071638351],
				[-0.3915220784696771, 1.159507693929413],
				[-0.3915220784696771, 2.7075257580326593],
				[-0.3915220784696771, 6.94801103868889],
				[-0.3915220784696771, 11.558936439743377],
				[-0.3915220784696771, 16.95290599773722],
				[-0.3915220784696771, 21.97944714362876],
				[0, 27.37642840991856],
				[0, 33.538383583372195],
				[0, 39.70033875682577],
				[0, 45.48583039328935],
				[-0.3915220784696771, 51.647785566742925],
				[-0.3915220784696771, 57.044766833032725],
				[-0.7890675735312129, 62.07130797892427],
				[-0.7890675735312129, 67.07375545844843],
				[-0.7890675735312129, 71.7087745258703],
				[-1.1504725690416535, 75.55171431146505],
				[-1.1504725690416535, 79.8102698418968],
				[-1.1504725690416535, 83.65622133578745],
				[-1.1504725690416535, 85.97222501535043],
				[-1.1504725690416535, 87.5021728296781],
				[-1.1504725690416535, 88.28822869491336],
				[-1.1504725690416535, 87.89369490814778],
				[-1.1504725690416535, 85.97222501535043],
				[-1.1504725690416535, 85.2072511081866],
			],
			pressures: [
				0.0784313753247261, 0.20392157137393951, 0.21176470816135406, 0.22745098173618317,
				0.2705882489681244, 0.3019607961177826, 0.3137255012989044, 0.3333333432674408,
				0.3294117748737335, 0.32156863808631897, 0.30980393290519714, 0.30980393290519714,
				0.3176470696926117, 0.32156863808631897, 0.30980393290519714, 0.3137255012989044,
				0.29411765933036804, 0.2823529541492462, 0.27450981736183167, 0.27450981736183167,
				0.2666666805744171, 0.26274511218070984, 0.2549019753932953, 0.1725490242242813,
				0.03529411926865578, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-1.1504725690416535, 85.2072511081866],
		},
		{
			id: "zHlzRKtaWAbK-LS9xCdRm",
			type: "freedraw",
			x: 230.03603841489297,
			y: 210.3449923049788,
			width: 48.57283139660797,
			height: 90.20969858771076,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 2064011475,
			version: 59,
			versionNonce: 2050439997,
			isDeleted: false,
			boundElements: null,
			updated: 1751811284051,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, -0.7890675735312129],
				[0.3975454950615358, -0.7890675735312129],
				[1.1504725690417104, -0.7890675735312129],
				[2.3340739293385013, -0.3945337867656349],
				[3.84896320218661, 0],
				[6.1830371315250545, 0.7649739071638351],
				[8.092460191138741, 1.5269361060317692],
				[10.426534120477243, 2.6864437999611823],
				[12.33595718009093, 3.8459514938906523],
				[15.031436104939871, 5.0024474795241645],
				[17.365510034278373, 6.532395293851835],
				[19.666455172361736, 8.083425066250982],
				[21.60599531493466, 10.004894959048329],
				[23.515418374548346, 11.555924731447476],
				[25.84949230388679, 13.477394624244823],
				[27.758915363500478, 15.793398303807805],
				[29.303921719307766, 18.109401983370788],
				[31.24346186188069, 20.79584578333197],
				[33.152884921494376, 23.876823370058787],
				[34.697891277301665, 26.981894623152982],
				[37.02895349834421, 30.062872209879743],
				[38.938376557957895, 33.14384979660656],
				[40.87791670053076, 36.616349461803054],
				[42.42292305633805, 39.69732704852987],
				[43.96792941214534, 43.169826713726366],
				[45.12141368948295, 46.25080430045318],
				[45.877352471759025, 50.88281165957909],
				[46.27188625852466, 52.40974776561086],
				[46.66642004529024, 56.27979292586889],
				[46.66642004529024, 58.571702939064494],
				[46.66642004529024, 61.67677419215869],
				[46.66642004529024, 65.91424776451902],
				[46.27188625852466, 68.6006915644802],
				[45.48583039328935, 70.91669524404318],
				[44.33234611595174, 72.46772501644227],
				[42.78733976014445, 74.39220661753558],
				[40.48338291376518, 76.31367651033293],
				[37.787903988916185, 78.23815811142623],
				[34.697891277301665, 79.39465409705974],
				[31.999400644156765, 80.55416179098921],
				[29.303921719307766, 81.33720594792857],
				[26.21390900769319, 82.1021798550924],
				[22.75947959227227, 83.26168754902187],
				[20.06098895912737, 84.41818353465538],
				[17.72992673808477, 84.78862365505364],
				[15.820503678471084, 85.5776912285848],
				[13.880963535898218, 85.94813134898305],
				[12.33595718009093, 86.73418721421837],
				[9.63746654694603, 87.10462733461657],
				[7.336521408862666, 87.4991611213822],
				[5.032564562483401, 87.8696012417804],
				[2.6984906331448997, 87.8696012417804],
				[1.1504725690417104, 88.26413502854604],
				[-0.3614049955104406, 88.65866881531161],
				[-1.5450063558072884, 89.02910893570987],
				[-1.906411351317729, 89.42063101417955],
				[-1.1504725690416535, 89.02910893570987],
			],
			pressures: [
				0.0784313753247261, 0.09803921729326248, 0.16470588743686676, 0.1882352977991104,
				0.2078431397676468, 0.23137255012989044, 0.2549019753932953, 0.2823529541492462,
				0.30980393290519714, 0.33725491166114807, 0.3529411852359772, 0.3607843220233917,
				0.3764705955982208, 0.3764705955982208, 0.38823530077934265, 0.3960784375667572,
				0.40784314274787903, 0.4313725531101227, 0.45098039507865906, 0.4588235318660736,
				0.4627451002597809, 0.46666666865348816, 0.47058823704719543, 0.47843137383461,
				0.48627451062202454, 0.48235294222831726, 0.501960813999176, 0.5058823823928833,
				0.5058823823928833, 0.47843137383461, 0.46666666865348816, 0.46666666865348816,
				0.4627451002597809, 0.4588235318660736, 0.45098039507865906, 0.4431372582912445,
				0.43921568989753723, 0.43529412150382996, 0.41960784792900085, 0.4117647111415863,
				0.40392157435417175, 0.3960784375667572, 0.3960784375667572, 0.40784314274787903,
				0.4156862795352936, 0.4156862795352936, 0.40784314274787903, 0.4000000059604645,
				0.3960784375667572, 0.3960784375667572, 0.40392157435417175, 0.40392157435417175,
				0.40392157435417175, 0.4000000059604645, 0.4000000059604645, 0.3960784375667572,
				0.3294117748737335, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-1.1504725690416535, 89.02910893570987],
		},
	],
	E: [
		{
			id: "geBwf7rDXVMzeQrOyn3R3",
			type: "freedraw",
			x: 222.73565750558134,
			y: 214.19094379886945,
			width: 47.78677553137271,
			height: 79.41573605513122,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1313593181,
			version: 45,
			versionNonce: 1802005203,
			isDeleted: false,
			boundElements: null,
			updated: 1751811308249,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, -0.3945337867656349],
				[0, 0.3885103701737762],
				[0, 2.316003679562982],
				[-0.39754549506147896, 5.785491636463519],
				[-1.183601360296791, 9.631443130354171],
				[-1.5450063558072884, 15.793398303807805],
				[-1.9425518508687674, 20.030871876168135],
				[-1.9425518508687674, 22.741409342496695],
				[-2.3370856376344022, 26.978882914857024],
				[-2.698490633144843, 31.984342102677147],
				[-2.698490633144843, 35.08338993917948],
				[-3.0930244199104777, 39.32387521983571],
				[-3.0930244199104777, 44.72085648612551],
				[-3.0930244199104777, 49.32877017888404],
				[-3.0930244199104777, 53.96077753801001],
				[-3.0930244199104777, 55.885259139103255],
				[-2.698490633144843, 60.14682637783096],
				[-2.3370856376344022, 63.22780396455778],
				[-1.9425518508687674, 65.54380764412076],
				[-1.183601360296791, 67.46527753691811],
				[-0.39754549506147896, 70.15172133687935],
				[0, 72.0762029379726],
				[1.1504725690417104, 73.62723271037174],
				[3.0568839203594393, 75.17525077447493],
				[4.210368197697051, 75.94022468163877],
				[7.697926404373163, 77.09973237556824],
				[8.848398973414817, 77.49125445403791],
				[11.149344111498237, 78.25622836120175],
				[13.877951827602317, 78.62968018989591],
				[16.937847456257657, 78.62968018989591],
				[20.027860167872234, 79.02120226836558],
				[23.12088458778271, 79.02120226836558],
				[25.421829725866075, 79.02120226836558],
				[28.120320359010975, 79.02120226836558],
				[30.0598605015839, 79.02120226836558],
				[32.36080563966726, 78.62968018989591],
				[35.84535213804742, 77.86169457443617],
				[38.908259474998715, 77.09973237556824],
				[41.23932169604126, 76.70821029709856],
				[42.39280597337887, 76.70821029709856],
				[43.54327854242058, 76.70821029709856],
				[44.693751111462234, 76.70821029709856],
				[44.329334407655836, 76.70821029709856],
			],
			pressures: [
				0.0784313753247261, 0.16470588743686676, 0.1764705926179886, 0.20392157137393951,
				0.23529411852359772, 0.2549019753932953, 0.27843138575553894, 0.2862745225429535,
				0.3019607961177826, 0.30588236451148987, 0.30588236451148987, 0.30588236451148987,
				0.3137255012989044, 0.32156863808631897, 0.32156863808631897, 0.3294117748737335,
				0.32156863808631897, 0.3176470696926117, 0.3176470696926117, 0.32156863808631897,
				0.32549020648002625, 0.32156863808631897, 0.32549020648002625,
				0.32549020648002625, 0.3450980484485626, 0.3529411852359772, 0.37254902720451355,
				0.3843137323856354, 0.3960784375667572, 0.4274509847164154, 0.45098039507865906,
				0.47843137383461, 0.49803921580314636, 0.501960813999176, 0.5098039507865906,
				0.5137255191802979, 0.529411792755127, 0.5529412031173706, 0.5686274766921997,
				0.5764706134796143, 0.5803921818733215, 0.5764706134796143, 0.572549045085907, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [44.329334407655836, 76.70821029709856],
		},
		{
			id: "0bcs_tkUjygK0V7JSb3LE",
			type: "freedraw",
			x: 223.88613007462305,
			y: 251.20182704743814,
			width: 43.148744755654945,
			height: 2.6864437999611823,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 2130746429,
			version: 22,
			versionNonce: 1630530195,
			isDeleted: false,
			boundElements: null,
			updated: 1751811309185,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7890675735312129, 0],
				[-1.1504725690417104, 0],
				[-0.7890675735312129, 0],
				[0.7559387822760755, 0],
				[3.0598956286553403, 0.3704401203982002],
				[5.393969557993842, 0.3704401203982002],
				[10.787939115987683, 0.7619621988678773],
				[14.636902318174293, 0.7619621988678773],
				[20.81692774140339, 1.1534842773375544],
				[25.060424730355578, 1.5269361060317124],
				[28.514854145776553, 1.9214698927973473],
				[31.60486685739113, 1.9214698927973473],
				[33.908823703770395, 1.9214698927973473],
				[36.99883641538497, 2.3129919712670244],
				[38.14930898442668, 2.3129919712670244],
				[39.69431534023397, 2.6864437999611823],
				[41.24233340433716, 2.6864437999611823],
				[41.63385548280684, 2.6864437999611823],
				[41.998272186613235, 2.6864437999611823],
				[41.63385548280684, 2.6864437999611823],
			],
			pressures: [
				0.0784313753247261, 0.07450980693101883, 0.1411764770746231, 0.26274511218070984,
				0.3176470696926117, 0.35686275362968445, 0.3803921639919281, 0.43529412150382996,
				0.4588235318660736, 0.47843137383461, 0.4901960790157318, 0.48627451062202454,
				0.47058823704719543, 0.47058823704719543, 0.4941176474094391, 0.501960813999176,
				0.5176470875740051, 0.5254902243614197, 0.5215686559677124, 0.48627451062202454,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [41.63385548280684, 2.6864437999611823],
		},
		{
			id: "hYn_r7c-HPlxYDnUn0NW0",
			type: "freedraw",
			x: 220.39857186794694,
			y: 213.03143610493998,
			width: 54.75888023642898,
			height: 8.104507024322459,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1380884947,
			version: 23,
			versionNonce: 1313576125,
			isDeleted: false,
			boundElements: null,
			updated: 1751811310315,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.7920792818271138, 0],
				[1.1534842773376113, 0],
				[3.090012711614577, 0],
				[5.7885033447594765, 0.3945337867656349],
				[9.63746654694603, 1.15950769392947],
				[15.820503678471084, 2.316003679562982],
				[20.064000667423272, 3.080977586726817],
				[25.457970225417114, 4.237473572360329],
				[29.303921719307766, 5.396981266289799],
				[33.152884921494376, 5.7885033447594765],
				[37.39638191044651, 6.161955173453634],
				[42.03140097786837, 6.5564889602192125],
				[44.335357824247694, 6.5564889602192125],
				[47.425370535862214, 6.944999330392989],
				[49.729327382241536, 7.318451159087147],
				[52.06038960328408, 7.709973237556824],
				[53.60539595909137, 7.709973237556824],
				[54.3643464496634, 7.709973237556824],
				[54.75888023642898, 7.709973237556824],
				[54.3643464496634, 7.709973237556824],
				[53.21387388062169, 8.104507024322459],
			],
			pressures: [
				0.0784313753247261, 0.14901961386203766, 0.16078431904315948, 0.19607843458652496,
				0.23137255012989044, 0.26274511218070984, 0.29019609093666077, 0.3019607961177826,
				0.3137255012989044, 0.3176470696926117, 0.33725491166114807, 0.3529411852359772,
				0.3607843220233917, 0.38823530077934265, 0.41960784792900085, 0.43921568989753723,
				0.4470588266849518, 0.45098039507865906, 0.45490196347236633, 0.45098039507865906,
				0.26274511218070984, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [53.21387388062169, 8.104507024322459],
		},
	],
	F: [
		{
			id: "sV_1vVNi8uCINzWgc0h0S",
			type: "freedraw",
			x: 219.64263308567087,
			y: 219.97643543533297,
			width: 1.9425518508687674,
			height: 79.3976658053557,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 631575005,
			version: 32,
			versionNonce: 1339468595,
			isDeleted: false,
			boundElements: null,
			updated: 1751811317776,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.39453378676557804, 0.7649739071638351],
				[-0.39453378676557804, 1.532959522623628],
				[-0.39453378676557804, 4.613937109350445],
				[0, 8.477958853016617],
				[0, 11.953470226509012],
				[0.3945337867656349, 16.19094379886934],
				[0.7559387822760755, 20.80186919992383],
				[0.7559387822760755, 25.433876559049793],
				[1.1504725690417104, 29.671350131410122],
				[1.1504725690417104, 34.30034578224013],
				[1.1504725690417104, 38.935364849661994],
				[1.1504725690417104, 43.17283842202232],
				[1.1504725690417104, 46.64834979551472],
				[1.1504725690417104, 50.49128958110947],
				[1.1504725690417104, 54.36133474136744],
				[1.1504725690417104, 58.207286235258096],
				[1.1504725690417104, 61.67978590045459],
				[1.1504725690417104, 65.52573739434524],
				[1.1504725690417104, 67.44720728714265],
				[1.1504725690417104, 70.92271866063504],
				[1.1504725690417104, 72.47073672473823],
				[1.1504725690417104, 75.55171431146505],
				[1.1504725690417104, 77.4731842042624],
				[1.1504725690417104, 78.63269189819187],
				[1.1504725690417104, 79.3976658053557],
				[1.1504725690417104, 79.02722568495744],
				[1.1504725690417104, 77.1027440838642],
				[1.1504725690417104, 75.55171431146505],
				[1.1504725690417104, 72.84418855343239],
				[1.5480180641031893, 71.7057628175744],
			],
			pressures: [
				0.0784313753247261, 0.250980406999588, 0.2862745225429535, 0.3294117748737335,
				0.3686274588108063, 0.38823530077934265, 0.40784314274787903, 0.4156862795352936,
				0.42352941632270813, 0.43529412150382996, 0.4431372582912445, 0.43921568989753723,
				0.4313725531101227, 0.4274509847164154, 0.42352941632270813, 0.42352941632270813,
				0.42352941632270813, 0.4156862795352936, 0.4117647111415863, 0.4117647111415863,
				0.4000000059604645, 0.3960784375667572, 0.3921568691730499, 0.3843137323856354,
				0.38823530077934265, 0.3843137323856354, 0.3450980484485626, 0.2823529541492462,
				0.2235294133424759, 0.07450980693101883, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [1.5480180641031893, 71.7057628175744],
		},
		{
			id: "kyqTKX9CkyjhaNqgSMW6-",
			type: "freedraw",
			x: 220.79310565471258,
			y: 218.42841737122978,
			width: 58.96924843412603,
			height: 1.532959522623628,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1409113565,
			version: 30,
			versionNonce: 1063600115,
			isDeleted: false,
			boundElements: null,
			updated: 1751811318759,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-1.1504725690417104, 0],
				[-1.1504725690417104, 0.3915220784696771],
				[-1.5450063558072884, 0.3915220784696771],
				[-1.1504725690417104, 0.3915220784696771],
				[0.7589504905719764, 0.3915220784696771],
				[3.0930244199104777, 0.3915220784696771],
				[6.544442127035495, 0.3915220784696771],
				[10.032000333711608, 0.3915220784696771],
				[14.275497322663796, 0.3915220784696771],
				[18.880399307126424, 0.3915220784696771],
				[25.454958517121156, -0.3945337867656349],
				[29.303921719307766, -0.7679856154597928],
				[32.39393443092234, -0.7679856154597928],
				[35.84836384634332, -0.7679856154597928],
				[38.54685447948816, -0.7679856154597928],
				[41.24233340433716, -0.3945337867656349],
				[42.78733976014445, 0],
				[44.726879902717315, 0],
				[47.03083674909658, 0.3915220784696771],
				[49.3347935954759, 0.3915220784696771],
				[51.665855816518444, 0.7649739071638351],
				[53.57527887613213, 0.7649739071638351],
				[55.514819018705055, 0.7649739071638351],
				[56.27376950927703, 0.7649739071638351],
				[56.66529158774671, 0.7649739071638351],
				[57.05982537451234, 0.7649739071638351],
				[57.42424207831874, 0.7649739071638351],
				[56.66529158774671, 0.7649739071638351],
			],
			pressures: [
				0.0784313753247261, 0.06666667014360428, 0.0941176488995552, 0.11764705926179886,
				0.29411765933036804, 0.34117648005485535, 0.3764705955982208, 0.3960784375667572,
				0.42352941632270813, 0.4431372582912445, 0.46666666865348816, 0.501960813999176,
				0.5176470875740051, 0.5254902243614197, 0.5411764979362488, 0.5607843399047852,
				0.5764706134796143, 0.5882353186607361, 0.5882353186607361, 0.5960784554481506,
				0.6039215922355652, 0.6078431606292725, 0.6078431606292725, 0.6039215922355652,
				0.6039215922355652, 0.5960784554481506, 0.5960784554481506, 0.4627451002597809, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [56.66529158774671, 0.7649739071638351],
		},
		{
			id: "ix2zt9vpYcHFH2dQD-bfc",
			type: "freedraw",
			x: 222.73565750558134,
			y: 260.8332701777923,
			width: 27.361369868439,
			height: 3.8459514938906523,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1545243933,
			version: 20,
			versionNonce: 2078500979,
			isDeleted: false,
			boundElements: null,
			updated: 1751811319641,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.7529270739801746, -0.3945337867656349],
				[0.7529270739801746, -0.7649739071638351],
				[1.5118775645522078, -0.7649739071638351],
				[2.3039568463793216, -1.15950769392947],
				[3.4514177071250742, -1.15950769392947],
				[5.393969557993898, -1.5480180641031893],
				[8.08944848284284, -1.5480180641031893],
				[11.543877898263815, -1.9214698927973473],
				[15.392841100450369, -1.9214698927973473],
				[18.87738759883058, -2.316003679562982],
				[21.575878231975423, -2.316003679562982],
				[23.51240666625239, -2.7075257580326593],
				[25.0303076473964, -2.7075257580326593],
				[26.21089729939729, -3.080977586726817],
				[26.966836081673364, -3.4755113734923953],
				[27.361369868439, -3.4755113734923953],
				[27.361369868439, -3.8459514938906523],
				[26.966836081673364, -3.8459514938906523],
			],
			pressures: [
				0.0784313753247261, 0.1568627506494522, 0.21568627655506134, 0.2705882489681244,
				0.33725491166114807, 0.38823530077934265, 0.43529412150382996, 0.4745098054409027,
				0.501960813999176, 0.5215686559677124, 0.545098066329956, 0.5490196347236633,
				0.5490196347236633, 0.5764706134796143, 0.5803921818733215, 0.5843137502670288,
				0.5803921818733215, 0.5607843399047852, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [26.966836081673364, -3.8459514938906523],
		},
	],
	G: [
		{
			id: "yZg_2FZjEX2bkp-odzwNe",
			type: "freedraw",
			x: 269.7634825463821,
			y: 219.5879250651592,
			width: 50.12084946071121,
			height: 82.49671364185804,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1175107923,
			version: 73,
			versionNonce: 2105191421,
			isDeleted: false,
			boundElements: null,
			updated: 1751811325483,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7890675735312129, -0.39453378676557804],
				[-1.5450063558072884, -1.159507693929413],
				[-2.6984906331448997, -1.554041480695048],
				[-4.635019067421865, -2.319015387858883],
				[-6.93897591380113, -2.71053746632856],
				[-10.028988625415707, -2.71053746632856],
				[-13.513535123795918, -2.71053746632856],
				[-16.967964539216837, -2.319015387858883],
				[-20.06098895912737, -1.554041480695048],
				[-21.60599531493466, -0.767985615459736],
				[-26.21089729939729, 1.5480180641032462],
				[-29.695443797777443, 3.8429397855947514],
				[-33.54440699996405, 6.550465543627411],
				[-35.8784809293025, 8.471935436424758],
				[-38.938376557957895, 11.94744680991721],
				[-41.272450487296396, 15.422958183409605],
				[-43.178861838614125, 18.503935770136422],
				[-45.12141368948295, 21.581901648567282],
				[-47.027825040800735, 25.451946808825312],
				[-48.572831396608024, 29.68640867288974],
				[-49.72631567394558, 33.535371875076294],
				[-50.12084946071121, 37.76983373914072],
				[-50.12084946071121, 42.01031901979695],
				[-50.12084946071121, 46.24779259215728],
				[-48.9703768916695, 50.48827787281351],
				[-47.425370535862214, 55.88525913910331],
				[-45.51594747624853, 59.752292591065384],
				[-42.817456843103685, 63.598244084956036],
				[-40.08884912699955, 66.3057698429887],
				[-37.39337020215061, 69.38373572141961],
				[-35.08941335577134, 72.09427318774817],
				[-31.999400644156765, 73.23269892360616],
				[-28.54497122873579, 74.39220661753563],
				[-25.060424730355635, 74.78071698770935],
				[-21.997517393404337, 75.17525077447499],
				[-18.512970895024125, 74.78071698770935],
				[-16.21202575694076, 73.62422100207584],
				[-12.727479258560606, 71.7027511092785],
				[-11.182472902753318, 70.54324341534902],
				[-6.93897591380113, 66.67922167168285],
				[-5.7885033447594765, 65.14927385735518],
				[-4.635019067421865, 61.67376248386279],
				[-4.243496988952188, 59.357758804299806],
				[-3.484546498380155, 55.12028523193948],
				[-3.484546498380155, 51.274333738048824],
				[-3.484546498380155, 48.95833005848584],
				[-3.484546498380155, 46.24779259215728],
				[-3.8790802851457897, 43.9317889125943],
				[-3.8790802851457897, 42.40485280656253],
				[-3.8790802851457897, 41.639878899398695],
				[-3.8790802851457897, 41.24534511263312],
				[-4.243496988952188, 41.639878899398695],
				[-4.243496988952188, 42.40485280656253],
				[-4.243496988952188, 45.09129660652377],
				[-4.635019067421865, 48.19335615132201],
				[-4.635019067421865, 50.48827787281351],
				[-4.635019067421865, 52.804281552376494],
				[-4.243496988952188, 57.43628891150246],
				[-3.8790802851457897, 61.28224040539311],
				[-3.484546498380155, 64.38128824189545],
				[-3.484546498380155, 67.46226582862221],
				[-3.090012711614577, 70.54324341534902],
				[-3.090012711614577, 72.859247094912],
				[-3.090012711614577, 74.78071698770935],
				[-3.090012711614577, 77.86169457443617],
				[-3.484546498380155, 79.02120226836564],
				[-3.484546498380155, 79.78617617552948],
				[-3.484546498380155, 79.41573605513122],
				[-3.484546498380155, 79.02120226836564],
				[-3.484546498380155, 78.6266684816],
				[-3.8790802851457897, 78.2562283612018],
			],
			pressures: [
				0.0784313753247261, 0.25882354378700256, 0.3333333432674408, 0.37254902720451355,
				0.4000000059604645, 0.4156862795352936, 0.40392157435417175, 0.3921568691730499,
				0.3803921639919281, 0.3764705955982208, 0.3764705955982208, 0.3764705955982208,
				0.3803921639919281, 0.3921568691730499, 0.4000000059604645, 0.4117647111415863,
				0.40784314274787903, 0.4117647111415863, 0.4117647111415863, 0.4117647111415863,
				0.4117647111415863, 0.4117647111415863, 0.4156862795352936, 0.4156862795352936,
				0.4156862795352936, 0.41960784792900085, 0.41960784792900085, 0.42352941632270813,
				0.43921568989753723, 0.4470588266849518, 0.4470588266849518, 0.4470588266849518,
				0.45098039507865906, 0.45490196347236633, 0.47843137383461, 0.48627451062202454,
				0.4901960790157318, 0.48235294222831726, 0.4745098054409027, 0.4745098054409027,
				0.4588235318660736, 0.4470588266849518, 0.40392157435417175, 0.3921568691730499,
				0.3529411852359772, 0.3294117748737335, 0.30980393290519714, 0.2980392277240753,
				0.2823529541492462, 0.2823529541492462, 0.2862745225429535, 0.2980392277240753,
				0.3333333432674408, 0.34117648005485535, 0.3764705955982208, 0.4000000059604645,
				0.41960784792900085, 0.43921568989753723, 0.45098039507865906,
				0.45098039507865906, 0.45490196347236633, 0.4588235318660736, 0.4588235318660736,
				0.45490196347236633, 0.4431372582912445, 0.4156862795352936, 0.38823530077934265,
				0.35686275362968445, 0.20000000298023224, 0.10980392247438431, 0, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-3.8790802851457897, 78.2562283612018],
		},
		{
			id: "ATfIIQ3XNe_MC8j2UPoAe",
			type: "freedraw",
			x: 248.55202101821305,
			y: 260.4387363910267,
			width: 34.697891277301665,
			height: 1.554041480695048,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1258986483,
			version: 26,
			versionNonce: 2065410493,
			isDeleted: false,
			boundElements: null,
			updated: 1751811326392,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.786055865235312, 0],
				[-1.1504725690417104, 0],
				[-0.786055865235312, 0],
				[0.39453378676557804, 0],
				[1.9395401425728664, 0],
				[4.243496988952188, 0],
				[6.152920048565818, 0],
				[8.483982269608418, 0],
				[11.182472902753318, 0.3945337867656349],
				[13.483418040836682, 0.3945337867656349],
				[15.422958183409548, 0.3945337867656349],
				[16.967964539216837, 0.3945337867656349],
				[19.666455172361736, 0.3945337867656349],
				[21.9674003104451, 0.3945337867656349],
				[24.271357156824365, 0.3945337867656349],
				[26.605431086162866, 0.3945337867656349],
				[27.755903655204577, 0.3945337867656349],
				[29.300910011011865, 1.15950769392947],
				[30.845916366819154, 1.554041480695048],
				[31.999400644156708, 1.554041480695048],
				[32.75533942643278, 1.554041480695048],
				[33.547418708259954, 1.554041480695048],
				[33.547418708259954, 1.15950769392947],
				[33.14987321319842, 1.15950769392947],
			],
			pressures: [
				0.0784313753247261, 0.05882352963089943, 0.1725490242242813, 0.2235294133424759,
				0.2823529541492462, 0.3333333432674408, 0.37254902720451355, 0.40784314274787903,
				0.4431372582912445, 0.48235294222831726, 0.5137255191802979, 0.5254902243614197,
				0.5333333611488342, 0.545098066329956, 0.5490196347236633, 0.5411764979362488,
				0.5411764979362488, 0.545098066329956, 0.5490196347236633, 0.5529412031173706,
				0.5607843399047852, 0.5607843399047852, 0.5411764979362488, 0.49803921580314636,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [33.14987321319842, 1.15950769392947],
		},
	],
	H: [
		{
			id: "12dVbD-P9a_VkZsyPHBlr",
			type: "freedraw",
			x: 230.03603841489297,
			y: 225.74385682202097,
			width: 1.9425518508688242,
			height: 74.413288575607,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1687242461,
			version: 33,
			versionNonce: 1449773011,
			isDeleted: false,
			boundElements: null,
			updated: 1751811330740,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, -1.1534842773375544],
				[0, -0.3704401203982002],
				[0, 0.7890675735312129],
				[0, 3.87004516025803],
				[0.3975454950615358, 6.556488960219269],
				[0.3975454950615358, 11.953470226509012],
				[0.7890675735312129, 15.034447813235829],
				[1.5480180641031893, 21.98245885192472],
				[1.5480180641031893, 25.45797022541717],
				[1.5480180641031893, 30.460417704941335],
				[1.5480180641031893, 32.77340967620836],
				[1.9425518508688242, 36.64044312817049],
				[1.9425518508688242, 40.48639462206114],
				[1.9425518508688242, 45.488842101585305],
				[1.9425518508688242, 48.199379567913866],
				[1.9425518508688242, 51.67489094140626],
				[1.5480180641031893, 54.75586852813308],
				[1.5480180641031893, 58.22535648503367],
				[1.5480180641031893, 60.14983808612692],
				[1.5480180641031893, 63.622337751323414],
				[1.5480180641031893, 65.15529727394704],
				[1.5480180641031893, 67.8628230319797],
				[1.1504725690417104, 69.78429292477705],
				[1.1504725690417104, 71.3353226971762],
				[1.1504725690417104, 72.86527051150387],
				[1.1504725690417104, 73.25980429826944],
				[1.1504725690417104, 72.47073672473823],
				[1.1504725690417104, 71.7057628175744],
				[1.1504725690417104, 70.94380061870652],
				[1.5480180641031893, 69.01931901761321],
				[1.5480180641031893, 68.62478523084758],
			],
			pressures: [
				0.0784313753247261, 0.10980392247438431, 0.20392157137393951, 0.21960784494876862,
				0.26274511218070984, 0.27843138575553894, 0.2980392277240753, 0.30980393290519714,
				0.30980393290519714, 0.3176470696926117, 0.32156863808631897, 0.32156863808631897,
				0.3137255012989044, 0.30980393290519714, 0.3019607961177826, 0.2980392277240753,
				0.29411765933036804, 0.29019609093666077, 0.29411765933036804,
				0.29019609093666077, 0.29019609093666077, 0.29019609093666077,
				0.27843138575553894, 0.27843138575553894, 0.2823529541492462, 0.2823529541492462,
				0.2705882489681244, 0.24705882370471954, 0.19607843458652496, 0.14901961386203766,
				0.0313725508749485, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [1.5480180641031893, 68.62478523084758],
		},
		{
			id: "XhzWkedW1GZcqjdzpzMyB",
			type: "freedraw",
			x: 273.21791196180305,
			y: 227.68942038118576,
			width: 1.5450063558072884,
			height: 65.52272568604928,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 750333757,
			version: 31,
			versionNonce: 1964407347,
			isDeleted: false,
			boundElements: null,
			updated: 1751811331895,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.3945337867656349, 0.7649739071638351],
				[-0.3945337867656349, 1.1354140275620352],
				[-0.3945337867656349, 3.0809775867267604],
				[-0.3945337867656349, 5.7674213866879995],
				[-0.7589504905720332, 9.242932760180395],
				[-1.1504725690417104, 13.480406332540724],
				[-1.1504725690417104, 17.350451492798754],
				[-1.1504725690417104, 20.80186919992377],
				[-1.1504725690417104, 24.665890943589943],
				[-1.1504725690417104, 28.141402317082395],
				[-1.1504725690417104, 32.378875889442725],
				[-1.1504725690417104, 35.83029359656774],
				[-0.7589504905720332, 39.305804970060194],
				[-0.3945337867656349, 42.77830463525669],
				[-0.3945337867656349, 46.64834979551466],
				[-0.7589504905720332, 49.72932738224148],
				[-0.7589504905720332, 52.41577118220272],
				[-0.7589504905720332, 54.73177486176564],
				[-0.7589504905720332, 56.27979292586889],
				[-0.7589504905720332, 58.20427452696214],
				[-0.7589504905720332, 59.734222341289865],
				[-0.3945337867656349, 61.282240405393054],
				[-0.3945337867656349, 62.44174809932247],
				[-0.3945337867656349, 63.60125579325194],
				[0, 64.36321799211987],
				[0, 64.75775177888545],
				[0, 65.13120360757961],
				[0.39453378676557804, 65.52272568604928],
				[0.39453378676557804, 65.52272568604928],
			],
			pressures: [
				0.0784313753247261, 0.19607843458652496, 0.21176470816135406, 0.250980406999588,
				0.29411765933036804, 0.3333333432674408, 0.3686274588108063, 0.3960784375667572,
				0.4156862795352936, 0.43529412150382996, 0.45490196347236633, 0.42352941632270813,
				0.3960784375667572, 0.35686275362968445, 0.34117648005485535, 0.3333333432674408,
				0.3294117748737335, 0.32156863808631897, 0.3137255012989044, 0.30588236451148987,
				0.2980392277240753, 0.2862745225429535, 0.29411765933036804, 0.2823529541492462,
				0.27450981736183167, 0.2549019753932953, 0.23137255012989044, 0.1882352977991104,
				0.04313725605607033, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [0.39453378676557804, 65.52272568604928],
		},
		{
			id: "DSkkpiLxrpjaou7ngBUZL",
			type: "freedraw",
			x: 232.37011234423147,
			y: 260.4387363910267,
			width: 44.696762819758135,
			height: 2.3129919712670244,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1122623197,
			version: 30,
			versionNonce: 1929432819,
			isDeleted: false,
			boundElements: null,
			updated: 1751811333037,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, -1.1534842773375544],
				[0.36441670380639835, -1.1534842773375544],
				[1.5148892728481087, -0.7649739071638351],
				[3.062907336951298, -0.3704401203982002],
				[6.152920048565875, 0],
				[10.001883250752428, 0],
				[13.486429749132583, 0],
				[16.18190867398158, 0],
				[18.485865520360846, 0],
				[20.816927741403447, 0],
				[23.51541837454829, 0],
				[26.21089729939729, -0.7649739071638351],
				[28.514854145776553, -0.7649739071638351],
				[30.454394288349476, -0.7649739071638351],
				[31.96928356119753, -0.7649739071638351],
				[33.51428991700482, -0.7649739071638351],
				[35.45383005957768, -0.7649739071638351],
				[36.60430262861939, -0.7649739071638351],
				[38.14930898442668, -1.1534842773375544],
				[39.69732704852987, -1.5269361060317124],
				[41.24233340433716, -1.5269361060317124],
				[41.63385548280684, -1.5269361060317124],
				[42.78733976014445, -1.9214698927973473],
				[43.54327854242052, -1.9214698927973473],
				[43.93781232918616, -1.9214698927973473],
				[44.33234611595174, -2.3129919712670244],
				[44.696762819758135, -2.3129919712670244],
				[44.696762819758135, -2.3129919712670244],
			],
			pressures: [
				0.0784313753247261, 0.14901961386203766, 0.27450981736183167, 0.3176470696926117,
				0.34117648005485535, 0.364705890417099, 0.38823530077934265, 0.3843137323856354,
				0.38823530077934265, 0.40392157435417175, 0.4156862795352936, 0.4274509847164154,
				0.4470588266849518, 0.4627451002597809, 0.48235294222831726, 0.4901960790157318,
				0.501960813999176, 0.5254902243614197, 0.529411792755127, 0.545098066329956,
				0.5647059082984924, 0.5764706134796143, 0.5764706134796143, 0.572549045085907,
				0.5411764979362488, 0.5098039507865906, 0.48627451062202454, 0.4588235318660736,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [44.696762819758135, -2.3129919712670244],
		},
	],
	I: [
		{
			id: "GzZb-Deq0Ka-C9yFr8xwi",
			type: "freedraw",
			x: 239.673504961839,
			y: 226.90336451595044,
			width: 1.9395401425729233,
			height: 64.77883373695693,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 191082451,
			version: 36,
			versionNonce: 1567499165,
			isDeleted: false,
			boundElements: null,
			updated: 1751811337997,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.3945337867656349, 0.786055865235312],
				[0.3945337867656349, 1.1564959856335122],
				[0.7890675735312129, 2.71053746632856],
				[0.7890675735312129, 5.791515053055377],
				[0.7890675735312129, 8.869480931486294],
				[1.1534842773376113, 11.580018397814854],
				[1.1534842773376113, 14.660995984541671],
				[1.5450063558072884, 17.74197357126843],
				[1.5450063558072884, 20.42841737122967],
				[1.5450063558072884, 23.903928744722066],
				[1.5450063558072884, 26.984906331448883],
				[1.5450063558072884, 29.300910011011865],
				[1.5450063558072884, 31.61390198227889],
				[1.5450063558072884, 33.92990566184187],
				[1.5450063558072884, 37.40541703533427],
				[1.5450063558072884, 39.72142071489725],
				[1.5450063558072884, 43.564360500492],
				[1.5450063558072884, 44.723868194421414],
				[1.5450063558072884, 47.80484578114823],
				[1.5450063558072884, 49.72631567394558],
				[1.5450063558072884, 52.04231935350856],
				[1.5450063558072884, 53.966800954601865],
				[1.5450063558072884, 55.90935280547063],
				[1.5450063558072884, 57.83383440656394],
				[1.5450063558072884, 58.99033039219745],
				[1.5450063558072884, 60.52027820652518],
				[1.5450063558072884, 61.67978590045459],
				[1.5450063558072884, 62.462830057393944],
				[1.5450063558072884, 63.22780396455778],
				[1.9395401425729233, 63.622337751323414],
				[1.9395401425729233, 63.99578958001757],
				[1.9395401425729233, 64.38731165848725],
				[1.9395401425729233, 64.77883373695693],
				[1.9395401425729233, 63.22780396455778],
			],
			pressures: [
				0.0784313753247261, 0.2078431397676468, 0.21176470816135406, 0.23529411852359772,
				0.26274511218070984, 0.27843138575553894, 0.27843138575553894,
				0.27450981736183167, 0.2549019753932953, 0.26274511218070984, 0.2666666805744171,
				0.27450981736183167, 0.27450981736183167, 0.27843138575553894,
				0.27843138575553894, 0.2862745225429535, 0.2862745225429535, 0.2823529541492462,
				0.27843138575553894, 0.27843138575553894, 0.27843138575553894, 0.2823529541492462,
				0.2862745225429535, 0.2862745225429535, 0.2862745225429535, 0.2862745225429535,
				0.2862745225429535, 0.29019609093666077, 0.29019609093666077, 0.29019609093666077,
				0.29019609093666077, 0.29019609093666077, 0.29411765933036804, 0.2980392277240753,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [1.9395401425729233, 63.22780396455778],
		},
	],
	J: [
		{
			id: "hFpSVV6wrBnMyqS6TpShn",
			type: "freedraw",
			x: 230.03603841489297,
			y: 220.7414093424968,
			width: 41.63385548280684,
			height: 1.5480180641032462,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 998825971,
			version: 29,
			versionNonce: 1004610931,
			isDeleted: false,
			boundElements: null,
			updated: 1751811341644,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-1.1504725690416535, 0],
				[0, 0],
				[1.5480180641031893, 0],
				[3.84896320218661, 0],
				[7.336521408862666, 0],
				[11.182472902753318, 0],
				[15.031436104939871, 0],
				[17.72992673808477, 0.3945337867656349],
				[20.819939449699348, 0.3945337867656349],
				[23.909952161313925, 0.3945337867656349],
				[26.9999648729285, 0.3945337867656349],
				[29.6984555060734, 0],
				[31.607878565687088, 0],
				[32.78846821768798, 0],
				[33.54440699996405, 0],
				[34.30335749053603, 0],
				[35.09242506406724, 0],
				[36.24289763310895, 0],
				[37.787903988916185, -0.3915220784696771],
				[38.54685447948822, -0.3915220784696771],
				[39.33291034472347, -0.3915220784696771],
				[39.72744413148911, -0.3915220784696771],
				[40.091860835295506, -0.3915220784696771],
				[40.091860835295506, -0.7649739071638351],
				[40.48338291376518, -0.7649739071638351],
				[40.48338291376518, -1.1534842773376113],
				[40.48338291376518, -1.1534842773376113],
			],
			pressures: [
				0.0784313753247261, 0.11764705926179886, 0.3333333432674408, 0.3803921639919281,
				0.40392157435417175, 0.4117647111415863, 0.41960784792900085, 0.40784314274787903,
				0.4000000059604645, 0.4117647111415863, 0.41960784792900085, 0.4274509847164154,
				0.4313725531101227, 0.4313725531101227, 0.43529412150382996, 0.4470588266849518,
				0.4588235318660736, 0.4745098054409027, 0.4745098054409027, 0.47843137383461,
				0.47843137383461, 0.46666666865348816, 0.4588235318660736, 0.43921568989753723,
				0.3921568691730499, 0.3294117748737335, 0.16470588743686676, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [40.48338291376518, -1.1534842773376113],
		},
		{
			id: "YewSYwFcI1abMu5hSWIar",
			type: "freedraw",
			x: 252.00645043363403,
			y: 221.5093949579566,
			width: 26.21390900769319,
			height: 61.28525211368901,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 2018471837,
			version: 45,
			versionNonce: 2091994771,
			isDeleted: false,
			boundElements: null,
			updated: 1751811342744,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.36441670380639835, -0.7679856154597928],
				[-0.36441670380639835, -1.15950769392947],
				[-0.36441670380639835, -1.532959522623628],
				[-0.7559387822760755, -1.532959522623628],
				[-0.7559387822760755, -0.37345182869415794],
				[-0.7559387822760755, 1.5480180641031893],
				[-0.7559387822760755, 3.8640217436661715],
				[-0.7559387822760755, 6.944999330392989],
				[0, 10.025976917119806],
				[0.39453378676557804, 13.501488290612201],
				[1.18058965200089, 16.973987955808695],
				[1.5450063558072884, 21.584913356863183],
				[2.3340739293384445, 25.451946808825255],
				[3.484546498380155, 30.062872209879743],
				[4.243496988952131, 33.16192004638208],
				[5.029552854187443, 37.00787154027273],
				[5.393969557993842, 40.87490499223486],
				[5.393969557993842, 43.56134879219604],
				[5.393969557993842, 46.2718862585246],
				[5.393969557993842, 48.56680798001611],
				[5.029552854187443, 51.6688675248144],
				[4.243496988952131, 53.96378924630591],
				[3.879080285145733, 56.27979292586889],
				[2.698490633144843, 57.83082269826798],
				[0.7890675735312129, 58.59579660543187],
				[-1.5148892728481087, 58.99033039219745],
				[-4.240485280656287, 59.36077051259571],
				[-6.544442127035552, 59.752292591065384],
				[-9.242932760180452, 59.752292591065384],
				[-11.938411685029394, 59.752292591065384],
				[-14.633890609878392, 59.36077051259571],
				[-17.332381243023292, 58.59579660543187],
				[-19.27192138559616, 57.4362889115024],
				[-20.42239395463787, 56.67432671263447],
				[-20.819939449699348, 55.12028523193942],
				[-20.819939449699348, 53.19881533914207],
				[-20.819939449699348, 50.51237153918089],
				[-20.819939449699348, 48.56680798001611],
				[-20.819939449699348, 47.03686016568844],
				[-20.42239395463787, 46.64232637892286],
				[-20.027860167872234, 46.2718862585246],
				[-18.87738759883058, 45.11539027289109],
				[-18.482853812064945, 44.72085648612551],
			],
			pressures: [
				0.0784313753247261, 0.09803921729326248, 0.13333334028720856, 0.18039216101169586,
				0.27843138575553894, 0.30588236451148987, 0.3294117748737335, 0.3529411852359772,
				0.3764705955982208, 0.3921568691730499, 0.40392157435417175, 0.40392157435417175,
				0.3960784375667572, 0.3921568691730499, 0.3843137323856354, 0.38823530077934265,
				0.38823530077934265, 0.3960784375667572, 0.4000000059604645, 0.40392157435417175,
				0.40392157435417175, 0.3960784375667572, 0.38823530077934265, 0.3843137323856354,
				0.3843137323856354, 0.3803921639919281, 0.3803921639919281, 0.38823530077934265,
				0.3921568691730499, 0.40392157435417175, 0.42352941632270813, 0.42352941632270813,
				0.4156862795352936, 0.4117647111415863, 0.3921568691730499, 0.3803921639919281,
				0.3607843220233917, 0.35686275362968445, 0.3529411852359772, 0.3450980484485626,
				0.3137255012989044, 0.23137255012989044, 0.05882352963089943, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-18.482853812064945, 44.72085648612551],
		},
	],
	K: [
		{
			id: "uGUTEzxWa8O8QcYCLWeMP",
			type: "freedraw",
			x: 230.82510598842418,
			y: 232.69487956900582,
			width: 0.7589504905719764,
			height: 60.51726649822922,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1395446643,
			version: 26,
			versionNonce: 1380002365,
			isDeleted: false,
			boundElements: null,
			updated: 1751811347029,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, -1.159507693929413],
				[0, -0.39453378676557804],
				[0, 1.1564959856335122],
				[0, 4.237473572360329],
				[0, 8.083425066250982],
				[0, 13.109966212142524],
				[0.36140499551049743, 17.73896186297253],
				[0.36140499551049743, 21.581901648567282],
				[0.36140499551049743, 26.216920715989147],
				[0.36140499551049743, 30.454394288349476],
				[0.36140499551049743, 33.92990566184187],
				[0.36140499551049743, 37.77284544743662],
				[0.36140499551049743, 41.642890607694596],
				[0.36140499551049743, 45.09430831481967],
				[0.36140499551049743, 47.80484578114823],
				[0.36140499551049743, 50.49128958110941],
				[0.36140499551049743, 53.19881533914207],
				[0.36140499551049743, 55.88827084739921],
				[0.36140499551049743, 58.204274526962195],
				[0.36140499551049743, 58.98731868390155],
				[0.36140499551049743, 59.357758804299806],
				[0.36140499551049743, 58.59579660543187],
				[0.36140499551049743, 55.88827084739921],
				[0.7589504905719764, 55.12329694023538],
			],
			pressures: [
				0.0784313753247261, 0.14901961386203766, 0.24705882370471954, 0.26274511218070984,
				0.2705882489681244, 0.29019609093666077, 0.30588236451148987, 0.3137255012989044,
				0.3176470696926117, 0.3176470696926117, 0.3176470696926117, 0.30980393290519714,
				0.30980393290519714, 0.30588236451148987, 0.30588236451148987,
				0.29411765933036804, 0.2862745225429535, 0.2862745225429535, 0.2823529541492462,
				0.2823529541492462, 0.27843138575553894, 0.25882354378700256, 0.20000000298023224,
				0.04313725605607033, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [0.7589504905719764, 55.12329694023538],
		},
		{
			id: "-py_YHmz9c0HZhZSMVfF6",
			type: "freedraw",
			x: 231.18651098393468,
			y: 267.7812812164812,
			width: 29.698455506073344,
			height: 32.3999578475142,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 556493235,
			version: 22,
			versionNonce: 1064205949,
			isDeleted: false,
			boundElements: null,
			updated: 1751811347937,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.39754549506147896, 0],
				[0.7920792818271138, -0.7860558652352552],
				[1.5480180641031893, -2.316003679562982],
				[2.6984906331448997, -4.261567238727707],
				[5.032564562483344, -6.5534772519233115],
				[7.336521408862666, -9.264014718251872],
				[9.64047825524193, -11.950458518213054],
				[12.366074263050109, -14.657984276245713],
				[14.275497322663796, -16.973987955808695],
				[16.215037465236662, -19.289991635371678],
				[18.12446052485035, -21.605995314934603],
				[20.45552274589295, -23.530476916027908],
				[23.154013379037792, -25.84648059559089],
				[25.454958517121213, -27.767950488388237],
				[27.39449865969408, -29.297898302715907],
				[28.153449150266056, -30.45439428834942],
				[28.939505015501368, -31.243461861880633],
				[29.303921719307766, -32.00843576904447],
				[29.698455506073344, -32.3999578475142],
				[29.698455506073344, -32.3999578475142],
			],
			pressures: [
				0.0784313753247261, 0.1882352977991104, 0.2078431397676468, 0.2549019753932953,
				0.2823529541492462, 0.30588236451148987, 0.30980393290519714, 0.3176470696926117,
				0.32156863808631897, 0.34117648005485535, 0.3607843220233917, 0.38823530077934265,
				0.38823530077934265, 0.38823530077934265, 0.3764705955982208, 0.364705890417099,
				0.3607843220233917, 0.3490196168422699, 0.3490196168422699, 0.3294117748737335, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [29.698455506073344, -32.3999578475142],
		},
		{
			id: "O5xb43TkcKkLbZyEANHd7",
			type: "freedraw",
			x: 231.9785902657618,
			y: 266.99522535124595,
			width: 27.361369868439,
			height: 32.378875889442725,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1713668467,
			version: 31,
			versionNonce: 1257969181,
			isDeleted: false,
			boundElements: null,
			updated: 1751811349054,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.3945337867656349, -0.7649739071638351],
				[1.1504725690416535, -2.316003679562982],
				[3.454429415420975, -4.240485280656287],
				[6.93897591380113, -5.767421386688056],
				[9.634454838650129, -6.9269290806174695],
				[12.724467550264649, -7.709973237556824],
				[15.787374887215947, -8.083425066250982],
				[17.723903321492912, -8.083425066250982],
				[19.27192138559616, -7.321462867383104],
				[20.422393954637812, -6.9269290806174695],
				[22.36193409721068, -6.161955173453634],
				[23.906940453017967, -5.002447479524221],
				[25.057413022059677, -3.080977586726817],
				[25.816363512631654, -1.15950769392947],
				[26.21089729939729, 1.1564959856335122],
				[26.602419377866966, 3.4724996651964943],
				[26.966836081673364, 6.1830371315250545],
				[26.966836081673364, 8.47795885301656],
				[26.966836081673364, 11.18849631934512],
				[26.966836081673364, 13.874940119306359],
				[26.966836081673364, 16.190943798869284],
				[26.966836081673364, 18.506947478432267],
				[26.966836081673364, 20.42841737122967],
				[26.966836081673364, 21.97643543533286],
				[26.966836081673364, 23.530476916027908],
				[26.966836081673364, 24.295450823191743],
				[26.966836081673364, 23.903928744722066],
				[26.966836081673364, 23.135943129262273],
				[26.602419377866966, 22.744421050792596],
			],
			pressures: [
				0.0784313753247261, 0.20000000298023224, 0.2549019753932953, 0.2705882489681244,
				0.29019609093666077, 0.29411765933036804, 0.29411765933036804,
				0.30588236451148987, 0.2980392277240753, 0.30980393290519714, 0.3137255012989044,
				0.3294117748737335, 0.3450980484485626, 0.35686275362968445, 0.364705890417099,
				0.3803921639919281, 0.38823530077934265, 0.3960784375667572, 0.40784314274787903,
				0.4156862795352936, 0.42352941632270813, 0.4274509847164154, 0.4274509847164154,
				0.43529412150382996, 0.4431372582912445, 0.45098039507865906, 0.4470588266849518,
				0.25882354378700256, 0.21176470816135406, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [26.602419377866966, 22.744421050792596],
		},
	],
	L: [
		{
			id: "4RfvmEcMF2AaqeJT7rTeN",
			type: "freedraw",
			x: 231.18651098393468,
			y: 225.74385682202097,
			width: 35.45383005957774,
			height: 58.60182002202373,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1050342771,
			version: 52,
			versionNonce: 1007932499,
			isDeleted: false,
			boundElements: null,
			updated: 1751811353302,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.36140499551049743, -0.7649739071638351],
				[-0.36140499551049743, 0],
				[-0.36140499551049743, 1.554041480695048],
				[0, 3.87004516025803],
				[0, 6.556488960219269],
				[0.39754549506147896, 10.028988625415764],
				[0.7920792818271138, 14.269473906071994],
				[0.7920792818271138, 18.506947478432323],
				[0.7920792818271138, 22.747432759088554],
				[0.7920792818271138, 26.219932424285048],
				[0.7920792818271138, 30.086965876247177],
				[0.7920792818271138, 33.54139529166815],
				[0.7920792818271138, 36.64044312817049],
				[0.7920792818271138, 38.935364849661994],
				[0.7920792818271138, 41.251368529224976],
				[0.7920792818271138, 43.5673722087879],
				[0.7920792818271138, 45.88337588835088],
				[0.7920792818271138, 48.199379567913866],
				[0.7920792818271138, 50.51538324747685],
				[1.183601360296791, 52.04533106180452],
				[1.183601360296791, 53.20182704743803],
				[1.5480180641031893, 54.3613347413675],
				[1.9425518508687674, 55.51783072700101],
				[2.3370856376344022, 56.28280463416485],
				[2.6984906331448997, 57.0688604994001],
				[3.0930244199104777, 57.44231232809426],
				[3.8820919934416906, 57.836846114859895],
				[5.032564562483344, 57.836846114859895],
				[6.941987622097031, 57.836846114859895],
				[8.881527764669954, 57.836846114859895],
				[11.577006689518896, 57.44231232809426],
				[13.880963535898161, 57.0688604994001],
				[16.215037465236662, 56.677338420930425],
				[18.12446052485035, 56.677338420930425],
				[19.669466880657637, 56.677338420930425],
				[21.60900702323056, 56.677338420930425],
				[23.51843008284419, 56.677338420930425],
				[25.454958517121213, 56.677338420930425],
				[27.002976581224402, 56.28280463416485],
				[28.54798293703169, 56.28280463416485],
				[29.698455506073344, 55.91236451376659],
				[30.848928075115055, 55.91236451376659],
				[32.002412352452666, 55.91236451376659],
				[32.78846821768792, 55.91236451376659],
				[33.547418708259954, 55.91236451376659],
				[33.94195249502553, 55.91236451376659],
				[34.33347457349521, 55.91236451376659],
				[34.69789127730161, 55.91236451376659],
				[35.09242506406724, 56.28280463416485],
				[34.69789127730161, 56.28280463416485],
			],
			pressures: [
				0.0784313753247261, 0.07450980693101883, 0.16470588743686676, 0.1882352977991104,
				0.21176470816135406, 0.23137255012989044, 0.24705882370471954,
				0.25882354378700256, 0.2705882489681244, 0.27843138575553894, 0.27843138575553894,
				0.2823529541492462, 0.27843138575553894, 0.27843138575553894, 0.27843138575553894,
				0.27843138575553894, 0.2823529541492462, 0.2823529541492462, 0.27450981736183167,
				0.2705882489681244, 0.2705882489681244, 0.2705882489681244, 0.2705882489681244,
				0.2705882489681244, 0.2705882489681244, 0.2666666805744171, 0.2666666805744171,
				0.2666666805744171, 0.3019607961177826, 0.33725491166114807, 0.37254902720451355,
				0.40392157435417175, 0.43529412150382996, 0.46666666865348816,
				0.48627451062202454, 0.5058823823928833, 0.5254902243614197, 0.5372549295425415,
				0.5529412031173706, 0.572549045085907, 0.5960784554481506, 0.615686297416687,
				0.6313725709915161, 0.6392157077789307, 0.6313725709915161, 0.6235294342041016,
				0.5960784554481506, 0.5843137502670288, 0.5529412031173706, 0.5137255191802979, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [34.69789127730161, 56.28280463416485],
		},
	],
	M: [
		{
			id: "obgvhKxJpreN9QSnEylJ8",
			type: "freedraw",
			x: 220.0371668724365,
			y: 298.2145935467592,
			width: 57.029708291553106,
			height: 92.13116848050811,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1777348915,
			version: 128,
			versionNonce: 860613309,
			isDeleted: false,
			boundElements: null,
			updated: 1751811380189,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, -1.1354140275620352],
				[0.3614049955104406, -2.2919100131956043],
				[0.3614049955104406, -3.8459514938906523],
				[0.7559387822760755, -5.7674213866879995],
				[1.1534842773375544, -8.083425066250982],
				[1.1534842773375544, -10.790950824283584],
				[1.1534842773375544, -13.085872545775146],
				[1.5148892728480519, -15.02842439664397],
				[1.5148892728480519, -17.714868196605153],
				[1.5148892728480519, -20.030871876168135],
				[1.5148892728480519, -23.111849462894952],
				[1.906411351317729, -26.192827049621712],
				[1.906411351317729, -28.138390608786494],
				[1.906411351317729, -31.98434210267709],
				[2.300945138083364, -35.06531968940391],
				[2.300945138083364, -37.775857155732524],
				[2.300945138083364, -40.462300955693706],
				[2.300945138083364, -43.54327854242052],
				[2.698490633144843, -46.25080430045318],
				[2.698490633144843, -49.32877017888404],
				[2.698490633144843, -52.0393076452126],
				[3.0598956286553403, -54.72575144517384],
				[3.0598956286553403, -58.571702939064494],
				[3.4514177071250174, -61.282240405393054],
				[3.4514177071250174, -63.992777871721614],
				[3.4514177071250174, -66.6792216716828],
				[3.848963202186553, -68.99522535124578],
				[3.848963202186553, -71.68166915120702],
				[3.848963202186553, -73.23571063190207],
				[4.210368197697051, -76.31367651033293],
				[4.210368197697051, -78.6266684816],
				[4.604901984462629, -80.94568386945889],
				[4.604901984462629, -83.26168754902181],
				[4.604901984462629, -84.78862365505358],
				[4.604901984462629, -86.73418721421831],
				[4.210368197697051, -87.8696012417804],
				[4.210368197697051, -88.65866881531161],
				[4.210368197697051, -89.42063101417955],
				[4.210368197697051, -90.18560492134338],
				[3.848963202186553, -90.58013870810896],
				[3.848963202186553, -90.18560492134338],
				[3.4514177071250174, -89.02910893570987],
				[3.4514177071250174, -87.8696012417804],
				[3.4514177071250174, -86.34266513574863],
				[3.848963202186553, -83.63513937771597],
				[4.604901984462629, -80.94568386945889],
				[5.393969557993842, -79.02120226836558],
				[6.9088588308418935, -75.54870260316909],
				[8.453865186649182, -72.84117684513643],
				[9.63746654694603, -70.15473304517525],
				[11.14934411149818, -67.83872936561227],
				[11.941423393325294, -65.91424776451896],
				[13.091895962366948, -63.2037102981904],
				[13.84783474464308, -61.67677419215863],
				[15.39585280874627, -59.73121063299391],
				[17.335392951319136, -58.20126281866624],
				[19.6363380894025, -56.65023304626709],
				[21.18134444520979, -55.49072535233768],
				[24.274368865120266, -54.334229366704164],
				[27.364381576734843, -53.174721672774695],
				[28.12032035901092, -52.80428155237644],
				[30.818810992155818, -52.80428155237644],
				[32.363817347963106, -52.80428155237644],
				[35.059296272812105, -53.174721672774695],
				[38.54384277119226, -54.72575144517384],
				[41.24233340433716, -56.65023304626709],
				[43.151756463950846, -58.571702939064494],
				[45.09129660652371, -60.51726649822922],
				[46.24176917556542, -62.04721431255689],
				[47.39224174460708, -63.992777871721614],
				[48.54572602194469, -66.28468788491722],
				[50.090732377751976, -69.76019925840961],
				[50.87678824298723, -71.31122903080876],
				[52.03027252032484, -73.99767283076994],
				[52.78621130260092, -76.31367651033293],
				[53.18074508936655, -77.4731842042624],
				[53.57527887613213, -79.78617617552942],
				[54.33121765840821, -82.1021798550924],
				[54.72575144517384, -83.26168754902181],
				[55.12028523193942, -84.41818353465538],
				[55.48470193574582, -85.18315744181922],
				[55.48470193574582, -86.34266513574863],
				[55.876224014215495, -87.49916112138214],
				[55.876224014215495, -88.65866881531161],
				[55.876224014215495, -89.02910893570987],
				[55.876224014215495, -88.26413502854604],
				[55.876224014215495, -87.49916112138214],
				[55.876224014215495, -86.34266513574863],
				[55.876224014215495, -84.02364974788975],
				[55.48470193574582, -80.55416179098921],
				[55.48470193574582, -77.86470628273207],
				[55.12028523193942, -73.23571063190207],
				[55.12028523193942, -69.38975913801141],
				[54.72575144517384, -67.07375545844843],
				[54.72575144517384, -63.598244084956036],
				[53.96680095460181, -59.73121063299391],
				[53.57527887613213, -55.885259139103255],
				[53.18074508936655, -53.174721672774695],
				[53.18074508936655, -49.72330396564968],
				[53.18074508936655, -46.25080430045318],
				[53.18074508936655, -43.169826713726366],
				[53.18074508936655, -40.08884912699955],
				[52.78621130260092, -35.83029359656774],
				[52.78621130260092, -32.378875889442725],
				[52.78621130260092, -29.668338423114164],
				[53.18074508936655, -26.981894623152925],
				[53.18074508936655, -23.876823370058787],
				[53.57527887613213, -20.79584578333197],
				[53.57527887613213, -18.479842103768988],
				[53.96680095460181, -15.02842439664397],
				[53.96680095460181, -13.085872545775146],
				[54.33121765840821, -11.164402652977799],
				[54.72575144517384, -9.242932760180395],
				[54.72575144517384, -6.923917372321512],
				[55.12028523193942, -5.7674213866879995],
				[55.48470193574582, -4.234461864064372],
				[55.48470193574582, -3.0809775867267604],
				[55.876224014215495, -2.2919100131956043],
				[55.876224014215495, -1.1354140275620352],
				[56.27075780098113, -0.7649739071638351],
				[56.27075780098113, 0],
				[56.66529158774671, 0.3945337867656349],
				[56.66529158774671, 1.15950769392947],
				[56.66529158774671, 1.551029772399147],
				[56.66529158774671, 1.15950769392947],
				[57.029708291553106, 1.15950769392947],
			],
			pressures: [
				0.0784313753247261, 0.14509804546833038, 0.15294118225574493, 0.16078431904315948,
				0.16470588743686676, 0.16862745583057404, 0.18039216101169586, 0.1882352977991104,
				0.19607843458652496, 0.20000000298023224, 0.20392157137393951, 0.2078431397676468,
				0.21960784494876862, 0.22745098173618317, 0.23137255012989044,
				0.23137255012989044, 0.23529411852359772, 0.239215686917305, 0.24705882370471954,
				0.2549019753932953, 0.25882354378700256, 0.25882354378700256, 0.2549019753932953,
				0.2549019753932953, 0.2549019753932953, 0.2549019753932953, 0.2549019753932953,
				0.2549019753932953, 0.2549019753932953, 0.2549019753932953, 0.24705882370471954,
				0.239215686917305, 0.23137255012989044, 0.22745098173618317, 0.2235294133424759,
				0.21960784494876862, 0.2235294133424759, 0.21568627655506134, 0.2078431397676468,
				0.20392157137393951, 0.2078431397676468, 0.2823529541492462, 0.30588236451148987,
				0.32156863808631897, 0.3450980484485626, 0.37254902720451355, 0.3960784375667572,
				0.4117647111415863, 0.4313725531101227, 0.4470588266849518, 0.4588235318660736,
				0.4627451002597809, 0.45490196347236633, 0.4588235318660736, 0.46666666865348816,
				0.4745098054409027, 0.47843137383461, 0.4901960790157318, 0.4941176474094391,
				0.501960813999176, 0.5058823823928833, 0.49803921580314636, 0.4941176474094391,
				0.4941176474094391, 0.5137255191802979, 0.5176470875740051, 0.5137255191802979,
				0.5058823823928833, 0.4941176474094391, 0.47843137383461, 0.4745098054409027,
				0.46666666865348816, 0.4470588266849518, 0.43921568989753723, 0.4274509847164154,
				0.41960784792900085, 0.40784314274787903, 0.40392157435417175, 0.3960784375667572,
				0.3843137323856354, 0.3764705955982208, 0.37254902720451355, 0.3607843220233917,
				0.3529411852359772, 0.3529411852359772, 0.3607843220233917, 0.3803921639919281,
				0.3803921639919281, 0.40392157435417175, 0.42352941632270813, 0.45098039507865906,
				0.45490196347236633, 0.4588235318660736, 0.45490196347236633, 0.4431372582912445,
				0.42352941632270813, 0.3960784375667572, 0.3686274588108063, 0.35686275362968445,
				0.3450980484485626, 0.34117648005485535, 0.3450980484485626, 0.34117648005485535,
				0.3529411852359772, 0.3529411852359772, 0.3450980484485626, 0.3450980484485626,
				0.3450980484485626, 0.3450980484485626, 0.3450980484485626, 0.34117648005485535,
				0.34117648005485535, 0.34117648005485535, 0.3529411852359772, 0.35686275362968445,
				0.35686275362968445, 0.3529411852359772, 0.3529411852359772, 0.3490196168422699,
				0.3490196168422699, 0.3529411852359772, 0.35686275362968445, 0.35686275362968445,
				0.3607843220233917, 0.33725491166114807, 0.05882352963089943, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [57.029708291553106, 1.15950769392947],
		},
	],
	N: [
		{
			id: "rQ5pVsokyBfYfiYz_EEXo",
			type: "freedraw",
			x: 213.4595959541458,
			y: 216.50694747843244,
			width: 1.1504725690416535,
			height: 77.4731842042624,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1307276371,
			version: 33,
			versionNonce: 490766845,
			isDeleted: false,
			boundElements: null,
			updated: 1751811392065,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7559387822760755, 0.3704401203982002],
				[-0.7559387822760755, 1.1534842773375544],
				[-0.7559387822760755, 3.0809775867267604],
				[-0.7559387822760755, 7.709973237556824],
				[-0.36441670380639835, 11.947446809917153],
				[0, 17.344428076206896],
				[0, 19.660431755769878],
				[0.39453378676557804, 24.662879235294042],
				[0.39453378676557804, 27.74385682202086],
				[0.39453378676557804, 31.98434210267709],
				[0.39453378676557804, 35.06531968940391],
				[0.39453378676557804, 37.38132336896689],
				[0.39453378676557804, 42.010319019796896],
				[0.39453378676557804, 44.720856486125456],
				[0, 48.958330058485785],
				[-0.36441670380639835, 52.0393076452126],
				[-0.36441670380639835, 54.72575144517384],
				[-0.36441670380639835, 57.83082269826798],
				[-0.36441670380639835, 59.752292591065384],
				[-0.36441670380639835, 63.22780396455778],
				[-0.36441670380639835, 65.14927385735513],
				[-0.36441670380639835, 68.23025144408194],
				[-0.36441670380639835, 70.15172133687929],
				[-0.36441670380639835, 72.0762029379726],
				[-0.36441670380639835, 74.01875478884142],
				[-0.36441670380639835, 75.54569089487319],
				[-0.36441670380639835, 76.31367651033293],
				[-0.36441670380639835, 77.09973237556824],
				[-0.36441670380639835, 77.4731842042624],
				[-0.36441670380639835, 75.54569089487319],
				[-0.36441670380639835, 74.39220661753558],
			],
			pressures: [
				0.0784313753247261, 0.16078431904315948, 0.20000000298023224, 0.22745098173618317,
				0.2549019753932953, 0.27450981736183167, 0.29411765933036804, 0.29411765933036804,
				0.30588236451148987, 0.3019607961177826, 0.30588236451148987, 0.30980393290519714,
				0.30980393290519714, 0.30588236451148987, 0.30980393290519714,
				0.30588236451148987, 0.3019607961177826, 0.2980392277240753, 0.2980392277240753,
				0.2980392277240753, 0.29411765933036804, 0.2980392277240753, 0.29411765933036804,
				0.29019609093666077, 0.2862745225429535, 0.2862745225429535, 0.2823529541492462,
				0.27450981736183167, 0.27450981736183167, 0.2705882489681244, 0.06666667014360428,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-0.36441670380639835, 74.39220661753558],
		},
		{
			id: "ts7DK58yuiWQQ6P-Hlcg4",
			type: "freedraw",
			x: 212.70365717186974,
			y: 216.50694747843244,
			width: 55.514819018705055,
			height: 82.49972535015394,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 835970547,
			version: 75,
			versionNonce: 863734323,
			isDeleted: false,
			boundElements: null,
			updated: 1751811393891,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7890675735312129, 0],
				[-0.7890675735312129, 0.3704401203982002],
				[0.7559387822760755, 3.0809775867267604],
				[2.300945138083364, 5.393969557993842],
				[4.24048528065623, 8.866469223190336],
				[6.93897591380113, 12.317886930315353],
				[9.634454838650129, 15.422958183409548],
				[11.938411685029394, 18.503935770136366],
				[13.880963535898218, 21.190379570097548],
				[15.425969891705506, 23.50638324966053],
				[18.121448816554448, 26.587360836387347],
				[19.666455172361736, 28.532924395552072],
				[22.364945805506636, 31.98434210267709],
				[24.274368865120323, 34.69487956900571],
				[25.81937522092761, 36.616349461803054],
				[28.514854145776553, 39.69732704852987],
				[29.668338423114164, 41.61879694132722],
				[32.75835113472874, 45.877352471759025],
				[33.15288492149432, 46.64232637892286],
				[34.69789127730161, 48.56379627172021],
				[36.607314336915294, 51.27433373804877],
				[38.15232069272258, 53.19881533914207],
				[39.30279326176429, 54.72575144517384],
				[41.24233340433716, 57.83082269826798],
				[43.181873546910026, 60.51726649822922],
				[44.696762819758135, 62.833270177792144],
				[46.636302962331, 65.51971397775338],
				[47.78677553137271, 67.07375545844843],
				[49.72631567394558, 69.76019925840961],
				[50.12084946071121, 70.54324341534897],
				[51.27132202975287, 72.0762029379726],
				[52.42480630709048, 73.23269892360611],
				[53.18074508936655, 74.01875478884142],
				[53.57527887613219, 74.39220661753558],
				[53.969812662897766, 74.39220661753558],
				[54.36133474136744, 74.39220661753558],
				[54.36133474136744, 74.01875478884142],
				[54.72575144517384, 73.23269892360611],
				[54.72575144517384, 72.0762029379726],
				[54.72575144517384, 69.76019925840961],
				[54.72575144517384, 67.46226582862221],
				[54.36133474136744, 59.35775880429975],
				[53.969812662897766, 55.12028523193942],
				[53.969812662897766, 52.40974776561086],
				[53.57527887613219, 48.17227419325053],
				[53.18074508936655, 44.720856486125456],
				[53.18074508936655, 41.24534511263306],
				[53.18074508936655, 39.69732704852987],
				[52.816328385560155, 35.84836384634326],
				[52.816328385560155, 32.7673862596165],
				[52.816328385560155, 29.297898302715907],
				[52.816328385560155, 26.21692071598909],
				[52.816328385560155, 23.900917036426108],
				[52.816328385560155, 21.190379570097548],
				[52.816328385560155, 18.503935770136366],
				[52.816328385560155, 15.793398303807805],
				[52.816328385560155, 13.106954503846566],
				[52.816328385560155, 10.396417037518006],
				[53.18074508936655, 8.083425066250982],
				[53.18074508936655, 6.158943465157677],
				[53.57527887613219, 3.8429397855946945],
				[53.57527887613219, 1.9214698927973473],
				[53.57527887613219, -0.3945337867656349],
				[53.969812662897766, -2.316003679562982],
				[53.969812662897766, -3.87004516025803],
				[54.36133474136744, -4.635019067421865],
				[54.36133474136744, -5.791515053055377],
				[54.36133474136744, -6.556488960219269],
				[54.72575144517384, -7.321462867383104],
				[54.72575144517384, -7.7129849458527815],
				[54.72575144517384, -8.10751873261836],
				[54.72575144517384, -6.951022746984847],
				[54.36133474136744, -6.556488960219269],
			],
			pressures: [
				0.0784313753247261, 0.06666667014360428, 0.21176470816135406, 0.24705882370471954,
				0.27450981736183167, 0.30980393290519714, 0.3333333432674408, 0.3490196168422699,
				0.3686274588108063, 0.37254902720451355, 0.3921568691730499, 0.40784314274787903,
				0.4156862795352936, 0.4274509847164154, 0.43921568989753723, 0.43921568989753723,
				0.45490196347236633, 0.4627451002597809, 0.47058823704719543, 0.4745098054409027,
				0.47843137383461, 0.47058823704719543, 0.4627451002597809, 0.4627451002597809,
				0.4627451002597809, 0.46666666865348816, 0.46666666865348816, 0.45098039507865906,
				0.45098039507865906, 0.45098039507865906, 0.4470588266849518, 0.4431372582912445,
				0.43529412150382996, 0.4274509847164154, 0.4274509847164154, 0.4156862795352936,
				0.3921568691730499, 0.38823530077934265, 0.38823530077934265, 0.38823530077934265,
				0.37254902720451355, 0.3607843220233917, 0.3490196168422699, 0.3529411852359772,
				0.3490196168422699, 0.3607843220233917, 0.364705890417099, 0.3686274588108063,
				0.364705890417099, 0.3686274588108063, 0.37254902720451355, 0.37254902720451355,
				0.37254902720451355, 0.3764705955982208, 0.3843137323856354, 0.3843137323856354,
				0.3843137323856354, 0.3843137323856354, 0.3843137323856354, 0.3843137323856354,
				0.3843137323856354, 0.3843137323856354, 0.3843137323856354, 0.3843137323856354,
				0.3843137323856354, 0.3843137323856354, 0.3843137323856354, 0.3843137323856354,
				0.3803921639919281, 0.3764705955982208, 0.37254902720451355, 0.364705890417099,
				0.13333334028720856, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [54.36133474136744, -6.556488960219269],
		},
	],
	O: [
		{
			id: "uht6slcPFNJAj7RPLK55r",
			type: "freedraw",
			x: 247.40154844917134,
			y: 211.4804063325409,
			width: 86.72515208933055,
			height: 74.78372869600526,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 3958675,
			version: 108,
			versionNonce: 691799411,
			isDeleted: false,
			boundElements: null,
			updated: 1751811403375,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7890675735312129, -0.370440120398257],
				[-0.7890675735312129, -0.7649739071638351],
				[-1.1534842773376113, -0.7649739071638351],
				[-2.3340739293385013, -0.7649739071638351],
				[-3.090012711614577, -0.7649739071638351],
				[-5.029552854187443, -0.370440120398257],
				[-7.333509700566708, 0.3915220784696771],
				[-10.423522412181285, 1.1564959856335122],
				[-13.87795182760226, 2.3160036795629253],
				[-17.365510034278373, 3.4724996651964943],
				[-19.666455172361736, 4.632007359125907],
				[-21.970412018741, 6.180025423229097],
				[-24.66589094359, 7.712984945852725],
				[-27.002976581224402, 9.261003009955914],
				[-29.303921719307766, 11.577006689518896],
				[-31.60787856568703, 13.893010369081878],
				[-33.547418708259954, 16.57945416904306],
				[-35.09242506406724, 19.28999163537162],
				[-36.242897633108896, 22.370969222098438],
				[-37.39638191044651, 25.451946808825255],
				[-38.54685447948816, 28.532924395552072],
				[-39.72744413148905, 32.399957847514145],
				[-40.88092840882666, 35.85137555463922],
				[-42.03140097786837, 39.326886928131614],
				[-42.79035146844035, 43.190908671797786],
				[-43.181873546910026, 46.64533808721876],
				[-43.181873546910026, 50.51237153918083],
				[-42.79035146844035, 53.19881533914207],
				[-41.63686719110274, 56.30087488394031],
				[-40.09186083529545, 59.752292591065384],
				[-38.18243777568176, 62.85736384415952],
				[-36.242897633108896, 65.54380764412076],
				[-34.30636919883193, 67.85981132368369],
				[-32.002412352452666, 69.38975913801141],
				[-29.303921719307766, 70.54625512364493],
				[-25.84949230388679, 71.70576281757434],
				[-21.60900702323056, 72.48880697451375],
				[-18.91051639008566, 72.86225880320791],
				[-14.272485614367895, 73.25679258997349],
				[-10.787939115987683, 73.64831466844316],
				[-6.574559209994732, 73.25679258997349],
				[-2.3340739293385013, 72.48880697451375],
				[1.5450063558072884, 71.70576281757434],
				[4.9994357712282635, 70.9407889104105],
				[8.848398973414817, 69.38975913801141],
				[13.483418040836682, 67.85981132368369],
				[16.17889696568568, 66.70331533805017],
				[18.87738759883058, 64.77883373695693],
				[22.361934097210735, 62.462830057393944],
				[25.81636351263171, 59.752292591065384],
				[28.906376224246287, 57.4362889115024],
				[31.210333070625552, 55.514819018705055],
				[32.75533942643284, 53.59033741761175],
				[34.30034578224013, 51.6688675248144],
				[35.84535213804742, 48.958330058485785],
				[36.99582470708907, 47.03686016568844],
				[38.938376557957895, 44.723868194421414],
				[40.091860835295506, 42.03441268616427],
				[41.24233340433716, 39.326886928131614],
				[41.998272186613235, 37.01088324856863],
				[42.78733976014445, 34.69487956900571],
				[43.18187354691008, 31.61390198227889],
				[43.18187354691008, 29.689420381185585],
				[43.54327854242052, 26.611454502754725],
				[43.54327854242052, 23.530476916027908],
				[43.54327854242052, 20.44949932930109],
				[43.18187354691008, 17.344428076206896],
				[41.998272186613235, 14.657984276245713],
				[40.453265830806004, 12.341980596682731],
				[38.54685447948822, 9.655536796721549],
				[36.60430262861939, 7.712984945852725],
				[34.30034578224013, 6.180025423229097],
				[32.360805639667205, 4.632007359125907],
				[30.451382580053576, 3.4724996651964943],
				[28.511842437480652, 1.9455635591647251],
				[26.602419377866966, 1.1564959856335122],
				[25.421829725866075, 0.3915220784696771],
				[24.271357156824422, 0],
				[22.361934097210735, 0],
				[20.816927741403447, -0.370440120398257],
				[19.27192138559616, -0.370440120398257],
				[17.72691502978887, -0.7649739071638351],
				[16.57343075245126, -0.7649739071638351],
				[15.422958183409605, -0.7649739071638351],
				[14.242368531408715, -0.7649739071638351],
				[12.724467550264706, -0.7649739071638351],
				[11.179461194457417, -0.7649739071638351],
				[9.634454838650129, -1.135414027562092],
				[8.08944848284284, -1.135414027562092],
				[6.93897591380113, -1.135414027562092],
				[5.393969557993898, -1.135414027562092],
				[4.240485280656287, -1.135414027562092],
				[2.6954789248489988, -0.7649739071638351],
				[1.5450063558072884, -0.7649739071638351],
				[0.7559387822760755, -0.7649739071638351],
				[-0.39453378676557804, -0.370440120398257],
				[-1.5450063558072884, -0.370440120398257],
				[-2.3340739293385013, 0],
				[-3.484546498380155, 0],
				[-4.243496988952131, 0.3915220784696771],
				[-5.393969557993842, 0.3915220784696771],
				[-6.574559209994732, 0.7860558652352552],
				[-7.333509700566708, 1.1564959856335122],
				[-7.728043487332343, 1.1564959856335122],
				[-7.728043487332343, 2.3160036795629253],
				[-7.333509700566708, 2.71053746632856],
			],
			pressures: [
				0.0784313753247261, 0.09019608050584793, 0.12941177189350128, 0.16078431904315948,
				0.20392157137393951, 0.2235294133424759, 0.250980406999588, 0.27450981736183167,
				0.29019609093666077, 0.30588236451148987, 0.3176470696926117, 0.32156863808631897,
				0.3333333432674408, 0.3529411852359772, 0.3607843220233917, 0.3686274588108063,
				0.3764705955982208, 0.3803921639919281, 0.3843137323856354, 0.3921568691730499,
				0.38823530077934265, 0.3921568691730499, 0.4000000059604645, 0.40392157435417175,
				0.4156862795352936, 0.41960784792900085, 0.41960784792900085, 0.4313725531101227,
				0.43529412150382996, 0.4470588266849518, 0.4588235318660736, 0.4627451002597809,
				0.4745098054409027, 0.48235294222831726, 0.501960813999176, 0.5137255191802979,
				0.5333333611488342, 0.5372549295425415, 0.545098066329956, 0.5490196347236633,
				0.5490196347236633, 0.5490196347236633, 0.5411764979362488, 0.5215686559677124,
				0.5137255191802979, 0.5098039507865906, 0.5058823823928833, 0.501960813999176,
				0.501960813999176, 0.501960813999176, 0.49803921580314636, 0.4941176474094391,
				0.4901960790157318, 0.4745098054409027, 0.47058823704719543, 0.46666666865348816,
				0.4627451002597809, 0.47058823704719543, 0.4745098054409027, 0.47058823704719543,
				0.4627451002597809, 0.4588235318660736, 0.4588235318660736, 0.4588235318660736,
				0.4588235318660736, 0.4431372582912445, 0.43529412150382996, 0.4313725531101227,
				0.43529412150382996, 0.45098039507865906, 0.45490196347236633,
				0.46666666865348816, 0.4745098054409027, 0.48235294222831726, 0.4901960790157318,
				0.5058823823928833, 0.5137255191802979, 0.5215686559677124, 0.529411792755127,
				0.5254902243614197, 0.5215686559677124, 0.5215686559677124, 0.5215686559677124,
				0.5215686559677124, 0.5215686559677124, 0.5176470875740051, 0.5137255191802979,
				0.5137255191802979, 0.5137255191802979, 0.5137255191802979, 0.5176470875740051,
				0.5137255191802979, 0.5098039507865906, 0.5098039507865906, 0.5098039507865906,
				0.5098039507865906, 0.501960813999176, 0.4941176474094391, 0.48627451062202454,
				0.4745098054409027, 0.47058823704719543, 0.4627451002597809, 0.4313725531101227,
				0.3764705955982208, 0.2862745225429535, 0.07450980693101883, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-7.333509700566708, 2.71053746632856],
		},
	],
	P: [
		{
			id: "z9ZD593fpU1dld-BX7vFG",
			type: "freedraw",
			x: 219.64263308567087,
			y: 214.19094379886945,
			width: 0.7890675735312129,
			height: 85.5776912285848,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1626109523,
			version: 39,
			versionNonce: 129334845,
			isDeleted: false,
			boundElements: null,
			updated: 1751811407574,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, -1.15950769392947],
				[-0.39453378676557804, -1.15950769392947],
				[-0.39453378676557804, -1.554041480695048],
				[-0.7890675735312129, -1.554041480695048],
				[-0.7890675735312129, -0.3945337867656349],
				[-0.7890675735312129, 2.316003679562982],
				[-0.7890675735312129, 6.158943465157677],
				[-0.7890675735312129, 10.787939115987683],
				[-0.7890675735312129, 15.793398303807805],
				[-0.7890675735312129, 20.425405662933713],
				[-0.7890675735312129, 25.057413022059677],
				[-0.7890675735312129, 29.689420381185585],
				[-0.7890675735312129, 33.92990566184187],
				[-0.7890675735312129, 37.772845447436566],
				[-0.7890675735312129, 41.639878899398695],
				[-0.7890675735312129, 45.09430831481967],
				[-0.7890675735312129, 48.56379627172021],
				[-0.7890675735312129, 51.644773858447024],
				[-0.7890675735312129, 54.72575144517384],
				[-0.7890675735312129, 57.83082269826804],
				[-0.7890675735312129, 60.51726649822922],
				[-0.7890675735312129, 63.22780396455778],
				[-0.7890675735312129, 65.91424776451902],
				[-0.7890675735312129, 67.07074375015253],
				[-0.7890675735312129, 70.54625512364493],
				[-0.7890675735312129, 72.46772501644227],
				[-0.7890675735312129, 74.39220661753558],
				[-0.7890675735312129, 75.94022468163877],
				[-0.7890675735312129, 77.49125445403791],
				[-0.7890675735312129, 79.02120226836558],
				[-0.7890675735312129, 80.57223204076473],
				[-0.7890675735312129, 82.1021798550924],
				[-0.7890675735312129, 83.65320962749155],
				[-0.7890675735312129, 84.02364974788975],
				[-0.7890675735312129, 82.88823572032771],
				[-0.7890675735312129, 78.62968018989591],
				[-0.39453378676557804, 77.09973237556824],
			],
			pressures: [
				0.0784313753247261, 0.06666667014360428, 0.09019608050584793, 0.11764705926179886,
				0.1725490242242813, 0.250980406999588, 0.2705882489681244, 0.2980392277240753,
				0.32156863808631897, 0.3333333432674408, 0.3529411852359772, 0.3686274588108063,
				0.3686274588108063, 0.364705890417099, 0.3686274588108063, 0.364705890417099,
				0.364705890417099, 0.3607843220233917, 0.3607843220233917, 0.35686275362968445,
				0.35686275362968445, 0.3529411852359772, 0.3529411852359772, 0.3490196168422699,
				0.3450980484485626, 0.34117648005485535, 0.3333333432674408, 0.3333333432674408,
				0.3333333432674408, 0.33725491166114807, 0.3333333432674408, 0.3333333432674408,
				0.32549020648002625, 0.3137255012989044, 0.2980392277240753, 0.20000000298023224,
				0.08627451211214066, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-0.39453378676557804, 77.09973237556824],
		},
		{
			id: "a_XNWp0MAtLNbaBWsoSK3",
			type: "freedraw",
			x: 219.2480992989053,
			y: 213.03143610493998,
			width: 62.453794932506185,
			height: 52.43384143197824,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1318639027,
			version: 66,
			versionNonce: 2062969597,
			isDeleted: false,
			boundElements: null,
			updated: 1751811409132,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-1.1504725690417104, 0],
				[-0.7589504905720332, -0.39453378676557804],
				[0.39453378676557804, -1.5510297723990902],
				[2.695478924848942, -3.080977586726817],
				[5.791515053055377, -4.632007359125907],
				[9.63746654694603, -6.161955173453578],
				[12.730490966856507, -6.94801103868889],
				[16.184920382277483, -7.712984945852725],
				[20.060988959127315, -7.712984945852725],
				[24.304485948079503, -8.083425066250982],
				[28.517865854072454, -8.47795885301656],
				[32.39393443092234, -8.47795885301656],
				[35.456841767873584, -8.083425066250982],
				[39.33291034472347, -7.318451159087147],
				[42.78733976014445, -6.5564889602192125],
				[45.48583039328935, -5.791515053055377],
				[47.81689261433189, -4.237473572360329],
				[50.120849460711156, -2.6864437999611823],
				[52.03027252032484, -1.5510297723990902],
				[54.75586852813302, 0.7649739071638351],
				[57.05982537451234, 3.080977586726817],
				[58.60483173031963, 5.396981266289799],
				[59.758316007657186, 8.477958853016617],
				[60.51425478993326, 11.185484611049276],
				[60.908788576698896, 14.266462197776036],
				[61.303322363464474, 17.344428076206952],
				[61.303322363464474, 20.054965542535513],
				[61.303322363464474, 22.741409342496752],
				[60.51425478993326, 25.060424730355635],
				[59.758316007657186, 28.138390608786494],
				[58.96924843412603, 30.457405996645377],
				[57.81877586508432, 32.77340967620836],
				[56.66529158774671, 34.30034578224013],
				[54.75586852813302, 36.24289763310895],
				[52.03027252032484, 37.775857155732524],
				[49.72631567394558, 39.32387521983571],
				[47.81689261433189, 39.69732704852987],
				[45.880364180054926, 40.091860835295506],
				[43.94082403748206, 40.48338291376518],
				[42.03140097786837, 41.24534511263312],
				[40.09186083529545, 41.639878899398695],
				[37.787903988916185, 41.639878899398695],
				[35.456841767873584, 42.01333072809285],
				[33.15288492149432, 42.01333072809285],
				[30.45439428834942, 42.799386593328165],
				[28.517865854072454, 43.17283842202232],
				[26.608442794458767, 43.17283842202232],
				[24.6689026518859, 43.564360500492],
				[22.759479592272214, 43.95588257896168],
				[18.515982603320026, 43.95588257896168],
				[17.365510034278373, 43.95588257896168],
				[15.031436104939871, 43.95588257896168],
				[13.122013045326185, 43.95588257896168],
				[10.787939115987683, 43.95588257896168],
				[9.63746654694603, 43.95588257896168],
				[7.697926404373106, 43.564360500492],
				[5.791515053055377, 43.17283842202232],
				[3.4875582066760558, 42.799386593328165],
				[1.9425518508687674, 42.799386593328165],
				[0.7890675735312129, 42.40485280656253],
				[0, 42.01333072809285],
				[0.39453378676557804, 42.01333072809285],
				[1.1504725690416535, 41.639878899398695],
				[1.9425518508687674, 41.24534511263312],
			],
			pressures: [
				0.0784313753247261, 0.0470588244497776, 0.1568627506494522, 0.19607843458652496,
				0.23137255012989044, 0.2666666805744171, 0.2862745225429535, 0.30588236451148987,
				0.32549020648002625, 0.3450980484485626, 0.3607843220233917, 0.3843137323856354,
				0.3960784375667572, 0.4117647111415863, 0.43529412150382996, 0.4470588266849518,
				0.4627451002597809, 0.47843137383461, 0.5058823823928833, 0.5137255191802979,
				0.5372549295425415, 0.5607843399047852, 0.5686274766921997, 0.5647059082984924,
				0.5607843399047852, 0.5607843399047852, 0.5607843399047852, 0.5686274766921997,
				0.5607843399047852, 0.5490196347236633, 0.5490196347236633, 0.5411764979362488,
				0.5333333611488342, 0.5333333611488342, 0.5254902243614197, 0.529411792755127,
				0.5333333611488342, 0.5372549295425415, 0.5333333611488342, 0.5333333611488342,
				0.5215686559677124, 0.5215686559677124, 0.5098039507865906, 0.5137255191802979,
				0.5215686559677124, 0.5098039507865906, 0.5098039507865906, 0.5137255191802979,
				0.5098039507865906, 0.501960813999176, 0.4941176474094391, 0.48627451062202454,
				0.48627451062202454, 0.48627451062202454, 0.48235294222831726,
				0.47058823704719543, 0.45098039507865906, 0.4313725531101227, 0.4156862795352936,
				0.40392157435417175, 0.37254902720451355, 0.3333333432674408, 0.16078431904315948,
				0.05882352963089943, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [1.9425518508687674, 41.24534511263312],
		},
	],
	Q: [
		{
			id: "TaAxCAbE7PrLGAXSBZo8A",
			type: "freedraw",
			x: 243.9170019507912,
			y: 212.6369023181744,
			width: 75.93721297334287,
			height: 82.8671537622563,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1069815443,
			version: 97,
			versionNonce: 1375859347,
			isDeleted: false,
			boundElements: null,
			updated: 1751811413788,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7589504905719764, -0.370440120398257],
				[-1.1534842773376113, -0.370440120398257],
				[-1.5450063558072884, -0.370440120398257],
				[-2.303956846379265, -0.370440120398257],
				[-3.090012711614577, -0.370440120398257],
				[-3.848963202186553, 0],
				[-5.393969557993842, 0.39453378676557804],
				[-6.93897591380113, 1.159507693929413],
				[-9.242932760180452, 2.71053746632856],
				[-11.546889606559716, 4.24048528065623],
				[-13.483418040836682, 5.791515053055377],
				[-15.787374887215947, 8.104507024322402],
				[-17.332381243023235, 10.028988625415707],
				[-18.877387598830524, 12.341980596682731],
				[-20.030871876168135, 14.266462197776036],
				[-22.364945805506636, 17.73896186297253],
				[-24.274368865120323, 20.819939449699348],
				[-25.427853142457934, 23.530476916027908],
				[-26.608442794458824, 27.005988289520303],
				[-27.3673932850308, 30.851939783410955],
				[-27.758915363500478, 34.32443944860745],
				[-27.758915363500478, 37.01088324856869],
				[-27.758915363500478, 41.25136852922492],
				[-27.3673932850308, 45.11539027289109],
				[-26.972859498265223, 48.19636785961791],
				[-26.21390900769319, 52.828375218743815],
				[-25.427853142457934, 55.90935280547063],
				[-24.274368865120323, 58.59579660543187],
				[-22.364945805506636, 62.07130797892427],
				[-20.42841737122967, 64.78184544525283],
				[-18.877387598830524, 66.70331533805017],
				[-16.970976247512795, 69.01931901761316],
				[-15.787374887215947, 70.54926683194083],
				[-13.483418040836682, 72.10029660433997],
				[-10.393405329222105, 74.02176649713732],
				[-7.303392617607528, 75.94624809823063],
				[-3.848963202186553, 77.10274408386414],
				[-1.1534842773376113, 77.88879994909945],
				[2.695478924848942, 78.26225177779361],
				[5.393969557993842, 79.04529593473296],
				[8.08944848284284, 79.41573605513122],
				[11.179461194457417, 79.41573605513122],
				[15.02842439664397, 79.41573605513122],
				[18.90750468178976, 78.26225177779361],
				[21.9674003104451, 77.10274408386414],
				[25.057413022059677, 75.57279626953647],
				[28.541959520439832, 73.63024441866764],
				[31.60486685739113, 71.7057628175744],
				[34.30034578224013, 69.78429292477699],
				[36.239885924812995, 68.2332631523779],
				[37.784892280620284, 66.3087815512846],
				[40.480371205469226, 63.22780396455778],
				[41.63385548280684, 61.30633407176043],
				[43.178861838614125, 58.99033039219745],
				[44.726879902717315, 55.1443788983068],
				[45.877352471759025, 52.04231935350856],
				[46.66642004529024, 48.590901646383486],
				[47.425370535862214, 45.48884210158525],
				[47.81689261433189, 42.03441268616427],
				[48.17829760984239, 39.71840900660129],
				[48.17829760984239, 35.48394714253692],
				[48.17829760984239, 32.4029695558101],
				[48.17829760984239, 28.141402317082395],
				[47.81689261433189, 24.689984609957378],
				[47.02782504080068, 21.97944714362876],
				[45.877352471759025, 18.898469556902],
				[43.57640733367566, 15.052518063011348],
				[41.63385548280684, 11.953470226509012],
				[40.08884912699955, 9.655536796721549],
				[38.18243777568182, 6.9510227469847905],
				[36.239885924812995, 4.24048528065623],
				[35.089413355771285, 3.1020595447982373],
				[33.541395291668096, 1.554041480695048],
				[31.24045015358473, 0.39453378676557804],
				[28.90637622424623, -0.7649739071638351],
				[26.21089729939729, -1.5269361060317692],
				[23.906940453017967, -2.2919100131956043],
				[22.361934097210735, -2.686443799961239],
				[20.057977250831414, -3.080977586726817],
				[18.512970895024125, -3.4514177071250742],
				[16.20901404864486, -3.4514177071250742],
				[14.272485614367895, -3.4514177071250742],
				[11.968528767988573, -3.4514177071250742],
				[9.27003813484373, -3.4514177071250742],
				[8.483982269608418, -3.4514177071250742],
				[5.785491636463519, -2.686443799961239],
				[3.848963202186553, -2.2919100131956043],
				[1.9395401425728664, -1.1564959856335122],
				[-0.7589504905719764, 0],
				[-3.090012711614577, 1.159507693929413],
				[-4.9994357712282635, 2.316003679562982],
				[-7.303392617607528, 3.1020595447982373],
				[-8.848398973414817, 4.632007359125907],
				[-10.032000333711608, 6.9510227469847905],
				[-10.393405329222105, 8.104507024322402],
			],
			pressures: [
				0.0784313753247261, 0.0784313753247261, 0.0784313753247261, 0.13333334028720856,
				0.1725490242242813, 0.20392157137393951, 0.22745098173618317, 0.250980406999588,
				0.27450981736183167, 0.2862745225429535, 0.3019607961177826, 0.3137255012989044,
				0.32156863808631897, 0.32156863808631897, 0.3137255012989044, 0.3137255012989044,
				0.3176470696926117, 0.32156863808631897, 0.3333333432674408, 0.3450980484485626,
				0.35686275362968445, 0.3529411852359772, 0.3607843220233917, 0.3686274588108063,
				0.3686274588108063, 0.3764705955982208, 0.3843137323856354, 0.40392157435417175,
				0.4000000059604645, 0.4117647111415863, 0.4117647111415863, 0.4156862795352936,
				0.41960784792900085, 0.42352941632270813, 0.4274509847164154, 0.45098039507865906,
				0.46666666865348816, 0.47843137383461, 0.4901960790157318, 0.5058823823928833,
				0.5254902243614197, 0.5411764979362488, 0.545098066329956, 0.5490196347236633,
				0.5490196347236633, 0.5215686559677124, 0.5137255191802979, 0.5176470875740051,
				0.5137255191802979, 0.5137255191802979, 0.5333333611488342, 0.5372549295425415,
				0.5176470875740051, 0.5137255191802979, 0.5254902243614197, 0.529411792755127,
				0.5098039507865906, 0.49803921580314636, 0.4941176474094391, 0.4941176474094391,
				0.4941176474094391, 0.47843137383461, 0.46666666865348816, 0.45098039507865906,
				0.43921568989753723, 0.43921568989753723, 0.43921568989753723, 0.4431372582912445,
				0.43529412150382996, 0.43921568989753723, 0.43921568989753723, 0.4470588266849518,
				0.45098039507865906, 0.4588235318660736, 0.47058823704719543, 0.4745098054409027,
				0.47843137383461, 0.48235294222831726, 0.47843137383461, 0.4745098054409027,
				0.47058823704719543, 0.4627451002597809, 0.45490196347236633, 0.45098039507865906,
				0.43529412150382996, 0.4313725531101227, 0.41960784792900085, 0.4117647111415863,
				0.40392157435417175, 0.3921568691730499, 0.3843137323856354, 0.364705890417099,
				0.32549020648002625, 0.2235294133424759, 0.09803921729326248, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-10.393405329222105, 8.104507024322402],
		},
		{
			id: "6qb2CPSRB81XQsUIqpCG3",
			type: "freedraw",
			x: 257.79495377839345,
			y: 272.3922066175357,
			width: 32.78846821768798,
			height: 26.611454502754725,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1366288509,
			version: 30,
			versionNonce: 1123245907,
			isDeleted: false,
			boundElements: null,
			updated: 1751811414977,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.3945337867656349, -1.159507693929413],
				[0.786055865235312, -1.159507693929413],
				[1.9395401425729233, -1.159507693929413],
				[4.240485280656287, -0.7649739071638351],
				[6.938975913801187, 0.786055865235312],
				[8.08944848284284, 1.551029772399147],
				[10.423522412181342, 3.867033451962129],
				[11.179461194457417, 5.396981266289799],
				[12.332945471795028, 7.3425448254545245],
				[13.119001337030284, 8.869480931486294],
				[13.483418040836682, 10.420510703885384],
				[13.877951827602317, 11.950458518213111],
				[13.877951827602317, 13.874940119306359],
				[14.272485614367895, 15.425969891705506],
				[14.664007692837572, 16.973987955808695],
				[15.817491970175183, 18.898469556902],
				[16.20901404864486, 20.054965542535513],
				[17.72691502978887, 21.58792506515914],
				[18.90750468178976, 22.741409342496752],
				[20.42239395463787, 23.900917036426165],
				[22.361934097210735, 24.686972901661477],
				[24.30448594807956, 25.057413022059677],
				[26.9999648729285, 25.451946808825312],
				[28.54497122873579, 25.057413022059677],
				[30.451382580053576, 24.2954508231918],
				[31.60486685739113, 23.530476916027908],
				[32.39393443092234, 22.370969222098495],
				[32.78846821768798, 21.97643543533286],
			],
			pressures: [
				0.0784313753247261, 0.15294118225574493, 0.16078431904315948, 0.18431372940540314,
				0.21176470816135406, 0.23137255012989044, 0.24705882370471954,
				0.26274511218070984, 0.25882354378700256, 0.2666666805744171, 0.27450981736183167,
				0.2823529541492462, 0.29411765933036804, 0.3019607961177826, 0.30588236451148987,
				0.30980393290519714, 0.3137255012989044, 0.3137255012989044, 0.32549020648002625,
				0.3333333432674408, 0.3450980484485626, 0.35686275362968445, 0.3607843220233917,
				0.3607843220233917, 0.35686275362968445, 0.3450980484485626, 0.3294117748737335,
				0.1411764770746231, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [32.78846821768798, 21.97643543533286],
		},
	],
	R: [
		{
			id: "O1qVjqQv5Ryj2IXrMF72K",
			type: "freedraw",
			x: 218.85356551213965,
			y: 208.02898862541582,
			width: 1.5450063558072884,
			height: 89.05019089378135,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1144635421,
			version: 32,
			versionNonce: 1796705213,
			isDeleted: false,
			boundElements: null,
			updated: 1751811418777,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, 0.370440120398257],
				[0, 1.9214698927973473],
				[0, 3.4514177071250742],
				[0, 7.709973237556824],
				[0, 11.947446809917153],
				[0, 14.263450489480135],
				[0.3945337867656349, 21.190379570097605],
				[0.3945337867656349, 25.822386929223512],
				[0.3945337867656349, 30.824834408747677],
				[0.3945337867656349, 34.30034578224013],
				[0.3945337867656349, 38.932353141366036],
				[0, 43.54327854242052],
				[0, 47.407300286086695],
				[0, 51.644773858447024],
				[0, 55.88525913910331],
				[0, 60.51726649822922],
				[-0.36441670380639835, 64.7577517788855],
				[-0.36441670380639835, 68.99522535124584],
				[-0.36441670380639835, 72.47073672473823],
				[-0.36441670380639835, 75.94022468163882],
				[-0.36441670380639835, 79.02120226836558],
				[-0.36441670380639835, 82.1021798550924],
				[-0.7559387822760755, 84.79163536334954],
				[-0.7559387822760755, 86.73418721421837],
				[-0.7559387822760755, 87.4991611213822],
				[-1.1504725690416535, 88.26413502854604],
				[-1.1504725690416535, 89.05019089378135],
				[-1.1504725690416535, 88.65866881531167],
				[-1.1504725690416535, 84.79163536334954],
				[-1.1504725690416535, 83.65320962749155],
			],
			pressures: [
				0.0784313753247261, 0.1921568661928177, 0.2235294133424759, 0.24705882370471954,
				0.27450981736183167, 0.3019607961177826, 0.30588236451148987, 0.34117648005485535,
				0.3490196168422699, 0.35686275362968445, 0.35686275362968445, 0.364705890417099,
				0.35686275362968445, 0.35686275362968445, 0.3686274588108063, 0.37254902720451355,
				0.3764705955982208, 0.3843137323856354, 0.3803921639919281, 0.37254902720451355,
				0.3529411852359772, 0.3490196168422699, 0.3490196168422699, 0.3529411852359772,
				0.3450980484485626, 0.33725491166114807, 0.3176470696926117, 0.30588236451148987,
				0.1725490242242813, 0.05098039284348488, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-1.1504725690416535, 83.65320962749155],
		},
		{
			id: "uJ0PzbmcGfOseVnk5_sGC",
			type: "freedraw",
			x: 218.48914880833325,
			y: 210.3449923049788,
			width: 66.69428021316241,
			height: 91.34511261527285,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 989007923,
			version: 91,
			versionNonce: 124959197,
			isDeleted: false,
			boundElements: null,
			updated: 1751811420744,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7860558652352552, -0.7890675735312129],
				[-0.7860558652352552, -1.15950769392947],
				[-0.7860558652352552, -1.551029772399147],
				[0.36441670380639835, -2.316003679562982],
				[2.3039568463793216, -3.4755113734923953],
				[6.550465543627411, -5.026541145891542],
				[10.396417037518063, -5.791515053055377],
				[13.880963535898218, -6.186048839821012],
				[18.124460524850406, -6.5564889602192125],
				[21.97342372703696, -6.5564889602192125],
				[25.427853142457934, -6.186048839821012],
				[30.0628722098798, -5.791515053055377],
				[33.152884921494376, -5.026541145891542],
				[36.21579225844562, -3.87004516025803],
				[39.70033875682583, -3.105071253094195],
				[42.39581768167477, -2.316003679562982],
				[44.335357824247694, -1.15950769392947],
				[46.63931467062696, 0.370440120398257],
				[47.78978723966867, 1.9214698927973473],
				[49.729327382241536, 3.8459514938906523],
				[51.274333738048824, 5.7674213866879995],
				[52.789223010896876, 7.688891279485347],
				[54.334229366704164, 10.004894959048329],
				[55.87923572251145, 12.320898638611311],
				[57.42424207831874, 14.245380239704616],
				[58.57772635565635, 16.95290599773722],
				[59.363782220891665, 19.2689096773002],
				[60.12273271146364, 21.584913356863183],
				[60.51726649822922, 24.271357156824365],
				[60.51726649822922, 26.981894623152982],
				[59.72819892469806, 29.668338423114164],
				[58.213309651849954, 32.74931600984098],
				[57.032719999849064, 35.065319689403964],
				[53.969812662897766, 37.775857155732524],
				[51.274333738048824, 39.69732704852987],
				[47.78978723966867, 41.61879694132722],
				[44.69977452805409, 42.77830463525669],
				[41.636867191102795, 44.32632269935988],
				[38.54685447948822, 45.09129660652371],
				[37.00184812368093, 45.48583039328935],
				[33.91183541206635, 46.25080430045318],
				[31.607878565687088, 47.01276649932112],
				[29.668338423114164, 47.407300286086695],
				[27.3673932850308, 48.17227419325053],
				[24.668902651885958, 48.566807980016165],
				[22.337840430843357, 48.94025980871032],
				[20.42841737122967, 48.94025980871032],
				[18.124460524850406, 48.94025980871032],
				[16.184920382277483, 48.94025980871032],
				[14.639914026470194, 48.94025980871032],
				[13.48944145742854, 48.94025980871032],
				[12.697362175601427, 48.94025980871032],
				[12.33595718009093, 48.94025980871032],
				[12.697362175601427, 48.94025980871032],
				[13.094907670662906, 48.94025980871032],
				[13.880963535898218, 48.94025980871032],
				[16.579454169043117, 48.94025980871032],
				[19.639349797698458, 48.94025980871032],
				[23.518430082844247, 48.94025980871032],
				[27.3673932850308, 48.94025980871032],
				[30.821822700451776, 48.94025980871032],
				[33.152884921494376, 49.72330396564968],
				[35.06230798110806, 50.09374408604788],
				[37.39638191044651, 50.88281165957909],
				[39.305804970060194, 51.647785566742925],
				[40.456277539101904, 52.40974776561086],
				[42.39581768167477, 53.56925545954033],
				[43.94082403748206, 54.72575144517384],
				[45.48583039328935, 55.88525913910331],
				[46.24478088386138, 57.044766833032725],
				[47.395253452903034, 58.20126281866624],
				[48.94025980871032, 59.73121063299391],
				[51.274333738048824, 62.441748099322524],
				[52.0302725203249, 63.2037102981904],
				[53.57829058442809, 65.51971397775338],
				[55.514819018705055, 67.83872936561227],
				[56.668303296042666, 69.76019925840967],
				[57.818775865084376, 71.31122903080876],
				[58.96924843412603, 73.23571063190207],
				[60.12273271146364, 75.15718052469941],
				[61.273205280505294, 77.4731842042624],
				[62.06227285403651, 79.39465409705974],
				[63.21274542307822, 81.33720594792857],
				[64.36321799211987, 82.86715376225624],
				[65.15529727394704, 84.02364974788975],
				[65.51670226945748, 84.78862365505364],
				[65.90822434792716, 84.78862365505364],
				[65.15529727394704, 84.02364974788975],
				[64.7577517788855, 83.63513937771603],
			],
			pressures: [
				0.0784313753247261, 0.07058823853731155, 0.125490203499794, 0.1764705926179886,
				0.21960784494876862, 0.2549019753932953, 0.29411765933036804, 0.30980393290519714,
				0.32156863808631897, 0.32549020648002625, 0.32549020648002625, 0.3529411852359772,
				0.3803921639919281, 0.3843137323856354, 0.4000000059604645, 0.4156862795352936,
				0.42352941632270813, 0.4431372582912445, 0.4745098054409027, 0.47058823704719543,
				0.4745098054409027, 0.48627451062202454, 0.4941176474094391, 0.49803921580314636,
				0.49803921580314636, 0.501960813999176, 0.5098039507865906, 0.529411792755127,
				0.5411764979362488, 0.5568627715110779, 0.5607843399047852, 0.5568627715110779,
				0.5568627715110779, 0.5529412031173706, 0.5411764979362488, 0.5176470875740051,
				0.501960813999176, 0.49803921580314636, 0.4901960790157318, 0.47843137383461,
				0.46666666865348816, 0.4470588266849518, 0.43529412150382996, 0.41960784792900085,
				0.3960784375667572, 0.37254902720451355, 0.3686274588108063, 0.3529411852359772,
				0.3529411852359772, 0.3490196168422699, 0.34117648005485535, 0.34117648005485535,
				0.3450980484485626, 0.35686275362968445, 0.364705890417099, 0.3764705955982208,
				0.38823530077934265, 0.4313725531101227, 0.45490196347236633, 0.49803921580314636,
				0.5176470875740051, 0.529411792755127, 0.5490196347236633, 0.572549045085907,
				0.5843137502670288, 0.6000000238418579, 0.615686297416687, 0.6117647290229797,
				0.6039215922355652, 0.6000000238418579, 0.5921568870544434, 0.5960784554481506,
				0.5843137502670288, 0.5960784554481506, 0.5960784554481506, 0.5960784554481506,
				0.5960784554481506, 0.5960784554481506, 0.5960784554481506, 0.6078431606292725,
				0.6078431606292725, 0.6039215922355652, 0.5960784554481506, 0.5921568870544434,
				0.5921568870544434, 0.5882353186607361, 0.5843137502670288, 0.5607843399047852,
				0.1921568661928177, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [64.7577517788855, 83.63513937771603],
		},
	],
	S: [
		{
			id: "MAeDVj6OY5dh5uUhUeMjJ",
			type: "freedraw",
			x: 265.8844022612363,
			y: 214.19094379886945,
			width: 62.05926114574055,
			height: 82.8671537622563,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 719993011,
			version: 90,
			versionNonce: 243208445,
			isDeleted: false,
			boundElements: null,
			updated: 1751811434600,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.36441670380639835, -0.7649739071638351],
				[-0.36441670380639835, -1.15950769392947],
				[-1.1504725690416535, -1.15950769392947],
				[-2.303956846379265, -1.554041480695048],
				[-5.393969557993842, -2.319015387858883],
				[-9.242932760180395, -3.080977586726817],
				[-12.332945471794972, -3.8459514938906523],
				[-16.937847456257657, -4.635019067421865],
				[-20.027860167872234, -5.005459187820122],
				[-22.726350801017077, -5.005459187820122],
				[-24.66589094359, -5.005459187820122],
				[-27.755903655204577, -4.240485280656287],
				[-29.27079292805263, -3.8459514938906523],
				[-33.14987321319842, -2.319015387858883],
				[-35.45081835128178, -0.7649739071638351],
				[-37.39337020215061, 0.7619621988679341],
				[-40.091860835295506, 2.316003679562982],
				[-42.78733976014445, 4.237473572360329],
				[-45.48583039328935, 6.158943465157677],
				[-47.78677553137271, 7.709973237556824],
				[-50.48526616451761, 10.787939115987683],
				[-53.18074508936655, 15.422958183409548],
				[-53.969812662897766, 17.344428076206952],
				[-55.12028523193942, 20.425405662933713],
				[-55.12028523193942, 23.50638324966053],
				[-55.12028523193942, 25.451946808825255],
				[-53.57527887613219, 28.532924395552072],
				[-51.635738733559265, 31.21936819551331],
				[-50.090732377751976, 32.7703979679124],
				[-47.030836749096636, 34.69487956900571],
				[-45.09129660652371, 35.45684176787364],
				[-41.24233340433716, 36.616349461803054],
				[-38.14930898442668, 36.616349461803054],
				[-35.84836384634332, 36.616349461803054],
				[-32.360805639667205, 36.242897633108896],
				[-29.27079292805263, 36.242897633108896],
				[-26.21089729939729, 36.242897633108896],
				[-23.12088458778271, 36.242897633108896],
				[-20.816927741403447, 36.242897633108896],
				[-16.937847456257657, 36.242897633108896],
				[-14.242368531408658, 36.242897633108896],
				[-11.179461194457417, 36.616349461803054],
				[-8.483982269608418, 37.772845447436566],
				[-6.149908340269917, 38.5378193546004],
				[-4.24048528065623, 39.32387521983571],
				[-2.303956846379265, 40.480371205469226],
				[-0.7559387822760755, 41.639878899398695],
				[0.7890675735312129, 43.56134879219604],
				[1.9395401425728664, 45.48281868499339],
				[3.484546498380155, 47.80183407285227],
				[4.243496988952188, 49.32877017888404],
				[4.635019067421865, 50.117837752415255],
				[6.1830371315250545, 55.12028523193942],
				[6.93897591380113, 57.83082269826804],
				[6.93897591380113, 61.282240405393054],
				[6.93897591380113, 63.22780396455778],
				[6.574559209994732, 65.14927385735513],
				[5.393969557993842, 67.07074375015253],
				[3.8790802851457897, 68.62177352255162],
				[1.9395401425728664, 70.54625512364493],
				[0.3945337867656349, 71.70275110927844],
				[-2.303956846379265, 73.23269892360616],
				[-4.9994357712282635, 74.39220661753558],
				[-7.6949146960772055, 75.17525077447493],
				[-13.483418040836682, 76.70821029709856],
				[-15.787374887215947, 77.49125445403791],
				[-18.482853812064945, 77.49125445403791],
				[-20.027860167872234, 77.86169457443617],
				[-23.51240666625239, 77.86169457443617],
				[-26.966836081673364, 77.86169457443617],
				[-31.210333070625552, 77.86169457443617],
				[-34.30034578224013, 77.49125445403791],
				[-38.14930898442668, 76.3347584684044],
				[-40.091860835295506, 75.17525077447493],
				[-43.148744755654945, 72.85924709491195],
				[-45.84723538879979, 71.31122903080876],
				[-47.78677553137271, 69.77826950818519],
				[-49.3347935954759, 68.23025144408194],
				[-50.090732377751976, 66.67922167168285],
				[-50.48526616451761, 65.91424776451902],
				[-50.48526616451761, 63.992777871721614],
				[-50.48526616451761, 62.8332701777922],
				[-50.48526616451761, 62.438736391026566],
				[-50.48526616451761, 62.068296270628366],
				[-50.48526616451761, 61.67376248386273],
				[-50.090732377751976, 61.282240405393054],
				[-49.72631567394558, 61.282240405393054],
				[-49.3347935954759, 61.282240405393054],
			],
			pressures: [
				0.0784313753247261, 0.18431372940540314, 0.2235294133424759, 0.26274511218070984,
				0.29411765933036804, 0.3333333432674408, 0.364705890417099, 0.3803921639919281,
				0.38823530077934265, 0.3921568691730499, 0.3960784375667572, 0.40392157435417175,
				0.4117647111415863, 0.41960784792900085, 0.4117647111415863, 0.40784314274787903,
				0.40784314274787903, 0.3960784375667572, 0.3921568691730499, 0.38823530077934265,
				0.3843137323856354, 0.3803921639919281, 0.3333333432674408, 0.32549020648002625,
				0.32156863808631897, 0.30980393290519714, 0.3176470696926117, 0.3294117748737335,
				0.34117648005485535, 0.3490196168422699, 0.3607843220233917, 0.364705890417099,
				0.3686274588108063, 0.3764705955982208, 0.3921568691730499, 0.4117647111415863,
				0.4431372582912445, 0.4627451002597809, 0.4901960790157318, 0.5176470875740051,
				0.5568627715110779, 0.5882353186607361, 0.5843137502670288, 0.5882353186607361,
				0.5882353186607361, 0.5960784554481506, 0.6039215922355652, 0.6000000238418579,
				0.5960784554481506, 0.5803921818733215, 0.5803921818733215, 0.5803921818733215,
				0.5803921818733215, 0.5803921818733215, 0.5803921818733215, 0.5882353186607361,
				0.5921568870544434, 0.5960784554481506, 0.5843137502670288, 0.572549045085907,
				0.5686274766921997, 0.5647059082984924, 0.572549045085907, 0.572549045085907,
				0.572549045085907, 0.5490196347236633, 0.545098066329956, 0.5333333611488342,
				0.5176470875740051, 0.49803921580314636, 0.4745098054409027, 0.4627451002597809,
				0.45098039507865906, 0.4274509847164154, 0.4117647111415863, 0.38823530077934265,
				0.3686274588108063, 0.3490196168422699, 0.3333333432674408, 0.3294117748737335,
				0.32549020648002625, 0.32549020648002625, 0.3294117748737335, 0.3176470696926117,
				0.29411765933036804, 0.2549019753932953, 0.1921568661928177, 0.09803921729326248,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-49.3347935954759, 61.282240405393054],
		},
	],
	T: [
		{
			id: "hlxwz5d-aPTi_j3fK5Tgi",
			type: "freedraw",
			x: 245.06747451983284,
			y: 219.97643543533297,
			width: 2.695478924848942,
			height: 80.55416179098921,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 2002712093,
			version: 32,
			versionNonce: 1751522035,
			isDeleted: false,
			boundElements: null,
			updated: 1751811437948,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-1.1504725690416535, 0],
				[-1.1504725690416535, 0.37345182869415794],
				[-1.1504725690416535, 0.7649739071638351],
				[-1.1504725690416535, 2.316003679562982],
				[-1.1504725690416535, 4.240485280656287],
				[-1.1504725690416535, 7.7129849458527815],
				[-1.1504725690416535, 11.953470226509012],
				[-1.1504725690416535, 16.955917706033176],
				[-1.1504725690416535, 21.95836518555734],
				[-1.1504725690416535, 26.984906331448883],
				[-1.1504725690416535, 31.987353810973048],
				[-1.1504725690416535, 36.227839091629335],
				[-1.1504725690416535, 40.85683474245934],
				[-1.1504725690416535, 44.70278623634999],
				[-1.5148892728480519, 48.569819688312066],
				[-1.90942305961363, 52.04533106180452],
				[-1.90942305961363, 55.88827084739921],
				[-2.303956846379265, 59.36378222089161],
				[-2.695478924848942, 62.8362818860881],
				[-2.695478924848942, 65.91725947281492],
				[-2.695478924848942, 68.2332631523779],
				[-2.695478924848942, 70.54926683194088],
				[-2.695478924848942, 72.84418855343239],
				[-2.695478924848942, 75.15718052469947],
				[-2.695478924848942, 77.1027440838642],
				[-2.695478924848942, 78.63269189819187],
				[-2.695478924848942, 79.78918788382538],
				[-2.695478924848942, 80.18372167059096],
				[-2.695478924848942, 80.55416179098921],
				[-2.695478924848942, 75.55171431146505],
			],
			pressures: [
				0.0784313753247261, 0.14509804546833038, 0.1725490242242813, 0.2078431397676468,
				0.24313725531101227, 0.27843138575553894, 0.30588236451148987, 0.3294117748737335,
				0.3450980484485626, 0.364705890417099, 0.37254902720451355, 0.37254902720451355,
				0.364705890417099, 0.35686275362968445, 0.3529411852359772, 0.3529411852359772,
				0.3294117748737335, 0.32549020648002625, 0.32549020648002625, 0.32549020648002625,
				0.32156863808631897, 0.32156863808631897, 0.32156863808631897, 0.3176470696926117,
				0.30588236451148987, 0.30588236451148987, 0.30588236451148987, 0.3019607961177826,
				0.29019609093666077, 0.2666666805744171, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-2.695478924848942, 75.55171431146505],
		},
		{
			id: "0TVAIJgvS0L-xtnTMBpue",
			type: "freedraw",
			x: 207.6741043176823,
			y: 219.19339127839362,
			width: 75.18127419106679,
			height: 3.0990478365023364,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 255605299,
			version: 41,
			versionNonce: 172482845,
			isDeleted: false,
			boundElements: null,
			updated: 1751811439205,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-1.1534842773376113, 0],
				[-0.7589504905720332, 0],
				[0.3915220784696771, 0],
				[1.9365284342769655, 0.39453378676557804],
				[4.24048528065623, 0.7830441569393543],
				[6.574559209994732, 1.5480180641031893],
				[9.634454838650072, 1.9425518508688242],
				[13.87795182760226, 2.316003679562982],
				[18.11843710825849, 2.316003679562982],
				[21.605995314934603, 2.316003679562982],
				[24.69600802654918, 2.316003679562982],
				[27.39449865969408, 2.316003679562982],
				[31.243461861880633, 2.316003679562982],
				[35.089413355771285, 2.316003679562982],
				[38.57395985415144, 2.316003679562982],
				[41.63686719110274, 2.316003679562982],
				[44.726879902717315, 2.316003679562982],
				[47.03083674909658, 2.316003679562982],
				[49.36189897013918, 2.7075257580326593],
				[51.27132202975287, 2.7075257580326593],
				[52.816328385560155, 2.7075257580326593],
				[54.75586852813302, 2.7075257580326593],
				[56.66529158774671, 3.0990478365023364],
				[58.210297943553996, 3.0990478365023364],
				[60.14983808612686, 3.0990478365023364],
				[61.69484444193415, 3.0990478365023364],
				[63.23985079774144, 3.0990478365023364],
				[65.14927385735513, 3.0990478365023364],
				[66.69428021316241, 3.0990478365023364],
				[68.2392865689697, 3.0990478365023364],
				[69.78429292477699, 3.0990478365023364],
				[70.9377772021146, 2.7075257580326593],
				[71.72383306734991, 2.7075257580326593],
				[72.08824977115626, 2.7075257580326593],
				[72.48278355792189, 2.316003679562982],
				[72.87731734468747, 2.316003679562982],
				[73.2718511314531, 1.9425518508688242],
				[74.02778991372918, 1.5480180641031893],
				[74.02778991372918, 1.5480180641031893],
			],
			pressures: [
				0.0784313753247261, 0.0470588244497776, 0.16862745583057404, 0.21568627655506134,
				0.25882354378700256, 0.29019609093666077, 0.32156863808631897, 0.3490196168422699,
				0.364705890417099, 0.35686275362968445, 0.364705890417099, 0.3686274588108063,
				0.3843137323856354, 0.4000000059604645, 0.4117647111415863, 0.4156862795352936,
				0.41960784792900085, 0.4117647111415863, 0.41960784792900085, 0.43529412150382996,
				0.4470588266849518, 0.45098039507865906, 0.4745098054409027, 0.48627451062202454,
				0.4941176474094391, 0.49803921580314636, 0.49803921580314636, 0.5137255191802979,
				0.5137255191802979, 0.5215686559677124, 0.5215686559677124, 0.529411792755127,
				0.529411792755127, 0.5215686559677124, 0.48627451062202454, 0.3960784375667572,
				0.32549020648002625, 0.250980406999588, 0.2235294133424759, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [74.02778991372918, 1.5480180641031893],
		},
	],
	U: [
		{
			id: "aVoWIufIVisXZpzsLTsdn",
			type: "freedraw",
			x: 221.55205614528455,
			y: 212.26646219777615,
			width: 68.21218119430648,
			height: 88.65866881531167,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 37689971,
			version: 95,
			versionNonce: 2053531443,
			isDeleted: false,
			boundElements: null,
			updated: 1751811443706,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7589504905719764, 0.370440120398257],
				[-1.1534842773376113, 0.7649739071638351],
				[-1.1534842773376113, 2.3129919712670812],
				[-1.5148892728480519, 3.4724996651964943],
				[-1.9094230596136867, 6.5534772519233115],
				[-2.303956846379265, 9.242932760180452],
				[-2.6984906331448997, 12.323910346907269],
				[-3.062907336951298, 15.422958183409605],
				[-3.062907336951298, 17.71787990490111],
				[-3.454429415420975, 20.42841737122967],
				[-3.454429415420975, 23.900917036426165],
				[-3.848963202186553, 26.216920715989147],
				[-4.243496988952188, 31.222379903809212],
				[-4.607913692758586, 34.69487956900571],
				[-4.607913692758586, 37.381323368966946],
				[-4.607913692758586, 41.24835682092902],
				[-4.607913692758586, 43.564360500492],
				[-4.243496988952188, 48.17227419325053],
				[-3.848963202186553, 51.25325177997735],
				[-3.454429415420975, 54.7287631534698],
				[-3.454429415420975, 57.044766833032725],
				[-2.6984906331448997, 60.52027820652518],
				[-1.9094230596136867, 63.20672200648636],
				[-1.1534842773376113, 65.15228556565108],
				[0, 68.2332631523779],
				[1.183601360296791, 70.54625512364493],
				[2.6954789248489988, 72.47073672473823],
				[4.24048528065623, 74.39220661753558],
				[5.785491636463519, 76.31668821862888],
				[6.93897591380113, 77.4731842042624],
				[9.273049843139631, 79.41573605513122],
				[11.182472902753318, 80.55416179098921],
				[12.332945471795028, 81.34021765622452],
				[15.425969891705506, 82.1021798550924],
				[18.121448816554448, 82.1021798550924],
				[20.45552274589295, 82.1021798550924],
				[23.51541837454829, 82.49671364185804],
				[25.84949230388679, 82.8671537622563],
				[27.39449865969408, 82.8671537622563],
				[29.6984555060734, 82.8671537622563],
				[31.999400644156765, 82.8671537622563],
				[34.69789127730161, 82.49671364185804],
				[37.39337020215061, 82.1021798550924],
				[39.33291034472347, 81.34021765622452],
				[41.272450487296396, 80.55416179098921],
				[43.57640733367566, 79.41573605513122],
				[45.12141368948295, 77.4731842042624],
				[47.030836749096636, 75.55171431146505],
				[48.9673651833736, 74.0006845390659],
				[50.90690532594647, 72.47073672473823],
				[52.816328385560155, 70.54625512364493],
				[54.36133474136744, 68.99522535124584],
				[55.90634109717473, 67.46828924521407],
				[56.665291587746765, 65.91725947281492],
				[57.845881239747655, 63.99277787172167],
				[58.60483173031963, 61.282240405393054],
				[59.393899303850844, 58.96623672583013],
				[59.755304299361285, 56.65023304626715],
				[60.14983808612692, 54.7287631534698],
				[60.14983808612692, 52.804281552376494],
				[60.547383581188456, 50.48827787281351],
				[60.908788576698896, 47.407300286086695],
				[61.30031065516857, 45.48583039328935],
				[61.69484444193421, 42.77830463525669],
				[62.092389936995744, 40.08884912699955],
				[62.453794932506185, 36.61936117009901],
				[62.84531701097586, 35.065319689403964],
				[62.84531701097586, 33.14384979660662],
				[63.2428625060374, 30.457405996645377],
				[63.2428625060374, 28.511842437480652],
				[63.604267501547895, 25.430864850753835],
				[63.604267501547895, 23.900917036426165],
				[63.604267501547895, 21.95535347726144],
				[63.604267501547895, 19.663443464065836],
				[63.604267501547895, 18.109401983370788],
				[63.2428625060374, 16.18793209057344],
				[63.2428625060374, 14.266462197776036],
				[63.2428625060374, 12.323910346907269],
				[62.84531701097586, 10.025976917119806],
				[62.84531701097586, 6.5534772519233115],
				[62.84531701097586, 5.0024474795241645],
				[62.453794932506185, 3.8459514938906523],
				[62.092389936995744, 2.3129919712670812],
				[62.092389936995744, 0.7649739071638351],
				[61.69484444193421, -0.7860558652352552],
				[61.30031065516857, -1.9214698927973473],
				[60.908788576698896, -3.4724996651964943],
				[60.547383581188456, -4.632007359125907],
				[60.547383581188456, -5.3969812662897425],
				[60.547383581188456, -5.791515053055377],
				[60.14983808612692, -5.791515053055377],
				[60.14983808612692, -4.632007359125907],
				[59.755304299361285, -3.8670334519620724],
			],
			pressures: [
				0.0784313753247261, 0.08235294371843338, 0.10196078568696976, 0.13725490868091583,
				0.1568627506494522, 0.18431372940540314, 0.2078431397676468, 0.22745098173618317,
				0.239215686917305, 0.24313725531101227, 0.24705882370471954, 0.250980406999588,
				0.25882354378700256, 0.2666666805744171, 0.2705882489681244, 0.2705882489681244,
				0.27843138575553894, 0.2823529541492462, 0.2823529541492462, 0.2862745225429535,
				0.29411765933036804, 0.2980392277240753, 0.2980392277240753, 0.30588236451148987,
				0.30588236451148987, 0.3176470696926117, 0.3176470696926117, 0.32156863808631897,
				0.3176470696926117, 0.3294117748737335, 0.3333333432674408, 0.34117648005485535,
				0.3450980484485626, 0.3529411852359772, 0.364705890417099, 0.3764705955982208,
				0.3803921639919281, 0.3843137323856354, 0.3921568691730499, 0.3960784375667572,
				0.3960784375667572, 0.3921568691730499, 0.3921568691730499, 0.3843137323856354,
				0.3921568691730499, 0.3921568691730499, 0.3960784375667572, 0.4000000059604645,
				0.4000000059604645, 0.40392157435417175, 0.4117647111415863, 0.42352941632270813,
				0.4274509847164154, 0.4274509847164154, 0.4313725531101227, 0.4313725531101227,
				0.43921568989753723, 0.4431372582912445, 0.4470588266849518, 0.4470588266849518,
				0.45098039507865906, 0.45098039507865906, 0.45098039507865906,
				0.45098039507865906, 0.45098039507865906, 0.45098039507865906,
				0.43921568989753723, 0.43529412150382996, 0.43529412150382996,
				0.43529412150382996, 0.43529412150382996, 0.4313725531101227, 0.4274509847164154,
				0.41960784792900085, 0.40392157435417175, 0.4000000059604645, 0.3921568691730499,
				0.3921568691730499, 0.38823530077934265, 0.38823530077934265, 0.3803921639919281,
				0.3803921639919281, 0.3803921639919281, 0.37254902720451355, 0.3607843220233917,
				0.35686275362968445, 0.35686275362968445, 0.35686275362968445, 0.3529411852359772,
				0.34117648005485535, 0.3333333432674408, 0.32156863808631897, 0.07450980693101883,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [59.755304299361285, -3.8670334519620724],
		},
	],
	V: [
		{
			id: "Cae_b5dQYA6E5kBPBYCdf",
			type: "freedraw",
			x: 216.5496086657604,
			y: 214.19094379886945,
			width: 67.45323070373445,
			height: 85.20725110818654,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 2030711763,
			version: 69,
			versionNonce: 230076413,
			isDeleted: false,
			boundElements: null,
			updated: 1751811453474,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7559387822760755, 0.3885103701737762],
				[-0.7559387822760755, 0.7619621988679341],
				[-0.3915220784696771, 2.6864437999611823],
				[1.1534842773376113, 5.785491636463519],
				[2.6984906331448997, 8.474947144720659],
				[4.641042484013667, 12.712420717080988],
				[6.93897591380113, 17.344428076206952],
				[8.881527764669954, 21.190379570097548],
				[11.185484611049219, 25.822386929223512],
				[12.33595718009093, 28.90336451595033],
				[13.883975244194119, 32.375864181146824],
				[15.034447813235772, 36.242897633108896],
				[16.57945416904306, 40.85382303416338],
				[17.335392951319193, 42.40485280656253],
				[19.669466880657637, 46.64232637892286],
				[21.578889940271324, 50.117837752415255],
				[22.759479592272214, 52.43384143197824],
				[24.6689026518859, 56.67131500433857],
				[26.21390900769319, 59.752292591065384],
				[27.3673932850308, 62.068296270628366],
				[28.91239964083809, 65.14927385735513],
				[29.698455506073344, 67.83571765731637],
				[30.457405996645377, 70.54625512364493],
				[31.216356487217354, 72.46772501644227],
				[32.002412352452666, 75.54870260316909],
				[32.396946139218244, 77.09973237556824],
				[32.76136284302464, 79.02120226836558],
				[33.547418708259954, 80.1776982539991],
				[33.94195249502553, 80.94267216116299],
				[33.94195249502553, 81.73173973469414],
				[34.30636919883193, 81.73173973469414],
				[34.30636919883193, 80.57223204076473],
				[35.45684176787364, 76.3347584684044],
				[35.85137555463922, 74.01875478884142],
				[37.00184812368093, 69.38975913801141],
				[37.790915697212085, 65.14927385735513],
				[39.335922053019374, 60.14682637783096],
				[40.85081132586748, 54.355311324775585],
				[42.03140097786837, 50.87979995128319],
				[43.184885255205984, 47.80183407285227],
				[44.33535782424764, 43.9348006208902],
				[45.880364180054926, 40.08583741870365],
				[47.425370535862214, 37.01088324856869],
				[48.578854813199825, 35.08338993917948],
				[50.123861169007114, 31.21936819551331],
				[51.6688675248144, 28.532924395552072],
				[52.819340093856056, 25.451946808825255],
				[53.969812662897766, 23.13594312926233],
				[54.72876315346974, 21.581901648567282],
				[55.517830727000955, 19.2658979690043],
				[55.90935280547063, 17.73896186297253],
				[56.668303296042666, 15.422958183409548],
				[58.213309651849954, 12.341980596682731],
				[58.60784343861553, 11.182472902753318],
				[59.36378222089161, 9.631443130354171],
				[60.908788576698896, 7.318451159087147],
				[61.66773906727093, 6.158943465157677],
				[62.84832871927182, 4.237473572360329],
				[63.607279209843796, 2.6864437999611823],
				[64.00181299660937, 1.1564959856335122],
				[64.75775177888545, 0],
				[65.15228556565108, -1.15950769392947],
				[65.91123605622306, -1.924481601093305],
				[65.91123605622306, -2.71053746632856],
				[66.30275813469274, -3.080977586726817],
				[66.69729192145837, -3.4755113734923953],
				[66.30275813469274, -3.080977586726817],
			],
			pressures: [
				0.0784313753247261, 0.16862745583057404, 0.1882352977991104, 0.21176470816135406,
				0.239215686917305, 0.26274511218070984, 0.27843138575553894, 0.2980392277240753,
				0.30980393290519714, 0.32549020648002625, 0.3333333432674408, 0.3333333432674408,
				0.3490196168422699, 0.3529411852359772, 0.3607843220233917, 0.37254902720451355,
				0.3843137323856354, 0.3843137323856354, 0.3843137323856354, 0.3803921639919281,
				0.3843137323856354, 0.3921568691730499, 0.3960784375667572, 0.4000000059604645,
				0.3921568691730499, 0.38823530077934265, 0.3803921639919281, 0.3803921639919281,
				0.3764705955982208, 0.3686274588108063, 0.3607843220233917, 0.3490196168422699,
				0.32156863808631897, 0.3176470696926117, 0.30588236451148987, 0.2980392277240753,
				0.29411765933036804, 0.29411765933036804, 0.29411765933036804, 0.3019607961177826,
				0.30588236451148987, 0.3137255012989044, 0.3333333432674408, 0.33725491166114807,
				0.3333333432674408, 0.3333333432674408, 0.3294117748737335, 0.3333333432674408,
				0.34117648005485535, 0.3450980484485626, 0.3490196168422699, 0.3529411852359772,
				0.3490196168422699, 0.34117648005485535, 0.34117648005485535, 0.32549020648002625,
				0.32156863808631897, 0.32156863808631897, 0.3176470696926117, 0.3176470696926117,
				0.3176470696926117, 0.3176470696926117, 0.32156863808631897, 0.32549020648002625,
				0.32549020648002625, 0.3294117748737335, 0.32549020648002625, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [66.30275813469274, -3.080977586726817],
		},
	],
	W: [
		{
			id: "vQMtEew3dEb_TtX4G6dOS",
			type: "freedraw",
			x: 206.15620333653828,
			y: 219.19339127839362,
			width: 53.969812662897766,
			height: 68.2332631523779,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1149145267,
			version: 53,
			versionNonce: 694451997,
			isDeleted: false,
			boundElements: null,
			updated: 1751811462505,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.786055865235312, 0],
				[-0.786055865235312, -0.37345182869415794],
				[-0.786055865235312, 0],
				[-0.3915220784696771, 1.1564959856335122],
				[0.36441670380639835, 3.4724996651964943],
				[1.9094230596136867, 6.550465543627354],
				[3.454429415420975, 10.420510703885384],
				[5.0024474795241645, 15.02842439664397],
				[6.547453835331453, 19.289991635371678],
				[8.092460191138741, 23.530476916027908],
				[9.242932760180395, 27.767950488388237],
				[10.393405329222105, 31.61390198227889],
				[11.152355819794082, 36.242897633108896],
				[12.69736217560137, 40.480371205469226],
				[13.486429749132583, 43.56134879219604],
				[15.034447813235772, 48.19636785961791],
				[16.18190867398158, 52.03930764521266],
				[17.332381243023235, 55.514819018705055],
				[18.485865520360846, 58.99033039219745],
				[19.27493309389206, 61.67677419215869],
				[20.030871876168135, 63.22780396455778],
				[20.42841737122967, 65.14927385735518],
				[21.18134444520979, 66.3087815512846],
				[21.578889940271324, 66.70030362975427],
				[21.578889940271324, 66.3087815512846],
				[22.3348287225474, 65.14927385735518],
				[23.123896296078613, 62.8332701777922],
				[23.879835078354688, 60.14682637783096],
				[24.6689026518859, 56.27979292586889],
				[26.21390900769319, 51.274333738048824],
				[28.123332067306876, 45.877352471759025],
				[30.062872209879743, 40.480371205469226],
				[31.60787856568703, 37.01088324856869],
				[33.91183541206635, 32.7703979679124],
				[35.85137555463922, 29.692432089481542],
				[37.760798614252906, 25.84648059559089],
				[39.70033875682577, 22.741409342496695],
				[41.24534511263306, 19.660431755769878],
				[42.39581768167477, 16.973987955808695],
				[43.546290250716424, 15.02842439664397],
				[45.48583039328935, 11.577006689518896],
				[46.244780883861324, 9.631443130354171],
				[48.18432102643419, 6.550465543627354],
				[48.94025980871032, 4.6289956508300065],
				[50.87979995128319, 2.316003679562982],
				[52.0332842286208, 0.7830441569393543],
				[52.789223010896876, -0.37345182869415794],
				[53.183756797662454, -1.15950769392947],
				[53.183756797662454, -1.532959522623628],
				[52.42480630709048, -0.7649739071638351],
				[52.0332842286208, -0.37345182869415794],
			],
			pressures: [
				0.0784313753247261, 0.125490203499794, 0.1411764770746231, 0.19607843458652496,
				0.21960784494876862, 0.24313725531101227, 0.2705882489681244, 0.30588236451148987,
				0.32549020648002625, 0.3490196168422699, 0.3529411852359772, 0.3529411852359772,
				0.364705890417099, 0.3764705955982208, 0.4000000059604645, 0.4156862795352936,
				0.4274509847164154, 0.4274509847164154, 0.4313725531101227, 0.4274509847164154,
				0.41960784792900085, 0.41960784792900085, 0.41960784792900085, 0.4156862795352936,
				0.3843137323856354, 0.3529411852359772, 0.3529411852359772, 0.35686275362968445,
				0.3490196168422699, 0.3450980484485626, 0.34117648005485535, 0.33725491166114807,
				0.34117648005485535, 0.3450980484485626, 0.3490196168422699, 0.3529411852359772,
				0.34117648005485535, 0.34117648005485535, 0.3450980484485626, 0.3450980484485626,
				0.3450980484485626, 0.3450980484485626, 0.34117648005485535, 0.33725491166114807,
				0.33725491166114807, 0.34117648005485535, 0.3450980484485626, 0.3450980484485626,
				0.33725491166114807, 0.3176470696926117, 0.09803921729326248, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [52.0332842286208, -0.37345182869415794],
		},
		{
			id: "2xuLo7t1An2Js9eNlTGX9",
			type: "freedraw",
			x: 230.4335839099545,
			y: 232.30034578224024,
			width: 65.15228556565108,
			height: 67.07375545844843,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1015164627,
			version: 51,
			versionNonce: 1094568509,
			isDeleted: false,
			boundElements: null,
			updated: 1751811463720,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.3975454950615358, -0.7649739071638351],
				[-1.1534842773376113, -1.529947814327727],
				[-1.1534842773376113, -2.686443799961239],
				[-1.1534842773376113, -3.080977586726817],
				[-1.1534842773376113, -3.475511373492452],
				[-1.1534842773376113, -3.8459514938906523],
				[-0.7589504905719764, -3.8459514938906523],
				[0, -3.080977586726817],
				[1.1504725690416535, -1.529947814327727],
				[2.300945138083364, 0],
				[3.8459514938906523, 2.71053746632856],
				[6.544442127035552, 6.1830371315250545],
				[10.028988625415707, 11.18849631934512],
				[13.483418040836682, 16.58547758563492],
				[15.422958183409548, 20.82295115799525],
				[16.57343075245126, 25.057413022059677],
				[17.723903321492912, 29.692432089481485],
				[19.2689096773002, 33.92990566184187],
				[20.422393954637812, 37.01088324856863],
				[22.361934097210735, 40.87791670053076],
				[24.271357156824365, 43.95889428725758],
				[26.207885591101387, 47.03987187398434],
				[27.361369868438942, 48.96134176678174],
				[28.147425733674254, 49.35587555354732],
				[28.90637622424623, 50.120849460711156],
				[29.300910011011865, 50.51237153918083],
				[29.692432089481542, 50.120849460711156],
				[30.45138258005352, 48.96134176678174],
				[31.210333070625552, 47.03987187398434],
				[32.39092272262644, 44.32933440765578],
				[33.905811995474494, 41.24835682092896],
				[36.63140800328267, 34.69487956900571],
				[38.54083106289636, 29.297898302715907],
				[41.23932169604126, 23.530476916027908],
				[43.5703839170838, 19.2719213855961],
				[47.02481333250478, 13.874940119306359],
				[49.32877017888404, 9.634454838650072],
				[50.87377653469133, 6.1830371315250545],
				[53.21086217232579, 1.5510297723990902],
				[55.514819018705055, -2.686443799961239],
				[58.210297943553996, -6.556488960219269],
				[60.14983808612692, -9.634454838650129],
				[61.66171565067907, -11.950458518213111],
				[62.84531701097586, -14.266462197776093],
				[63.604267501547895, -15.422958183409605],
				[63.99880128831347, -16.18793209057344],
				[63.99880128831347, -16.5613839192676],
				[63.604267501547895, -16.18793209057344],
				[63.20973371478226, -15.422958183409605],
			],
			pressures: [
				0.0784313753247261, 0.0784313753247261, 0.062745101749897, 0.07058823853731155,
				0.10980392247438431, 0.14509804546833038, 0.18039216101169586,
				0.23137255012989044, 0.27843138575553894, 0.3333333432674408, 0.3607843220233917,
				0.3960784375667572, 0.4313725531101227, 0.46666666865348816, 0.4901960790157318,
				0.5137255191802979, 0.529411792755127, 0.545098066329956, 0.5490196347236633,
				0.5529412031173706, 0.5490196347236633, 0.5411764979362488, 0.5254902243614197,
				0.5137255191802979, 0.49803921580314636, 0.48627451062202454, 0.47843137383461,
				0.45098039507865906, 0.43529412150382996, 0.42352941632270813, 0.4117647111415863,
				0.40392157435417175, 0.3960784375667572, 0.3960784375667572, 0.3921568691730499,
				0.3843137323856354, 0.38823530077934265, 0.3843137323856354, 0.3803921639919281,
				0.3803921639919281, 0.3764705955982208, 0.37254902720451355, 0.3803921639919281,
				0.3803921639919281, 0.3764705955982208, 0.37254902720451355, 0.3686274588108063,
				0.3686274588108063, 0.07450980693101883, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [63.20973371478226, -15.422958183409605],
		},
	],
	X: [
		{
			id: "HdJ6lHbMHU7HNpeBmmM0_",
			type: "freedraw",
			x: 216.5496086657604,
			y: 209.95045851821317,
			width: 68.2392865689697,
			height: 81.34021765622452,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 2012445235,
			version: 44,
			versionNonce: 1740149779,
			isDeleted: false,
			boundElements: null,
			updated: 1751811476240,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.3915220784696771, 0.7649739071638919],
				[-0.3915220784696771, 1.15950769392947],
				[0.7589504905719764, 2.316003679562982],
				[1.5480180641031893, 3.475511373492452],
				[3.0930244199104777, 6.161955173453634],
				[4.641042484013667, 8.083425066250982],
				[6.186048839820955, 9.63746654694603],
				[9.242932760180395, 11.950458518213111],
				[11.580018397814854, 14.266462197776093],
				[13.125024753622142, 16.18793209057344],
				[15.034447813235772, 19.663443464065836],
				[16.973987955808695, 21.58491335686324],
				[18.883411015422382, 23.900917036426165],
				[21.214473236464926, 26.216920715989147],
				[23.912963869609825, 28.53292439555213],
				[26.21390900769319, 31.613901982278946],
				[28.517865854072454, 34.69487956900571],
				[30.851939783410955, 37.01088324856869],
				[33.15288492149432, 39.32387521983577],
				[35.45684176787364, 42.01333072809285],
				[37.00184812368093, 43.93781232918616],
				[40.091860835295506, 47.80183407285233],
				[41.639878899398695, 50.11783775241531],
				[44.33535782424764, 54.35832303307154],
				[45.880364180054926, 56.674326712634524],
				[47.78978723966861, 59.36077051259571],
				[50.123861169007114, 62.441748099322524],
				[51.6688675248144, 64.38731165848725],
				[53.57829058442809, 66.30878155128465],
				[56.668303296042666, 70.1547330451753],
				[58.60784343861553, 72.07620293797265],
				[59.75831600765724, 73.23571063190207],
				[61.66773906727093, 74.78674040430121],
				[63.21274542307816, 76.31668821862888],
				[64.39634678337501, 77.86771799102803],
				[65.54983106071262, 79.41573605513122],
				[66.30275813469274, 80.18070996229505],
				[67.09483741651991, 80.94869557775485],
				[67.45624241203035, 81.34021765622452],
				[67.84776449050003, 81.34021765622452],
				[66.69729192145837, 81.34021765622452],
				[65.91123605622306, 80.94869557775485],
			],
			pressures: [
				0.0784313753247261, 0.14901961386203766, 0.16078431904315948, 0.18431372940540314,
				0.20392157137393951, 0.2235294133424759, 0.24313725531101227, 0.25882354378700256,
				0.27450981736183167, 0.2862745225429535, 0.29019609093666077, 0.3019607961177826,
				0.3137255012989044, 0.32156863808631897, 0.3294117748737335, 0.33725491166114807,
				0.33725491166114807, 0.3490196168422699, 0.364705890417099, 0.37254902720451355,
				0.3960784375667572, 0.3960784375667572, 0.40392157435417175, 0.40784314274787903,
				0.4117647111415863, 0.4156862795352936, 0.43529412150382996, 0.43921568989753723,
				0.43921568989753723, 0.43529412150382996, 0.43529412150382996,
				0.43529412150382996, 0.43921568989753723, 0.4470588266849518, 0.4470588266849518,
				0.45098039507865906, 0.45490196347236633, 0.45098039507865906, 0.4470588266849518,
				0.4156862795352936, 0.364705890417099, 0.13725490868091583, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [65.91123605622306, 80.94869557775485],
		},
		{
			id: "c5e9beGZ5pbqgdvAXHw_2",
			type: "freedraw",
			x: 212.70365717186974,
			y: 292.0526383733056,
			width: 77.48523103744606,
			height: 84.41818353465538,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 486756093,
			version: 43,
			versionNonce: 1382947315,
			isDeleted: false,
			boundElements: null,
			updated: 1751811477674,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7890675735312129, 0],
				[-0.7890675735312129, -0.370440120398257],
				[-0.3945337867656349, -0.7619621988679341],
				[0, -1.5269361060317692],
				[2.300945138083364, -4.2344618640644285],
				[4.604901984462629, -6.923917372321569],
				[6.93897591380113, -9.23992105188455],
				[11.543877898263815, -13.868916702714557],
				[13.880963535898218, -16.579454169043117],
				[17.72992673808477, -20.819939449699348],
				[19.666455172361736, -23.900917036426165],
				[22.729362509313034, -27.37341670162266],
				[26.969847789969265, -31.21936819551331],
				[31.999400644156708, -36.221815675037476],
				[34.69789127730161, -38.929341433070135],
				[37.39337020215061, -42.01031901979695],
				[41.24233340433716, -46.24779259215728],
				[43.546290250716424, -48.563796271720264],
				[46.24176917556542, -51.274333738048824],
				[48.575843104903925, -53.96077753801001],
				[50.87678824298729, -56.671315004338624],
				[53.57527887613219, -60.12273271146364],
				[55.87923572251145, -62.8332701777922],
				[58.210297943553996, -64.7547400705896],
				[61.30031065516857, -67.83571765731637],
				[62.81821163631258, -69.38674742971551],
				[64.36321799211987, -71.7027511092785],
				[65.90822434792716, -73.23269892360616],
				[67.45323070373445, -74.78372869600531],
				[68.24229827726566, -75.94022468163882],
				[69.75718755011371, -77.86169457443617],
				[70.54324341534902, -78.6266684816],
				[71.69371598439068, -80.18070996229505],
				[72.45266647496271, -81.33720594792857],
				[73.6362678352595, -82.49671364185804],
				[74.39220661753558, -83.25867584072597],
				[74.78975211259711, -83.25867584072597],
				[75.54267918657729, -84.0236497478898],
				[75.94022468163877, -84.41818353465538],
				[76.69616346391484, -84.41818353465538],
				[76.69616346391484, -84.41818353465538],
			],
			pressures: [
				0.0784313753247261, 0.054901961237192154, 0.1411764770746231, 0.16470588743686676,
				0.18431372940540314, 0.23529411852359772, 0.250980406999588, 0.25882354378700256,
				0.2549019753932953, 0.2549019753932953, 0.2666666805744171, 0.2705882489681244,
				0.29019609093666077, 0.30588236451148987, 0.29411765933036804, 0.2980392277240753,
				0.2980392277240753, 0.29019609093666077, 0.29019609093666077, 0.2862745225429535,
				0.2862745225429535, 0.2862745225429535, 0.29019609093666077, 0.27843138575553894,
				0.27843138575553894, 0.2705882489681244, 0.2705882489681244, 0.2705882489681244,
				0.2705882489681244, 0.2862745225429535, 0.3019607961177826, 0.30980393290519714,
				0.3176470696926117, 0.32156863808631897, 0.32156863808631897, 0.32156863808631897,
				0.32156863808631897, 0.32156863808631897, 0.27450981736183167,
				0.21176470816135406, 0.08235294371843338, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [76.69616346391484, -84.41818353465538],
		},
	],
	Y: [
		{
			id: "Y1B9-j77rqMSveTAkD8bY",
			type: "freedraw",
			x: 231.18651098393468,
			y: 211.87192841101057,
			width: 44.32933440765578,
			height: 77.10274408386414,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1026611923,
			version: 85,
			versionNonce: 1574076157,
			isDeleted: false,
			boundElements: null,
			updated: 1751811482795,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7529270739801746, -0.3915220784696771],
				[-0.7529270739801746, -0.7619621988679341],
				[-1.1504725690417104, -0.7619621988679341],
				[-1.1504725690417104, 0.39453378676557804],
				[-1.9064113513177858, 1.9244816010932482],
				[-2.300945138083364, 3.8670334519620724],
				[-2.6954789248489988, 6.5564889602192125],
				[-3.0568839203594393, 9.63746654694603],
				[-3.0568839203594393, 12.718444133672847],
				[-3.0568839203594393, 15.42596989170545],
				[-3.0568839203594393, 18.503935770136366],
				[-2.300945138083364, 21.214473236464926],
				[-0.7529270739801746, 23.50939495795643],
				[0.7920792818271138, 25.825398637519413],
				[3.0930244199104777, 28.141402317082395],
				[5.791515053055377, 29.692432089481542],
				[9.276061551435532, 30.851939783410955],
				[13.516546832091763, 31.222379903809212],
				[16.970976247512738, 31.61691369057479],
				[18.515982603320026, 31.61691369057479],
				[23.51843008284419, 31.222379903809212],
				[27.002976581224402, 30.062872209879743],
				[30.09298929283898, 28.141402317082395],
				[31.637995648646267, 26.981894623152925],
				[33.94195249502553, 24.295450823191743],
				[35.48695885083282, 21.584913356863183],
				[37.39638191044651, 18.898469556901944],
				[38.5769715624474, 16.58246587733902],
				[38.941388266253796, 13.501488290612201],
				[39.33291034472347, 10.420510703885384],
				[39.33291034472347, 7.3214628673830475],
				[38.5769715624474, 4.635019067421865],
				[37.787903988916185, 2.7075257580326593],
				[37.03196520664011, 1.554041480695048],
				[36.637431419874474, 0.39453378676557804],
				[36.242897633108896, -0.3915220784696771],
				[35.8784809293025, -0.7619621988679341],
				[35.48695885083282, -1.1564959856335122],
				[35.09242506406724, -1.1564959856335122],
				[35.09242506406724, -0.3915220784696771],
				[35.09242506406724, 0.39453378676557804],
				[34.69789127730161, 1.554041480695048],
				[34.69789127730161, 3.4755113734923953],
				[35.09242506406724, 5.3969812662897425],
				[35.8784809293025, 7.715996654148626],
				[36.637431419874474, 10.420510703885384],
				[37.39638191044651, 13.501488290612201],
				[37.787903988916185, 16.187932090573383],
				[38.5769715624474, 19.663443464065836],
				[38.941388266253796, 23.900917036426165],
				[39.33291034472347, 26.981894623152925],
				[39.72744413148905, 30.851939783410955],
				[39.72744413148905, 35.089413355771285],
				[40.09186083529545, 38.1703909424981],
				[40.09186083529545, 43.95889428725758],
				[40.486394622061084, 48.56680798001611],
				[40.88092840882666, 52.04231935350856],
				[40.88092840882666, 55.90935280547063],
				[41.27245048729634, 58.59579660543187],
				[41.27245048729634, 62.8362818860881],
				[40.486394622061084, 65.91725947281492],
				[38.941388266253796, 68.62779693914348],
				[37.39638191044651, 70.9407889104105],
				[35.09242506406724, 72.86527051150381],
				[32.002412352452666, 74.02176649713732],
				[28.153449150266056, 74.78674040430116],
				[23.154013379037792, 74.78674040430116],
				[18.12446052485035, 75.17826248277083],
				[14.670031109429374, 75.55171431146505],
				[11.577006689518896, 75.94624809823063],
				[8.48699397790432, 75.94624809823063],
				[5.427098349248979, 74.39521832583148],
				[2.3370856376344022, 72.47073672473823],
				[0, 71.31424073910466],
				[-0.7529270739801746, 70.54926683194083],
				[-0.7529270739801746, 68.99823705954174],
				[-0.7529270739801746, 66.70331533805017],
				[0, 64.38731165848725],
				[1.5480180641031893, 61.67677419215863],
				[2.3370856376344022, 60.14983808612692],
				[3.0930244199104777, 59.36077051259571],
				[3.8820919934416906, 58.59579660543187],
				[4.246508697248089, 57.83383440656394],
			],
			pressures: [
				0.0784313753247261, 0.05882352963089943, 0.0784313753247261, 0.125490203499794,
				0.1568627506494522, 0.1764705926179886, 0.2078431397676468, 0.22745098173618317,
				0.24705882370471954, 0.25882354378700256, 0.2705882489681244, 0.2862745225429535,
				0.2980392277240753, 0.2980392277240753, 0.3019607961177826, 0.3019607961177826,
				0.30588236451148987, 0.30980393290519714, 0.3137255012989044, 0.3137255012989044,
				0.30980393290519714, 0.30588236451148987, 0.2980392277240753, 0.2980392277240753,
				0.2980392277240753, 0.2980392277240753, 0.2862745225429535, 0.27843138575553894,
				0.26274511218070984, 0.250980406999588, 0.24313725531101227, 0.23529411852359772,
				0.239215686917305, 0.24313725531101227, 0.24705882370471954, 0.24705882370471954,
				0.24705882370471954, 0.24705882370471954, 0.250980406999588, 0.2823529541492462,
				0.2862745225429535, 0.2980392277240753, 0.3137255012989044, 0.3333333432674408,
				0.35686275362968445, 0.37254902720451355, 0.38823530077934265,
				0.38823530077934265, 0.3764705955982208, 0.364705890417099, 0.35686275362968445,
				0.3450980484485626, 0.33725491166114807, 0.3450980484485626, 0.35686275362968445,
				0.364705890417099, 0.37254902720451355, 0.37254902720451355, 0.364705890417099,
				0.364705890417099, 0.3607843220233917, 0.35686275362968445, 0.35686275362968445,
				0.35686275362968445, 0.3607843220233917, 0.35686275362968445, 0.3686274588108063,
				0.3843137323856354, 0.4000000059604645, 0.40784314274787903, 0.4156862795352936,
				0.4117647111415863, 0.38823530077934265, 0.3607843220233917, 0.34117648005485535,
				0.3490196168422699, 0.33725491166114807, 0.32549020648002625, 0.3137255012989044,
				0.29411765933036804, 0.250980406999588, 0.22745098173618317, 0.12156862765550613,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [4.246508697248089, 57.83383440656394],
		},
	],
	Z: [
		{
			id: "o4KeqKEt2g_OvPeIuRh0R",
			type: "freedraw",
			x: 212.70365717186974,
			y: 218.81993944969946,
			width: 77.48221932915015,
			height: 74.0006845390659,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 2063672349,
			version: 78,
			versionNonce: 1485835187,
			isDeleted: false,
			boundElements: null,
			updated: 1751811487771,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7890675735312129, 0.37345182869415794],
				[-0.7890675735312129, 0.767985615459736],
				[0.3915220784696771, 0.767985615459736],
				[1.9094230596136867, 1.1564959856335122],
				[4.9994357712282635, 1.5299478143276701],
				[9.634454838650129, 1.9214698927973473],
				[15.031436104939871, 1.9214698927973473],
				[20.030871876168135, 1.9214698927973473],
				[24.6689026518859, 2.316003679562982],
				[30.05986050158384, 3.080977586726817],
				[35.45383005957768, 3.8459514938906523],
				[41.24233340433716, 4.610925401054487],
				[47.78677553137271, 4.610925401054487],
				[52.42480630709048, 4.610925401054487],
				[56.27075780098113, 4.610925401054487],
				[59.755304299361285, 4.610925401054487],
				[63.20973371478226, 4.237473572360329],
				[65.14927385735518, 3.4724996651964943],
				[67.05869691696881, 3.080977586726817],
				[68.24229827726566, 2.316003679562982],
				[68.99823705954174, 2.316003679562982],
				[69.75718755011371, 1.9214698927973473],
				[70.14870962858339, 1.9214698927973473],
				[69.75718755011371, 2.68945550825714],
				[68.99823705954174, 3.8459514938906523],
				[67.45323070373445, 5.770433094983957],
				[65.51369056116158, 8.869480931486294],
				[60.908788576698896, 14.636902318174293],
				[58.96924843412603, 16.952905997737275],
				[54.72575144517384, 21.587925065159084],
				[51.635738733559265, 25.825398637519413],
				[49.33178188718, 29.300910011011865],
				[46.636302962331, 32.75232771813688],
				[43.181873546910026, 36.22482738333338],
				[38.54685447948822, 41.24835682092902],
				[34.30335749053603, 46.25080430045318],
				[31.213344778921453, 49.72631567394558],
				[26.21390900769319, 53.966800954601865],
				[22.729362509313034, 56.65324475456305],
				[18.482853812064945, 59.755304299361285],
				[15.031436104939871, 62.05022602085285],
				[11.182472902753318, 63.992777871721614],
				[7.333509700566765, 65.14927385735518],
				[4.24048528065623, 67.07375545844843],
				[1.9094230596136867, 68.99823705954174],
				[-0.3945337867656349, 70.54625512364493],
				[-2.3340739293385013, 72.07921464626855],
				[-3.848963202186553, 72.86225880320791],
				[-5.029552854187443, 73.23269892360616],
				[-5.393969557993842, 73.23269892360616],
				[-5.7885033447594765, 73.23269892360616],
				[-5.029552854187443, 73.23269892360616],
				[-3.484546498380155, 73.23269892360616],
				[-1.1534842773376113, 73.23269892360616],
				[1.5450063558072884, 73.23269892360616],
				[5.393969557993842, 73.62723271037174],
				[10.784927407691782, 73.62723271037174],
				[15.787374887215947, 73.62723271037174],
				[23.12088458778271, 74.0006845390659],
				[28.909387932542188, 74.0006845390659],
				[34.30335749053603, 74.0006845390659],
				[36.242897633108896, 74.0006845390659],
				[42.78733976014445, 74.0006845390659],
				[47.42235882756631, 73.62723271037174],
				[50.87678824298729, 73.23269892360616],
				[55.12028523193942, 72.86225880320791],
				[57.81576415678842, 72.47073672473823],
				[62.05926114574061, 71.7057628175744],
				[65.14927385735518, 70.54625512364493],
				[67.84776449050003, 69.38975913801141],
				[68.99823705954174, 68.99823705954174],
				[70.14870962858339, 68.99823705954174],
				[70.94078891041056, 68.60370327277616],
				[71.302193905921, 68.23025144408194],
				[71.69371598439068, 67.83872936561227],
				[71.302193905921, 67.83872936561227],
			],
			pressures: [
				0.0784313753247261, 0.13333334028720856, 0.24313725531101227, 0.3019607961177826,
				0.3450980484485626, 0.3686274588108063, 0.3843137323856354, 0.3960784375667572,
				0.38823530077934265, 0.38823530077934265, 0.40784314274787903,
				0.41960784792900085, 0.41960784792900085, 0.4117647111415863, 0.40392157435417175,
				0.4000000059604645, 0.3960784375667572, 0.3921568691730499, 0.3921568691730499,
				0.3921568691730499, 0.3921568691730499, 0.38823530077934265, 0.3803921639919281,
				0.3529411852359772, 0.33725491166114807, 0.33725491166114807, 0.34117648005485535,
				0.33725491166114807, 0.33725491166114807, 0.33725491166114807,
				0.33725491166114807, 0.3333333432674408, 0.32156863808631897, 0.3176470696926117,
				0.3137255012989044, 0.30980393290519714, 0.3019607961177826, 0.2980392277240753,
				0.3019607961177826, 0.3019607961177826, 0.2980392277240753, 0.29019609093666077,
				0.2862745225429535, 0.2862745225429535, 0.2705882489681244, 0.26274511218070984,
				0.2549019753932953, 0.23137255012989044, 0.21568627655506134, 0.20392157137393951,
				0.2078431397676468, 0.21176470816135406, 0.21176470816135406, 0.23529411852359772,
				0.250980406999588, 0.29019609093666077, 0.33725491166114807, 0.37254902720451355,
				0.3960784375667572, 0.4274509847164154, 0.4431372582912445, 0.46666666865348816,
				0.47843137383461, 0.47058823704719543, 0.48627451062202454, 0.5137255191802979,
				0.529411792755127, 0.5411764979362488, 0.545098066329956, 0.5607843399047852,
				0.5647059082984924, 0.5568627715110779, 0.5607843399047852, 0.4431372582912445,
				0.3333333432674408, 0.16862745583057404, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [71.302193905921, 67.83872936561227],
		},
		{
			id: "gAy7PHTJ9ikB98jP54GFd",
			type: "freedraw",
			x: 239.3090882580326,
			y: 252.72876315346986,
			width: 26.21089729939729,
			height: 11.950458518213111,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 664753501,
			version: 19,
			versionNonce: 230039187,
			isDeleted: false,
			boundElements: null,
			updated: 1751811488723,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7860558652352552, 0],
				[-1.18058965200089, 0],
				[-1.5450063558072884, 0],
				[-1.18058965200089, 0.3945337867656349],
				[1.1534842773376113, 1.15950769392947],
				[4.243496988952188, 2.316003679562982],
				[7.697926404373163, 3.867033451962129],
				[11.546889606559716, 5.396981266289799],
				[15.39585280874627, 6.944999330392989],
				[18.09133173359527, 8.104507024322459],
				[21.575878231975423, 10.025976917119806],
				[23.12088458778271, 11.185484611049276],
				[23.879835078354745, 11.580018397814854],
				[24.271357156824422, 11.580018397814854],
				[24.66589094359, 11.580018397814854],
				[23.879835078354745, 11.580018397814854],
				[23.515418374548346, 11.950458518213111],
			],
			pressures: [
				0.0784313753247261, 0.062745101749897, 0.05098039284348488, 0.12156862765550613,
				0.20000000298023224, 0.26274511218070984, 0.2862745225429535, 0.34117648005485535,
				0.3803921639919281, 0.3960784375667572, 0.40784314274787903, 0.4313725531101227,
				0.42352941632270813, 0.41960784792900085, 0.3843137323856354, 0.34117648005485535,
				0.10588235408067703, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [23.515418374548346, 11.950458518213111],
		},
	],
	À: [
		{
			id: "w1ntTUle7li9gyHd62nLv",
			type: "freedraw",
			x: 220.79310565471258,
			y: 296.6876574407275,
			width: 62.453794932506185,
			height: 93.29067617443758,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 178496371,
			version: 88,
			versionNonce: 1594256765,
			isDeleted: false,
			boundElements: null,
			updated: 1751811496360,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, 1.1564959856335122],
				[0, 0.3915220784696771],
				[0, -0.7649739071638919],
				[-0.3945337867656349, -2.7075257580326593],
				[-0.7559387822760755, -5.396981266289799],
				[-1.1504725690417104, -9.264014718251872],
				[-1.5450063558072884, -10.42051070388544],
				[-1.5450063558072884, -14.660995984541671],
				[-1.5450063558072884, -17.74197357126849],
				[-1.5450063558072884, -20.822951157995305],
				[-1.5450063558072884, -24.66589094359],
				[-1.5450063558072884, -28.141402317082452],
				[-1.5450063558072884, -30.457405996645377],
				[-1.5450063558072884, -34.30335749053603],
				[-1.5450063558072884, -36.61936117009901],
				[-1.5450063558072884, -40.091860835295506],
				[-1.5450063558072884, -43.564360500492],
				[-1.1504725690417104, -46.64533808721882],
				[-0.7559387822760755, -49.35587555354738],
				[0, -52.04231935350862],
				[0, -54.35832303307154],
				[0.39754549506147896, -56.674326712634524],
				[1.1504725690416535, -59.75530429936134],
				[2.303956846379265, -62.83628188608816],
				[3.454429415420975, -65.91725947281498],
				[4.638030775717766, -68.62779693914354],
				[5.791515053055377, -71.31424073910472],
				[6.941987622097031, -74.02176649713738],
				[8.48699397790432, -76.71122200539452],
				[10.032000333711608, -79.0272256849575],
				[11.185484611049219, -80.57524374906069],
				[13.486429749132583, -83.26168754902187],
				[15.820503678471084, -84.81572902971692],
				[18.880399307126424, -86.34266513574869],
				[22.364945805506636, -88.28822869491341],
				[25.819375220927554, -89.44773638884288],
				[28.517865854072454, -90.6042323744764],
				[31.213344778921453, -91.36920628164023],
				[34.30335749053603, -91.73964640203849],
				[37.787903988916185, -92.13418018880407],
				[40.85081132586748, -92.13418018880407],
				[43.94082403748206, -92.13418018880407],
				[46.2718862585246, -91.73964640203849],
				[48.9703768916695, -90.6042323744764],
				[51.665855816518444, -88.65866881531167],
				[53.57527887613213, -86.73719892251432],
				[55.514819018705055, -84.81572902971692],
				[56.66529158774671, -82.10820327168426],
				[57.42424207831874, -79.41874776342718],
				[58.60483173031963, -76.33777017670036],
				[59.36378222089161, -74.02176649713738],
				[60.15284979442282, -70.1547330451753],
				[60.51425478993326, -66.31179325958055],
				[60.908788576698896, -62.4658417656899],
				[60.908788576698896, -59.75530429936134],
				[60.908788576698896, -54.75285681983718],
				[60.908788576698896, -50.51237153918089],
				[60.51425478993326, -47.413323702678554],
				[60.15284979442282, -43.564360500492],
				[59.758316007657186, -38.561913020967836],
				[59.36378222089161, -34.694879569005764],
				[59.36378222089161, -32.37887588944278],
				[58.96924843412597, -28.53593610384803],
				[58.60483173031963, -25.454958517121213],
				[58.2133096518499, -22.349887264027075],
				[58.2133096518499, -19.663443464065836],
				[57.81877586508432, -16.952905997737275],
				[57.81877586508432, -15.031436104939928],
				[57.81877586508432, -12.718444133672847],
				[57.42424207831874, -10.793962532579599],
				[57.42424207831874, -8.869480931486294],
				[57.42424207831874, -6.948011038688946],
				[57.42424207831874, -5.396981266289799],
				[57.81877586508432, -4.240485280656287],
				[57.81877586508432, -3.867033451962129],
				[58.2133096518499, -3.867033451962129],
				[58.2133096518499, -3.475511373492452],
				[58.2133096518499, -2.7075257580326593],
				[58.2133096518499, -1.924481601093305],
				[58.2133096518499, -1.15950769392947],
				[58.2133096518499, -0.3945337867656349],
				[58.2133096518499, 0.3915220784696771],
				[58.2133096518499, 0.7619621988678773],
				[58.2133096518499, 1.1564959856335122],
				[58.2133096518499, -0.3945337867656349],
				[57.81877586508432, -1.15950769392947],
			],
			pressures: [
				0.0784313753247261, 0.054901961237192154, 0.16862745583057404, 0.1882352977991104,
				0.2078431397676468, 0.2235294133424759, 0.22745098173618317, 0.22745098173618317,
				0.23529411852359772, 0.24313725531101227, 0.24705882370471954,
				0.24313725531101227, 0.23529411852359772, 0.239215686917305, 0.24313725531101227,
				0.24313725531101227, 0.24313725531101227, 0.239215686917305, 0.239215686917305,
				0.23137255012989044, 0.23137255012989044, 0.23137255012989044,
				0.22745098173618317, 0.22745098173618317, 0.2235294133424759, 0.21960784494876862,
				0.21960784494876862, 0.21960784494876862, 0.2235294133424759, 0.21960784494876862,
				0.21568627655506134, 0.21568627655506134, 0.21960784494876862, 0.2235294133424759,
				0.23137255012989044, 0.24313725531101227, 0.25882354378700256, 0.2666666805744171,
				0.25882354378700256, 0.2666666805744171, 0.27450981736183167, 0.29019609093666077,
				0.30980393290519714, 0.32156863808631897, 0.3294117748737335, 0.34117648005485535,
				0.3529411852359772, 0.3686274588108063, 0.3843137323856354, 0.3960784375667572,
				0.4156862795352936, 0.42352941632270813, 0.43921568989753723, 0.45490196347236633,
				0.46666666865348816, 0.47058823704719543, 0.47058823704719543,
				0.46666666865348816, 0.46666666865348816, 0.46666666865348816,
				0.45490196347236633, 0.4470588266849518, 0.43529412150382996, 0.4274509847164154,
				0.42352941632270813, 0.4274509847164154, 0.4274509847164154, 0.41960784792900085,
				0.4117647111415863, 0.4117647111415863, 0.4117647111415863, 0.4117647111415863,
				0.4156862795352936, 0.4156862795352936, 0.4117647111415863, 0.40784314274787903,
				0.40392157435417175, 0.3803921639919281, 0.3529411852359772, 0.3490196168422699,
				0.33725491166114807, 0.3333333432674408, 0.3450980484485626, 0.3450980484485626,
				0.32156863808631897, 0.03529411926865578, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [57.81877586508432, -1.15950769392947],
		},
		{
			id: "YZjMvBGg0JrbVFnWsUO43",
			type: "freedraw",
			x: 223.48858457956152,
			y: 252.72876315346986,
			width: 59.36378222089161,
			height: 2.7075257580326593,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 831447667,
			version: 32,
			versionNonce: 1944598909,
			isDeleted: false,
			boundElements: null,
			updated: 1751811497693,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[1.1534842773376113, 0],
				[1.9425518508688242, 0],
				[4.641042484013724, 0.3945337867656349],
				[7.697926404373163, 0.786055865235312],
				[10.790950824283641, 0.786055865235312],
				[16.973987955808695, 0.786055865235312],
				[21.578889940271324, 0.786055865235312],
				[25.457970225417114, 0.786055865235312],
				[28.51786585407251, 0.786055865235312],
				[32.002412352452666, 0.786055865235312],
				[35.45684176787364, 0.786055865235312],
				[38.54685447948822, 1.15950769392947],
				[40.85081132586748, 1.5480180641032462],
				[42.790351468440406, 1.5480180641032462],
				[44.33535782424764, 1.9425518508688242],
				[47.030836749096636, 1.9425518508688242],
				[48.578854813199825, 1.9425518508688242],
				[50.51538324747679, 1.9425518508688242],
				[52.0332842286208, 1.9425518508688242],
				[53.57829058442809, 1.9425518508688242],
				[54.7287631534698, 1.9425518508688242],
				[55.90935280547069, 1.9425518508688242],
				[56.668303296042666, 1.9425518508688242],
				[57.45737086957388, 1.9425518508688242],
				[58.213309651849954, 2.316003679562982],
				[58.61085514691149, 2.316003679562982],
				[58.97226014242193, 2.316003679562982],
				[59.36378222089161, 2.316003679562982],
				[58.97226014242193, 2.316003679562982],
				[58.61085514691149, 2.7075257580326593],
			],
			pressures: [
				0.0784313753247261, 0.27843138575553894, 0.29411765933036804, 0.3294117748737335,
				0.35686275362968445, 0.3686274588108063, 0.38823530077934265, 0.4000000059604645,
				0.4156862795352936, 0.42352941632270813, 0.43921568989753723, 0.4470588266849518,
				0.45098039507865906, 0.4627451002597809, 0.46666666865348816, 0.47058823704719543,
				0.4901960790157318, 0.48627451062202454, 0.48235294222831726, 0.47843137383461,
				0.47843137383461, 0.4745098054409027, 0.48627451062202454, 0.48627451062202454,
				0.4941176474094391, 0.49803921580314636, 0.49803921580314636, 0.4901960790157318,
				0.47843137383461, 0.20392157137393951, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [58.61085514691149, 2.7075257580326593],
		},
		{
			id: "xSYatVOZQIXopGCabxScf",
			type: "freedraw",
			x: 231.58405647899616,
			y: 175.6501127359731,
			width: 26.608442794458767,
			height: 21.95535347726141,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1694219837,
			version: 19,
			versionNonce: 350441395,
			isDeleted: false,
			boundElements: null,
			updated: 1751811500570,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.39754549506147896, 0],
				[0.786055865235312, 0.7649739071638351],
				[1.9395401425729233, 2.2919100131956043],
				[3.84896320218661, 3.8459514938906523],
				[6.544442127035552, 5.7674213866879995],
				[9.634454838650129, 8.083425066250982],
				[12.332945471795028, 10.004894959048329],
				[15.02842439664397, 11.947446809917153],
				[17.72691502978887, 14.245380239704588],
				[19.666455172361793, 15.793398303807805],
				[21.21146152816908, 17.714868196605153],
				[22.756467883976313, 18.874375890534623],
				[23.906940453018024, 20.030871876168135],
				[25.057413022059734, 21.190379570097576],
				[25.81636351263171, 21.584913356863183],
				[26.21089729939729, 21.95535347726141],
				[25.81636351263171, 21.95535347726141],
			],
			pressures: [
				0.0784313753247261, 0.30588236451148987, 0.3450980484485626, 0.3803921639919281,
				0.4156862795352936, 0.4470588266849518, 0.47843137383461, 0.501960813999176,
				0.5176470875740051, 0.5372549295425415, 0.5372549295425415, 0.5372549295425415,
				0.5411764979362488, 0.5490196347236633, 0.5411764979362488, 0.5411764979362488,
				0.5254902243614197, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [25.81636351263171, 21.95535347726141],
		},
	],
	È: [
		{
			id: "KGhkMXgIpd94046o3LuNa",
			type: "freedraw",
			x: 225.79254142594078,
			y: 216.50694747843244,
			width: 45.12141368948295,
			height: 79.41573605513116,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 466214429,
			version: 48,
			versionNonce: 484830451,
			isDeleted: false,
			boundElements: null,
			updated: 1751811505314,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-1.1504725690416535, 0],
				[-1.1504725690416535, 0.7619621988678773],
				[-1.5450063558072316, 1.9214698927973473],
				[-1.5450063558072316, 3.4694879569005366],
				[-1.5450063558072316, 6.550465543627354],
				[-1.5450063558072316, 9.631443130354171],
				[-1.5450063558072316, 12.317886930315353],
				[-1.906411351317729, 15.422958183409548],
				[-2.303956846379265, 18.874375890534566],
				[-2.303956846379265, 21.584913356863183],
				[-3.0568839203594393, 26.981894623152925],
				[-3.4544294154209183, 31.219368195513255],
				[-3.848963202186553, 34.69487956900571],
				[-4.24048528065623, 38.92934143307008],
				[-4.601890276166728, 43.16681500543041],
				[-4.601890276166728, 46.64232637892286],
				[-4.999435771228207, 49.72330396564968],
				[-5.393969557993842, 53.56925545954027],
				[-5.393969557993842, 55.885259139103255],
				[-5.393969557993842, 58.96623672583007],
				[-4.999435771228207, 62.438736391026566],
				[-4.601890276166728, 64.75474007058955],
				[-3.4544294154209183, 67.07375545844843],
				[-2.303956846379265, 69.38674742971546],
				[-1.1504725690416535, 70.91669524404318],
				[1.1534842773376113, 74.01875478884142],
				[2.6984906331448997, 75.94022468163877],
				[4.243496988952188, 77.4731842042624],
				[6.186048839821012, 78.6266684816],
				[8.486993977904376, 79.02120226836558],
				[11.971540476284531, 79.41573605513116],
				[15.034447813235829, 79.41573605513116],
				[19.27493309389206, 79.41573605513116],
				[21.60900702323056, 79.41573605513116],
				[24.699019734845137, 79.41573605513116],
				[27.00297658122446, 79.02120226836558],
				[30.84892807511511, 78.6266684816],
				[33.152884921494376, 78.6266684816],
				[36.24289763310895, 78.6266684816],
				[36.63743141987453, 78.25622836120175],
				[38.18243777568182, 77.86169457443611],
				[38.94138826625385, 77.4731842042624],
				[39.33592205301943, 76.7051985888026],
				[39.72744413148911, 76.31367651033293],
				[39.72744413148911, 75.94022468163877],
				[39.33592205301943, 74.78372869600526],
			],
			pressures: [
				0.0784313753247261, 0.09803921729326248, 0.16862745583057404, 0.2078431397676468,
				0.23137255012989044, 0.2666666805744171, 0.29019609093666077, 0.30588236451148987,
				0.3176470696926117, 0.3333333432674408, 0.34117648005485535, 0.34117648005485535,
				0.3294117748737335, 0.3333333432674408, 0.3333333432674408, 0.3294117748737335,
				0.3176470696926117, 0.3176470696926117, 0.30980393290519714, 0.3019607961177826,
				0.2980392277240753, 0.2823529541492462, 0.2823529541492462, 0.2862745225429535,
				0.29411765933036804, 0.2980392277240753, 0.30980393290519714, 0.3176470696926117,
				0.3176470696926117, 0.3333333432674408, 0.3607843220233917, 0.3921568691730499,
				0.42352941632270813, 0.4627451002597809, 0.48627451062202454, 0.5176470875740051,
				0.5490196347236633, 0.5686274766921997, 0.5843137502670288, 0.5882353186607361,
				0.5921568870544434, 0.5843137502670288, 0.5529412031173706, 0.529411792755127,
				0.501960813999176, 0.4470588266849518, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [39.33592205301943, 74.78372869600526],
		},
		{
			id: "BJNZipTQUv796ke1N3dCU",
			type: "freedraw",
			x: 222.33811201051986,
			y: 253.51481901870517,
			width: 44.726879902717315,
			height: 1.532959522623628,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 377147421,
			version: 22,
			versionNonce: 1933907123,
			isDeleted: false,
			boundElements: null,
			updated: 1751811506427,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[1.1504725690416535, 0],
				[1.5480180641031893, 0],
				[3.4544294154209183, 0],
				[6.547453835331453, 0.37345182869415794],
				[10.032000333711608, 0.37345182869415794],
				[14.275497322663796, 0.37345182869415794],
				[18.488877228656747, 0.37345182869415794],
				[22.729362509312978, 0.37345182869415794],
				[25.427853142457877, 0.37345182869415794],
				[27.758915363500478, 0.37345182869415794],
				[29.668338423114164, 0.37345182869415794],
				[32.36682905625901, 0],
				[34.30335749053603, 0],
				[37.39638191044651, 0],
				[39.305804970060194, 0],
				[41.24233340433716, -0.3915220784696771],
				[42.39581768167477, -0.786055865235312],
				[44.33535782424764, -1.15950769392947],
				[44.726879902717315, -1.15950769392947],
				[43.546290250716424, -0.786055865235312],
			],
			pressures: [
				0.0784313753247261, 0.25882354378700256, 0.27450981736183167, 0.32156863808631897,
				0.3529411852359772, 0.3843137323856354, 0.40784314274787903, 0.4156862795352936,
				0.42352941632270813, 0.45098039507865906, 0.4745098054409027, 0.4941176474094391,
				0.5176470875740051, 0.5333333611488342, 0.5568627715110779, 0.5647059082984924,
				0.5686274766921997, 0.5647059082984924, 0.5529412031173706, 0.5098039507865906, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [43.546290250716424, -0.786055865235312],
		},
		{
			id: "m4rWVOcJypaMgpVOBppPZ",
			type: "freedraw",
			x: 225.79254142594078,
			y: 217.26890967730031,
			width: 52.02726081202894,
			height: 2.6864437999611823,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 507673693,
			version: 28,
			versionNonce: 279624243,
			isDeleted: false,
			boundElements: null,
			updated: 1751811507540,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.3614049955104406, -0.7619621988678773],
				[0, -0.7619621988678773],
				[1.9425518508688242, -0.7619621988678773],
				[3.8820919934417475, -0.3915220784696771],
				[7.336521408862666, 0],
				[11.580018397814854, 0.3915220784696771],
				[16.21503746523672, 0.7649739071638351],
				[20.064000667423272, 0.7649739071638351],
				[23.15401337903785, 0.7649739071638351],
				[25.063436438651536, 1.15950769392947],
				[27.394498659694136, 1.551029772399147],
				[29.303921719307823, 1.924481601093305],
				[31.607878565687088, 1.924481601093305],
				[34.333474573495266, 1.924481601093305],
				[35.851375554639276, 1.924481601093305],
				[37.78790398891624, 1.924481601093305],
				[38.94138826625385, 1.924481601093305],
				[40.091860835295506, 1.924481601093305],
				[43.18187354691008, 1.551029772399147],
				[45.48583039328935, 1.15950769392947],
				[48.575843104903925, 0.3915220784696771],
				[50.909917034242426, 0],
				[51.6658558165185, -0.3915220784696771],
				[50.909917034242426, -0.3915220784696771],
				[50.12084946071121, -0.3915220784696771],
				[49.729327382241536, 0],
			],
			pressures: [
				0.0784313753247261, 0.1568627506494522, 0.25882354378700256, 0.2823529541492462,
				0.29411765933036804, 0.30980393290519714, 0.30588236451148987,
				0.30588236451148987, 0.30980393290519714, 0.30980393290519714,
				0.32549020648002625, 0.34117648005485535, 0.364705890417099, 0.3843137323856354,
				0.4000000059604645, 0.40784314274787903, 0.42352941632270813, 0.4313725531101227,
				0.4431372582912445, 0.46666666865348816, 0.5176470875740051, 0.5058823823928833,
				0.4941176474094391, 0.47058823704719543, 0.3843137323856354, 0.1411764770746231,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [49.729327382241536, 0],
		},
		{
			id: "hppweLWvtvoXV9AaNDC-C",
			type: "freedraw",
			x: 232.37011234423147,
			y: 176.02055285637132,
			width: 29.665326714818264,
			height: 30.06287220987977,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1559291379,
			version: 26,
			versionNonce: 661979069,
			isDeleted: false,
			boundElements: null,
			updated: 1751811519648,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.786055865235312, -0.3704401203982286],
				[-1.183601360296791, -0.3704401203982286],
				[-1.5450063558072884, -0.7649739071638351],
				[-1.183601360296791, -0.7649739071638351],
				[-0.3915220784696771, 0],
				[0.7589504905719764, 1.1564959856335406],
				[2.303956846379265, 3.080977586726817],
				[4.607913692758586, 5.396981266289771],
				[7.303392617607528, 7.318451159087147],
				[9.242932760180452, 8.872492639782195],
				[12.69736217560137, 11.577006689518925],
				[14.242368531408658, 12.715432425376918],
				[15.787374887215947, 14.657984276245742],
				[17.332381243023235, 16.58246587733902],
				[19.27192138559616, 19.26890967730023],
				[20.816927741403447, 21.584913356863183],
				[21.970412018741, 22.741409342496723],
				[23.12088458778271, 24.29545082319177],
				[24.66589094359, 26.21692071598912],
				[26.21089729939729, 27.767950488388266],
				[26.575314003203687, 28.138390608786466],
				[27.755903655204577, 29.297898302715936],
				[28.120320359010975, 29.297898302715936],
				[28.120320359010975, 29.297898302715936],
			],
			pressures: [
				0.0784313753247261, 0.0784313753247261, 0.054901961237192154, 0.10588235408067703,
				0.1921568661928177, 0.21568627655506134, 0.25882354378700256, 0.29019609093666077,
				0.3176470696926117, 0.34117648005485535, 0.3529411852359772, 0.3843137323856354,
				0.3960784375667572, 0.4156862795352936, 0.43529412150382996, 0.45098039507865906,
				0.46666666865348816, 0.46666666865348816, 0.48235294222831726, 0.4901960790157318,
				0.5098039507865906, 0.5098039507865906, 0.5137255191802979, 0.501960813999176, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [28.120320359010975, 29.297898302715936],
		},
	],
	É: [
		{
			id: "tiN2bSclTdhHiDzQTKRTE",
			type: "freedraw",
			x: 223.09706250109184,
			y: 213.42596989170562,
			width: 49.756432756904815,
			height: 72.84117684513643,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 828845053,
			version: 46,
			versionNonce: 2044062941,
			isDeleted: false,
			boundElements: null,
			updated: 1751811551406,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-1.1534842773376113, 0],
				[-1.1534842773376113, 0.3704401203982002],
				[-1.5450063558072884, 0.7649739071638351],
				[-1.5450063558072884, 1.1534842773376113],
				[-1.5450063558072884, 2.3129919712670244],
				[-1.5450063558072884, 3.8429397855946945],
				[-1.5450063558072884, 6.550465543627354],
				[-1.5450063558072884, 9.239921051884494],
				[-1.9064113513177858, 12.712420717080988],
				[-2.6984906331448997, 16.187932090573383],
				[-3.0598956286553403, 18.503935770136366],
				[-3.848963202186553, 23.50638324966053],
				[-4.607913692758586, 27.74385682202086],
				[-4.9994357712282635, 31.984342102677147],
				[-4.9994357712282635, 35.84836384634332],
				[-5.393969557993842, 40.08884912699955],
				[-5.393969557993842, 44.32632269935988],
				[-5.7885033447594765, 48.17227419325053],
				[-5.7885033447594765, 51.644773858447024],
				[-5.7885033447594765, 55.49072535233768],
				[-5.393969557993842, 57.80672903190066],
				[-4.607913692758586, 61.282240405393054],
				[-3.848963202186553, 63.992777871721614],
				[-3.0598956286553403, 66.3087815512846],
				[-1.5450063558072884, 68.23025144408194],
				[0.7890675735312129, 69.76019925840961],
				[3.4875582066761126, 71.31122903080876],
				[5.7885033447594765, 72.46772501644227],
				[8.48699397790432, 72.84117684513643],
				[11.577006689518896, 72.84117684513643],
				[15.031436104939871, 72.84117684513643],
				[18.91051639008566, 72.84117684513643],
				[22.759479592272214, 72.0762029379726],
				[26.21390900769319, 71.31122903080876],
				[29.303921719307766, 70.54324341534902],
				[32.39393443092234, 69.76019925840961],
				[35.84836384634332, 68.99522535124578],
				[38.18243777568182, 68.99522535124578],
				[40.48338291376518, 68.6006915644802],
				[42.03140097786837, 68.6006915644802],
				[42.78733976014445, 68.23025144408194],
				[43.57640733367566, 67.83571765731637],
				[43.96792941214534, 67.83571765731637],
				[43.57640733367566, 67.83571765731637],
			],
			pressures: [
				0.0784313753247261, 0.06666667014360428, 0.062745101749897, 0.09019608050584793,
				0.11372549086809158, 0.1411764770746231, 0.1725490242242813, 0.20392157137393951,
				0.21960784494876862, 0.24705882370471954, 0.2705882489681244, 0.2823529541492462,
				0.29411765933036804, 0.30980393290519714, 0.32156863808631897, 0.3333333432674408,
				0.3450980484485626, 0.33725491166114807, 0.33725491166114807, 0.34117648005485535,
				0.34117648005485535, 0.34117648005485535, 0.34117648005485535, 0.3333333432674408,
				0.32549020648002625, 0.32549020648002625, 0.33725491166114807, 0.3450980484485626,
				0.3529411852359772, 0.35686275362968445, 0.3686274588108063, 0.3921568691730499,
				0.40392157435417175, 0.42352941632270813, 0.43529412150382996,
				0.45490196347236633, 0.4745098054409027, 0.4901960790157318, 0.4941176474094391,
				0.501960813999176, 0.49803921580314636, 0.4941176474094391, 0.48627451062202454,
				0.4627451002597809, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [43.57640733367566, 67.83571765731637],
		},
		{
			id: "c9ADdFJBPmGIOKMip_Y0o",
			type: "freedraw",
			x: 219.2480992989053,
			y: 250.04231935350867,
			width: 35.48695885083282,
			height: 3.87004516025803,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 677086035,
			version: 21,
			versionNonce: 975846355,
			isDeleted: false,
			boundElements: null,
			updated: 1751811555913,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.3945337867656349, 0.7649739071638351],
				[0, 0.7649739071638351],
				[1.1504725690416535, 1.15950769392947],
				[3.4875582066760558, 1.15950769392947],
				[6.93897591380113, 1.15950769392947],
				[10.032000333711608, 0.7649739071638351],
				[13.880963535898161, 0],
				[18.515982603320026, -0.767985615459736],
				[22.364945805506636, -1.551029772399147],
				[25.819375220927554, -1.9214698927973473],
				[28.153449150266056, -2.316003679562982],
				[29.698455506073344, -2.71053746632856],
				[30.848928075115055, -2.71053746632856],
				[32.002412352452666, -2.71053746632856],
				[33.15288492149432, -2.71053746632856],
				[33.93894078672963, -2.71053746632856],
				[34.30335749053603, -2.71053746632856],
				[34.69789127730161, -2.71053746632856],
				[35.092425064067186, -2.316003679562982],
			],
			pressures: [
				0.0784313753247261, 0.12941177189350128, 0.14901961386203766, 0.1764705926179886,
				0.19607843458652496, 0.21568627655506134, 0.23137255012989044,
				0.24705882370471954, 0.26274511218070984, 0.27843138575553894, 0.2862745225429535,
				0.3019607961177826, 0.3137255012989044, 0.3137255012989044, 0.3176470696926117,
				0.3137255012989044, 0.29411765933036804, 0.2666666805744171, 0.1882352977991104,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [35.092425064067186, -2.316003679562982],
		},
		{
			id: "izVxzn2_ljzqNKkCUKxJm",
			type: "freedraw",
			x: 221.94357822375423,
			y: 213.03143610493998,
			width: 60.51425478993326,
			height: 4.240485280656287,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1651538749,
			version: 22,
			versionNonce: 1709112211,
			isDeleted: false,
			boundElements: null,
			updated: 1751811556945,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-1.1504725690416535, 0],
				[-0.7529270739801746, 0],
				[0, 0],
				[1.9425518508688242, 0],
				[3.4875582066761126, 0.3945337867656349],
				[7.731055195628301, 1.15950769392947],
				[12.730490966856507, 1.15950769392947],
				[18.518994311615984, 1.15950769392947],
				[23.912963869609825, 0.7649739071638351],
				[28.91239964083809, 0.3945337867656349],
				[34.30636919883193, -0.39453378676557804],
				[39.70033875682583, -0.7649739071638351],
				[43.94082403748206, -1.5510297723990902],
				[48.18432102643425, -1.5510297723990902],
				[52.81934009385611, -2.3160036795629253],
				[56.668303296042666, -2.6864437999611823],
				[58.60784343861553, -3.080977586726817],
				[59.36378222089161, -3.080977586726817],
				[59.00237722538117, -3.080977586726817],
				[58.213309651849954, -2.6864437999611823],
			],
			pressures: [
				0.0784313753247261, 0.0784313753247261, 0.11764705926179886, 0.1411764770746231,
				0.18431372940540314, 0.2078431397676468, 0.24313725531101227, 0.26274511218070984,
				0.2823529541492462, 0.29411765933036804, 0.3490196168422699, 0.4000000059604645,
				0.43921568989753723, 0.4588235318660736, 0.49803921580314636, 0.4901960790157318,
				0.48235294222831726, 0.47843137383461, 0.43529412150382996, 0.239215686917305, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [58.213309651849954, -2.6864437999611823],
		},
		{
			id: "hefaLVOF3zvURg-PjDPxQ",
			type: "freedraw",
			x: 244.70305781602644,
			y: 199.92146989279746,
			width: 35.84836384634326,
			height: 24.271357156824365,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 288191187,
			version: 20,
			versionNonce: 1619143325,
			isDeleted: false,
			boundElements: null,
			updated: 1751811558910,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7860558652352552, -0.39453378676557804],
				[-0.7860558652352552, 0],
				[-0.7860558652352552, 0.3945337867656349],
				[-1.1504725690416535, 0.3945337867656349],
				[-1.1504725690416535, 0.7649739071638351],
				[-1.5450063558072316, 0.7649739071638351],
				[-0.7860558652352552, 0.3945337867656349],
				[1.1534842773376113, -0.7649739071638351],
				[4.243496988952188, -3.080977586726789],
				[6.152920048565875, -4.24048528065623],
				[14.636902318174293, -9.63746654694603],
				[20.03087187616819, -13.106954503846566],
				[23.515418374548346, -15.796410012103706],
				[25.81636351263171, -17.73896186297253],
				[30.454394288349476, -20.425405662933713],
				[31.999400644156765, -21.584913356863183],
				[33.149873213198475, -22.349887264027018],
				[34.30335749053603, -23.50638324966053],
			],
			pressures: [
				0.0784313753247261, 0.10588235408067703, 0.11372549086809158, 0.12941177189350128,
				0.14901961386203766, 0.16470588743686676, 0.1764705926179886, 0.21568627655506134,
				0.23529411852359772, 0.250980406999588, 0.2549019753932953, 0.250980406999588,
				0.250980406999588, 0.250980406999588, 0.23137255012989044, 0.20000000298023224,
				0.13725490868091583, 0.08235294371843338, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [34.30335749053603, -23.50638324966053],
		},
	],
	Ì: [
		{
			id: "F8qArGNtz6vToG44JIU10",
			type: "freedraw",
			x: 243.9170019507912,
			y: 229.98434210267726,
			width: 0.7589504905719764,
			height: 65.14927385735518,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 294187965,
			version: 28,
			versionNonce: 1309991123,
			isDeleted: false,
			boundElements: null,
			updated: 1751811563273,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7589504905719764, 0.3915220784696771],
				[-0.7589504905719764, 1.1564959856335122],
				[-0.7589504905719764, 3.1020595447982373],
				[-0.7589504905719764, 5.7885033447594765],
				[-0.36441670380639835, 9.264014718251872],
				[-0.36441670380639835, 13.109966212142524],
				[-0.36441670380639835, 16.976999664104596],
				[-0.36441670380639835, 20.82295115799525],
				[-0.36441670380639835, 24.68697290166142],
				[-0.36441670380639835, 28.532924395552072],
				[-0.36441670380639835, 32.3999578475142],
				[-0.36441670380639835, 35.85137555463922],
				[-0.36441670380639835, 40.09186083529545],
				[-0.36441670380639835, 43.564360500491944],
				[-0.36441670380639835, 47.434405660749974],
				[-0.36441670380639835, 50.51538324747679],
				[-0.36441670380639835, 53.59636083420361],
				[-0.7589504905719764, 57.065848791104145],
				[-0.7589504905719764, 60.14682637783096],
				[-0.7589504905719764, 62.068296270628366],
				[-0.7589504905719764, 63.622337751323414],
				[-0.7589504905719764, 64.77883373695693],
				[-0.7589504905719764, 65.14927385735518],
				[-0.7589504905719764, 64.77883373695693],
				[-0.36441670380639835, 63.622337751323414],
				[-0.36441670380639835, 62.8362818860881],
			],
			pressures: [
				0.0784313753247261, 0.14509804546833038, 0.1725490242242813, 0.20000000298023224,
				0.22745098173618317, 0.250980406999588, 0.25882354378700256, 0.26274511218070984,
				0.2666666805744171, 0.2666666805744171, 0.2705882489681244, 0.2705882489681244,
				0.2705882489681244, 0.2705882489681244, 0.2705882489681244, 0.2705882489681244,
				0.26274511218070984, 0.26274511218070984, 0.26274511218070984,
				0.26274511218070984, 0.2549019753932953, 0.24313725531101227, 0.22745098173618317,
				0.1882352977991104, 0.15294118225574493, 0.03529411926865578, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-0.36441670380639835, 62.8362818860881],
		},
		{
			id: "3TiSrfGnUP39hNuZl1B9d",
			type: "freedraw",
			x: 222.73565750558134,
			y: 193.75951471934388,
			width: 18.482853812064945,
			height: 21.193391278393506,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 11617853,
			version: 17,
			versionNonce: 249727091,
			isDeleted: false,
			boundElements: null,
			updated: 1751811564613,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, 0.37345182869415794],
				[0.36140499551049743, 1.159507693929413],
				[1.1504725690417104, 2.3160036795629537],
				[3.0568839203594393, 4.24048528065623],
				[5.393969557993898, 6.161955173453578],
				[7.697926404373163, 8.47795885301656],
				[9.634454838650129, 10.793962532579542],
				[11.543877898263815, 13.480406332540724],
				[13.088884254071104, 15.42596989170545],
				[14.636902318174293, 16.955917706033176],
				[16.18190867398158, 18.11241369166669],
				[17.332381243023292, 19.2719213855961],
				[17.72691502978887, 20.43142907952557],
				[18.09133173359527, 21.193391278393506],
				[18.482853812064945, 20.819939449699348],
			],
			pressures: [
				0.0784313753247261, 0.1411764770746231, 0.16470588743686676, 0.1882352977991104,
				0.2078431397676468, 0.239215686917305, 0.2823529541492462, 0.30980393290519714,
				0.3333333432674408, 0.3450980484485626, 0.3607843220233917, 0.364705890417099,
				0.3764705955982208, 0.3764705955982208, 0.364705890417099, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [18.482853812064945, 20.819939449699348],
		},
	],
	Ò: [
		{
			id: "yzTdjMoPMVnuFJsMO7nex",
			type: "freedraw",
			x: 247.40154844917134,
			y: 203.7885033447596,
			width: 86.36374709382011,
			height: 95.6066798540005,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 242273523,
			version: 105,
			versionNonce: 1461934685,
			isDeleted: false,
			boundElements: null,
			updated: 1751811575745,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7890675735312129, 0.3704401203982002],
				[-1.1534842773376113, 0.3704401203982002],
				[-1.5450063558072884, 0.7649739071638351],
				[-2.6984906331448997, 0.7649739071638351],
				[-3.484546498380155, 0.7649739071638351],
				[-5.029552854187443, 1.159507693929413],
				[-6.93897591380113, 1.5299478143276701],
				[-8.878516056373996, 1.9244816010932482],
				[-12.332945471794972, 2.6864437999611823],
				[-15.031436104939871, 3.4514177071250174],
				[-17.365510034278373, 4.610925401054487],
				[-19.666455172361736, 6.161955173453578],
				[-23.154013379037792, 8.848398973414817],
				[-24.66589094359, 10.00790666734423],
				[-28.153449150266056, 13.480406332540724],
				[-30.457405996645377, 16.56138391926754],
				[-32.396946139218244, 19.64236150599436],
				[-33.547418708259954, 22.744421050792596],
				[-34.69789127730161, 26.19583875791767],
				[-35.85137555463922, 29.668338423114164],
				[-37.03196520664011, 33.14384979660656],
				[-38.18243777568176, 36.619361170098955],
				[-38.941388266253796, 40.462300955693706],
				[-39.335922053019374, 43.9378123291861],
				[-40.09186083529545, 47.413323702678554],
				[-40.486394622061084, 50.88281165957909],
				[-40.486394622061084, 54.337241075000065],
				[-40.486394622061084, 58.59579660543187],
				[-40.486394622061084, 62.8362818860881],
				[-39.335922053019374, 66.67922167168285],
				[-38.18243777568176, 70.54926683194083],
				[-37.03196520664011, 74.39521832583148],
				[-35.48695885083282, 77.4731842042624],
				[-34.30636919883193, 80.94869557775479],
				[-32.78846821768792, 83.63513937771603],
				[-30.851939783410955, 86.34266513574863],
				[-28.153449150266056, 88.26413502854604],
				[-24.66589094359, 89.81817650924108],
				[-20.81692774140339, 91.34511261527285],
				[-16.967964539216837, 92.13418018880401],
				[-13.516546832091763, 92.8991540959679],
				[-8.878516056373996, 93.66111629483578],
				[-4.243496988952131, 93.66111629483578],
				[0.36441670380639835, 93.66111629483578],
				[3.84896320218661, 93.66111629483578],
				[6.93897591380113, 93.66111629483578],
				[10.393405329222105, 93.66111629483578],
				[14.242368531408715, 92.8991540959679],
				[17.332381243023292, 91.34511261527285],
				[20.422393954637812, 89.03212064400577],
				[23.51240666625239, 86.73719892251427],
				[26.21089729939729, 84.02967316448161],
				[29.300910011011865, 81.34021765622447],
				[31.210333070625552, 79.02421397666149],
				[33.14987321319842, 76.71122200539446],
				[34.30034578224013, 74.78674040430116],
				[36.24289763310895, 71.68468085950292],
				[37.754775197661104, 68.99823705954174],
				[39.29978155346839, 65.52272568604928],
				[41.24233340433716, 61.67677419215863],
				[41.998272186613235, 59.73121063299391],
				[42.78733976014445, 56.65023304626709],
				[43.54327854242052, 53.19881533914207],
				[44.33234611595174, 48.940259808710266],
				[44.693751111462234, 46.64533808721876],
				[45.09129660652377, 43.17283842202227],
				[45.48583039328935, 40.09186083529545],
				[45.48583039328935, 36.98980129049721],
				[45.877352471759025, 33.908823703770395],
				[45.48583039328935, 30.433312330278],
				[44.693751111462234, 26.981894623152925],
				[43.94082403748206, 23.900917036426165],
				[43.18187354691008, 21.584913356863183],
				[41.998272186613235, 19.64236150599436],
				[40.453265830806004, 17.72089161319701],
				[38.938376557957895, 16.187932090573383],
				[37.39337020215061, 13.871928411010401],
				[35.84535213804742, 11.950458518213054],
				[34.697891277301665, 10.00790666734423],
				[33.54440699996405, 8.848398973414817],
				[31.60486685739113, 6.5564889602192125],
				[30.05684879328794, 4.610925401054487],
				[27.755903655204577, 3.080977586726817],
				[25.057413022059677, 1.5299478143276701],
				[22.726350801017134, 0.3704401203982002],
				[20.816927741403447, -0.3915220784696771],
				[18.87738759883058, -1.1564959856335122],
				[16.937847456257657, -1.551029772399147],
				[15.02842439664397, -1.9455635591647251],
				[12.724467550264706, -1.9455635591647251],
				[9.634454838650129, -1.9455635591647251],
				[6.544442127035552, -1.551029772399147],
				[2.6954789248489988, -1.551029772399147],
				[0.7559387822760755, -1.551029772399147],
				[-1.9395401425728664, -1.1564959856335122],
				[-3.848963202186553, -0.786055865235312],
				[-6.574559209994732, 0.3704401203982002],
				[-9.273049843139631, 1.159507693929413],
				[-11.968528767988573, 1.5299478143276701],
				[-13.87795182760226, 1.9244816010932482],
				[-14.667019401133473, 2.294921721491505],
				[-15.031436104939871, 2.294921721491505],
				[-15.422958183409548, 3.080977586726817],
			],
			pressures: [
				0.0784313753247261, 0.05882352963089943, 0.07450980693101883, 0.12941177189350128,
				0.16078431904315948, 0.1725490242242813, 0.2078431397676468, 0.22745098173618317,
				0.23137255012989044, 0.24705882370471954, 0.25882354378700256,
				0.26274511218070984, 0.2705882489681244, 0.27450981736183167, 0.29019609093666077,
				0.2980392277240753, 0.2980392277240753, 0.3019607961177826, 0.30980393290519714,
				0.3176470696926117, 0.32549020648002625, 0.3294117748737335, 0.3333333432674408,
				0.3333333432674408, 0.33725491166114807, 0.34117648005485535, 0.3490196168422699,
				0.3529411852359772, 0.364705890417099, 0.3686274588108063, 0.3803921639919281,
				0.3843137323856354, 0.3843137323856354, 0.3843137323856354, 0.3843137323856354,
				0.4000000059604645, 0.40784314274787903, 0.41960784792900085, 0.43529412150382996,
				0.45098039507865906, 0.4627451002597809, 0.47058823704719543, 0.48235294222831726,
				0.48235294222831726, 0.48627451062202454, 0.4901960790157318, 0.4941176474094391,
				0.49803921580314636, 0.5058823823928833, 0.5137255191802979, 0.5176470875740051,
				0.5176470875740051, 0.5137255191802979, 0.5098039507865906, 0.4941176474094391,
				0.48627451062202454, 0.47843137383461, 0.47058823704719543, 0.47058823704719543,
				0.46666666865348816, 0.46666666865348816, 0.46666666865348816,
				0.46666666865348816, 0.46666666865348816, 0.46666666865348816,
				0.46666666865348816, 0.46666666865348816, 0.46666666865348816,
				0.47058823704719543, 0.46666666865348816, 0.4588235318660736, 0.45490196347236633,
				0.45490196347236633, 0.4627451002597809, 0.47058823704719543, 0.48235294222831726,
				0.47843137383461, 0.47843137383461, 0.4745098054409027, 0.48235294222831726,
				0.48627451062202454, 0.47843137383461, 0.4627451002597809, 0.43529412150382996,
				0.40784314274787903, 0.40392157435417175, 0.40784314274787903,
				0.40784314274787903, 0.41960784792900085, 0.4156862795352936, 0.4117647111415863,
				0.40784314274787903, 0.40392157435417175, 0.4000000059604645, 0.40784314274787903,
				0.4117647111415863, 0.4117647111415863, 0.3921568691730499, 0.364705890417099,
				0.3294117748737335, 0.27843138575553894, 0.20392157137393951, 0.1411764770746231,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-15.422958183409548, 3.080977586726817],
		},
		{
			id: "olAPS17PFBrsxCNYJD6B-",
			type: "freedraw",
			x: 232.73452904803787,
			y: 168.30756791051857,
			width: 28.514854145776553,
			height: 21.97944714362876,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1288447773,
			version: 20,
			versionNonce: 1247473267,
			isDeleted: false,
			boundElements: null,
			updated: 1751811577991,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, -1.159507693929413],
				[-0.36441670380639835, -1.159507693929413],
				[0, -1.159507693929413],
				[1.5450063558072884, 0],
				[2.6984906331448997, 1.1564959856335406],
				[5.029552854187443, 3.080977586726817],
				[8.092460191138741, 5.791515053055377],
				[10.81805619894692, 8.477958853016617],
				[15.422958183409548, 11.577006689518925],
				[18.90750468178976, 13.874940119306359],
				[21.605995314934603, 15.817491970175183],
				[23.906940453018024, 17.73896186297253],
				[25.454958517121213, 18.898469556902],
				[26.9999648729285, 20.054965542535513],
				[27.39148695139818, 20.42841737122967],
				[27.755903655204577, 20.42841737122967],
				[28.150437441970155, 20.819939449699348],
				[28.150437441970155, 20.819939449699348],
			],
			pressures: [
				0.0784313753247261, 0.10588235408067703, 0.14509804546833038, 0.21176470816135406,
				0.24313725531101227, 0.27843138575553894, 0.3137255012989044, 0.3490196168422699,
				0.37254902720451355, 0.4000000059604645, 0.4117647111415863, 0.4274509847164154,
				0.43529412150382996, 0.4588235318660736, 0.47058823704719543, 0.48235294222831726,
				0.46666666865348816, 0.07058823853731155, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [28.150437441970155, 20.819939449699348],
		},
	],
	Ù: [
		{
			id: "n8CYF0RbaJZa5LKbfP9Z0",
			type: "freedraw",
			x: 221.55205614528455,
			y: 217.26890967730031,
			width: 61.273205280505294,
			height: 84.41818353465538,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1410792189,
			version: 69,
			versionNonce: 971156605,
			isDeleted: false,
			boundElements: null,
			updated: 1751811582184,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, 1.15950769392947],
				[0, 1.551029772399147],
				[0, 1.924481601093305],
				[0, 2.7075257580326593],
				[-0.36140499551049743, 3.4724996651964943],
				[-0.36140499551049743, 4.240485280656287],
				[-0.7589504905719764, 6.161955173453634],
				[-1.5148892728480519, 9.264014718251872],
				[-2.303956846379265, 12.344992304978689],
				[-2.6984906331448997, 16.58246587733902],
				[-3.062907336951298, 20.822951157995305],
				[-3.062907336951298, 25.454958517121213],
				[-3.062907336951298, 29.692432089481542],
				[-3.062907336951298, 33.93291737013783],
				[-3.062907336951298, 38.935364849661994],
				[-3.062907336951298, 43.564360500492],
				[-2.6984906331448997, 47.80183407285233],
				[-1.9094230596136867, 52.04231935350856],
				[-1.1534842773376113, 55.51783072700101],
				[0.3915220784696771, 59.75530429936134],
				[2.3340739293385013, 63.99277787172167],
				[4.635019067421865, 67.46828924521407],
				[7.333509700566765, 70.1547330451753],
				[9.273049843139631, 72.09728489604407],
				[12.727479258560606, 75.17826248277089],
				[16.21202575694076, 77.49426616233387],
				[20.819939449699348, 80.18070996229505],
				[22.759479592272214, 80.94568386945889],
				[26.21390900769319, 81.34021765622452],
				[33.93894078672963, 79.81026984189685],
				[37.39337020215061, 79.02421397666154],
				[38.938376557957895, 79.02421397666154],
				[41.272450487296396, 78.25924006949771],
				[43.96792941214534, 77.49426616233387],
				[47.030836749096636, 74.78372869600531],
				[49.72631567394558, 72.09728489604407],
				[52.06038960328408, 69.38975913801141],
				[53.60539595909137, 67.07375545844849],
				[55.150402314898656, 64.38731165848725],
				[55.90634109717473, 61.30633407176043],
				[56.665291587746765, 58.59579660543187],
				[57.05982537451234, 52.807293260672395],
				[57.45435916127792, 48.566807980016165],
				[57.845881239747655, 46.25080430045318],
				[57.845881239747655, 44.329334407655836],
				[58.210297943553996, 41.24835682092902],
				[58.210297943553996, 37.775857155732524],
				[58.210297943553996, 33.93291737013783],
				[58.210297943553996, 30.457405996645377],
				[58.210297943553996, 26.611454502754725],
				[58.210297943553996, 24.66589094359],
				[57.845881239747655, 21.584913356863183],
				[57.845881239747655, 19.268909677300257],
				[57.45435916127792, 16.58246587733902],
				[57.45435916127792, 13.871928411010458],
				[57.45435916127792, 12.344992304978689],
				[57.05982537451234, 9.634454838650129],
				[56.665291587746765, 7.709973237556824],
				[56.30087488394037, 5.023529437595641],
				[55.90634109717473, 2.7075257580326593],
				[55.514819018705055, 1.15950769392947],
				[54.75586852813308, -0.3915220784696771],
				[54.36133474136744, -1.5299478143276701],
				[53.969812662897766, -2.3160036795629253],
				[53.21086217232579, -2.6894555082570832],
				[53.21086217232579, -3.0779658784308594],
				[53.21086217232579, -2.3160036795629253],
			],
			pressures: [
				0.0784313753247261, 0.08627451211214066, 0.11372549086809158, 0.1411764770746231,
				0.1725490242242813, 0.20000000298023224, 0.21176470816135406, 0.24705882370471954,
				0.2549019753932953, 0.27450981736183167, 0.29411765933036804, 0.30588236451148987,
				0.3137255012989044, 0.3176470696926117, 0.32156863808631897, 0.3294117748737335,
				0.3333333432674408, 0.33725491166114807, 0.3450980484485626, 0.3607843220233917,
				0.3686274588108063, 0.37254902720451355, 0.3764705955982208, 0.3686274588108063,
				0.3686274588108063, 0.364705890417099, 0.364705890417099, 0.3607843220233917,
				0.3607843220233917, 0.364705890417099, 0.3843137323856354, 0.40392157435417175,
				0.41960784792900085, 0.41960784792900085, 0.42352941632270813, 0.4274509847164154,
				0.4156862795352936, 0.42352941632270813, 0.42352941632270813, 0.42352941632270813,
				0.41960784792900085, 0.40784314274787903, 0.40392157435417175,
				0.40392157435417175, 0.3960784375667572, 0.3960784375667572, 0.38823530077934265,
				0.3764705955982208, 0.37254902720451355, 0.3764705955982208, 0.3764705955982208,
				0.3764705955982208, 0.3803921639919281, 0.37254902720451355, 0.35686275362968445,
				0.3450980484485626, 0.3450980484485626, 0.34117648005485535, 0.3450980484485626,
				0.33725491166114807, 0.33725491166114807, 0.3294117748737335, 0.32549020648002625,
				0.32156863808631897, 0.3019607961177826, 0.23137255012989044, 0.1725490242242813,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [53.21086217232579, -2.3160036795629253],
		},
		{
			id: "1VORkB70Y9xFozo1-tkRp",
			type: "freedraw",
			x: 233.52359662156908,
			y: 187.20603746742057,
			width: 22.756467883976313,
			height: 28.138390608786494,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 792031549,
			version: 19,
			versionNonce: 215002291,
			isDeleted: false,
			boundElements: null,
			updated: 1751811584067,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.3945337867656349, -0.7649739071638351],
				[-0.3945337867656349, -0.3915220784696771],
				[0.36140499551049743, 0.3915220784696771],
				[1.5450063558072884, 2.3160036795629537],
				[3.454429415420975, 5.0024474795241645],
				[6.149908340269917, 8.474947144720659],
				[8.848398973414817, 11.950458518213054],
				[11.543877898263759, 15.031436104939871],
				[13.87795182760226, 17.347439784502853],
				[15.422958183409548, 19.2689096773002],
				[16.57343075245126, 20.82295115799525],
				[18.877387598830524, 23.903928744722066],
				[20.027860167872234, 25.430864850753835],
				[21.572866523679522, 26.590372544683248],
				[22.36193409721068, 27.37341670162266],
				[21.572866523679522, 27.37341670162266],
				[21.18134444520979, 26.984906331448883],
			],
			pressures: [
				0.0784313753247261, 0.14509804546833038, 0.239215686917305, 0.27450981736183167,
				0.2980392277240753, 0.3176470696926117, 0.3333333432674408, 0.3333333432674408,
				0.32156863808631897, 0.32156863808631897, 0.3176470696926117, 0.32549020648002625,
				0.3529411852359772, 0.3843137323856354, 0.3921568691730499, 0.3803921639919281,
				0.07450980693101883, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [21.18134444520979, 26.984906331448883],
		},
	],
	a: [
		{
			id: "nLeiq5-s1X2p05Ds8c8Q7",
			type: "freedraw",
			x: 231.58405647899616,
			y: 253.88827084739933,
			width: 42.78432805184855,
			height: 57.0688604994001,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1277439891,
			version: 66,
			versionNonce: 1960648477,
			isDeleted: false,
			boundElements: null,
			updated: 1751811622617,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, -1.15950769392947],
				[0.786055865235312, -1.924481601093305],
				[2.3009451380834207, -3.454429415420975],
				[4.635019067421865, -5.396981266289799],
				[8.483982269608475, -7.712984945852725],
				[12.332945471795028, -8.848398973414817],
				[16.18190867398158, -9.63746654694603],
				[20.05797725083147, -9.63746654694603],
				[24.3014742397836, -9.63746654694603],
				[27.361369868439, -8.848398973414817],
				[31.996388935860864, -8.083425066250982],
				[34.694879569005764, -6.5564889602192125],
				[37.390358493854706, -5.0024474795241645],
				[40.088849126999605, -1.924481601093305],
				[41.23932169604126, 0.7830441569393543],
				[42.02838926957247, 4.6289956508300065],
				[42.41991134804215, 7.709973237556824],
				[42.78432805184855, 11.947446809917153],
				[42.78432805184855, 16.187932090573383],
				[42.78432805184855, 20.44949932930109],
				[42.78432805184855, 24.295450823191743],
				[42.78432805184855, 28.532924395552072],
				[42.78432805184855, 31.61390198227889],
				[42.41991134804215, 34.69487956900571],
				[42.02838926957247, 37.01088324856869],
				[42.02838926957247, 39.32387521983571],
				[42.02838926957247, 40.480371205469226],
				[42.02838926957247, 40.87490499223486],
				[41.633855482806894, 40.87490499223486],
				[41.23932169604126, 40.480371205469226],
				[40.87490499223486, 38.932353141366036],
				[40.48338291376518, 36.63743141987453],
				[39.69431534023397, 33.16192004638208],
				[38.17942606738592, 28.92444647402175],
				[35.84535213804742, 25.057413022059677],
				[32.75533942643284, 21.97643543533286],
				[30.0598605015839, 20.819939449699348],
				[24.3014742397836, 19.289991635371678],
				[20.816927741403447, 18.503935770136366],
				[16.967964539216894, 17.73896186297253],
				[13.483418040836682, 17.344428076206952],
				[11.179461194457417, 17.73896186297253],
				[7.725031779036442, 20.44949932930109],
				[4.635019067421865, 23.530476916027908],
				[3.4845464983802117, 25.057413022059677],
				[2.3009451380834207, 28.92444647402175],
				[1.9395401425729233, 32.00542406074857],
				[1.9395401425729233, 35.47792372594506],
				[3.4845464983802117, 38.55890131267188],
				[5.393969557993898, 40.87490499223486],
				[8.483982269608475, 43.19090867179784],
				[11.96852876798863, 45.11539027289109],
				[16.18190867398158, 46.64232637892286],
				[20.816927741403447, 47.43139395245407],
				[25.81636351263171, 47.43139395245407],
				[30.451382580053576, 47.43139395245407],
				[34.30034578224013, 47.036860165688495],
				[36.99883641538503, 46.2718862585246],
				[38.935364849661994, 45.877352471759025],
				[40.87490499223486, 44.72085648612551],
				[41.633855482806894, 43.95588257896168],
				[42.78432805184855, 42.40485280656253],
				[42.78432805184855, 41.639878899398695],
				[42.41991134804215, 41.639878899398695],
			],
			pressures: [
				0.0784313753247261, 0.20392157137393951, 0.24313725531101227, 0.27450981736183167,
				0.2862745225429535, 0.3019607961177826, 0.3176470696926117, 0.3490196168422699,
				0.3921568691730499, 0.45098039507865906, 0.4588235318660736, 0.48627451062202454,
				0.501960813999176, 0.5098039507865906, 0.5176470875740051, 0.5176470875740051,
				0.5058823823928833, 0.501960813999176, 0.501960813999176, 0.501960813999176,
				0.5098039507865906, 0.49803921580314636, 0.48627451062202454, 0.4745098054409027,
				0.4588235318660736, 0.4470588266849518, 0.4313725531101227, 0.40784314274787903,
				0.3803921639919281, 0.2980392277240753, 0.27843138575553894, 0.2666666805744171,
				0.250980406999588, 0.23529411852359772, 0.21568627655506134, 0.21176470816135406,
				0.21960784494876862, 0.24705882370471954, 0.2666666805744171, 0.27843138575553894,
				0.2862745225429535, 0.2862745225429535, 0.2823529541492462, 0.2549019753932953,
				0.24313725531101227, 0.23137255012989044, 0.2549019753932953, 0.27843138575553894,
				0.30588236451148987, 0.32156863808631897, 0.33725491166114807, 0.3607843220233917,
				0.3921568691730499, 0.4431372582912445, 0.48235294222831726, 0.4901960790157318,
				0.501960813999176, 0.5333333611488342, 0.5568627715110779, 0.5764706134796143,
				0.572549045085907, 0.5333333611488342, 0.4431372582912445, 0.3019607961177826, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [42.41991134804215, 41.639878899398695],
		},
	],
	b: [
		{
			id: "GWauCKF7Nsbpr98I8Qc2u",
			type: "freedraw",
			x: 244.31153573755677,
			y: 272.3922066175357,
			width: 33.541395291668096,
			height: 31.613901982278946,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1260533821,
			version: 48,
			versionNonce: 1391918291,
			isDeleted: false,
			boundElements: null,
			updated: 1751811626881,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7589504905719764, -0.3704401203982002],
				[-0.7589504905719764, -0.7649739071638351],
				[-1.1534842773375544, -1.159507693929413],
				[-1.9395401425728664, -1.5299478143276701],
				[-2.698490633144843, -1.9244816010932482],
				[-3.848963202186553, -1.9244816010932482],
				[-5.393969557993842, -1.9244816010932482],
				[-7.333509700566708, -1.5299478143276701],
				[-8.878516056373996, -0.3704401203982002],
				[-10.426534120477186, 1.551029772399147],
				[-11.577006689518896, 4.237473572360329],
				[-12.332945471794972, 7.3425448254545245],
				[-12.332945471794972, 11.577006689518953],
				[-12.332945471794972, 15.425969891705506],
				[-10.787939115987683, 18.506947478432323],
				[-8.878516056373996, 21.58792506515914],
				[-6.1830371315250545, 23.900917036426165],
				[-2.698490633144843, 26.216920715989147],
				[0.3915220784696771, 27.767950488388237],
				[3.8459514938906523, 28.53292439555213],
				[5.390957849697941, 28.53292439555213],
				[10.784927407691839, 28.53292439555213],
				[14.269473906071994, 27.37341670162266],
				[17.332381243023292, 25.451946808825312],
				[19.268909677300257, 23.530476916027908],
				[20.42239395463787, 21.214473236464983],
				[20.816927741403447, 18.898469556902],
				[21.208449819873124, 15.817491970175183],
				[21.208449819873124, 12.736514383448366],
				[20.42239395463787, 9.634454838650129],
				[18.87738759883058, 7.3425448254545245],
				[16.57343075245126, 4.632007359125964],
				[14.269473906071994, 1.9455635591647251],
				[11.179461194457417, -0.3704401203982002],
				[7.694914696077262, -1.9244816010932482],
				[4.635019067421865, -2.6864437999611823],
				[2.300945138083364, -3.080977586726817],
				[0.3915220784696771, -3.080977586726817],
				[-1.9395401425728664, -2.6864437999611823],
				[-3.848963202186553, -2.6864437999611823],
				[-6.1830371315250545, -1.9244816010932482],
				[-8.48699397790432, -0.3704401203982002],
				[-10.426534120477186, 1.9455635591647251],
				[-11.577006689518896, 4.632007359125964],
				[-11.577006689518896, 8.10751873261836],
				[-11.182472902753318, 8.869480931486294],
			],
			pressures: [
				0.0784313753247261, 0.05098039284348488, 0.062745101749897, 0.12156862765550613,
				0.1568627506494522, 0.20392157137393951, 0.25882354378700256, 0.2980392277240753,
				0.32549020648002625, 0.3529411852359772, 0.3686274588108063, 0.3686274588108063,
				0.3764705955982208, 0.38823530077934265, 0.40784314274787903, 0.40784314274787903,
				0.4117647111415863, 0.41960784792900085, 0.43529412150382996, 0.43921568989753723,
				0.4431372582912445, 0.43921568989753723, 0.4313725531101227, 0.42352941632270813,
				0.4156862795352936, 0.40784314274787903, 0.3960784375667572, 0.3921568691730499,
				0.3764705955982208, 0.37254902720451355, 0.37254902720451355, 0.37254902720451355,
				0.37254902720451355, 0.364705890417099, 0.3686274588108063, 0.3764705955982208,
				0.40392157435417175, 0.42352941632270813, 0.4431372582912445, 0.4431372582912445,
				0.4313725531101227, 0.42352941632270813, 0.3960784375667572, 0.3607843220233917,
				0.2823529541492462, 0.10588235408067703, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-11.182472902753318, 8.869480931486294],
		},
		{
			id: "dDA4RrZoLbDIHX1sCCiJF",
			type: "freedraw",
			x: 229.67463341938253,
			y: 244.2508043004533,
			width: 3.848963202186553,
			height: 52.82837521874387,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1681549885,
			version: 23,
			versionNonce: 1035858483,
			isDeleted: false,
			boundElements: null,
			updated: 1751811627839,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.3945337867656349, 1.15950769392947],
				[-0.3945337867656349, 1.554041480695048],
				[-0.7890675735312129, 3.87004516025803],
				[-0.7890675735312129, 7.712984945852725],
				[-0.7890675735312129, 13.106954503846623],
				[-0.7890675735312129, 18.898469556902],
				[-0.3945337867656349, 23.530476916027908],
				[0.3614049955104406, 27.37642840991856],
				[0.7589504905719764, 32.008435769044524],
				[0.7589504905719764, 35.48394714253692],
				[1.1504725690416535, 38.56191302096778],
				[1.511877564552151, 41.642890607694596],
				[1.511877564552151, 44.72085648612551],
				[1.511877564552151, 48.19636785961791],
				[1.511877564552151, 50.88281165957915],
				[1.511877564552151, 52.436853140274195],
				[1.511877564552151, 52.82837521874387],
				[1.90942305961363, 52.82837521874387],
				[2.303956846379265, 52.82837521874387],
				[2.695478924848942, 50.88281165957915],
				[3.0598956286553403, 50.117837752415255],
			],
			pressures: [
				0.0784313753247261, 0.1411764770746231, 0.16470588743686676, 0.22745098173618317,
				0.29411765933036804, 0.33725491166114807, 0.3607843220233917, 0.37254902720451355,
				0.3803921639919281, 0.37254902720451355, 0.3607843220233917, 0.3607843220233917,
				0.3529411852359772, 0.3529411852359772, 0.3529411852359772, 0.3529411852359772,
				0.3529411852359772, 0.3333333432674408, 0.29019609093666077, 0.21176470816135406,
				0.07058823853731155, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [3.0598956286553403, 50.117837752415255],
		},
	],
	c: [
		{
			id: "Ib4AK8IYNtcfoAmJWN7bt",
			type: "freedraw",
			x: 253.55145678944132,
			y: 270.862258803208,
			width: 30.0598605015839,
			height: 32.375864181146824,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1687460627,
			version: 37,
			versionNonce: 508348605,
			isDeleted: false,
			boundElements: null,
			updated: 1751811632178,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.39453378676557804, -0.786055865235312],
				[0.39453378676557804, -1.1564959856335122],
				[0.39453378676557804, -1.551029772399147],
				[0.39453378676557804, -1.9455635591647251],
				[0.39453378676557804, -2.316003679562982],
				[-0.36441670380639835, -2.71053746632856],
				[-2.300945138083364, -3.080977586726817],
				[-2.6954789248489988, -3.080977586726817],
				[-5.393969557993898, -3.4724996651964943],
				[-7.303392617607585, -3.4724996651964943],
				[-9.998871542456527, -3.4724996651964943],
				[-13.088884254071104, -3.080977586726817],
				[-16.57343075245126, -1.551029772399147],
				[-18.87738759883058, 1.15950769392947],
				[-20.027860167872234, 3.080977586726817],
				[-21.181344445209845, 6.5564889602192125],
				[-21.967400310445157, 9.63746654694603],
				[-21.967400310445157, 13.874940119306359],
				[-21.967400310445157, 17.347439784502853],
				[-21.181344445209845, 20.42841737122967],
				[-19.666455172361736, 23.11787287948681],
				[-18.118437108258547, 24.271357156824422],
				[-14.633890609878392, 26.216920715989147],
				[-11.543877898263815, 27.352334743551182],
				[-9.23992105188455, 28.141402317082395],
				[-5.393969557993898, 28.90336451595033],
				[-3.059895628655397, 28.90336451595033],
				[1.1534842773375544, 28.90336451595033],
				[4.243496988952131, 28.511842437480652],
				[5.78850334475942, 28.141402317082395],
				[6.93897591380113, 27.746868530316817],
				[7.333509700566708, 27.352334743551182],
				[7.728043487332343, 26.981894623152982],
				[8.092460191138741, 26.587360836387347],
				[8.092460191138741, 26.216920715989147],
			],
			pressures: [
				0.0784313753247261, 0.09019608050584793, 0.12941177189350128, 0.1764705926179886,
				0.250980406999588, 0.29019609093666077, 0.3490196168422699, 0.3803921639919281,
				0.40392157435417175, 0.43529412150382996, 0.4274509847164154, 0.4470588266849518,
				0.42352941632270813, 0.4156862795352936, 0.40392157435417175, 0.3921568691730499,
				0.38823530077934265, 0.38823530077934265, 0.3843137323856354, 0.38823530077934265,
				0.3921568691730499, 0.3921568691730499, 0.4000000059604645, 0.40784314274787903,
				0.4156862795352936, 0.4274509847164154, 0.4588235318660736, 0.4627451002597809,
				0.47843137383461, 0.4745098054409027, 0.4745098054409027, 0.45490196347236633,
				0.45490196347236633, 0.3960784375667572, 0.2862745225429535, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [8.092460191138741, 26.216920715989147],
		},
	],
	d: [
		{
			id: "2XB0Kzi8EqMxFtXRjA-tm",
			type: "freedraw",
			x: 241.2185113176463,
			y: 277.02421397666166,
			width: 29.695443797777443,
			height: 26.587360836387404,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 298378451,
			version: 40,
			versionNonce: 1809880115,
			isDeleted: false,
			boundElements: null,
			updated: 1751811635914,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-1.1504725690416535, 0],
				[-1.5450063558072884, -0.3945337867656349],
				[-2.300945138083364, -0.3945337867656349],
				[-2.695478924848942, -0.7649739071638351],
				[-3.454429415420975, -0.7649739071638351],
				[-4.24048528065623, -0.7649739071638351],
				[-4.9994357712282635, 0.39453378676557804],
				[-6.149908340269917, 2.71053746632856],
				[-6.93897591380113, 5.3969812662897425],
				[-7.333509700566708, 8.869480931486237],
				[-7.333509700566708, 13.106954503846566],
				[-6.544442127035552, 16.58246587733902],
				[-4.24048528065623, 19.2689096773002],
				[-1.5450063558072884, 21.190379570097548],
				[1.9395401425729233, 22.741409342496695],
				[5.7885033447594765, 23.50638324966053],
				[8.878516056374053, 23.900917036426165],
				[11.96852876798863, 23.50638324966053],
				[15.031436104939871, 21.97944714362876],
				[17.72691502978887, 20.054965542535513],
				[19.666455172361736, 17.73896186297253],
				[21.211461528169025, 15.02842439664397],
				[21.970412018741058, 11.947446809917153],
				[22.361934097210735, 8.47795885301656],
				[21.60599531493466, 5.0024474795241645],
				[20.06098895912737, 2.3160036795629253],
				[17.72691502978887, 0.39453378676557804],
				[13.122013045326185, -1.551029772399147],
				[11.182472902753318, -1.921469892797404],
				[7.333509700566765, -2.686443799961239],
				[3.848963202186553, -2.686443799961239],
				[1.1534842773376113, -2.686443799961239],
				[-1.1504725690416535, -1.921469892797404],
				[-2.695478924848942, -0.3945337867656349],
				[-4.604901984462629, 3.4755113734923953],
				[-5.785491636463519, 8.104507024322402],
				[-5.785491636463519, 12.71543242537689],
				[-5.393969557993842, 15.422958183409548],
			],
			pressures: [
				0.0784313753247261, 0.04313725605607033, 0.06666667014360428, 0.10980392247438431,
				0.1411764770746231, 0.16862745583057404, 0.20392157137393951, 0.24313725531101227,
				0.2705882489681244, 0.3019607961177826, 0.3294117748737335, 0.3529411852359772,
				0.3686274588108063, 0.37254902720451355, 0.3686274588108063, 0.3686274588108063,
				0.3529411852359772, 0.34117648005485535, 0.3333333432674408, 0.3333333432674408,
				0.3294117748737335, 0.32156863808631897, 0.3137255012989044, 0.3137255012989044,
				0.3137255012989044, 0.32156863808631897, 0.32156863808631897, 0.3294117748737335,
				0.33725491166114807, 0.3490196168422699, 0.3529411852359772, 0.3529411852359772,
				0.3450980484485626, 0.3490196168422699, 0.3490196168422699, 0.32156863808631897,
				0.27450981736183167, 0.1411764770746231, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-5.393969557993842, 15.422958183409548],
		},
		{
			id: "UaIfNWJ1ae4w4nFu-b1Ik",
			type: "freedraw",
			x: 261.27950027677366,
			y: 250.43384143197835,
			width: 12.727479258560606,
			height: 51.277345446344725,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1667605725,
			version: 26,
			versionNonce: 1487911539,
			isDeleted: false,
			boundElements: null,
			updated: 1751811636842,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7890675735312129, -0.3915220784696771],
				[-0.7890675735312129, -0.7860558652352552],
				[-0.7890675735312129, 0],
				[-0.7890675735312129, 1.5299478143276701],
				[-0.7890675735312129, 5.0024474795241645],
				[-0.7890675735312129, 10.004894959048329],
				[-0.7890675735312129, 15.031436104939871],
				[-0.7890675735312129, 19.64236150599436],
				[-0.3945337867656349, 23.903928744722066],
				[-0.3945337867656349, 27.749880238612718],
				[0, 30.827846117043634],
				[0.36441670380639835, 34.30335749053603],
				[0.7559387822760755, 37.38433507726285],
				[0.7559387822760755, 40.465312663989664],
				[1.1504725690416535, 43.54629025071648],
				[1.5450063558072884, 45.859282221983506],
				[1.9094230596136867, 47.41031199438265],
				[2.695478924848942, 48.94025980871032],
				[3.848963202186553, 49.72631567394558],
				[5.785491636463519, 50.49128958110947],
				[8.483982269608418, 50.49128958110947],
				[10.787939115987683, 50.49128958110947],
				[11.938411685029394, 50.096755794343835],
				[11.543877898263759, 49.33178188718],
			],
			pressures: [
				0.0784313753247261, 0.16078431904315948, 0.18431372940540314, 0.25882354378700256,
				0.30588236451148987, 0.3450980484485626, 0.38823530077934265, 0.40784314274787903,
				0.4156862795352936, 0.4156862795352936, 0.3960784375667572, 0.38823530077934265,
				0.3921568691730499, 0.3921568691730499, 0.3803921639919281, 0.3686274588108063,
				0.3607843220233917, 0.35686275362968445, 0.35686275362968445, 0.364705890417099,
				0.364705890417099, 0.3803921639919281, 0.3764705955982208, 0.3137255012989044, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [11.543877898263759, 49.33178188718],
		},
	],
	e: [
		{
			id: "Uu_4xgX30zbkVS66uW_sy",
			type: "freedraw",
			x: 235.43301968118277,
			y: 273.5487026031692,
			width: 36.239885924812995,
			height: 47.036860165688495,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 561989053,
			version: 60,
			versionNonce: 323494611,
			isDeleted: false,
			boundElements: null,
			updated: 1751811645350,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.7860558652352552, 0],
				[1.5450063558072884, 0],
				[3.876068576849832, 0.3945337867656349],
				[5.785491636463519, 0.7890675735312129],
				[10.423522412181285, 1.15950769392947],
				[12.724467550264649, 1.554041480695048],
				[14.269473906071937, 1.554041480695048],
				[20.81692774140339, 1.924481601093305],
				[23.51240666625239, 1.924481601093305],
				[27.39148695139818, 0.3945337867656349],
				[29.300910011011865, -0.3704401203982002],
				[30.45138258005352, -1.9214698927973473],
				[31.24045015358473, -3.0809775867267604],
				[31.996388935860807, -4.632007359125907],
				[32.390922722626385, -6.923917372321512],
				[32.78545650939202, -8.869480931486237],
				[32.78545650939202, -10.399428745813907],
				[32.390922722626385, -12.71543242537689],
				[31.24045015358473, -14.263450489480078],
				[30.45138258005352, -15.796410012103706],
				[28.90637622424623, -17.717879904901054],
				[26.996953164632544, -19.2719213855961],
				[24.3014742397836, -20.425405662933713],
				[20.81692774140339, -20.819939449699348],
				[17.75402040445215, -20.819939449699348],
				[13.87795182760226, -20.425405662933713],
				[11.968528767988573, -19.660431755769878],
				[9.634454838650072, -17.717879904901054],
				[8.878516056373996, -16.95290599773722],
				[6.93897591380113, -15.031436104939871],
				[5.029552854187443, -11.950458518213054],
				[3.484546498380155, -10.399428745813907],
				[2.3310622210425436, -8.083425066250982],
				[1.18058965200089, -5.7674213866879995],
				[0.7860558652352552, -3.8429397855946945],
				[0.3915220784696771, -0.7619621988678773],
				[0.3915220784696771, 1.554041480695048],
				[0.3915220784696771, 5.396981266289799],
				[0.3915220784696771, 7.321462867383104],
				[0.7860558652352552, 10.793962532579599],
				[1.5450063558072884, 13.501488290612201],
				[2.695478924848942, 15.422958183409605],
				[5.029552854187443, 19.27192138559616],
				[7.330497992270807, 21.58491335686324],
				[9.634454838650072, 23.530476916027965],
				[12.724467550264649, 25.060424730355635],
				[14.664007692837572, 25.82539863751947],
				[19.2719213855961, 26.216920715989147],
				[22.36193409721068, 26.216920715989147],
				[26.996953164632544, 25.82539863751947],
				[29.300910011011865, 25.060424730355635],
				[31.996388935860807, 24.2954508231918],
				[33.541395291668096, 23.900917036426165],
				[35.086401647475384, 23.900917036426165],
				[35.48093543424096, 23.900917036426165],
				[36.239885924812995, 23.530476916027965],
				[36.239885924812995, 23.138954837558288],
				[35.84535213804736, 23.138954837558288],
			],
			pressures: [
				0.0784313753247261, 0.21568627655506134, 0.2235294133424759, 0.250980406999588,
				0.26274511218070984, 0.29411765933036804, 0.30588236451148987,
				0.30980393290519714, 0.3176470696926117, 0.3176470696926117, 0.30980393290519714,
				0.30980393290519714, 0.30980393290519714, 0.3137255012989044, 0.3176470696926117,
				0.32549020648002625, 0.3333333432674408, 0.3294117748737335, 0.33725491166114807,
				0.34117648005485535, 0.3450980484485626, 0.3490196168422699, 0.3450980484485626,
				0.3450980484485626, 0.34117648005485535, 0.34117648005485535, 0.33725491166114807,
				0.33725491166114807, 0.33725491166114807, 0.3333333432674408, 0.32549020648002625,
				0.32549020648002625, 0.32549020648002625, 0.32549020648002625, 0.3294117748737335,
				0.3294117748737335, 0.3333333432674408, 0.3333333432674408, 0.34117648005485535,
				0.3450980484485626, 0.3490196168422699, 0.3529411852359772, 0.3607843220233917,
				0.3843137323856354, 0.4000000059604645, 0.4156862795352936, 0.43921568989753723,
				0.4588235318660736, 0.4941176474094391, 0.501960813999176, 0.5098039507865906,
				0.5176470875740051, 0.5176470875740051, 0.5176470875740051, 0.4901960790157318,
				0.45490196347236633, 0.37254902720451355, 0.27843138575553894, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [35.84535213804736, 23.138954837558288],
		},
	],
	f: [
		{
			id: "9E-4rra_xTvXA7vC51M1Q",
			type: "freedraw",
			x: 238.91756617956293,
			y: 299.76562331915835,
			width: 25.451946808825255,
			height: 56.67131500433857,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1692995507,
			version: 35,
			versionNonce: 2025545053,
			isDeleted: false,
			boundElements: null,
			updated: 1751811650406,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, -1.1564959856335122],
				[0, -1.551029772399147],
				[-0.39453378676557804, -3.0779658784308594],
				[-1.1534842773376113, -5.396981266289799],
				[-1.9395401425728664, -8.083425066250982],
				[-3.484546498380155, -11.947446809917153],
				[-4.243496988952188, -15.02842439664397],
				[-5.393969557993842, -18.503935770136366],
				[-6.1830371315250545, -22.346875555731117],
				[-7.333509700566765, -26.216920715989147],
				[-8.092460191138741, -30.848928075115055],
				[-8.483982269608418, -34.69487956900571],
				[-8.483982269608418, -36.245909341404854],
				[-8.092460191138741, -45.09430831481967],
				[-7.333509700566765, -47.80183407285233],
				[-6.547453835331453, -50.117837752415255],
				[-5.393969557993842, -52.03930764521266],
				[-4.243496988952188, -53.19881533914207],
				[-1.1534842773376113, -55.514819018705055],
				[1.5450063558072884, -56.27678121757299],
				[3.8459514938906523, -56.67131500433857],
				[6.149908340269917, -56.67131500433857],
				[8.483982269608418, -55.88525913910331],
				[10.028988625415707, -54.72575144517384],
				[11.573994981222995, -53.19881533914207],
				[13.088884254071104, -51.274333738048824],
				[14.269473906071994, -48.56379627172021],
				[15.02842439664397, -46.25080430045318],
				[15.787374887215947, -43.9348006208902],
				[16.17889696568568, -42.40786451485843],
				[16.967964539216837, -41.639878899398695],
				[16.967964539216837, -41.24835682092902],
				[16.967964539216837, -41.24835682092902],
			],
			pressures: [
				0.0784313753247261, 0.2235294133424759, 0.23529411852359772, 0.2705882489681244,
				0.29019609093666077, 0.3019607961177826, 0.3019607961177826, 0.29411765933036804,
				0.2980392277240753, 0.2980392277240753, 0.2980392277240753, 0.2980392277240753,
				0.2980392277240753, 0.29411765933036804, 0.2666666805744171, 0.2666666805744171,
				0.25882354378700256, 0.25882354378700256, 0.25882354378700256, 0.2549019753932953,
				0.250980406999588, 0.24705882370471954, 0.250980406999588, 0.2705882489681244,
				0.27843138575553894, 0.29019609093666077, 0.30588236451148987,
				0.33725491166114807, 0.3686274588108063, 0.3921568691730499, 0.3921568691730499,
				0.37254902720451355, 0.3019607961177826, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [16.967964539216837, -41.24835682092902],
		},
		{
			id: "Ojth0HG6p2fg85izb2af7",
			type: "freedraw",
			x: 233.88500161707958,
			y: 278.945683869459,
			width: 16.970976247512738,
			height: 1.1564959856335122,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 437558419,
			version: 11,
			versionNonce: 1190269309,
			isDeleted: false,
			boundElements: null,
			updated: 1751811651097,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.7890675735311561, -0.370440120398257],
				[2.3340739293384445, -0.370440120398257],
				[5.032564562483344, -0.7619621988679341],
				[8.122577274097921, -0.7619621988679341],
				[12.363062554754151, -0.370440120398257],
				[15.061553187899051, -0.370440120398257],
				[16.60655954370634, 0],
				[16.970976247512738, 0],
				[16.60655954370634, 0.39453378676557804],
			],
			pressures: [
				0.0784313753247261, 0.3607843220233917, 0.3921568691730499, 0.4470588266849518,
				0.47058823704719543, 0.47058823704719543, 0.4588235318660736, 0.43921568989753723,
				0.2823529541492462, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [16.60655954370634, 0.39453378676557804],
		},
	],
	g: [
		{
			id: "yC-hln-OmopuVUMbjU5O4",
			type: "freedraw",
			x: 243.1580514602192,
			y: 275.10274408386425,
			width: 28.906376224246287,
			height: 24.662879235294042,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1782646227,
			version: 37,
			versionNonce: 860418557,
			isDeleted: false,
			boundElements: null,
			updated: 1751811667987,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.786055865235312, -0.39453378676557804],
				[-1.1504725690417104, -0.39453378676557804],
				[-1.5450063558072884, -0.7649739071638351],
				[-2.6954789248489988, -0.7649739071638351],
				[-3.4845464983802117, -0.7649739071638351],
				[-5.0295528541875, 0],
				[-6.180025423229154, 1.921469892797404],
				[-6.938975913801187, 3.8429397855947514],
				[-7.333509700566765, 6.923917372321569],
				[-7.333509700566765, 10.025976917119806],
				[-5.785491636463576, 13.106954503846623],
				[-3.090012711614577, 16.18793209057344],
				[0, 18.109401983370788],
				[3.4544294154209183, 19.2658979690043],
				[6.544442127035495, 19.2658979690043],
				[10.028988625415707, 18.87738759883058],
				[13.483418040836682, 17.344428076206952],
				[16.57644246074716, 15.422958183409605],
				[18.485865520360846, 12.715432425376946],
				[20.030871876168135, 10.025976917119806],
				[20.422393954637812, 6.923917372321569],
				[20.422393954637812, 4.237473572360329],
				[19.2719213855961, 1.921469892797404],
				[17.332381243023235, -0.7649739071638351],
				[15.031436104939871, -3.0809775867267604],
				[11.938411685029394, -4.635019067421808],
				[8.483982269608418, -5.3969812662897425],
				[4.60791369275853, -5.3969812662897425],
				[1.5450063558072316, -5.026541145891542],
				[-1.5450063558072884, -3.8700451602579733],
				[-5.0295528541875, -1.554041480695048],
				[-7.333509700566765, 1.921469892797404],
				[-8.483982269608475, 6.5534772519233115],
				[-5.785491636463576, 15.422958183409605],
				[-4.240485280656287, 16.579454169043117],
			],
			pressures: [
				0.0784313753247261, 0.019607843831181526, 0.03921568766236305,
				0.07450980693101883, 0.09803921729326248, 0.125490203499794, 0.16470588743686676,
				0.1921568661928177, 0.2235294133424759, 0.2549019753932953, 0.27843138575553894,
				0.2980392277240753, 0.3137255012989044, 0.32549020648002625, 0.32156863808631897,
				0.3137255012989044, 0.30588236451148987, 0.2980392277240753, 0.29019609093666077,
				0.2862745225429535, 0.2823529541492462, 0.27843138575553894, 0.2666666805744171,
				0.27450981736183167, 0.2823529541492462, 0.2862745225429535, 0.29019609093666077,
				0.29019609093666077, 0.2862745225429535, 0.2823529541492462, 0.27450981736183167,
				0.2705882489681244, 0.27450981736183167, 0.25882354378700256, 0.125490203499794,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-4.240485280656287, 16.579454169043117],
		},
		{
			id: "T9xGfcZtoirkcKFFGu_a3",
			type: "freedraw",
			x: 262.03543905904974,
			y: 278.57524374906075,
			width: 25.816363512631654,
			height: 43.5613487921961,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1970828787,
			version: 39,
			versionNonce: 2021051549,
			isDeleted: false,
			boundElements: null,
			updated: 1751811669020,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7559387822760755, -0.3915220784696771],
				[-1.1504725690417104, -0.3915220784696771],
				[-1.1504725690417104, 0.7649739071638351],
				[-1.1504725690417104, 2.294921721491562],
				[-0.7559387822760755, 5.393969557993898],
				[0, 9.634454838650129],
				[1.1534842773376113, 14.245380239704616],
				[2.303956846379265, 19.268909677300257],
				[3.484546498380155, 24.66589094359],
				[3.848963202186553, 30.0628722098798],
				[3.848963202186553, 34.30335749053603],
				[3.848963202186553, 37.775857155732524],
				[3.0930244199104777, 39.70033875682583],
				[1.9395401425728664, 41.24835682092902],
				[0.39453378676557804, 42.01333072809285],
				[-1.9094230596136867, 42.77830463525669],
				[-4.9994357712282635, 43.16982671372642],
				[-8.483982269608418, 43.16982671372642],
				[-11.543877898263815, 42.38678255678701],
				[-13.088884254071104, 41.24835682092902],
				[-14.269473906071994, 39.70033875682583],
				[-14.633890609878392, 38.14629727613078],
				[-15.02842439664397, 36.61936117009901],
				[-15.02842439664397, 34.69487956900571],
				[-14.269473906071994, 32.74931600984098],
				[-12.724467550264706, 30.827846117043634],
				[-11.179461194457417, 28.906376224246287],
				[-8.848398973414817, 26.981894623152982],
				[-5.393969557993842, 25.430864850753835],
				[-1.5450063558072884, 23.900917036426165],
				[1.9395401425728664, 23.11486117119091],
				[5.393969557993842, 22.349887264027075],
				[7.728043487332343, 21.95535347726144],
				[9.242932760180395, 21.584913356863183],
				[10.423522412181285, 21.190379570097605],
				[10.787939115987683, 20.033883584464093],
				[10.032000333711608, 19.639349797698458],
			],
			pressures: [
				0.0784313753247261, 0.12156862765550613, 0.1921568661928177, 0.2705882489681244,
				0.30588236451148987, 0.3333333432674408, 0.3607843220233917, 0.3843137323856354,
				0.3803921639919281, 0.3764705955982208, 0.3529411852359772, 0.3490196168422699,
				0.33725491166114807, 0.3176470696926117, 0.30588236451148987, 0.2862745225429535,
				0.2666666805744171, 0.2549019753932953, 0.250980406999588, 0.24313725531101227,
				0.24313725531101227, 0.23529411852359772, 0.22745098173618317,
				0.21960784494876862, 0.21960784494876862, 0.23137255012989044,
				0.25882354378700256, 0.29411765933036804, 0.32156863808631897, 0.364705890417099,
				0.38823530077934265, 0.4000000059604645, 0.4117647111415863, 0.4117647111415863,
				0.4117647111415863, 0.32549020648002625, 0.1882352977991104, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [10.032000333711608, 19.639349797698458],
		},
	],
	h: [
		{
			id: "Q9zGXr3Psh09LPi8lupmu",
			type: "freedraw",
			x: 234.27953540384516,
			y: 255.43628891150252,
			width: 24.304485948079503,
			height: 48.569819688312066,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 772130227,
			version: 44,
			versionNonce: 1509101459,
			isDeleted: false,
			boundElements: null,
			updated: 1751811677791,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.39453378676557804, -0.7649739071638351],
				[-0.39453378676557804, 1.15950769392947],
				[-0.39453378676557804, 4.237473572360329],
				[-0.39453378676557804, 8.872492639782195],
				[-0.39453378676557804, 13.874940119306359],
				[0.39453378676557804, 19.666455172361736],
				[0.7890675735312129, 25.433876559049793],
				[1.1534842773376113, 30.457405996645377],
				[1.5450063558072884, 34.69487956900571],
				[1.5450063558072884, 38.932353141366036],
				[1.9395401425728664, 41.64289060769465],
				[1.9395401425728664, 43.93781232918616],
				[1.9395401425728664, 46.25381600874914],
				[2.3340739293385013, 47.80484578114823],
				[2.6984906331448997, 46.64834979551472],
				[2.6984906331448997, 42.40786451485849],
				[3.0930244199104777, 39.32688692813167],
				[3.848963202186553, 35.08941335577134],
				[4.243496988952188, 30.457405996645377],
				[5.029552854187443, 26.219932424285048],
				[5.7885033447594765, 23.13895483755823],
				[6.547453835331453, 21.193391278393506],
				[7.728043487332343, 19.666455172361736],
				[9.273049843139631, 18.506947478432323],
				[10.787939115987683, 17.74197357126849],
				[12.332945471794972, 16.955917706033176],
				[14.272485614367895, 16.955917706033176],
				[15.422958183409548, 17.35045149279881],
				[16.970976247512795, 18.506947478432323],
				[18.90750468178976, 19.666455172361736],
				[20.425405662933713, 21.193391278393506],
				[21.605995314934603, 23.13895483755823],
				[22.756467883976313, 25.433876559049793],
				[23.12088458778271, 28.53292439555213],
				[23.12088458778271, 32.38188759773868],
				[23.12088458778271, 36.245909341404854],
				[23.12088458778271, 39.69732704852993],
				[23.12088458778271, 42.40786451485849],
				[23.12088458778271, 43.5673722087879],
				[23.51541837454829, 43.5673722087879],
				[23.909952161313925, 43.5673722087879],
				[23.12088458778271, 42.77830463525669],
			],
			pressures: [
				0.0784313753247261, 0.12156862765550613, 0.30588236451148987, 0.35686275362968445,
				0.40392157435417175, 0.4313725531101227, 0.45098039507865906, 0.4431372582912445,
				0.42352941632270813, 0.4000000059604645, 0.3843137323856354, 0.3843137323856354,
				0.38823530077934265, 0.3921568691730499, 0.3803921639919281, 0.30588236451148987,
				0.2705882489681244, 0.22745098173618317, 0.19607843458652496, 0.1568627506494522,
				0.13725490868091583, 0.13333334028720856, 0.13725490868091583,
				0.14509804546833038, 0.1568627506494522, 0.1764705926179886, 0.18039216101169586,
				0.19607843458652496, 0.20000000298023224, 0.2235294133424759, 0.250980406999588,
				0.2705882489681244, 0.2980392277240753, 0.30588236451148987, 0.34117648005485535,
				0.3843137323856354, 0.4313725531101227, 0.45098039507865906, 0.45490196347236633,
				0.4588235318660736, 0.4470588266849518, 0.3960784375667572, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [23.12088458778271, 42.77830463525669],
		},
	],
	i: [
		{
			id: "Z98CWJYiq7EkLylFMhqTe",
			type: "freedraw",
			x: 248.55202101821305,
			y: 275.10274408386425,
			width: 1.9395401425728664,
			height: 26.216920715989147,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 130171869,
			version: 16,
			versionNonce: 1504141107,
			isDeleted: false,
			boundElements: null,
			updated: 1751811681302,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, 1.156495985633569],
				[0, 3.4724996651964943],
				[0, 6.923917372321569],
				[0.39453378676557804, 11.164402652977799],
				[0.7589504905719764, 15.422958183409605],
				[0.7589504905719764, 18.87738759883058],
				[0.7589504905719764, 21.976435435332917],
				[1.1504725690416535, 23.900917036426165],
				[1.1504725690416535, 24.6628792352941],
				[1.5450063558072884, 25.427853142457934],
				[1.9395401425728664, 25.82238692922357],
				[1.9395401425728664, 26.216920715989147],
				[1.9395401425728664, 25.82238692922357],
				[1.9395401425728664, 25.427853142457934],
			],
			pressures: [
				0.0784313753247261, 0.25882354378700256, 0.29019609093666077, 0.3176470696926117,
				0.3137255012989044, 0.3137255012989044, 0.3333333432674408, 0.3490196168422699,
				0.3529411852359772, 0.3490196168422699, 0.3294117748737335, 0.3176470696926117,
				0.2705882489681244, 0.04313725605607033, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [1.9395401425728664, 25.427853142457934],
		},
		{
			id: "Ukx2xRt9LDXKHgwAjmhB1",
			type: "freedraw",
			x: 247.00701466240577,
			y: 258.12574441975966,
			width: 2.3039568463793216,
			height: 3.8459514938906523,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 665415283,
			version: 23,
			versionNonce: 828261917,
			isDeleted: false,
			boundElements: null,
			updated: 1751811682293,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.3945337867656349, 0.786055865235312],
				[-0.3945337867656349, 1.15950769392947],
				[-0.7589504905720332, 1.5480180641031893],
				[-0.7589504905720332, 1.9425518508688242],
				[-0.7589504905720332, 2.3129919712670244],
				[-0.3945337867656349, 2.3129919712670244],
				[0, 2.7075257580326593],
				[0.7589504905719764, 2.7075257580326593],
				[1.1504725690416535, 1.9425518508688242],
				[1.1504725690416535, 1.15950769392947],
				[1.5450063558072884, 0.3915220784696771],
				[1.5450063558072884, -0.37345182869415794],
				[1.1504725690416535, -0.767985615459736],
				[0.39453378676557804, -1.138425735857993],
				[0, -1.138425735857993],
				[-0.7589504905720332, -0.767985615459736],
				[-0.7589504905720332, 0],
				[-0.7589504905720332, 0.3915220784696771],
				[-0.7589504905720332, 0.786055865235312],
				[0, 0],
			],
			pressures: [
				0.0784313753247261, 0.06666667014360428, 0.11372549086809158, 0.14509804546833038,
				0.16470588743686676, 0.18431372940540314, 0.1882352977991104, 0.18039216101169586,
				0.1764705926179886, 0.16862745583057404, 0.1764705926179886, 0.18039216101169586,
				0.18039216101169586, 0.1921568661928177, 0.2078431397676468, 0.2078431397676468,
				0.2078431397676468, 0.21176470816135406, 0.19607843458652496, 0.16078431904315948,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [0, 1.15950769392947],
		},
	],
	j: [
		{
			id: "mwuZlYt8rabXsFke_v8Sn",
			type: "freedraw",
			x: 240.06803874860464,
			y: 280.1051915633885,
			width: 24.66589094359,
			height: 0.7649739071638919,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1478475357,
			version: 17,
			versionNonce: 1014832723,
			isDeleted: false,
			boundElements: null,
			updated: 1751811698868,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.39453378676557804, 0],
				[1.9395401425728664, -0.370440120398257],
				[3.848963202186553, -0.7649739071638919],
				[6.180025423229097, -0.7649739071638919],
				[8.878516056373996, -0.7649739071638919],
				[11.573994981222995, -0.7649739071638919],
				[14.272485614367838, -0.7649739071638919],
				[16.967964539216837, -0.7649739071638919],
				[19.666455172361736, -0.7649739071638919],
				[21.575878231975423, -0.7649739071638919],
				[23.51240666625239, -0.7649739071638919],
				[24.271357156824365, -0.7649739071638919],
				[24.66589094359, -0.7649739071638919],
				[24.271357156824365, -0.7649739071638919],
				[23.51240666625239, -0.7649739071638919],
			],
			pressures: [
				0.0784313753247261, 0.22745098173618317, 0.27450981736183167, 0.32156863808631897,
				0.3686274588108063, 0.40784314274787903, 0.4470588266849518, 0.48235294222831726,
				0.49803921580314636, 0.5098039507865906, 0.49803921580314636, 0.48235294222831726,
				0.4431372582912445, 0.40392157435417175, 0.1568627506494522, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [23.51240666625239, -0.7649739071638919],
		},
		{
			id: "BBrwAw4IqUtdlEX4mdeFa",
			type: "freedraw",
			x: 252.79551800716524,
			y: 280.49972535015405,
			width: 15.422958183409605,
			height: 33.92689395354597,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1906725053,
			version: 23,
			versionNonce: 1252901811,
			isDeleted: false,
			boundElements: null,
			updated: 1751811699641,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7890675735312129, 0],
				[-0.3945337867656349, 1.5269361060317692],
				[0.3915220784696771, 3.8429397855947514],
				[2.300945138083364, 8.083425066250982],
				[4.604901984462629, 13.8689167027145],
				[6.93897591380113, 19.2658979690043],
				[8.089448482842784, 23.50638324966053],
				[8.483982269608418, 26.587360836387347],
				[8.089448482842784, 29.297898302715907],
				[6.93897591380113, 31.21936819551331],
				[4.999435771228207, 33.14083808831066],
				[2.695478924848942, 33.92689395354597],
				[-0.3945337867656349, 33.535371875076294],
				[-3.4845464983802117, 30.824834408747677],
				[-5.7885033447594765, 28.138390608786494],
				[-6.938975913801187, 25.822386929223512],
				[-6.938975913801187, 24.271357156824422],
				[-5.7885033447594765, 22.741409342496695],
				[-3.4845464983802117, 20.819939449699348],
				[-0.3945337867656349, 18.874375890534623],
				[1.5450063558072316, 18.109401983370788],
			],
			pressures: [
				0.0784313753247261, 0.14509804546833038, 0.34117648005485535, 0.3607843220233917,
				0.3921568691730499, 0.40392157435417175, 0.3921568691730499, 0.3843137323856354,
				0.3803921639919281, 0.3764705955982208, 0.37254902720451355, 0.37254902720451355,
				0.3686274588108063, 0.364705890417099, 0.3686274588108063, 0.364705890417099,
				0.37254902720451355, 0.3764705955982208, 0.34117648005485535, 0.2980392277240753,
				0.26274511218070984, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [1.5450063558072316, 18.109401983370788],
		},
	],
	k: [
		{
			id: "G4lkYCyzpQqo0385JKkjE",
			type: "freedraw",
			x: 240.06803874860464,
			y: 274.7082102970987,
			width: 20.030871876168135,
			height: 26.981894623152925,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 71865715,
			version: 28,
			versionNonce: 887053565,
			isDeleted: false,
			boundElements: null,
			updated: 1751811708085,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7589504905720332, 0.39453378676557804],
				[-0.7589504905720332, 1.1564959856335122],
				[-0.7589504905720332, 2.71053746632856],
				[-0.3945337867656349, 4.632007359125907],
				[0, 8.872492639782195],
				[0.39453378676557804, 13.109966212142524],
				[0.39453378676557804, 17.344428076206952],
				[0.7589504905719764, 20.819939449699348],
				[1.1504725690416535, 22.370969222098495],
				[1.1504725690416535, 23.50638324966053],
				[1.1504725690416535, 23.13594312926233],
				[1.1504725690416535, 21.979447143628818],
				[1.5450063558072884, 20.054965542535513],
				[2.303956846379265, 17.73896186297253],
				[2.695478924848942, 16.19094379886934],
				[4.243496988952131, 12.715432425376946],
				[5.393969557993842, 10.420510703885384],
				[7.697926404373106, 6.5534772519233115],
				[9.634454838650072, 4.237473572360329],
				[11.573994981222995, 1.9214698927973473],
				[13.119001337030284, 0.7649739071638351],
				[14.636902318174236, -0.370440120398257],
				[16.181908673981525, -1.5299478143276701],
				[17.726915029788813, -2.316003679562982],
				[19.2719213855961, -3.080977586726817],
				[19.2719213855961, -3.4755113734923953],
			],
			pressures: [
				0.0784313753247261, 0.1882352977991104, 0.20000000298023224, 0.23137255012989044,
				0.24705882370471954, 0.2666666805744171, 0.2823529541492462, 0.29019609093666077,
				0.29019609093666077, 0.27843138575553894, 0.24705882370471954, 0.2235294133424759,
				0.21176470816135406, 0.20000000298023224, 0.1921568661928177, 0.1882352977991104,
				0.18431372940540314, 0.20000000298023224, 0.23137255012989044,
				0.23529411852359772, 0.25882354378700256, 0.250980406999588, 0.23529411852359772,
				0.2078431397676468, 0.16862745583057404, 0.0313725508749485, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [19.2719213855961, -3.4755113734923953],
		},
		{
			id: "UbOYOC3tg11INyaTAFpRs",
			type: "freedraw",
			x: 245.85654209336406,
			y: 285.8936949081479,
			width: 11.543877898263815,
			height: 16.5613839192676,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1636932339,
			version: 14,
			versionNonce: 541716029,
			isDeleted: false,
			boundElements: null,
			updated: 1751811708602,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.7559387822760755, -0.3915220784696771],
				[1.1504725690417104, -0.3915220784696771],
				[3.090012711614577, -0.7649739071638351],
				[4.9994357712282635, -0.7649739071638351],
				[7.330497992270864, 0.37345182869415794],
				[9.634454838650129, 3.0779658784309163],
				[11.179461194457417, 6.5534772519233115],
				[11.543877898263815, 9.634454838650129],
				[11.543877898263815, 13.480406332540781],
				[11.543877898263815, 15.031436104939928],
				[11.543877898263815, 15.796410012103763],
				[11.543877898263815, 15.796410012103763],
			],
			pressures: [
				0.0784313753247261, 0.23137255012989044, 0.24705882370471954, 0.2823529541492462,
				0.30588236451148987, 0.3333333432674408, 0.34117648005485535, 0.35686275362968445,
				0.3529411852359772, 0.3529411852359772, 0.30980393290519714, 0.23137255012989044,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [11.543877898263815, 15.796410012103763],
		},
	],
	l: [
		{
			id: "UrpYzOQCJwY4rGA9rO3jZ",
			type: "freedraw",
			x: 240.8269892391766,
			y: 267.7812812164812,
			width: 9.634454838650129,
			height: 28.906376224246287,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1120015453,
			version: 19,
			versionNonce: 1273147283,
			isDeleted: false,
			boundElements: null,
			updated: 1751811719757,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, 1.135414027562092],
				[0, 1.924481601093305],
				[0, 5.396981266289799],
				[-0.36441670380639835, 10.402440454109865],
				[-0.36441670380639835, 15.031436104939871],
				[-0.36441670380639835, 18.877387598830524],
				[-0.36441670380639835, 22.349887264027018],
				[0, 25.82539863751947],
				[0.3915220784696771, 26.981894623152982],
				[1.18058965200089, 28.511842437480652],
				[2.3310622210426004, 28.906376224246287],
				[3.484546498380155, 28.906376224246287],
				[5.42107493265712, 28.511842437480652],
				[6.93897591380113, 28.141402317082395],
				[8.11956556580202, 27.746868530316817],
				[8.483982269608418, 27.746868530316817],
				[9.27003813484373, 27.746868530316817],
			],
			pressures: [
				0.0784313753247261, 0.19607843458652496, 0.21176470816135406, 0.23137255012989044,
				0.22745098173618317, 0.23529411852359772, 0.23529411852359772,
				0.22745098173618317, 0.2235294133424759, 0.2235294133424759, 0.2235294133424759,
				0.2235294133424759, 0.22745098173618317, 0.22745098173618317, 0.21960784494876862,
				0.1882352977991104, 0.11372549086809158, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [9.27003813484373, 27.746868530316817],
		},
	],
	m: [
		{
			id: "nKSu9k5Z0jLHX_Bwph7c2",
			type: "freedraw",
			x: 233.12906283480345,
			y: 279.7347514429902,
			width: 32.39092272262644,
			height: 20.033883584464093,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1072551027,
			version: 66,
			versionNonce: 1996208189,
			isDeleted: false,
			boundElements: null,
			updated: 1751811726718,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.3945337867656349, 1.9214698927973473],
				[0.3945337867656349, 2.2919100131956043],
				[0.7559387822761323, 4.607913692758586],
				[1.1504725690417104, 10.396417037518006],
				[1.9395401425729233, 14.245380239704616],
				[2.3039568463793216, 16.952905997737275],
				[2.3039568463793216, 18.479842103768988],
				[2.6954789248489988, 18.874375890534623],
				[2.6954789248489988, 19.2689096773002],
				[2.6954789248489988, 18.874375890534623],
				[2.6954789248489988, 17.714868196605153],
				[2.6954789248489988, 15.793398303807805],
				[2.6954789248489988, 13.477394624244823],
				[2.3039568463793216, 11.164402652977799],
				[2.3039568463793216, 8.848398973414817],
				[2.3039568463793216, 6.158943465157677],
				[2.3039568463793216, 4.607913692758586],
				[3.4845464983802117, 3.0779658784308594],
				[5.7885033447594765, 1.135414027562092],
				[7.333509700566765, 0.370440120398257],
				[9.242932760180452, 0],
				[11.182472902753318, -0.3945337867656349],
				[13.483418040836682, 0.7649739071638351],
				[14.272485614367895, 1.5269361060317692],
				[15.422958183409605, 2.6864437999611823],
				[15.817491970175183, 3.8459514938906523],
				[16.57343075245126, 5.7674213866879995],
				[16.57343075245126, 8.083425066250982],
				[16.967964539216894, 10.790950824283641],
				[16.967964539216894, 13.477394624244823],
				[17.36249832598247, 15.398864517042227],
				[17.36249832598247, 17.344428076206952],
				[17.72691502978887, 18.479842103768988],
				[18.121448816554505, 19.2689096773002],
				[18.121448816554505, 19.639349797698458],
				[18.121448816554505, 18.874375890534623],
				[18.121448816554505, 17.344428076206952],
				[18.121448816554505, 15.02842439664397],
				[18.121448816554505, 12.31788693031541],
				[18.121448816554505, 9.236909343588593],
				[18.121448816554505, 6.923917372321512],
				[18.87738759883058, 4.2344618640644285],
				[20.05797725083147, 1.9214698927973473],
				[21.211461528169025, 1.135414027562092],
				[22.361934097210735, 0.7649739071638351],
				[24.271357156824422, 0.370440120398257],
				[25.451946808825312, 0.370440120398257],
				[26.605431086162923, 0.370440120398257],
				[27.755903655204577, 0.7649739071638351],
				[28.51485414577661, 1.9214698927973473],
				[29.300910011011865, 3.0779658784308594],
				[30.0598605015839, 4.2344618640644285],
				[30.845916366819154, 5.393969557993842],
				[31.210333070625552, 6.923917372321512],
				[31.604866857391187, 8.474947144720659],
				[31.604866857391187, 10.396417037518006],
				[31.604866857391187, 13.085872545775146],
				[31.604866857391187, 14.245380239704616],
				[31.604866857391187, 16.952905997737275],
				[31.999400644156765, 18.109401983370788],
				[31.999400644156765, 18.479842103768988],
				[32.39092272262644, 18.479842103768988],
				[32.39092272262644, 17.714868196605153],
				[32.39092272262644, 17.344428076206952],
			],
			pressures: [
				0.0784313753247261, 0.21960784494876862, 0.23529411852359772, 0.2549019753932953,
				0.27450981736183167, 0.27450981736183167, 0.27843138575553894, 0.2862745225429535,
				0.29411765933036804, 0.2823529541492462, 0.27843138575553894, 0.25882354378700256,
				0.23137255012989044, 0.2078431397676468, 0.1921568661928177, 0.1882352977991104,
				0.18431372940540314, 0.1764705926179886, 0.1764705926179886, 0.1882352977991104,
				0.1882352977991104, 0.1882352977991104, 0.1882352977991104, 0.20000000298023224,
				0.21568627655506134, 0.2235294133424759, 0.239215686917305, 0.2549019753932953,
				0.2666666805744171, 0.27843138575553894, 0.29019609093666077, 0.2862745225429535,
				0.2823529541492462, 0.2862745225429535, 0.29019609093666077, 0.29019609093666077,
				0.24705882370471954, 0.22745098173618317, 0.1882352977991104, 0.16078431904315948,
				0.14509804546833038, 0.14509804546833038, 0.14509804546833038, 0.1568627506494522,
				0.16078431904315948, 0.16470588743686676, 0.16470588743686676,
				0.16862745583057404, 0.16862745583057404, 0.1882352977991104, 0.21568627655506134,
				0.22745098173618317, 0.239215686917305, 0.24705882370471954, 0.2705882489681244,
				0.2823529541492462, 0.30588236451148987, 0.32156863808631897, 0.3333333432674408,
				0.34117648005485535, 0.32156863808631897, 0.2980392277240753, 0.29019609093666077,
				0.10588235408067703, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [32.39092272262644, 17.344428076206952],
		},
	],
	n: [
		{
			id: "mOLw-9ENolo9ur32LfkxL",
			type: "freedraw",
			x: 235.82454175965245,
			y: 277.41874776342723,
			width: 18.118437108258547,
			height: 21.190379570097548,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1961528659,
			version: 38,
			versionNonce: 754929011,
			isDeleted: false,
			boundElements: null,
			updated: 1751811730282,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.3915220784696771, 0.7649739071638351],
				[-0.3915220784696771, 1.1564959856335122],
				[-0.3915220784696771, 1.5269361060317692],
				[-0.3915220784696771, 2.316003679562982],
				[0, 3.8429397855947514],
				[0.39453378676557804, 6.550465543627411],
				[0.39453378676557804, 10.004894959048386],
				[0.7890675735312129, 13.106954503846623],
				[1.9395401425728664, 18.109401983370788],
				[2.303956846379265, 20.030871876168135],
				[2.6984906331448997, 20.79584578333197],
				[2.6984906331448997, 20.030871876168135],
				[2.6984906331448997, 18.874375890534623],
				[2.6984906331448997, 17.71486819660521],
				[2.6984906331448997, 15.793398303807805],
				[2.6984906331448997, 13.871928411010458],
				[3.0930244199104777, 10.790950824283641],
				[4.638030775717766, 6.550465543627411],
				[5.393969557993842, 5.0024474795241645],
				[6.93897591380113, 2.686443799961239],
				[8.48699397790432, 0.7649739071638351],
				[10.032000333711608, 0],
				[11.577006689518896, -0.39453378676557804],
				[13.122013045326185, -0.39453378676557804],
				[14.272485614367895, 0],
				[15.425969891705506, 1.5269361060317692],
				[16.57644246074716, 3.8429397855947514],
				[17.36249832598247, 6.161955173453634],
				[17.72691502978887, 8.848398973414817],
				[17.72691502978887, 12.320898638611311],
				[17.72691502978887, 15.401876225338128],
				[17.36249832598247, 18.109401983370788],
				[17.36249832598247, 20.030871876168135],
				[17.36249832598247, 20.42540566293377],
				[17.36249832598247, 20.030871876168135],
				[17.36249832598247, 19.660431755769935],
			],
			pressures: [
				0.0784313753247261, 0.14901961386203766, 0.18039216101169586, 0.20000000298023224,
				0.2235294133424759, 0.26274511218070984, 0.2862745225429535, 0.3176470696926117,
				0.3176470696926117, 0.32156863808631897, 0.3176470696926117, 0.30588236451148987,
				0.2666666805744171, 0.2549019753932953, 0.24313725531101227, 0.21960784494876862,
				0.20392157137393951, 0.1921568661928177, 0.1764705926179886, 0.1764705926179886,
				0.1725490242242813, 0.18039216101169586, 0.19607843458652496, 0.2078431397676468,
				0.2235294133424759, 0.239215686917305, 0.2705882489681244, 0.2862745225429535,
				0.2980392277240753, 0.32156863808631897, 0.34117648005485535, 0.3529411852359772,
				0.35686275362968445, 0.3450980484485626, 0.33725491166114807, 0.10980392247438431,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [17.36249832598247, 19.660431755769935],
		},
	],
	o: [
		{
			id: "eqgUq7Ehp38qkiFKmij-6",
			type: "freedraw",
			x: 250.85597786459232,
			y: 277.02421397666166,
			width: 22.756467883976313,
			height: 23.13594312926233,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1549519869,
			version: 40,
			versionNonce: 1295705757,
			isDeleted: false,
			boundElements: null,
			updated: 1751811734062,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-1.1534842773376113, 0],
				[-1.9094230596136867, 0],
				[-2.6984906331448997, 0],
				[-3.454429415420975, 0],
				[-4.243496988952188, 0.39453378676557804],
				[-4.9994357712282635, 1.159507693929413],
				[-6.152920048565875, 2.3160036795629253],
				[-6.93897591380113, 3.8459514938906523],
				[-7.697926404373106, 6.161955173453578],
				[-8.483982269608418, 8.869480931486237],
				[-8.483982269608418, 11.947446809917153],
				[-8.092460191138741, 14.657984276245713],
				[-6.93897591380113, 16.955917706033176],
				[-5.393969557993842, 19.2689096773002],
				[-3.454429415420975, 21.190379570097548],
				[-1.5450063558072884, 22.349887264027018],
				[1.1504725690417104, 22.741409342496695],
				[4.240485280656287, 22.741409342496695],
				[7.333509700566765, 22.349887264027018],
				[10.028988625415707, 21.190379570097548],
				[12.332945471795028, 19.2689096773002],
				[13.483418040836682, 17.344428076206896],
				[14.272485614367895, 15.02842439664397],
				[14.272485614367895, 12.341980596682731],
				[14.272485614367895, 9.242932760180395],
				[13.119001337030284, 6.944999330392989],
				[11.96852876798863, 5.0024474795241645],
				[10.028988625415707, 3.8459514938906523],
				[7.725031779036442, 2.71053746632856],
				[5.029552854187443, 1.9214698927973473],
				[3.090012711614577, 1.159507693929413],
				[0, 0],
				[-1.9094230596136867, -0.3945337867656349],
				[-3.454429415420975, -0.3945337867656349],
				[-4.9994357712282635, 1.159507693929413],
				[-6.544442127035552, 3.8459514938906523],
				[-7.303392617607528, 7.712984945852725],
				[-7.697926404373106, 8.869480931486237],
			],
			pressures: [
				0.0784313753247261, 0.07450980693101883, 0.08235294371843338, 0.14509804546833038,
				0.18039216101169586, 0.20392157137393951, 0.23137255012989044,
				0.25882354378700256, 0.27843138575553894, 0.3019607961177826, 0.3294117748737335,
				0.34117648005485535, 0.3333333432674408, 0.3333333432674408, 0.34117648005485535,
				0.3450980484485626, 0.3490196168422699, 0.3490196168422699, 0.33725491166114807,
				0.32549020648002625, 0.30980393290519714, 0.2980392277240753, 0.29019609093666077,
				0.27450981736183167, 0.27450981736183167, 0.2705882489681244, 0.26274511218070984,
				0.2666666805744171, 0.2862745225429535, 0.29411765933036804, 0.3176470696926117,
				0.32549020648002625, 0.32549020648002625, 0.3450980484485626, 0.3450980484485626,
				0.34117648005485535, 0.3019607961177826, 0.1764705926179886, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-7.697926404373106, 8.869480931486237],
		},
	],
	p: [
		{
			id: "cy5uey7pJ1-pF8seT9ddF",
			type: "freedraw",
			x: 241.2185113176463,
			y: 282.4211952429514,
			width: 22.726350801017134,
			height: 32.378875889442725,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1971752179,
			version: 44,
			versionNonce: 1150934739,
			isDeleted: false,
			boundElements: null,
			updated: 1751811737732,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7559387822760755, 0.3915220784696771],
				[-0.7559387822760755, 1.15950769392947],
				[-0.7559387822760755, 4.6289956508300065],
				[-0.3915220784696771, 8.869480931486294],
				[0.3945337867656349, 14.266462197776093],
				[0.7890675735312129, 18.109401983370788],
				[1.5450063558072884, 22.349887264027075],
				[2.3340739293385013, 25.451946808825312],
				[2.6984906331448997, 27.37642840991856],
				[3.0930244199104777, 27.746868530316817],
				[3.0930244199104777, 26.611454502754725],
				[2.6984906331448997, 25.060424730355635],
				[2.3340739293385013, 23.13594312926233],
				[1.9395401425729233, 20.42540566293377],
				[1.5450063558072884, 17.73896186297253],
				[0.7890675735312129, 12.341980596682788],
				[0.3945337867656349, 6.944999330392989],
				[0.3945337867656349, 4.237473572360329],
				[0.3945337867656349, 1.5480180641032462],
				[1.1534842773376113, -0.7649739071638351],
				[2.6984906331448997, -2.3160036795629253],
				[3.848963202186553, -3.4755113734923953],
				[5.393969557993842, -4.237473572360329],
				[6.547453835331453, -4.632007359125907],
				[8.092460191138741, -4.632007359125907],
				[10.423522412181342, -3.4755113734923953],
				[12.332945471795028, -1.9214698927973473],
				[15.817491970175183, 0.3915220784696771],
				[18.515982603320083, 2.7075257580326593],
				[20.42540566293377, 5.396981266289799],
				[21.211461528169025, 7.709973237556824],
				[21.970412018741058, 10.399428745813964],
				[21.970412018741058, 12.341980596682788],
				[21.211461528169025, 13.501488290612201],
				[19.666455172361736, 14.266462197776093],
				[15.422958183409605, 15.422958183409605],
				[12.332945471795028, 15.422958183409605],
				[8.483982269608418, 15.422958183409605],
				[5.029552854187443, 15.02842439664397],
				[3.848963202186553, 14.65798427624577],
				[4.638030775717766, 14.65798427624577],
				[5.029552854187443, 14.65798427624577],
			],
			pressures: [
				0.0784313753247261, 0.1568627506494522, 0.1921568661928177, 0.22745098173618317,
				0.25882354378700256, 0.2705882489681244, 0.27450981736183167, 0.2549019753932953,
				0.24313725531101227, 0.22745098173618317, 0.21176470816135406,
				0.15294118225574493, 0.12156862765550613, 0.10980392247438431,
				0.08627451211214066, 0.07450980693101883, 0.05098039284348488,
				0.03529411926865578, 0.04313725605607033, 0.07450980693101883,
				0.10196078568696976, 0.11764705926179886, 0.14509804546833038, 0.1725490242242813,
				0.19607843458652496, 0.21176470816135406, 0.23137255012989044,
				0.23137255012989044, 0.239215686917305, 0.24313725531101227, 0.2549019753932953,
				0.26274511218070984, 0.2862745225429535, 0.3176470696926117, 0.3490196168422699,
				0.364705890417099, 0.3843137323856354, 0.38823530077934265, 0.40784314274787903,
				0.4000000059604645, 0.3960784375667572, 0.13725490868091583, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [5.029552854187443, 14.65798427624577],
		},
	],
	q: [
		{
			id: "te3ack3ymxBoow-_MD5a3",
			type: "freedraw",
			x: 242.76351767345358,
			y: 282.0266614561858,
			width: 21.60599531493466,
			height: 21.584913356863183,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 399038621,
			version: 32,
			versionNonce: 549912691,
			isDeleted: false,
			boundElements: null,
			updated: 1751811741081,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7559387822760755, 0.39453378676557804],
				[-1.1504725690416535, 0.7860558652352552],
				[-1.1504725690416535, 1.159507693929413],
				[-1.5450063558072884, 1.9425518508688242],
				[-1.5450063558072884, 3.4755113734923953],
				[-1.5450063558072884, 5.791515053055377],
				[-1.1504725690416535, 8.872492639782195],
				[0, 11.953470226509012],
				[2.303956846379265, 14.660995984541671],
				[5.7885033447594765, 16.58246587733902],
				[8.092460191138741, 16.58246587733902],
				[11.941423393325294, 15.817491970175183],
				[15.425969891705506, 14.266462197776036],
				[17.72691502978887, 12.341980596682731],
				[19.27192138559616, 10.025976917119806],
				[19.666455172361736, 7.712984945852725],
				[20.06098895912737, 4.24048528065623],
				[18.515982603320083, 1.9425518508688242],
				[16.57644246074716, -0.370440120398257],
				[13.877951827602317, -2.2919100131956043],
				[10.78793911598774, -4.237473572360329],
				[7.728043487332343, -5.0024474795241645],
				[5.393969557993842, -5.0024474795241645],
				[3.0930244199104777, -3.4514177071250742],
				[1.1534842773376113, -0.7649739071638351],
				[-0.3915220784696771, 2.316003679562982],
				[-0.7559387822760755, 5.791515053055377],
				[-0.3915220784696771, 10.025976917119806],
				[2.303956846379265, 14.660995984541671],
				[3.0930244199104777, 15.422958183409548],
			],
			pressures: [
				0.0784313753247261, 0.0784313753247261, 0.11372549086809158, 0.13725490868091583,
				0.16470588743686676, 0.19607843458652496, 0.21960784494876862, 0.239215686917305,
				0.250980406999588, 0.2549019753932953, 0.24313725531101227, 0.22745098173618317,
				0.21960784494876862, 0.2078431397676468, 0.22745098173618317, 0.21960784494876862,
				0.21568627655506134, 0.1921568661928177, 0.1921568661928177, 0.18431372940540314,
				0.18431372940540314, 0.1725490242242813, 0.1725490242242813, 0.1764705926179886,
				0.18039216101169586, 0.1921568661928177, 0.19607843458652496, 0.18431372940540314,
				0.1411764770746231, 0.027450980618596077, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [3.0930244199104777, 15.422958183409548],
		},
		{
			id: "6CPLQNCkKRnJcBKGx9_S4",
			type: "freedraw",
			x: 261.64391698058006,
			y: 284.7371989225144,
			width: 1.1534842773376113,
			height: 33.538383583372195,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1841414067,
			version: 18,
			versionNonce: 1506897661,
			isDeleted: false,
			boundElements: null,
			updated: 1751811741799,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-1.1534842773376113, 0],
				[-1.1534842773376113, 1.1564959856335122],
				[-1.1534842773376113, 3.080977586726817],
				[-1.1534842773376113, 5.7885033447594765],
				[-1.1534842773376113, 8.869480931486294],
				[-1.1534842773376113, 11.555924731447476],
				[-0.7589504905720332, 14.636902318174293],
				[-0.7589504905720332, 18.109401983370788],
				[-0.7589504905720332, 21.190379570097605],
				[-0.7589504905720332, 23.900917036426165],
				[-0.7589504905720332, 26.216920715989147],
				[-0.7589504905720332, 28.532924395552072],
				[-0.7589504905720332, 31.21936819551331],
				[-0.7589504905720332, 32.378875889442725],
				[-0.7589504905720332, 33.538383583372195],
				[-0.36441670380639835, 33.14384979660656],
			],
			pressures: [
				0.0784313753247261, 0.12156862765550613, 0.19607843458652496, 0.23137255012989044,
				0.2549019753932953, 0.25882354378700256, 0.25882354378700256, 0.250980406999588,
				0.25882354378700256, 0.2705882489681244, 0.2705882489681244, 0.27450981736183167,
				0.2666666805744171, 0.24705882370471954, 0.22745098173618317, 0.18039216101169586,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-0.36441670380639835, 33.14384979660656],
		},
	],
	r: [
		{
			id: "NSZOBLI03Yl7XHSYwDqxL",
			type: "freedraw",
			x: 242.0075788911775,
			y: 278.18372167059107,
			width: 14.269473906071994,
			height: 22.346875555731117,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 527192723,
			version: 30,
			versionNonce: 456650163,
			isDeleted: false,
			boundElements: null,
			updated: 1751811745359,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7890675735312129, 0],
				[-1.18058965200089, 0],
				[-1.18058965200089, 1.1564959856335122],
				[-1.18058965200089, 3.0779658784309163],
				[-1.18058965200089, 4.6289956508300065],
				[-0.7890675735312129, 5.785491636463576],
				[0.36441670380639835, 15.422958183409605],
				[1.1504725690417104, 19.2658979690043],
				[1.9094230596136867, 21.581901648567282],
				[2.303956846379265, 22.346875555731117],
				[2.303956846379265, 21.581901648567282],
				[2.303956846379265, 20.030871876168135],
				[1.9094230596136867, 18.503935770136422],
				[1.9094230596136867, 16.184920382277483],
				[1.9094230596136867, 13.868916702714557],
				[1.9094230596136867, 10.399428745813964],
				[2.303956846379265, 6.1589434651577335],
				[3.0598956286553403, 2.686443799961239],
				[4.24048528065623, 1.1564959856335122],
				[5.393969557993842, 0.3915220784696771],
				[6.93897591380113, 0.3915220784696771],
				[8.483982269608418, 0.3915220784696771],
				[9.998871542456527, 0.3915220784696771],
				[11.543877898263815, 0.3915220784696771],
				[12.332945471794972, 0.7619621988679341],
				[12.69736217560137, 0.7619621988679341],
				[13.088884254071104, 0.7619621988679341],
				[13.088884254071104, 0.7619621988679341],
			],
			pressures: [
				0.0784313753247261, 0.05882352963089943, 0.12156862765550613, 0.1764705926179886,
				0.2078431397676468, 0.21568627655506134, 0.2235294133424759, 0.2549019753932953,
				0.2549019753932953, 0.24705882370471954, 0.23529411852359772, 0.2235294133424759,
				0.21568627655506134, 0.21176470816135406, 0.2078431397676468, 0.19607843458652496,
				0.18039216101169586, 0.1725490242242813, 0.16862745583057404, 0.16862745583057404,
				0.1882352977991104, 0.20000000298023224, 0.21176470816135406, 0.21568627655506134,
				0.21960784494876862, 0.20392157137393951, 0.14509804546833038, 0, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [13.088884254071104, 0.7619621988679341],
		},
	],
	s: [
		{
			id: "9FoB7rovZflwMtQCWuF0a",
			type: "freedraw",
			x: 248.94655480497863,
			y: 282.4211952429514,
			width: 18.485865520360846,
			height: 23.506383249660587,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1254704371,
			version: 30,
			versionNonce: 969558589,
			isDeleted: false,
			boundElements: null,
			updated: 1751811758254,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.39453378676557804, -1.159507693929413],
				[-0.39453378676557804, -1.5510297723990902],
				[-0.39453378676557804, -1.9214698927973473],
				[-0.7890675735312129, -2.6864437999611823],
				[-1.9395401425728664, -3.4755113734923953],
				[-3.484546498380155, -4.237473572360329],
				[-5.78850334475942, -4.237473572360329],
				[-8.483982269608418, -3.4755113734923953],
				[-10.028988625415707, -2.3160036795629253],
				[-11.182472902753318, -0.7649739071638351],
				[-11.182472902753318, 1.15950769392947],
				[-10.028988625415707, 1.921469892797404],
				[-7.728043487332343, 3.4724996651964943],
				[-4.243496988952188, 4.6289956508300065],
				[-1.5450063558072884, 5.7885033447594765],
				[0.7559387822760755, 6.550465543627411],
				[5.393969557993842, 10.025976917119806],
				[6.544442127035552, 11.947446809917153],
				[7.303392617607528, 13.871928411010458],
				[7.303392617607528, 16.18793209057344],
				[5.393969557993842, 18.109401983370788],
				[2.3039568463793216, 19.268909677300257],
				[-1.18058965200089, 19.268909677300257],
				[-3.8790802851457897, 18.109401983370788],
				[-7.728043487332343, 15.422958183409605],
				[-9.273049843139631, 13.871928411010458],
				[-10.81805619894692, 13.106954503846623],
				[-10.81805619894692, 13.501488290612201],
			],
			pressures: [
				0.0784313753247261, 0.1568627506494522, 0.1725490242242813, 0.1921568661928177,
				0.22745098173618317, 0.250980406999588, 0.2823529541492462, 0.29411765933036804,
				0.29019609093666077, 0.27843138575553894, 0.27450981736183167, 0.250980406999588,
				0.250980406999588, 0.250980406999588, 0.250980406999588, 0.2549019753932953,
				0.24313725531101227, 0.21960784494876862, 0.2235294133424759, 0.21176470816135406,
				0.27450981736183167, 0.30980393290519714, 0.3294117748737335, 0.3450980484485626,
				0.3764705955982208, 0.40392157435417175, 0.4000000059604645, 0.3764705955982208,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-10.81805619894692, 13.501488290612201],
		},
	],
	t: [
		{
			id: "o3ZTlsHwt7BWkVyETYU4K",
			type: "freedraw",
			x: 246.24806417183373,
			y: 264.67922167168297,
			width: 15.02842439664397,
			height: 33.16493175467804,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 2022553437,
			version: 23,
			versionNonce: 806533907,
			isDeleted: false,
			boundElements: null,
			updated: 1751811761572,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7860558652352552, 0.3915220784696771],
				[-0.7860558652352552, 1.1564959856335122],
				[-0.7860558652352552, 2.71053746632856],
				[-0.7860558652352552, 5.026541145891542],
				[-1.18058965200089, 8.499040811088037],
				[-1.18058965200089, 12.739526091744267],
				[-1.5450063558072884, 16.58246587733902],
				[-1.9365284342769655, 20.44949932930109],
				[-1.9365284342769655, 24.292439114895842],
				[-1.9365284342769655, 27.37341670162266],
				[-1.5450063558072884, 29.689420381185585],
				[-0.3915220784696771, 30.848928075115055],
				[0.36441670380639835, 31.61390198227889],
				[1.9094230596136867, 32.3999578475142],
				[4.243496988952188, 32.7703979679124],
				[6.54745383533151, 32.7703979679124],
				[9.242932760180452, 33.16493175467804],
				[11.152355819794138, 32.7703979679124],
				[12.697362175601427, 32.008435769044524],
				[13.091895962367005, 32.008435769044524],
				[13.091895962367005, 31.61390198227889],
			],
			pressures: [
				0.0784313753247261, 0.18039216101169586, 0.21568627655506134, 0.24313725531101227,
				0.2705882489681244, 0.3019607961177826, 0.3176470696926117, 0.32156863808631897,
				0.3176470696926117, 0.3137255012989044, 0.3137255012989044, 0.30980393290519714,
				0.30980393290519714, 0.30588236451148987, 0.30588236451148987, 0.3137255012989044,
				0.32156863808631897, 0.32549020648002625, 0.3333333432674408, 0.29411765933036804,
				0.18039216101169586, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [13.091895962367005, 31.61390198227889],
		},
		{
			id: "qJ0Ga03yk08AonCdkLwj1",
			type: "freedraw",
			x: 239.3090882580326,
			y: 281.65622133578756,
			width: 16.18190867398158,
			height: 0.39453378676557804,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 2048348755,
			version: 12,
			versionNonce: 1925353501,
			isDeleted: false,
			boundElements: null,
			updated: 1751811762339,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.36441670380639835, 0],
				[2.3039568463793216, 0],
				[5.393969557993842, 0],
				[8.45687689494514, 0],
				[11.182472902753318, 0],
				[13.091895962367005, -0.39453378676557804],
				[14.636902318174293, -0.39453378676557804],
				[15.39585280874627, -0.39453378676557804],
				[15.787374887216004, 0],
				[16.18190867398158, 0],
			],
			pressures: [
				0.0784313753247261, 0.23137255012989044, 0.2705882489681244, 0.2980392277240753,
				0.32549020648002625, 0.3294117748737335, 0.32549020648002625, 0.2980392277240753,
				0.2705882489681244, 0.20000000298023224, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [16.18190867398158, 0],
		},
	],
	u: [
		{
			id: "ZikpAfmJGwGg_G5dmeuD1",
			type: "freedraw",
			x: 243.1580514602192,
			y: 276.2592400694978,
			width: 21.602983606638702,
			height: 24.271357156824365,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1712233331,
			version: 44,
			versionNonce: 1383988563,
			isDeleted: false,
			boundElements: null,
			updated: 1751811765955,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.786055865235312, 0.3704401203982002],
				[-1.1504725690417104, 0.7649739071638351],
				[-1.1504725690417104, 1.5299478143276701],
				[-1.5450063558072884, 2.6864437999611823],
				[-1.9395401425729233, 4.610925401054487],
				[-2.3310622210426004, 6.926929080617413],
				[-2.3310622210426004, 9.242932760180395],
				[-2.3310622210426004, 13.480406332540724],
				[-2.3310622210426004, 16.56138391926754],
				[-1.5450063558072884, 19.2689096773002],
				[-0.3945337867656349, 20.42841737122967],
				[2.303956846379265, 21.584913356863183],
				[4.60791369275853, 21.955353477261383],
				[6.93897591380113, 21.584913356863183],
				[9.63746654694603, 20.819939449699348],
				[11.938411685029394, 19.66344346406578],
				[13.87795182760226, 18.10940198337073],
				[15.031436104939871, 16.187932090573383],
				[15.787374887215947, 13.106954503846566],
				[16.181908673981525, 9.634454838650072],
				[16.57644246074716, 6.161955173453578],
				[16.181908673981525, 3.0809775867267604],
				[15.787374887215947, 1.159507693929413],
				[15.422958183409548, 0.3704401203982002],
				[15.031436104939871, 0],
				[14.636902318174236, 0],
				[14.636902318174236, 0.3704401203982002],
				[14.636902318174236, 1.159507693929413],
				[14.636902318174236, 1.9244816010932482],
				[14.636902318174236, 3.4755113734923953],
				[14.636902318174236, 5.7674213866879995],
				[15.031436104939871, 8.083425066250982],
				[15.787374887215947, 11.558936439743377],
				[16.57644246074716, 15.031436104939871],
				[17.332381243023235, 17.72089161319701],
				[18.485865520360846, 20.033883584464036],
				[18.877387598830524, 20.819939449699348],
				[18.877387598830524, 21.955353477261383],
				[19.2719213855961, 23.114861171190853],
				[19.2719213855961, 23.900917036426108],
				[18.877387598830524, 24.271357156824365],
				[18.485865520360846, 23.900917036426108],
			],
			pressures: [
				0.0784313753247261, 0.09019608050584793, 0.13333334028720856, 0.16078431904315948,
				0.1725490242242813, 0.1921568661928177, 0.21176470816135406, 0.2235294133424759,
				0.23529411852359772, 0.24313725531101227, 0.24705882370471954,
				0.24313725531101227, 0.24705882370471954, 0.24313725531101227, 0.239215686917305,
				0.23137255012989044, 0.21960784494876862, 0.2078431397676468, 0.20392157137393951,
				0.1882352977991104, 0.16470588743686676, 0.14509804546833038, 0.1411764770746231,
				0.13333334028720856, 0.12941177189350128, 0.15294118225574493, 0.1725490242242813,
				0.21176470816135406, 0.23137255012989044, 0.2549019753932953, 0.27450981736183167,
				0.29019609093666077, 0.3137255012989044, 0.3137255012989044, 0.32549020648002625,
				0.32549020648002625, 0.3176470696926117, 0.3176470696926117, 0.2862745225429535,
				0.2549019753932953, 0.2078431397676468, 0.12941177189350128, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [18.485865520360846, 23.900917036426108],
		},
	],
	v: [
		{
			id: "Qf4AqKwMTnwrC1qAPbjiM",
			type: "freedraw",
			x: 242.0075788911775,
			y: 278.945683869459,
			width: 18.512970895024125,
			height: 20.819939449699348,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 596083229,
			version: 20,
			versionNonce: 1515946867,
			isDeleted: false,
			boundElements: null,
			updated: 1751811769041,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.39453378676557804, 0],
				[0.7559387822760755, 1.554041480695048],
				[1.9094230596136867, 4.635019067421865],
				[3.454429415420975, 8.872492639782195],
				[5.393969557993842, 13.106954503846623],
				[6.544442127035552, 16.976999664104596],
				[7.303392617607528, 18.503935770136366],
				[7.6949146960772055, 18.898469556902],
				[8.08944848284284, 17.74197357126849],
				[8.848398973414817, 16.18793209057344],
				[9.634454838650129, 13.874940119306359],
				[10.78793911598774, 11.185484611049219],
				[12.332945471794972, 8.477958853016617],
				[13.87795182760226, 5.023529437595641],
				[15.392841100450369, 1.924481601093305],
				[16.18190867398158, 0.7890675735312129],
				[17.72691502978887, -1.5269361060317692],
				[18.118437108258547, -1.9214698927973473],
			],
			pressures: [
				0.0784313753247261, 0.239215686917305, 0.29411765933036804, 0.32549020648002625,
				0.34117648005485535, 0.364705890417099, 0.3607843220233917, 0.3490196168422699,
				0.33725491166114807, 0.30980393290519714, 0.2980392277240753, 0.2862745225429535,
				0.27843138575553894, 0.2705882489681244, 0.25882354378700256, 0.24705882370471954,
				0.22745098173618317, 0.1411764770746231, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [18.118437108258547, -1.9214698927973473],
		},
	],
	w: [
		{
			id: "67YEJ3Z-EL4DxLaL6CQUY",
			type: "freedraw",
			x: 231.58405647899616,
			y: 278.57524374906075,
			width: 32.002412352452666,
			height: 22.741409342496752,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1877711613,
			version: 43,
			versionNonce: 1436040893,
			isDeleted: false,
			boundElements: null,
			updated: 1751811777223,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.39754549506147896, 0],
				[-0.39754549506147896, 0.7649739071638351],
				[-0.39754549506147896, 3.080977586726817],
				[0.3945337867656349, 6.9269290806174695],
				[1.9395401425729233, 11.164402652977799],
				[3.4845464983802117, 14.636902318174293],
				[5.393969557993898, 17.347439784502853],
				[6.938975913801187, 18.112413691666745],
				[9.242932760180452, 18.503935770136422],
				[10.78793911598774, 17.71787990490111],
				[12.332945471795028, 15.793398303807805],
				[13.119001337030284, 14.245380239704616],
				[14.272485614367895, 10.396417037518063],
				[15.02842439664397, 6.9269290806174695],
				[15.02842439664397, 3.8459514938906523],
				[15.422958183409605, 1.529947814327727],
				[15.422958183409605, -0.7860558652352552],
				[15.422958183409605, -1.5510297723990902],
				[15.422958183409605, -1.9455635591647251],
				[15.422958183409605, -2.3160036795629253],
				[15.422958183409605, -1.9455635591647251],
				[15.422958183409605, -0.3915220784696771],
				[15.817491970175183, 1.924481601093305],
				[15.817491970175183, 4.610925401054487],
				[16.57343075245126, 7.318451159087147],
				[17.72691502978887, 10.790950824283641],
				[19.666455172361793, 13.871928411010458],
				[21.967400310445157, 16.18793209057344],
				[24.3014742397836, 16.952905997737275],
				[26.9969531646326, 16.952905997737275],
				[28.906376224246287, 16.558372210971697],
				[30.451382580053576, 15.793398303807805],
				[31.24045015358479, 13.871928411010458],
				[31.604866857391187, 11.555924731447476],
				[31.604866857391187, 8.083425066250982],
				[31.604866857391187, 4.610925401054487],
				[31.604866857391187, 0],
				[31.604866857391187, -2.71053746632856],
				[31.604866857391187, -3.8670334519620724],
				[31.604866857391187, -4.237473572360329],
				[30.845916366819154, -2.71053746632856],
			],
			pressures: [
				0.0784313753247261, 0.23137255012989044, 0.2549019753932953, 0.29019609093666077,
				0.3176470696926117, 0.3333333432674408, 0.3294117748737335, 0.3176470696926117,
				0.3019607961177826, 0.29019609093666077, 0.27843138575553894, 0.2666666805744171,
				0.2549019753932953, 0.2549019753932953, 0.2549019753932953, 0.2549019753932953,
				0.24705882370471954, 0.23529411852359772, 0.22745098173618317, 0.2235294133424759,
				0.21960784494876862, 0.24705882370471954, 0.2823529541492462, 0.2980392277240753,
				0.3176470696926117, 0.32549020648002625, 0.34117648005485535, 0.34117648005485535,
				0.3176470696926117, 0.29019609093666077, 0.2666666805744171, 0.250980406999588,
				0.250980406999588, 0.24705882370471954, 0.250980406999588, 0.250980406999588,
				0.24705882370471954, 0.23529411852359772, 0.2235294133424759, 0.21176470816135406,
				0.18431372940540314, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [30.845916366819154, -2.71053746632856],
		},
	],
	x: [
		{
			id: "CRAO-lmqjiM4FF0jNzXc-",
			type: "freedraw",
			x: 238.91756617956293,
			y: 279.3402176562246,
			width: 21.9674003104451,
			height: 19.2689096773002,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1315848915,
			version: 19,
			versionNonce: 82043923,
			isDeleted: false,
			boundElements: null,
			updated: 1751811785206,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7890675735312129, 0],
				[-1.1534842773376113, -0.39453378676557804],
				[-1.5450063558072884, -0.39453378676557804],
				[-0.7890675735312129, -0.39453378676557804],
				[0.7559387822760755, 0.7649739071638919],
				[3.090012711614577, 2.316003679562982],
				[5.393969557993842, 4.628995650830063],
				[8.483982269608418, 8.083425066251039],
				[11.938411685029394, 11.950458518213111],
				[14.633890609878392, 15.02842439664397],
				[16.967964539216837, 16.952905997737275],
				[18.482853812064945, 18.109401983370788],
				[19.663443464065836, 18.874375890534623],
				[20.422393954637812, 18.874375890534623],
				[19.663443464065836, 18.503935770136422],
				[18.877387598830524, 17.738961862972587],
				[18.482853812064945, 17.34743978450291],
			],
			pressures: [
				0.0784313753247261, 0.07450980693101883, 0.07450980693101883, 0.23137255012989044,
				0.3137255012989044, 0.35686275362968445, 0.38823530077934265, 0.40392157435417175,
				0.40392157435417175, 0.40392157435417175, 0.3960784375667572, 0.3960784375667572,
				0.3960784375667572, 0.3843137323856354, 0.3686274588108063, 0.1921568661928177,
				0.12156862765550613, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [18.482853812064945, 17.34743978450291],
		},
		{
			id: "nSYyy0Wtx4__eWC9xyeWk",
			type: "freedraw",
			x: 235.82454175965245,
			y: 298.60912733352484,
			width: 21.575878231975423,
			height: 24.66589094359,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1832845053,
			version: 13,
			versionNonce: 1436702003,
			isDeleted: false,
			boundElements: null,
			updated: 1751811785667,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.39453378676557804, -0.7649739071638351],
				[1.5480180641031893, -1.5299478143276701],
				[5.0024474795241645, -4.6289956508300065],
				[9.242932760180395, -9.242932760180452],
				[13.122013045326185, -13.871928411010458],
				[15.817491970175183, -18.109401983370788],
				[18.515982603320026, -21.190379570097605],
				[20.425405662933713, -23.506383249660587],
				[21.575878231975423, -24.66589094359],
				[21.211461528169025, -23.13594312926233],
				[20.816927741403447, -22.349887264027018],
			],
			pressures: [
				0.0784313753247261, 0.25882354378700256, 0.27450981736183167, 0.32549020648002625,
				0.364705890417099, 0.37254902720451355, 0.3764705955982208, 0.34117648005485535,
				0.2980392277240753, 0.239215686917305, 0.0313725508749485, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [20.816927741403447, -22.349887264027018],
		},
	],
	y: [
		{
			id: "YEFgAc0hz9SKVsEm6m8gK",
			type: "freedraw",
			x: 242.0075788911775,
			y: 280.1051915633885,
			width: 21.572866523679522,
			height: 40.856834742459284,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 793120829,
			version: 38,
			versionNonce: 465875091,
			isDeleted: false,
			boundElements: null,
			updated: 1751811789154,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, 1.1564959856335122],
				[0, 1.9214698927973473],
				[0.7559387822760755, 4.632007359125907],
				[1.9094230596136867, 7.318451159087147],
				[3.848963202186553, 10.025976917119749],
				[6.544442127035552, 11.577006689518896],
				[9.998871542456527, 11.577006689518896],
				[13.483418040836682, 10.420510703885384],
				[16.57343075245126, 8.47795885301656],
				[18.118437108258547, 6.944999330392932],
				[19.27192138559616, 3.4755113734923953],
				[19.636338089402557, 0],
				[19.636338089402557, -3.080977586726817],
				[18.482853812064945, -5.767421386688056],
				[17.332381243023235, -8.477958853016617],
				[16.57343075245126, -9.63746654694603],
				[15.787374887215947, -9.63746654694603],
				[15.392841100450369, -9.63746654694603],
				[15.02842439664397, -8.477958853016617],
				[15.02842439664397, -6.556488960219269],
				[15.392841100450369, -4.632007359125964],
				[16.18190867398158, -1.921469892797404],
				[17.332381243023235, 1.5510297723990902],
				[18.482853812064945, 5.023529437595585],
				[20.027860167872234, 10.793962532579542],
				[21.181344445209845, 16.187932090573383],
				[21.572866523679522, 21.214473236464926],
				[21.181344445209845, 23.900917036426108],
				[19.636338089402557, 26.981894623152925],
				[18.118437108258547, 29.297898302715907],
				[13.87795182760226, 31.219368195513255],
				[10.78793911598774, 31.219368195513255],
				[6.544442127035552, 30.45439428834942],
				[4.9994357712282635, 30.062872209879743],
				[4.604901984462629, 29.692432089481485],
				[5.393969557993842, 29.297898302715907],
			],
			pressures: [
				0.0784313753247261, 0.2666666805744171, 0.2823529541492462, 0.3137255012989044,
				0.3333333432674408, 0.3450980484485626, 0.3450980484485626, 0.3450980484485626,
				0.3333333432674408, 0.30588236451148987, 0.3019607961177826, 0.2666666805744171,
				0.250980406999588, 0.24313725531101227, 0.250980406999588, 0.250980406999588,
				0.2666666805744171, 0.3019607961177826, 0.3333333432674408, 0.3529411852359772,
				0.37254902720451355, 0.3921568691730499, 0.4156862795352936, 0.4313725531101227,
				0.4313725531101227, 0.4588235318660736, 0.45098039507865906, 0.4431372582912445,
				0.43529412150382996, 0.4313725531101227, 0.4313725531101227, 0.43529412150382996,
				0.45098039507865906, 0.46666666865348816, 0.47843137383461, 0.4745098054409027, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [5.393969557993842, 29.297898302715907],
		},
	],
	z: [
		{
			id: "3ViY2DWTL6uXdTg2Q7WPk",
			type: "freedraw",
			x: 240.8269892391766,
			y: 279.7347514429902,
			width: 21.181344445209845,
			height: 19.663443464065836,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1317998397,
			version: 35,
			versionNonce: 1499359411,
			isDeleted: false,
			boundElements: null,
			updated: 1751811795376,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.3915220784696771, 0],
				[2.3310622210426004, 0.370440120398257],
				[5.42107493265712, 0.7649739071638351],
				[8.483982269608418, 1.135414027562092],
				[11.179461194457417, 1.135414027562092],
				[13.513535123795862, 0.7649739071638351],
				[15.422958183409548, 0],
				[16.20901404864486, -0.3945337867656349],
				[16.57343075245126, -0.7890675735312129],
				[15.814480261879282, -0.7890675735312129],
				[15.05854147960315, -0.3945337867656349],
				[13.119001337030284, 0.7649739071638351],
				[12.724467550264706, 0.7649739071638351],
				[10.423522412181342, 2.2919100131956043],
				[8.483982269608418, 4.2344618640644285],
				[6.180025423229154, 6.158943465157677],
				[3.876068576849832, 8.474947144720659],
				[2.3310622210426004, 11.164402652977799],
				[0.786055865235312, 13.085872545775146],
				[0, 15.02842439664397],
				[-0.36441670380639835, 16.55837221097164],
				[-0.36441670380639835, 17.714868196605153],
				[0.3915220784696771, 18.109401983370788],
				[1.5450063558072884, 18.479842103768988],
				[4.24048528065623, 18.874375890534623],
				[6.574559209994732, 18.874375890534623],
				[9.664571921609308, 18.874375890534623],
				[12.724467550264706, 18.109401983370788],
				[16.20901404864486, 17.344428076206952],
				[18.512970895024125, 16.55837221097164],
				[20.057977250831414, 16.187932090573383],
				[20.816927741403447, 15.793398303807805],
				[20.816927741403447, 15.793398303807805],
			],
			pressures: [
				0.0784313753247261, 0.250980406999588, 0.27843138575553894, 0.27450981736183167,
				0.27843138575553894, 0.25882354378700256, 0.239215686917305, 0.22745098173618317,
				0.2235294133424759, 0.21960784494876862, 0.2235294133424759, 0.2078431397676468,
				0.19607843458652496, 0.20000000298023224, 0.21960784494876862,
				0.23529411852359772, 0.24313725531101227, 0.24705882370471954,
				0.24705882370471954, 0.24313725531101227, 0.24313725531101227,
				0.24313725531101227, 0.24705882370471954, 0.24705882370471954, 0.2549019753932953,
				0.2980392277240753, 0.32549020648002625, 0.35686275362968445, 0.3843137323856354,
				0.3764705955982208, 0.3490196168422699, 0.2823529541492462, 0.21960784494876862,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [20.816927741403447, 15.793398303807805],
		},
		{
			id: "3FfvlxoNq2vr8NBheGZMq",
			type: "freedraw",
			x: 238.91756617956293,
			y: 288.2096985877109,
			width: 14.633890609878392,
			height: 0.7649739071638351,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1719330909,
			version: 9,
			versionNonce: 623318867,
			isDeleted: false,
			boundElements: null,
			updated: 1751811796055,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[1.5450063558072884, 0],
				[3.090012711614577, 0],
				[5.785491636463519, 0],
				[8.848398973414817, 0],
				[11.179461194457417, 0.37345182869415794],
				[13.483418040836682, 0.37345182869415794],
				[14.633890609878392, -0.3915220784696771],
			],
			pressures: [
				0.0784313753247261, 0.2666666805744171, 0.2980392277240753, 0.32156863808631897,
				0.33725491166114807, 0.30980393290519714, 0.27843138575553894, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [14.633890609878392, -0.3915220784696771],
		},
	],
	à: [
		{
			id: "SDzIdOB8NIeG6uKSiCotR",
			type: "freedraw",
			x: 243.9170019507912,
			y: 273.178262482771,
			width: 22.36193409721068,
			height: 27.74686853031676,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1917990365,
			version: 37,
			versionNonce: 560129875,
			isDeleted: false,
			boundElements: null,
			updated: 1751811809490,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, -0.786055865235312],
				[0.7860558652352552, -1.551029772399147],
				[1.9395401425728664, -2.316003679562982],
				[3.848963202186553, -2.71053746632856],
				[6.180025423229154, -2.71053746632856],
				[8.878516056374053, -0.786055865235312],
				[11.179461194457417, 2.6864437999611823],
				[12.724467550264706, 7.3214628673830475],
				[13.87795182760226, 11.558936439743377],
				[13.87795182760226, 15.031436104939871],
				[13.87795182760226, 17.72089161319701],
				[13.87795182760226, 18.503935770136366],
				[13.87795182760226, 17.72089161319701],
				[13.87795182760226, 16.56138391926754],
				[13.119001337030284, 15.031436104939871],
				[11.968528767988573, 13.871928411010401],
				[10.787939115987683, 12.71543242537689],
				[8.878516056374053, 11.558936439743377],
				[5.393969557993842, 10.790950824283641],
				[2.3310622210425436, 10.790950824283641],
				[-0.7589504905719764, 11.164402652977799],
				[-3.090012711614577, 11.950458518213054],
				[-4.607913692758586, 13.088884254071047],
				[-5.393969557993842, 15.031436104939871],
				[-5.393969557993842, 17.347439784502853],
				[-4.243496988952188, 20.033883584464036],
				[-1.5450063558072884, 22.349887264027018],
				[0.7860558652352552, 23.509394957956488],
				[4.635019067421865, 24.66589094359],
				[8.878516056374053, 25.0363310639882],
				[12.724467550264706, 24.271357156824365],
				[15.422958183409548, 23.509394957956488],
				[16.20901404864486, 22.744421050792596],
				[16.967964539216837, 21.95535347726144],
				[16.57343075245126, 21.584913356863183],
			],
			pressures: [
				0.0784313753247261, 0.0784313753247261, 0.18431372940540314, 0.2235294133424759,
				0.24705882370471954, 0.26274511218070984, 0.25882354378700256, 0.2549019753932953,
				0.25882354378700256, 0.2705882489681244, 0.27450981736183167, 0.27843138575553894,
				0.25882354378700256, 0.21960784494876862, 0.21176470816135406,
				0.20000000298023224, 0.1921568661928177, 0.18431372940540314, 0.1725490242242813,
				0.16078431904315948, 0.16862745583057404, 0.16862745583057404,
				0.18431372940540314, 0.2078431397676468, 0.23529411852359772, 0.25882354378700256,
				0.2823529541492462, 0.3019607961177826, 0.3137255012989044, 0.33725491166114807,
				0.364705890417099, 0.3764705955982208, 0.3803921639919281, 0.3529411852359772,
				0.23137255012989044, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [16.57343075245126, 21.584913356863183],
		},
		{
			id: "OVEyLLMbaOLXH798Y-p4B",
			type: "freedraw",
			x: 245.06747451983284,
			y: 248.12084946071133,
			width: 8.878516056374053,
			height: 15.39886451704217,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 574619923,
			version: 12,
			versionNonce: 1261018461,
			isDeleted: false,
			boundElements: null,
			updated: 1751811819097,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.3945337867656349, 1.1534842773376113],
				[0.7890675735312129, 1.5269361060317692],
				[1.9395401425729233, 4.60791369275853],
				[3.8790802851457897, 8.474947144720659],
				[6.183037131525111, 11.947446809917153],
				[7.7280434873324, 14.633890609878335],
				[8.483982269608475, 15.39886451704217],
				[8.878516056374053, 15.39886451704217],
				[8.878516056374053, 14.263450489480135],
				[8.878516056374053, 13.871928411010401],
			],
			pressures: [
				0.0784313753247261, 0.1568627506494522, 0.16078431904315948, 0.18431372940540314,
				0.20000000298023224, 0.21176470816135406, 0.2078431397676468, 0.1921568661928177,
				0.1411764770746231, 0.04313725605607033, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [8.878516056374053, 13.871928411010401],
		},
	],
	è: [
		{
			id: "GuoEa7TJVv-iGlv3QhN7l",
			type: "freedraw",
			x: 237.37255982375564,
			y: 279.7347514429902,
			width: 26.207885591101387,
			height: 27.37341670162266,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1723620989,
			version: 39,
			versionNonce: 2116240371,
			isDeleted: false,
			boundElements: null,
			updated: 1751811824729,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, 0.370440120398257],
				[0.3915220784696771, 0.370440120398257],
				[1.9365284342769655, 1.135414027562092],
				[4.9994357712282635, 1.9214698927973473],
				[8.483982269608418, 3.0779658784308594],
				[11.938411685029394, 3.8459514938906523],
				[15.422958183409605, 3.8459514938906523],
				[18.512970895024125, 3.4514177071250174],
				[20.422393954637812, 1.9214698927973473],
				[21.572866523679522, 0],
				[21.9674003104451, -1.9455635591647251],
				[21.9674003104451, -3.87004516025803],
				[21.208449819873124, -5.791515053055377],
				[19.663443464065836, -7.712984945852725],
				[17.332381243023235, -9.267026426547773],
				[14.633890609878392, -10.028988625415707],
				[11.938411685029394, -10.028988625415707],
				[9.634454838650129, -10.028988625415707],
				[7.330497992270807, -9.658548505017507],
				[5.390957849697941, -8.872492639782195],
				[3.454429415420975, -6.94801103868889],
				[1.5450063558072884, -4.632007359125964],
				[0.3915220784696771, -2.316003679562982],
				[0, 0.7649739071638351],
				[0, 4.2344618640644285],
				[0.7559387822760755, 7.315439450791189],
				[2.6954789248489988, 10.790950824283641],
				[4.9994357712282635, 13.477394624244823],
				[8.08944848284284, 15.398864517042227],
				[11.573994981222995, 16.55837221097164],
				[15.02842439664397, 17.344428076206952],
				[18.877387598830524, 17.344428076206952],
				[21.9674003104451, 16.952905997737275],
				[24.271357156824422, 16.187932090573383],
				[25.451946808825312, 15.02842439664397],
				[25.81636351263171, 13.871928411010458],
				[26.207885591101387, 13.085872545775146],
			],
			pressures: [
				0.0784313753247261, 0.1764705926179886, 0.18431372940540314, 0.21568627655506134,
				0.239215686917305, 0.2705882489681244, 0.2862745225429535, 0.29019609093666077,
				0.27450981736183167, 0.2666666805744171, 0.26274511218070984, 0.23529411852359772,
				0.2235294133424759, 0.21960784494876862, 0.21176470816135406, 0.21568627655506134,
				0.2235294133424759, 0.239215686917305, 0.24705882370471954, 0.25882354378700256,
				0.27450981736183167, 0.27450981736183167, 0.27450981736183167,
				0.29019609093666077, 0.2980392277240753, 0.30588236451148987, 0.3137255012989044,
				0.33725491166114807, 0.3529411852359772, 0.3607843220233917, 0.3803921639919281,
				0.3921568691730499, 0.4000000059604645, 0.40392157435417175, 0.37254902720451355,
				0.2823529541492462, 0.10980392247438431, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [26.207885591101387, 13.085872545775146],
		},
		{
			id: "8VSSAtHZIGPbWDXf5MMRE",
			type: "freedraw",
			x: 238.91756617956293,
			y: 252.3553113247757,
			width: 15.02842439664397,
			height: 11.558936439743434,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 2101823773,
			version: 10,
			versionNonce: 882278451,
			isDeleted: false,
			boundElements: null,
			updated: 1751811825640,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.7559387822760755, 0.37345182869415794],
				[3.090012711614577, 2.316003679562982],
				[6.149908340269917, 4.632007359125964],
				[9.634454838650129, 7.7129849458527815],
				[12.332945471795028, 10.399428745813964],
				[14.269473906071994, 11.558936439743434],
				[15.02842439664397, 11.558936439743434],
				[14.633890609878392, 11.164402652977799],
			],
			pressures: [
				0.0784313753247261, 0.2666666805744171, 0.3137255012989044, 0.364705890417099,
				0.40392157435417175, 0.4156862795352936, 0.3764705955982208, 0.2980392277240753,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [14.633890609878392, 11.164402652977799],
		},
	],
	é: [
		{
			id: "cSWFo7A62Osi21fHC-f5X",
			type: "freedraw",
			x: 237.7640819022253,
			y: 278.945683869459,
			width: 26.21089729939729,
			height: 31.61390198227889,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 286494333,
			version: 37,
			versionNonce: 1331061939,
			isDeleted: false,
			boundElements: null,
			updated: 1751811836412,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.7589504905720332, 0.39453378676557804],
				[1.1534842773376113, 0.39453378676557804],
				[3.454429415420975, 0.39453378676557804],
				[6.152920048565875, 0.7890675735312129],
				[10.393405329222105, 0.7890675735312129],
				[13.091895962367005, 0.7890675735312129],
				[18.121448816554448, 0.39453378676557804],
				[20.42540566293377, -0.370440120398257],
				[22.726350801017134, -1.9214698927973473],
				[24.66589094359, -3.4724996651964943],
				[25.81636351263171, -5.7674213866879995],
				[26.21089729939729, -7.712984945852725],
				[26.21089729939729, -9.634454838650129],
				[25.81636351263171, -10.793962532579542],
				[24.66589094359, -11.950458518213054],
				[21.970412018741058, -13.480406332540781],
				[18.485865520360846, -14.266462197776036],
				[14.636902318174293, -14.636902318174293],
				[10.78793911598774, -14.266462197776036],
				[8.092460191138741, -12.71543242537689],
				[5.7885033447594765, -10.793962532579542],
				[3.454429415420975, -8.083425066250982],
				[1.5450063558072884, -3.8429397855947514],
				[0, 1.15950769392947],
				[0, 5.791515053055377],
				[1.1534842773376113, 10.420510703885384],
				[3.84896320218661, 13.874940119306359],
				[7.303392617607528, 16.18793209057344],
				[10.78793911598774, 16.976999664104596],
				[14.636902318174293, 16.976999664104596],
				[18.485865520360846, 16.58246587733902],
				[22.361934097210735, 15.422958183409548],
				[24.66589094359, 15.034447813235829],
				[25.424841434162033, 15.034447813235829],
				[25.060424730355635, 15.034447813235829],
			],
			pressures: [
				0.0784313753247261, 0.1764705926179886, 0.18431372940540314, 0.21176470816135406,
				0.24313725531101227, 0.2666666805744171, 0.2862745225429535, 0.30588236451148987,
				0.3176470696926117, 0.3176470696926117, 0.3137255012989044, 0.2980392277240753,
				0.27450981736183167, 0.250980406999588, 0.239215686917305, 0.22745098173618317,
				0.21960784494876862, 0.21960784494876862, 0.21568627655506134,
				0.21176470816135406, 0.21176470816135406, 0.2078431397676468, 0.2235294133424759,
				0.24705882370471954, 0.2705882489681244, 0.2862745225429535, 0.3019607961177826,
				0.2980392277240753, 0.30588236451148987, 0.3176470696926117, 0.32156863808631897,
				0.32549020648002625, 0.32549020648002625, 0.32156863808631897, 0.2666666805744171,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [25.060424730355635, 15.034447813235829],
		},
		{
			id: "BvwNp2Ax1lvF7CcMPIzCa",
			type: "freedraw",
			x: 250.09702737402034,
			y: 253.51481901870517,
			width: 13.87795182760226,
			height: 11.185484611049219,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 510989299,
			version: 11,
			versionNonce: 1847839773,
			isDeleted: false,
			boundElements: null,
			updated: 1751811838267,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, -0.3915220784696771],
				[1.1534842773376113, -1.15950769392947],
				[3.848963202186553, -3.080977586726817],
				[7.697926404373106, -5.7885033447594765],
				[11.938411685029394, -9.264014718251872],
				[13.091895962367005, -10.790950824283641],
				[13.87795182760226, -11.185484611049219],
				[13.87795182760226, -10.790950824283641],
				[13.87795182760226, -10.420510703885384],
			],
			pressures: [
				0.0784313753247261, 0.19607843458652496, 0.2235294133424759, 0.250980406999588,
				0.2705882489681244, 0.2549019753932953, 0.23137255012989044, 0.1725490242242813,
				0.04313725605607033, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [13.87795182760226, -10.420510703885384],
		},
	],
	ì: [
		{
			id: "MYw0s6uBLatiBBaXbqapX",
			type: "freedraw",
			x: 243.9170019507912,
			y: 277.02421397666166,
			width: 2.695478924848942,
			height: 20.819939449699348,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1981685619,
			version: 12,
			versionNonce: 1070140755,
			isDeleted: false,
			boundElements: null,
			updated: 1751811841907,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.36441670380639835, 0.7649739071638351],
				[0, 3.4755113734923953],
				[0, 7.318451159087147],
				[0.39453378676557804, 12.341980596682731],
				[0.7860558652352552, 15.796410012103706],
				[1.1504725690416535, 19.2689096773002],
				[1.5450063558072884, 20.425405662933713],
				[1.9395401425728664, 20.819939449699348],
				[1.9395401425728664, 20.425405662933713],
				[2.3310622210425436, 19.663443464065836],
			],
			pressures: [
				0.0784313753247261, 0.23137255012989044, 0.27450981736183167, 0.29019609093666077,
				0.2862745225429535, 0.29019609093666077, 0.2823529541492462, 0.2666666805744171,
				0.239215686917305, 0.09019608050584793, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [2.3310622210425436, 19.663443464065836],
		},
		{
			id: "N3USjEsE40ybdV5sjYp-U",
			type: "freedraw",
			x: 231.18651098393468,
			y: 260.4387363910267,
			width: 15.422958183409548,
			height: 8.848398973414817,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 219984317,
			version: 10,
			versionNonce: 546443667,
			isDeleted: false,
			boundElements: null,
			updated: 1751811842498,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7529270739801746, -0.3704401203982002],
				[-0.36140499551049743, -0.3704401203982002],
				[1.9425518508687674, 1.554041480695048],
				[5.791515053055377, 3.87004516025803],
				[10.82106790724282, 6.556488960219269],
				[13.125024753622085, 7.7129849458527815],
				[14.275497322663796, 8.477958853016617],
				[14.670031109429374, 8.477958853016617],
			],
			pressures: [
				0.0784313753247261, 0.09803921729326248, 0.1921568661928177, 0.24313725531101227,
				0.2705882489681244, 0.2666666805744171, 0.23529411852359772, 0.08627451211214066,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [14.670031109429374, 8.477958853016617],
		},
	],
	ò: [
		{
			id: "I4rcUvtCyHHdMoG6LVSWZ",
			type: "freedraw",
			x: 243.1580514602192,
			y: 278.18372167059107,
			width: 22.36193409721068,
			height: 23.530476916027965,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1065383539,
			version: 31,
			versionNonce: 117117213,
			isDeleted: false,
			boundElements: null,
			updated: 1751811846630,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.786055865235312, 0],
				[-1.5450063558072884, 0],
				[-1.9395401425729233, 0.3915220784696771],
				[-2.3310622210426004, 1.1564959856335122],
				[-3.090012711614577, 3.0779658784309163],
				[-3.84896320218661, 5.785491636463576],
				[-4.240485280656287, 9.23992105188455],
				[-3.84896320218661, 12.715432425376946],
				[-2.6954789248489988, 15.796410012103763],
				[-0.786055865235312, 17.73896186297253],
				[1.90942305961363, 18.8954578486061],
				[4.60791369275853, 18.8954578486061],
				[7.697926404373106, 17.73896186297253],
				[10.393405329222105, 16.579454169043117],
				[12.72747925856055, 15.02842439664397],
				[14.636902318174236, 12.715432425376946],
				[15.787374887215947, 10.025976917119806],
				[16.181908673981525, 7.318451159087147],
				[16.181908673981525, 3.8429397855947514],
				[14.242368531408658, 0.7619621988679341],
				[11.54688960655966, -1.9244816010932482],
				[8.848398973414817, -4.24048528065623],
				[5.78850334475942, -4.635019067421865],
				[3.09001271161452, -3.8459514938906523],
				[0, -1.159507693929413],
				[-3.090012711614577, 2.316003679562982],
				[-5.393969557993898, 6.1589434651577335],
				[-6.180025423229154, 11.947446809917153],
				[-5.785491636463576, 13.106954503846623],
			],
			pressures: [
				0.0784313753247261, 0.07058823853731155, 0.10196078568696976, 0.11372549086809158,
				0.1411764770746231, 0.1725490242242813, 0.19607843458652496, 0.2235294133424759,
				0.24313725531101227, 0.2666666805744171, 0.2823529541492462, 0.30588236451148987,
				0.32549020648002625, 0.33725491166114807, 0.34117648005485535,
				0.33725491166114807, 0.3333333432674408, 0.3294117748737335, 0.3137255012989044,
				0.2980392277240753, 0.27843138575553894, 0.2705882489681244, 0.2666666805744171,
				0.2862745225429535, 0.3019607961177826, 0.30980393290519714, 0.3019607961177826,
				0.23529411852359772, 0.10588235408067703, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-5.785491636463576, 13.106954503846623],
		},
		{
			id: "wb59TybDUEcaGR1BleJpx",
			type: "freedraw",
			x: 240.8269892391766,
			y: 252.72876315346986,
			width: 11.96852876798863,
			height: 13.106954503846623,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 2041916893,
			version: 11,
			versionNonce: 1459593491,
			isDeleted: false,
			boundElements: null,
			updated: 1751811848366,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, 0.3945337867656349],
				[0.3915220784696771, 0.3945337867656349],
				[2.7255960078081785, 2.316003679562982],
				[5.42107493265712, 5.396981266289799],
				[8.11956556580202, 8.869480931486294],
				[10.028988625415707, 11.580018397814854],
				[11.573994981222995, 12.736514383448366],
				[11.96852876798863, 13.106954503846623],
				[11.96852876798863, 12.736514383448366],
			],
			pressures: [
				0.0784313753247261, 0.22745098173618317, 0.23137255012989044, 0.25882354378700256,
				0.2862745225429535, 0.2980392277240753, 0.27843138575553894, 0.23137255012989044,
				0.07058823853731155, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [11.96852876798863, 12.736514383448366],
		},
	],
	ù: [
		{
			id: "sfo2xj307O86YRbcdmP7-",
			type: "freedraw",
			x: 240.4625725353702,
			y: 277.02421397666166,
			width: 23.11787287948681,
			height: 22.741409342496695,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 761391709,
			version: 42,
			versionNonce: 719537907,
			isDeleted: false,
			boundElements: null,
			updated: 1751811851733,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7890675735312129, 0],
				[-0.7890675735312129, 0.39453378676557804],
				[-1.1534842773376113, 1.159507693929413],
				[-1.5450063558072884, 1.9214698927973473],
				[-2.6984906331448997, 5.0024474795241645],
				[-3.090012711614577, 7.318451159087147],
				[-3.090012711614577, 11.558936439743377],
				[-2.6984906331448997, 14.657984276245713],
				[-0.7890675735312129, 17.344428076206896],
				[0.7559387822760755, 18.898469556901944],
				[3.090012711614577, 20.054965542535513],
				[5.393969557993842, 20.819939449699348],
				[7.303392617607528, 20.819939449699348],
				[9.634454838650129, 19.2689096773002],
				[11.543877898263815, 17.344428076206896],
				[13.088884254071104, 14.657984276245713],
				[15.02842439664397, 11.185484611049219],
				[16.17889696568568, 7.318451159087147],
				[16.57343075245126, 5.3969812662897425],
				[16.57343075245126, 3.080977586726817],
				[16.17889696568568, 1.159507693929413],
				[15.787374887215947, 0],
				[15.422958183409548, -0.7649739071638351],
				[15.422958183409548, -1.15950769392947],
				[15.02842439664397, -1.551029772399147],
				[14.633890609878392, -1.551029772399147],
				[14.633890609878392, -0.7649739071638351],
				[14.633890609878392, 0],
				[14.633890609878392, 1.5510297723990902],
				[14.633890609878392, 3.4755113734923953],
				[14.633890609878392, 5.78850334475942],
				[15.02842439664397, 8.869480931486237],
				[15.422958183409548, 11.558936439743377],
				[16.57343075245126, 16.187932090573383],
				[17.72691502978887, 18.503935770136366],
				[18.482853812064945, 20.425405662933713],
				[19.663443464065836, 21.190379570097548],
				[20.027860167872234, 21.190379570097548],
				[20.027860167872234, 20.819939449699348],
				[19.663443464065836, 20.819939449699348],
			],
			pressures: [
				0.0784313753247261, 0.1411764770746231, 0.16078431904315948, 0.18431372940540314,
				0.20392157137393951, 0.21960784494876862, 0.23137255012989044,
				0.24705882370471954, 0.250980406999588, 0.24705882370471954, 0.24313725531101227,
				0.2235294133424759, 0.21960784494876862, 0.21176470816135406, 0.20392157137393951,
				0.19607843458652496, 0.1882352977991104, 0.1725490242242813, 0.1568627506494522,
				0.14901961386203766, 0.16078431904315948, 0.1568627506494522, 0.16078431904315948,
				0.16078431904315948, 0.16470588743686676, 0.1764705926179886, 0.18039216101169586,
				0.2078431397676468, 0.21568627655506134, 0.239215686917305, 0.25882354378700256,
				0.27843138575553894, 0.2980392277240753, 0.30588236451148987, 0.3137255012989044,
				0.3137255012989044, 0.30588236451148987, 0.30588236451148987, 0.24705882370471954,
				0.0470588244497776, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [19.663443464065836, 20.819939449699348],
		},
		{
			id: "0oW9eMfJWqrEU2MnF2x6C",
			type: "freedraw",
			x: 237.37255982375564,
			y: 256.98731868390166,
			width: 11.938411685029394,
			height: 13.871928411010401,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 986221181,
			version: 12,
			versionNonce: 790301715,
			isDeleted: false,
			boundElements: null,
			updated: 1751811853265,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, -0.7830441569393543],
				[0.3915220784696771, -0.7830441569393543],
				[1.9365284342769655, 0.7649739071638351],
				[3.8459514938906523, 3.080977586726817],
				[7.6949146960772055, 7.6919029877813045],
				[9.634454838650129, 10.402440454109865],
				[11.573994981222995, 12.718444133672847],
				[11.938411685029394, 13.088884254071047],
				[11.938411685029394, 12.718444133672847],
				[11.573994981222995, 11.929376560141634],
			],
			pressures: [
				0.0784313753247261, 0.14509804546833038, 0.21568627655506134, 0.2666666805744171,
				0.2823529541492462, 0.3019607961177826, 0.3137255012989044, 0.2705882489681244,
				0.21960784494876862, 0.11372549086809158, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [11.573994981222995, 11.929376560141634],
		},
	],
	",": [
		{
			id: "gKaSdj_XEOE9mhmFL68x8",
			type: "freedraw",
			x: 253.18704008563492,
			y: 277.02421397666166,
			width: 10.393405329222105,
			height: 17.344428076206896,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1185541875,
			version: 9,
			versionNonce: 1022112861,
			isDeleted: false,
			boundElements: null,
			updated: 1751811980002,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.7589504905719764, 0.39453378676557804],
				[0.7589504905719764, 1.159507693929413],
				[0.36441670380639835, 3.080977586726817],
				[-0.786055865235312, 5.78850334475942],
				[-3.876068576849889, 11.185484611049219],
				[-7.330497992270864, 15.422958183409548],
				[-9.634454838650129, 17.344428076206896],
			],
			pressures: [
				0.0784313753247261, 0.07058823853731155, 0.125490203499794, 0.16470588743686676,
				0.19607843458652496, 0.2549019753932953, 0.20000000298023224, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-9.634454838650129, 17.344428076206896],
		},
	],
	".": [
		{
			id: "HzTR86eX7RO5mgxvtqan1",
			type: "freedraw",
			x: 248.15748723144742,
			y: 280.1051915633885,
			width: 3.454429415420975,
			height: 3.4514177071250742,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 433227773,
			version: 25,
			versionNonce: 1359013811,
			isDeleted: false,
			boundElements: null,
			updated: 1751811990881,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.3915220784696771, 0],
				[0.3945337867656349, 0.39453378676557804],
				[1.1534842773376113, 0.7649739071638351],
				[1.5450063558072884, 0.7649739071638351],
				[2.3340739293385013, 0.39453378676557804],
				[2.6984906331448997, 0],
				[2.6984906331448997, -0.7649739071638919],
				[2.6984906331448997, -1.921469892797404],
				[1.9395401425729233, -2.316003679562982],
				[1.1534842773376113, -2.686443799961239],
				[0.3945337867656349, -2.686443799961239],
				[-0.3915220784696771, -2.316003679562982],
				[-0.7559387822760755, -1.529947814327727],
				[-0.7559387822760755, -1.15950769392947],
				[-0.7559387822760755, 0],
				[0, 0],
				[0.7890675735312129, 0],
				[1.5450063558072884, 0],
				[1.9395401425729233, -0.7649739071638919],
				[1.9395401425729233, -1.529947814327727],
				[1.5450063558072884, -1.529947814327727],
				[0, 0],
			],
			pressures: [
				0.0784313753247261, 0.15294118225574493, 0.15294118225574493, 0.14509804546833038,
				0.1411764770746231, 0.13725490868091583, 0.13725490868091583, 0.1411764770746231,
				0.15294118225574493, 0.18039216101169586, 0.19607843458652496,
				0.20392157137393951, 0.2078431397676468, 0.21176470816135406, 0.21568627655506134,
				0.2078431397676468, 0.1882352977991104, 0.16862745583057404, 0.1725490242242813,
				0.18039216101169586, 0.20000000298023224, 0.1568627506494522, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [1.1534842773376113, -1.15950769392947],
		},
	],
	";": [
		{
			id: "je6M9m9lWmY6IWJ1qNSk9",
			type: "freedraw",
			x: 250.09702737402034,
			y: 261.2278039645579,
			width: 1.5480180641032462,
			height: 0.7890675735312129,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1789493395,
			version: 10,
			versionNonce: 2123176221,
			isDeleted: false,
			boundElements: null,
			updated: 1751811994949,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, -0.39453378676557804],
				[0.7589504905719764, -0.39453378676557804],
				[1.1534842773376113, -0.7890675735312129],
				[0.39453378676557804, -0.7890675735312129],
				[0, -0.7890675735312129],
				[-0.3945337867656349, -0.7890675735312129],
				[0, 0],
			],
			pressures: [
				0.0784313753247261, 0.2078431397676468, 0.1882352977991104, 0.21960784494876862,
				0.2980392277240753, 0.30588236451148987, 0.12941177189350128, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-0.3945337867656349, -0.7890675735312129],
		},
		{
			id: "jJBSibSiT9jtdiH8OiKY1",
			type: "freedraw",
			x: 248.15748723144742,
			y: 277.41874776342723,
			width: 11.17946119445736,
			height: 13.480406332540781,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 101625331,
			version: 7,
			versionNonce: 1770375325,
			isDeleted: false,
			boundElements: null,
			updated: 1751812001694,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, 0.7649739071638351],
				[-2.300945138083364, 5.0024474795241645],
				[-6.149908340269917, 9.631443130354171],
				[-10.028988625415707, 13.106954503846623],
				[-11.17946119445736, 13.480406332540781],
			],
			pressures: [
				0.0784313753247261, 0.1921568661928177, 0.239215686917305, 0.239215686917305,
				0.15294118225574493, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-11.17946119445736, 13.480406332540781],
		},
	],
	":": [
		{
			id: "f4CciMsYfTrd_iWW8gVXs",
			type: "freedraw",
			x: 248.15748723144742,
			y: 260.4387363910267,
			width: 1.5450063558072884,
			height: 1.1534842773375544,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1216958909,
			version: 13,
			versionNonce: 2043270771,
			isDeleted: false,
			boundElements: null,
			updated: 1751812006011,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.7890675735312129, 0],
				[1.1534842773376113, 0],
				[1.5450063558072884, 0],
				[1.5450063558072884, -0.7649739071638351],
				[1.1534842773376113, -1.1534842773375544],
				[0.7890675735312129, -1.1534842773375544],
				[0.3945337867656349, -0.7649739071638351],
				[0.3945337867656349, -0.3704401203982002],
				[0.7890675735312129, -0.3704401203982002],
				[0, 0],
			],
			pressures: [
				0.0784313753247261, 0.12941177189350128, 0.1411764770746231, 0.15294118225574493,
				0.1725490242242813, 0.1725490242242813, 0.1764705926179886, 0.1725490242242813,
				0.16862745583057404, 0.12156862765550613, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [1.1534842773376113, -0.7649739071638351],
		},
		{
			id: "4ofPXzMQDdXzENUxsCNc0",
			type: "freedraw",
			x: 247.40154844917134,
			y: 280.49972535015405,
			width: 0.7559387822760755,
			height: 1.924481601093305,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1259499165,
			version: 16,
			versionNonce: 2106921075,
			isDeleted: false,
			boundElements: null,
			updated: 1751812007025,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, -1.15950769392947],
				[0, -0.7649739071638351],
				[0, -0.39453378676557804],
				[0.36441670380639835, -0.39453378676557804],
				[0.7559387822760755, -0.39453378676557804],
				[0.7559387822760755, -1.15950769392947],
				[0.7559387822760755, -1.554041480695048],
				[0.7559387822760755, -1.924481601093305],
				[0.36441670380639835, -1.924481601093305],
				[0.36441670380639835, -1.554041480695048],
				[0.36441670380639835, -1.15950769392947],
				[0.36441670380639835, -0.7649739071638351],
				[0, 0],
			],
			pressures: [
				0.0784313753247261, 0.07058823853731155, 0.14901961386203766, 0.14509804546833038,
				0.12941177189350128, 0.13725490868091583, 0.16078431904315948,
				0.16470588743686676, 0.18431372940540314, 0.18431372940540314, 0.1764705926179886,
				0.16862745583057404, 0.13333334028720856, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [0.36441670380639835, -0.39453378676557804],
		},
	],
	"!": [
		{
			id: "uLc_5_T0jbY3XvQTR6q9_",
			type: "freedraw",
			x: 249.31097150878503,
			y: 220.7414093424968,
			width: 1.1534842773376113,
			height: 58.99033039219745,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 218315581,
			version: 29,
			versionNonce: 1995280115,
			isDeleted: false,
			boundElements: null,
			updated: 1751812034102,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, -1.1534842773376113],
				[0, -1.5480180641031893],
				[0, -0.7649739071638351],
				[0, 0.3945337867656349],
				[0, 2.68945550825714],
				[0, 6.948011038688946],
				[0, 10.028988625415707],
				[0, 13.480406332540781],
				[0, 19.27192138559616],
				[0, 23.509394957956488],
				[0, 27.379440118214518],
				[0, 30.830857825339535],
				[0, 33.92990566184187],
				[0, 37.38433507726285],
				[-0.36441670380639835, 40.091860835295506],
				[-0.36441670380639835, 42.77830463525669],
				[-0.36441670380639835, 45.488842101585305],
				[-0.7589504905719764, 47.80484578114823],
				[-1.1534842773376113, 50.12084946071121],
				[-1.1534842773376113, 52.04533106180452],
				[-1.1534842773376113, 53.966800954601865],
				[-1.1534842773376113, 55.51783072700101],
				[-1.1534842773376113, 56.677338420930425],
				[-1.1534842773376113, 57.04777854132868],
				[-1.1534842773376113, 57.44231232809426],
				[-0.7589504905719764, 56.28280463416485],
				[-0.36441670380639835, 53.966800954601865],
			],
			pressures: [
				0.0784313753247261, 0.07058823853731155, 0.125490203499794, 0.14901961386203766,
				0.16470588743686676, 0.1725490242242813, 0.18431372940540314, 0.19607843458652496,
				0.2078431397676468, 0.21960784494876862, 0.2235294133424759, 0.22745098173618317,
				0.23137255012989044, 0.23529411852359772, 0.239215686917305, 0.24705882370471954,
				0.250980406999588, 0.25882354378700256, 0.2666666805744171, 0.2705882489681244,
				0.2705882489681244, 0.2705882489681244, 0.2705882489681244, 0.2666666805744171,
				0.2666666805744171, 0.2666666805744171, 0.11372549086809158, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-0.36441670380639835, 53.966800954601865],
		},
		{
			id: "PUJiNVf8LZVABBoAlzSk5",
			type: "freedraw",
			x: 246.24806417183373,
			y: 293.6066798540007,
			width: 3.090012711614577,
			height: 5.393969557993898,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1998281469,
			version: 31,
			versionNonce: 283837043,
			isDeleted: false,
			boundElements: null,
			updated: 1751812039715,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, -0.786055865235312],
				[0, -1.15950769392947],
				[-0.3915220784696771, -1.15950769392947],
				[-0.3915220784696771, -0.786055865235312],
				[-0.3915220784696771, 0],
				[-0.3915220784696771, 0.7619621988678773],
				[-0.3915220784696771, 1.1564959856335122],
				[0.36441670380639835, 1.5269361060317692],
				[1.1534842773376113, 1.5269361060317692],
				[1.9094230596136867, 0.7619621988678773],
				[2.6984906331448997, -0.3945337867656349],
				[2.6984906331448997, -1.554041480695048],
				[2.6984906331448997, -2.316003679562982],
				[1.1534842773376113, -2.7075257580326593],
				[0.7589504905720332, -2.7075257580326593],
				[0.36441670380639835, -2.316003679562982],
				[-0.3915220784696771, -1.554041480695048],
				[-0.3915220784696771, -0.786055865235312],
				[-0.3915220784696771, 0.37345182869415794],
				[0.36441670380639835, 0.37345182869415794],
				[1.1534842773376113, 0.37345182869415794],
				[2.3039568463793216, -1.15950769392947],
				[2.6984906331448997, -2.316003679562982],
				[2.6984906331448997, -3.475511373492452],
				[1.9094230596136867, -3.867033451962129],
				[1.1534842773376113, -3.475511373492452],
				[0.36441670380639835, -1.924481601093305],
				[0, 0],
			],
			pressures: [
				0.0784313753247261, 0.04313725605607033, 0.07058823853731155, 0.125490203499794,
				0.14901961386203766, 0.16862745583057404, 0.1725490242242813, 0.1725490242242813,
				0.16862745583057404, 0.1568627506494522, 0.15294118225574493, 0.1568627506494522,
				0.1764705926179886, 0.1882352977991104, 0.19607843458652496, 0.1921568661928177,
				0.19607843458652496, 0.19607843458652496, 0.19607843458652496, 0.1921568661928177,
				0.18431372940540314, 0.1725490242242813, 0.16078431904315948, 0.16470588743686676,
				0.1921568661928177, 0.21960784494876862, 0.23137255012989044, 0.1411764770746231,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [0, -1.15950769392947],
		},
	],
	"?": [
		{
			id: "UxtJ0qpZANFhDx4AwF9tf",
			type: "freedraw",
			x: 242.3719955949839,
			y: 235.381323368967,
			width: 24.271357156824365,
			height: 53.19881533914207,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1161859923,
			version: 46,
			versionNonce: 1480722397,
			isDeleted: false,
			boundElements: null,
			updated: 1751812044081,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7589504905719764, 0.39152207846973397],
				[-2.303956846379265, 0.39152207846973397],
				[-3.062907336951298, 0.39152207846973397],
				[-4.607913692758586, 0.39152207846973397],
				[-5.75838626180024, 0],
				[-6.152920048565875, -0.3704401203982002],
				[-7.303392617607528, -2.294921721491505],
				[-7.303392617607528, -2.6864437999611823],
				[-7.303392617607528, -5.7674213866879995],
				[-7.303392617607528, -6.161955173453578],
				[-6.547453835331453, -7.691902987781248],
				[-4.607913692758586, -9.242932760180395],
				[-2.6984906331448997, -10.402440454109865],
				[-0.36441670380639835, -11.164402652977742],
				[1.9395401425728664, -11.950458518213054],
				[4.24048528065623, -11.950458518213054],
				[5.785491636463519, -11.950458518213054],
				[8.11956556580202, -10.790950824283584],
				[9.634454838650129, -10.00790666734423],
				[12.724467550264706, -8.083425066250982],
				[14.269473906071994, -6.5564889602192125],
				[15.817491970175183, -4.610925401054487],
				[16.57343075245126, -1.9244816010932482],
				[16.57343075245126, 0],
				[16.967964539216837, 2.710537466328617],
				[16.967964539216837, 5.026541145891542],
				[16.967964539216837, 7.3425448254545245],
				[16.20901404864486, 9.658548505017507],
				[15.02842439664397, 11.185484611049276],
				[13.119001337030284, 14.266462197776093],
				[11.573994981222995, 16.973987955808695],
				[10.423522412181342, 19.289991635371678],
				[8.878516056374053, 21.976435435332917],
				[7.725031779036442, 24.686972901661477],
				[6.93897591380113, 27.00297658122446],
				[6.180025423229154, 29.68942038118564],
				[5.785491636463519, 32.3999578475142],
				[5.393969557993842, 34.69487956900571],
				[5.393969557993842, 37.405417035334324],
				[5.393969557993842, 39.32688692813167],
				[5.785491636463519, 40.87791670053082],
				[5.785491636463519, 41.24835682092902],
				[6.180025423229154, 41.24835682092902],
				[6.180025423229154, 40.87791670053082],
			],
			pressures: [
				0.0784313753247261, 0.0784313753247261, 0.09019608050584793, 0.12941177189350128,
				0.1725490242242813, 0.21176470816135406, 0.2078431397676468, 0.20000000298023224,
				0.20392157137393951, 0.19607843458652496, 0.19607843458652496, 0.1882352977991104,
				0.18039216101169586, 0.1764705926179886, 0.18431372940540314, 0.1921568661928177,
				0.21176470816135406, 0.22745098173618317, 0.250980406999588, 0.250980406999588,
				0.2666666805744171, 0.2823529541492462, 0.32156863808631897, 0.37254902720451355,
				0.3960784375667572, 0.40784314274787903, 0.3960784375667572, 0.38823530077934265,
				0.38823530077934265, 0.38823530077934265, 0.38823530077934265,
				0.38823530077934265, 0.3803921639919281, 0.3607843220233917, 0.3490196168422699,
				0.3294117748737335, 0.32549020648002625, 0.32549020648002625, 0.3294117748737335,
				0.3294117748737335, 0.32156863808631897, 0.3019607961177826, 0.21176470816135406,
				0.07450980693101883, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [6.180025423229154, 40.87791670053082],
		},
		{
			id: "N1WVuaQjL5HIG1MzgpuU6",
			type: "freedraw",
			x: 246.61248087564013,
			y: 291.68219825290737,
			width: 2.6984906331448997,
			height: 5.791515053055377,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1521627645,
			version: 28,
			versionNonce: 2120873619,
			isDeleted: false,
			boundElements: null,
			updated: 1751812050166,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, 0.7649739071638351],
				[0, 1.5299478143276701],
				[0.3945337867656349, 2.6864437999611823],
				[0.7890675735312129, 3.080977586726817],
				[1.5450063558072884, 3.080977586726817],
				[1.9395401425729233, 2.6864437999611823],
				[2.3340739293385013, 1.5299478143276701],
				[2.3340739293385013, 0],
				[2.3340739293385013, -1.551029772399147],
				[1.5450063558072884, -2.316003679562982],
				[0.7890675735312129, -2.71053746632856],
				[0, -2.71053746632856],
				[-0.36441670380639835, -1.9425518508688242],
				[-0.36441670380639835, -0.3915220784696771],
				[-0.36441670380639835, 0.370440120398257],
				[0.3945337867656349, 1.138425735857993],
				[1.1534842773376113, 1.5299478143276701],
				[1.9395401425729233, 1.138425735857993],
				[2.3340739293385013, 0.370440120398257],
				[2.3340739293385013, -0.7830441569393543],
				[1.9395401425729233, -1.551029772399147],
				[1.1534842773376113, -1.9425518508688242],
				[0.3945337867656349, -1.9425518508688242],
				[0.3945337867656349, -1.1564959856335122],
				[0, 0],
			],
			pressures: [
				0.0784313753247261, 0.1411764770746231, 0.1411764770746231, 0.13333334028720856,
				0.13725490868091583, 0.13725490868091583, 0.13725490868091583,
				0.13725490868091583, 0.1411764770746231, 0.1568627506494522, 0.16862745583057404,
				0.1725490242242813, 0.1725490242242813, 0.1725490242242813, 0.1725490242242813,
				0.16862745583057404, 0.1568627506494522, 0.14901961386203766, 0.1411764770746231,
				0.14509804546833038, 0.1411764770746231, 0.18431372940540314, 0.20000000298023224,
				0.1882352977991104, 0.08627451211214066, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [0, -0.7830441569393543],
		},
	],
	"'": [
		{
			id: "EblhkkWpHBAPd7qsNpCFx",
			type: "freedraw",
			x: 247.76596515297774,
			y: 224.21692071598926,
			width: 0,
			height: 6.553477251923255,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 281443187,
			version: 6,
			versionNonce: 481190589,
			isDeleted: false,
			boundElements: null,
			updated: 1751812054112,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, 1.1564959856335122],
				[0, 2.6864437999611823],
				[0, 5.7674213866879995],
				[0, 6.553477251923255],
			],
			pressures: [
				0.0784313753247261, 0.1882352977991104, 0.21176470816135406, 0.09803921729326248,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [0, 6.553477251923255],
		},
	],
	'"': [
		{
			id: "LypmtJIZw2wGYi2WHg4uv",
			type: "freedraw",
			x: 239.3090882580326,
			y: 230.37586418114694,
			width: 1.9094230596136867,
			height: 16.955917706033176,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1752041725,
			version: 10,
			versionNonce: 385617491,
			isDeleted: false,
			boundElements: null,
			updated: 1751812072279,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, 1.15950769392947],
				[0, 2.71053746632856],
				[0.36441670380639835, 7.3214628673830475],
				[0.7589504905720332, 15.034447813235829],
				[0.7589504905720332, 15.799421720399664],
				[1.1534842773376113, 16.955917706033176],
				[1.5179009811440096, 16.19094379886934],
				[1.9094230596136867, 15.799421720399664],
			],
			pressures: [
				0.0784313753247261, 0.20392157137393951, 0.2235294133424759, 0.2666666805744171,
				0.29019609093666077, 0.29019609093666077, 0.24313725531101227,
				0.08627451211214066, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [1.9094230596136867, 15.799421720399664],
		},
		{
			id: "pQ7W4udJEWsuiAmVWslWE",
			type: "freedraw",
			x: 247.76596515297774,
			y: 231.5353718750764,
			width: 1.5450063558072884,
			height: 14.639914026470194,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 2001494205,
			version: 11,
			versionNonce: 1364592691,
			isDeleted: false,
			boundElements: null,
			updated: 1751812072667,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7589504905719764, 0.39453378676557804],
				[-0.7589504905719764, 0.7649739071638351],
				[-0.7589504905719764, 1.9214698927973473],
				[-0.7589504905719764, 5.3969812662897425],
				[-0.36441670380639835, 8.47795885301656],
				[0, 11.558936439743377],
				[0.3915220784696771, 13.109966212142467],
				[0.786055865235312, 13.874940119306359],
				[0.786055865235312, 14.639914026470194],
			],
			pressures: [
				0.0784313753247261, 0.12156862765550613, 0.14901961386203766, 0.1921568661928177,
				0.23137255012989044, 0.24705882370471954, 0.24705882370471954,
				0.20392157137393951, 0.10588235408067703, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [0.786055865235312, 14.639914026470194],
		},
	],
	"(": [
		{
			id: "gnp1kcBXi8jTSethEAxXY",
			type: "freedraw",
			x: 250.09702737402034,
			y: 221.90091703642628,
			width: 21.967400310445157,
			height: 77.10274408386414,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1675391251,
			version: 39,
			versionNonce: 1686095741,
			isDeleted: false,
			boundElements: null,
			updated: 1751812077760,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.786055865235312, 0],
				[-1.1504725690417104, 0.3915220784696771],
				[-1.5450063558072884, 0.3915220784696771],
				[-1.9395401425729233, 0.7649739071638351],
				[-2.6954789248489988, 1.5299478143276701],
				[-3.84896320218661, 2.316003679562982],
				[-5.0295528541875, 3.8429397855946945],
				[-6.180025423229154, 5.7885033447594765],
				[-7.725031779036442, 7.712984945852725],
				[-9.634454838650129, 10.399428745813964],
				[-11.96852876798863, 13.871928411010458],
				[-13.877951827602317, 16.95290599773722],
				[-15.02842439664397, 20.033883584464036],
				[-16.21202575694076, 23.13895483755823],
				[-16.967964539216894, 26.219932424285048],
				[-17.72691502978887, 29.671350131410065],
				[-18.118437108258547, 32.7703979679124],
				[-18.512970895024182, 37.38433507726285],
				[-18.512970895024182, 41.24835682092902],
				[-18.512970895024182, 44.723868194421414],
				[-18.512970895024182, 47.410311994382596],
				[-17.72691502978887, 51.647785566742925],
				[-16.967964539216894, 55.12329694023538],
				[-15.422958183409605, 58.204274526962195],
				[-13.877951827602317, 60.9118002849948],
				[-11.96852876798863, 63.22780396455778],
				[-9.634454838650129, 65.52272568604934],
				[-6.93897591380113, 67.46527753691811],
				[-4.635019067421865, 69.78128121648109],
				[-2.6954789248489988, 71.31122903080876],
				[-1.1504725690417104, 72.86225880320791],
				[0.39453378676557804, 74.39220661753558],
				[1.5450063558072884, 75.54870260316909],
				[2.6984906331448997, 76.70821029709856],
				[3.454429415420975, 77.10274408386414],
				[3.454429415420975, 75.94323638993473],
				[3.454429415420975, 75.17826248277089],
			],
			pressures: [
				0.0784313753247261, 0.07450980693101883, 0.11372549086809158, 0.1411764770746231,
				0.1764705926179886, 0.21960784494876862, 0.25882354378700256, 0.2823529541492462,
				0.30980393290519714, 0.32549020648002625, 0.32549020648002625, 0.3333333432674408,
				0.3333333432674408, 0.34117648005485535, 0.33725491166114807, 0.3333333432674408,
				0.34117648005485535, 0.3490196168422699, 0.35686275362968445, 0.3607843220233917,
				0.3607843220233917, 0.3607843220233917, 0.3529411852359772, 0.3529411852359772,
				0.3686274588108063, 0.38823530077934265, 0.40784314274787903, 0.4117647111415863,
				0.42352941632270813, 0.43529412150382996, 0.43529412150382996,
				0.45490196347236633, 0.4588235318660736, 0.4588235318660736, 0.4470588266849518,
				0.4156862795352936, 0.1411764770746231, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [3.454429415420975, 75.17826248277089],
		},
	],
	")": [
		{
			id: "3omE0O4GtZ_Z6bbmb9yYR",
			type: "freedraw",
			x: 245.85654209336406,
			y: 219.19339127839362,
			width: 21.208449819873124,
			height: 79.41573605513122,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 815611037,
			version: 30,
			versionNonce: 739462451,
			isDeleted: false,
			boundElements: null,
			updated: 1751812082156,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.7559387822760755, 0.39453378676557804],
				[1.1504725690417104, 0.39453378676557804],
				[2.6954789248489988, 1.5480180641031893],
				[4.635019067421865, 3.4724996651964943],
				[7.330497992270864, 6.180025423229154],
				[10.393405329222105, 9.631443130354171],
				[13.088884254071104, 13.106954503846623],
				[15.02842439664397, 17.344428076206952],
				[16.967964539216894, 22.370969222098495],
				[18.87738759883058, 26.981894623152982],
				[20.027860167872234, 31.61390198227889],
				[20.816927741403447, 36.63743141987453],
				[20.816927741403447, 42.03441268616427],
				[21.208449819873124, 46.64232637892286],
				[21.208449819873124, 50.117837752415255],
				[20.027860167872234, 55.90935280547063],
				[18.87738759883058, 60.14682637783096],
				[16.967964539216894, 64.38731165848725],
				[14.633890609878392, 68.230251444082],
				[11.938411685029394, 72.09728489604407],
				[9.23992105188455, 74.78674040430121],
				[6.544442127035552, 76.72929225516998],
				[4.240485280656287, 77.88578824080355],
				[2.6954789248489988, 78.65076214796738],
				[1.1504725690417104, 79.41573605513122],
				[0.7559387822760755, 79.41573605513122],
				[0.3915220784696771, 79.41573605513122],
				[0, 78.65076214796738],
			],
			pressures: [
				0.0784313753247261, 0.18039216101169586, 0.19607843458652496, 0.21960784494876862,
				0.250980406999588, 0.2823529541492462, 0.32549020648002625, 0.3607843220233917,
				0.38823530077934265, 0.3960784375667572, 0.4274509847164154, 0.4274509847164154,
				0.42352941632270813, 0.41960784792900085, 0.4117647111415863, 0.4117647111415863,
				0.4117647111415863, 0.41960784792900085, 0.4156862795352936, 0.41960784792900085,
				0.40784314274787903, 0.40784314274787903, 0.40392157435417175,
				0.40392157435417175, 0.3960784375667572, 0.3686274588108063, 0.33725491166114807,
				0.23137255012989044, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [0, 78.65076214796738],
		},
	],
	"{": [
		{
			id: "IOoFr5qO9ijDhFoQkE59t",
			type: "freedraw",
			x: 252.4009842203996,
			y: 207.2399210518846,
			width: 20.455522745892893,
			height: 89.81817650924108,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 966903453,
			version: 80,
			versionNonce: 751181939,
			isDeleted: false,
			boundElements: null,
			updated: 1751812092324,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7589504905719764, -0.3704401203982002],
				[-1.5450063558072884, -0.3704401203982002],
				[-2.6984906331448997, -0.3704401203982002],
				[-4.9994357712282635, 0.3945337867656349],
				[-7.333509700566765, 1.9455635591647251],
				[-9.63746654694603, 3.475511373492452],
				[-11.182472902753318, 5.026541145891542],
				[-14.272485614367895, 7.7129849458527815],
				[-15.787374887215947, 10.028988625415707],
				[-17.332381243023235, 11.953470226509012],
				[-18.121448816554448, 13.896022077377836],
				[-18.515982603320026, 15.817491970175183],
				[-18.515982603320026, 17.73896186297253],
				[-18.121448816554448, 19.663443464065836],
				[-17.72691502978887, 21.584913356863183],
				[-16.967964539216837, 23.530476916027908],
				[-15.787374887215947, 25.84648059559089],
				[-15.02842439664397, 27.770962196684195],
				[-14.272485614367895, 29.692432089481542],
				[-13.091895962367005, 31.24346186188069],
				[-11.938411685029394, 32.77340967620836],
				[-10.787939115987683, 34.32443944860751],
				[-10.028988625415707, 35.85438726293518],
				[-9.242932760180395, 37.40541703533427],
				[-8.483982269608418, 38.935364849661994],
				[-7.697926404373163, 40.486394622061084],
				[-7.333509700566765, 42.03441268616433],
				[-7.333509700566765, 43.5673722087879],
				[-7.697926404373163, 45.48884210158525],
				[-8.848398973414817, 47.43139395245407],
				[-10.393405329222105, 48.59090164638354],
				[-11.938411685029394, 49.747397632017055],
				[-13.483418040836682, 50.11783775241531],
				[-15.02842439664397, 50.88582336787505],
				[-16.18190867398158, 51.277345446344725],
				[-16.967964539216837, 51.277345446344725],
				[-16.57644246074716, 50.88582336787505],
				[-15.787374887215947, 50.88582336787505],
				[-15.02842439664397, 50.88582336787505],
				[-13.483418040836682, 50.88582336787505],
				[-11.573994981222995, 50.88582336787505],
				[-10.028988625415707, 50.88582336787505],
				[-9.242932760180395, 51.67187923311036],
				[-8.483982269608418, 52.82837521874387],
				[-8.483982269608418, 54.35832303307154],
				[-8.483982269608418, 55.144378898306854],
				[-9.242932760180395, 56.27979292586889],
				[-10.028988625415707, 57.0688604994001],
				[-10.787939115987683, 58.225356485033615],
				[-11.938411685029394, 59.384864178963085],
				[-12.727479258560606, 60.14983808612692],
				[-13.483418040836682, 61.30633407176043],
				[-14.272485614367895, 62.8362818860881],
				[-15.02842439664397, 63.99277787172167],
				[-15.787374887215947, 65.54681935241672],
				[-16.57644246074716, 68.2332631523779],
				[-16.967964539216837, 70.54926683194088],
				[-17.332381243023235, 72.49483039110561],
				[-17.332381243023235, 74.02176649713738],
				[-17.332381243023235, 75.94624809823063],
				[-17.332381243023235, 77.88879994909945],
				[-16.967964539216837, 79.41874776342712],
				[-16.18190867398158, 80.96977753582627],
				[-15.422958183409548, 82.89124742862361],
				[-14.636902318174293, 84.81271732142102],
				[-13.87795182760226, 85.97222501535043],
				[-13.091895962367005, 87.12872100098394],
				[-11.182472902753318, 88.28822869491341],
				[-9.63746654694603, 89.05320260207725],
				[-7.697926404373163, 89.44773638884288],
				[-5.7885033447594765, 89.44773638884288],
				[-3.848963202186553, 89.44773638884288],
				[-2.303956846379265, 89.44773638884288],
				[-0.7589504905719764, 89.44773638884288],
				[0.3945337867656349, 89.44773638884288],
				[1.1504725690417104, 89.05320260207725],
				[1.5450063558072884, 88.28822869491341],
				[1.9395401425728664, 87.89369490814784],
			],
			pressures: [
				0.0784313753247261, 0.16470588743686676, 0.20000000298023224, 0.21176470816135406,
				0.21960784494876862, 0.23137255012989044, 0.23137255012989044,
				0.23529411852359772, 0.23529411852359772, 0.23529411852359772,
				0.23529411852359772, 0.250980406999588, 0.2549019753932953, 0.26274511218070984,
				0.2666666805744171, 0.2705882489681244, 0.27843138575553894, 0.2862745225429535,
				0.29019609093666077, 0.2980392277240753, 0.29411765933036804, 0.29411765933036804,
				0.29411765933036804, 0.29411765933036804, 0.29411765933036804, 0.2980392277240753,
				0.2980392277240753, 0.30588236451148987, 0.30980393290519714, 0.30980393290519714,
				0.3137255012989044, 0.3019607961177826, 0.29411765933036804, 0.2862745225429535,
				0.2666666805744171, 0.25882354378700256, 0.24705882370471954, 0.20392157137393951,
				0.21176470816135406, 0.21568627655506134, 0.24705882370471954, 0.2705882489681244,
				0.2823529541492462, 0.2980392277240753, 0.30980393290519714, 0.30588236451148987,
				0.30980393290519714, 0.30980393290519714, 0.30980393290519714,
				0.30588236451148987, 0.3019607961177826, 0.3019607961177826, 0.29411765933036804,
				0.2862745225429535, 0.2823529541492462, 0.2862745225429535, 0.2823529541492462,
				0.2862745225429535, 0.29019609093666077, 0.29411765933036804, 0.30588236451148987,
				0.3176470696926117, 0.32549020648002625, 0.3333333432674408, 0.3529411852359772,
				0.3843137323856354, 0.38823530077934265, 0.3960784375667572, 0.40784314274787903,
				0.4156862795352936, 0.4156862795352936, 0.4274509847164154, 0.43529412150382996,
				0.43529412150382996, 0.4274509847164154, 0.37254902720451355, 0.24705882370471954,
				0.11372549086809158, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [1.9395401425728664, 87.89369490814784],
		},
	],
	"}": [
		{
			id: "0hOrqx7eagVCHVzzYNAli",
			type: "freedraw",
			x: 242.3719955949839,
			y: 207.2399210518846,
			width: 23.906940453018024,
			height: 89.05320260207719,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 63268819,
			version: 98,
			versionNonce: 1167217011,
			isDeleted: false,
			boundElements: null,
			updated: 1751812108046,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.786055865235312, -0.3704401203982002],
				[1.18058965200089, -0.3704401203982002],
				[2.3310622210425436, -0.3704401203982002],
				[3.484546498380155, -0.3704401203982002],
				[4.635019067421865, -0.3704401203982002],
				[6.93897591380113, 0.7890675735312129],
				[8.878516056374053, 2.316003679562982],
				[10.815044490651019, 3.87004516025803],
				[12.724467550264706, 5.026541145891542],
				[13.87795182760226, 6.186048839821012],
				[14.664007692837572, 7.3395331171586236],
				[15.422958183409548, 8.10751873261836],
				[15.817491970175183, 9.63746654694603],
				[15.817491970175183, 11.188496319345177],
				[15.817491970175183, 12.34800401327459],
				[15.817491970175183, 13.896022077377836],
				[15.817491970175183, 15.425969891705506],
				[15.422958183409548, 17.35045149279881],
				[15.02842439664397, 18.898469556902],
				[14.664007692837572, 20.057977250831414],
				[13.87795182760226, 21.584913356863183],
				[13.119001337030284, 22.744421050792653],
				[12.724467550264706, 23.530476916027908],
				[11.573994981222995, 24.689984609957378],
				[10.815044490651019, 25.454958517121213],
				[10.028988625415707, 26.611454502754725],
				[9.634454838650129, 27.37642840991856],
				[8.483982269608418, 28.53292439555213],
				[7.725031779036442, 30.086965876247177],
				[6.93897591380113, 31.61390198227889],
				[6.574559209994732, 32.4029695558101],
				[6.574559209994732, 33.538383583372195],
				[6.180025423229154, 34.32443944860751],
				[6.180025423229154, 35.85438726293518],
				[6.180025423229154, 36.64044312817043],
				[6.180025423229154, 37.40541703533427],
				[6.180025423229154, 38.17039094249816],
				[6.574559209994732, 38.935364849661994],
				[6.93897591380113, 39.72142071489725],
				[7.725031779036442, 40.091860835295506],
				[8.483982269608418, 40.88092840882672],
				[9.27003813484373, 41.645902315990554],
				[10.028988625415707, 42.03441268616433],
				[11.179461194457417, 42.802398301624066],
				[12.332945471794972, 43.19392038009374],
				[13.513535123795862, 43.961905995553536],
				[13.87795182760226, 44.33234611595174],
				[15.02842439664397, 44.723868194421414],
				[15.422958183409548, 45.11539027289109],
				[15.817491970175183, 45.48884210158525],
				[16.20901404864486, 45.48884210158525],
				[15.817491970175183, 45.48884210158525],
				[15.422958183409548, 45.48884210158525],
				[14.664007692837572, 45.88337588835088],
				[13.87795182760226, 46.64834979551472],
				[12.724467550264706, 47.80484578114823],
				[11.179461194457417, 50.11783775241531],
				[10.815044490651019, 50.88582336787505],
				[10.815044490651019, 51.67187923311036],
				[10.815044490651019, 52.43384143197824],
				[10.423522412181342, 53.19881533914207],
				[10.423522412181342, 54.75285681983712],
				[10.423522412181342, 55.144378898306854],
				[10.423522412181342, 55.514819018705055],
				[10.423522412181342, 55.90935280547069],
				[10.423522412181342, 57.0688604994001],
				[10.423522412181342, 57.83082269826804],
				[10.423522412181342, 58.59579660543187],
				[10.423522412181342, 59.384864178963085],
				[10.423522412181342, 60.911800284994854],
				[10.423522412181342, 61.67677419215869],
				[10.815044490651019, 62.8362818860881],
				[10.815044490651019, 63.622337751323414],
				[11.179461194457417, 64.78184544525288],
				[11.573994981222995, 65.9383414308864],
				[11.573994981222995, 67.46828924521407],
				[11.573994981222995, 69.78429292477705],
				[11.573994981222995, 70.94380061870646],
				[11.573994981222995, 73.25980429826944],
				[11.179461194457417, 74.41630028390296],
				[10.815044490651019, 75.57279626953647],
				[10.423522412181342, 77.1027440838642],
				[9.634454838650129, 78.26225177779361],
				[8.483982269608418, 80.57825545735659],
				[7.725031779036442, 81.7317397346942],
				[6.574559209994732, 83.28578121538925],
				[5.393969557993842, 84.81271732142102],
				[3.876068576849832, 86.36675880211607],
				[1.9395401425728664, 87.52325478774958],
				[-0.36441670380639835, 88.28822869491341],
				[-2.6984906331448997, 88.68276248167899],
				[-4.607913692758586, 88.68276248167899],
				[-6.152920048565875, 88.68276248167899],
				[-6.93897591380113, 88.68276248167899],
				[-7.303392617607528, 88.28822869491341],
				[-7.697926404373163, 88.28822869491341],
			],
			pressures: [
				0.0784313753247261, 0.08627451211214066, 0.0941176488995552, 0.10588235408067703,
				0.11372549086809158, 0.11764705926179886, 0.13333334028720856,
				0.13725490868091583, 0.13333334028720856, 0.13725490868091583,
				0.14509804546833038, 0.15294118225574493, 0.16470588743686676, 0.1764705926179886,
				0.1921568661928177, 0.20000000298023224, 0.2078431397676468, 0.21568627655506134,
				0.2235294133424759, 0.22745098173618317, 0.22745098173618317, 0.23529411852359772,
				0.23137255012989044, 0.23137255012989044, 0.22745098173618317,
				0.22745098173618317, 0.23529411852359772, 0.239215686917305, 0.24313725531101227,
				0.24313725531101227, 0.23529411852359772, 0.23529411852359772,
				0.23529411852359772, 0.23529411852359772, 0.239215686917305, 0.24705882370471954,
				0.24705882370471954, 0.250980406999588, 0.2549019753932953, 0.26274511218070984,
				0.26274511218070984, 0.2666666805744171, 0.2666666805744171, 0.26274511218070984,
				0.26274511218070984, 0.2705882489681244, 0.27450981736183167, 0.2705882489681244,
				0.25882354378700256, 0.250980406999588, 0.24313725531101227, 0.239215686917305,
				0.26274511218070984, 0.27450981736183167, 0.27843138575553894,
				0.29019609093666077, 0.29411765933036804, 0.29411765933036804,
				0.29411765933036804, 0.29411765933036804, 0.2980392277240753, 0.2980392277240753,
				0.2980392277240753, 0.2980392277240753, 0.2980392277240753, 0.2980392277240753,
				0.2980392277240753, 0.2980392277240753, 0.30588236451148987, 0.30588236451148987,
				0.30588236451148987, 0.3137255012989044, 0.30980393290519714, 0.30588236451148987,
				0.30588236451148987, 0.3137255012989044, 0.32156863808631897, 0.3294117748737335,
				0.3294117748737335, 0.3294117748737335, 0.3294117748737335, 0.3294117748737335,
				0.3333333432674408, 0.33725491166114807, 0.34117648005485535, 0.33725491166114807,
				0.33725491166114807, 0.33725491166114807, 0.32156863808631897, 0.3176470696926117,
				0.3137255012989044, 0.30980393290519714, 0.3019607961177826, 0.26274511218070984,
				0.2078431397676468, 0.10588235408067703, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-7.697926404373163, 88.28822869491341],
		},
	],
	"[": [
		{
			id: "epW-NmRI5VHU4usKxXWgM",
			type: "freedraw",
			x: 249.7024935872547,
			y: 211.4804063325409,
			width: 20.057977250831414,
			height: 88.28521698661746,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1204553725,
			version: 70,
			versionNonce: 1899430365,
			isDeleted: false,
			boundElements: null,
			updated: 1751812112783,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-1.1504725690416535, 0],
				[-1.5450063558072884, 0],
				[-1.9365284342769655, 0],
				[-2.695478924848942, 0],
				[-3.454429415420975, 0.3915220784696771],
				[-4.635019067421865, 0.7860558652352552],
				[-6.149908340269917, 1.1564959856335122],
				[-8.483982269608418, 1.1564959856335122],
				[-10.393405329222105, 1.1564959856335122],
				[-12.724467550264649, 1.1564959856335122],
				[-14.633890609878335, 1.5510297723990902],
				[-16.178896965685624, 1.9455635591647251],
				[-16.967964539216837, 1.9455635591647251],
				[-18.118437108258547, 1.9455635591647251],
				[-18.515982603320026, 1.9455635591647251],
				[-18.877387598830524, 2.3160036795629253],
				[-19.2689096773002, 2.71053746632856],
				[-19.2689096773002, 3.0990478365023364],
				[-19.2689096773002, 4.2585555304317495],
				[-19.2689096773002, 5.78850334475942],
				[-18.877387598830524, 8.107518732618303],
				[-18.515982603320026, 11.185484611049219],
				[-17.723903321492912, 15.052518063011291],
				[-16.967964539216837, 18.895457848606043],
				[-16.57343075245126, 22.741409342496695],
				[-16.178896965685624, 26.21692071598909],
				[-15.817491970175126, 29.689420381185585],
				[-15.817491970175126, 33.559465541443615],
				[-15.817491970175126, 37.01088324856863],
				[-15.817491970175126, 40.874904992234804],
				[-15.817491970175126, 44.350416365727256],
				[-16.178896965685624, 48.19335615132195],
				[-16.57343075245126, 51.6688675248144],
				[-16.57343075245126, 54.74984511154122],
				[-16.967964539216837, 57.83082269826798],
				[-16.967964539216837, 60.5413601645966],
				[-16.967964539216837, 63.22780396455778],
				[-17.332381243023235, 65.93834143088634],
				[-17.332381243023235, 68.25434511044932],
				[-17.332381243023235, 70.54625512364493],
				[-17.723903321492912, 73.25679258997349],
				[-17.723903321492912, 75.17826248277083],
				[-18.118437108258547, 78.25924006949765],
				[-18.118437108258547, 80.57223204076473],
				[-18.118437108258547, 82.12627352145978],
				[-18.515982603320026, 83.28276950709329],
				[-18.515982603320026, 84.04774341425713],
				[-18.515982603320026, 84.81271732142096],
				[-18.515982603320026, 85.59877318665627],
				[-18.515982603320026, 85.96921330705447],
				[-18.515982603320026, 86.73418721421831],
				[-18.515982603320026, 87.12872100098394],
				[-17.723903321492912, 87.12872100098394],
				[-16.178896965685624, 87.12872100098394],
				[-12.724467550264649, 87.12872100098394],
				[-11.573994981222995, 87.12872100098394],
				[-9.239921051884494, 87.12872100098394],
				[-6.93897591380113, 87.52325478774952],
				[-4.635019067421865, 87.89369490814778],
				[-3.090012711614577, 88.28521698661746],
				[-2.300945138083364, 88.28521698661746],
				[-1.5450063558072884, 88.28521698661746],
				[-0.7559387822760755, 88.28521698661746],
				[-0.3915220784696771, 88.28521698661746],
				[0, 88.28521698661746],
				[0.3945337867656349, 88.28521698661746],
				[0.7890675735312129, 87.89369490814778],
				[0.7890675735312129, 87.89369490814778],
			],
			pressures: [
				0.0784313753247261, 0.11764705926179886, 0.1568627506494522, 0.19607843458652496,
				0.2235294133424759, 0.250980406999588, 0.25882354378700256, 0.26274511218070984,
				0.24705882370471954, 0.24313725531101227, 0.24313725531101227,
				0.23529411852359772, 0.2235294133424759, 0.2078431397676468, 0.20392157137393951,
				0.20392157137393951, 0.20392157137393951, 0.21568627655506134, 0.2235294133424759,
				0.23529411852359772, 0.2549019753932953, 0.2862745225429535, 0.30588236451148987,
				0.3137255012989044, 0.3294117748737335, 0.33725491166114807, 0.34117648005485535,
				0.3333333432674408, 0.32549020648002625, 0.3176470696926117, 0.3019607961177826,
				0.2823529541492462, 0.27843138575553894, 0.2705882489681244, 0.2705882489681244,
				0.2705882489681244, 0.27450981736183167, 0.2705882489681244, 0.26274511218070984,
				0.25882354378700256, 0.2549019753932953, 0.24313725531101227, 0.24705882370471954,
				0.24705882370471954, 0.24705882370471954, 0.24313725531101227,
				0.23529411852359772, 0.23137255012989044, 0.23137255012989044,
				0.23137255012989044, 0.22745098173618317, 0.25882354378700256,
				0.30588236451148987, 0.38823530077934265, 0.43921568989753723, 0.47843137383461,
				0.5137255191802979, 0.545098066329956, 0.5686274766921997, 0.6196078658103943,
				0.6509804129600525, 0.658823549747467, 0.6509804129600525, 0.6352941393852234,
				0.6039215922355652, 0.4941176474094391, 0.4274509847164154, 0.3960784375667572, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [0.7890675735312129, 87.89369490814778],
		},
	],
	"]": [
		{
			id: "fL665njQ50iCheDD7DSpo",
			type: "freedraw",
			x: 243.9170019507912,
			y: 210.71543242537706,
			width: 24.3014742397836,
			height: 90.18861662963934,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 3511731,
			version: 70,
			versionNonce: 1953271251,
			isDeleted: false,
			boundElements: null,
			updated: 1751812117486,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, -1.15950769392947],
				[0.39453378676557804, -1.15950769392947],
				[0.39453378676557804, -1.529947814327727],
				[0.7860558652352552, -1.529947814327727],
				[1.5450063558072884, -1.529947814327727],
				[3.090012711614577, -1.529947814327727],
				[5.393969557993842, -1.15950769392947],
				[8.483982269608418, -0.7649739071638919],
				[12.332945471794972, -0.370440120398257],
				[14.664007692837572, -0.370440120398257],
				[17.36249832598247, -0.370440120398257],
				[19.663443464065836, -0.370440120398257],
				[20.816927741403447, -0.7649739071638919],
				[21.602983606638702, -0.7649739071638919],
				[20.816927741403447, -0.370440120398257],
				[20.422393954637812, 0.39453378676557804],
				[20.057977250831414, 1.5510297723990902],
				[19.663443464065836, 3.0809775867267604],
				[19.27192138559616, 4.632007359125907],
				[18.90750468178976, 7.712984945852725],
				[18.512970895024125, 9.634454838650072],
				[18.512970895024125, 13.106954503846566],
				[18.118437108258547, 16.58246587733896],
				[18.118437108258547, 20.054965542535456],
				[17.72691502978887, 23.900917036426108],
				[17.72691502978887, 28.532924395552072],
				[17.36249832598247, 31.61390198227889],
				[16.967964539216837, 35.85137555463922],
				[16.57343075245126, 40.09186083529545],
				[16.57343075245126, 44.32933440765578],
				[16.20901404864486, 47.03686016568844],
				[15.817491970175183, 51.27734544634467],
				[15.817491970175183, 54.355311324775585],
				[15.422958183409548, 57.83082269826798],
				[15.422958183409548, 60.9118002849948],
				[15.422958183409548, 63.992777871721614],
				[15.422958183409548, 67.46828924521401],
				[15.422958183409548, 70.15473304517525],
				[15.817491970175183, 72.47073672473817],
				[15.817491970175183, 75.55171431146499],
				[16.20901404864486, 77.10274408386414],
				[16.20901404864486, 78.65076214796733],
				[16.20901404864486, 80.18372167059096],
				[16.20901404864486, 81.33720594792857],
				[16.20901404864486, 82.1051915633883],
				[16.20901404864486, 82.89124742862361],
				[16.20901404864486, 83.65320962749149],
				[16.20901404864486, 84.41818353465538],
				[16.57343075245126, 84.81271732142096],
				[16.57343075245126, 85.5776912285848],
				[16.967964539216837, 85.97222501535043],
				[16.967964539216837, 86.73418721421831],
				[17.36249832598247, 87.12872100098394],
				[17.36249832598247, 87.49916112138214],
				[16.57343075245126, 87.12872100098394],
				[15.02842439664397, 87.12872100098394],
				[13.87795182760226, 87.12872100098394],
				[11.573994981222995, 87.12872100098394],
				[9.27003813484373, 87.12872100098394],
				[6.93897591380113, 87.12872100098394],
				[5.029552854187443, 87.12872100098394],
				[2.695478924848942, 87.12872100098394],
				[0.7860558652352552, 87.12872100098394],
				[-0.7589504905719764, 87.49916112138214],
				[-2.303956846379265, 87.49916112138214],
				[-2.6984906331448997, 87.89369490814778],
				[-2.303956846379265, 88.28822869491336],
				[-2.303956846379265, 88.65866881531161],
			],
			pressures: [
				0.0784313753247261, 0.10588235408067703, 0.1411764770746231, 0.1764705926179886,
				0.20000000298023224, 0.22745098173618317, 0.239215686917305, 0.24705882370471954,
				0.2549019753932953, 0.239215686917305, 0.24313725531101227, 0.24313725531101227,
				0.24313725531101227, 0.239215686917305, 0.2235294133424759, 0.20392157137393951,
				0.21568627655506134, 0.22745098173618317, 0.23529411852359772,
				0.24313725531101227, 0.250980406999588, 0.2549019753932953, 0.25882354378700256,
				0.26274511218070984, 0.2666666805744171, 0.2705882489681244, 0.2666666805744171,
				0.2549019753932953, 0.25882354378700256, 0.25882354378700256, 0.25882354378700256,
				0.25882354378700256, 0.24705882370471954, 0.23529411852359772, 0.239215686917305,
				0.239215686917305, 0.239215686917305, 0.23529411852359772, 0.22745098173618317,
				0.21960784494876862, 0.21568627655506134, 0.21568627655506134,
				0.21960784494876862, 0.21568627655506134, 0.21568627655506134,
				0.21176470816135406, 0.21176470816135406, 0.2078431397676468, 0.21176470816135406,
				0.21176470816135406, 0.21176470816135406, 0.21176470816135406,
				0.21176470816135406, 0.21176470816135406, 0.2078431397676468, 0.21176470816135406,
				0.21960784494876862, 0.22745098173618317, 0.24705882370471954, 0.2666666805744171,
				0.27450981736183167, 0.2862745225429535, 0.2980392277240753, 0.3137255012989044,
				0.33725491166114807, 0.3490196168422699, 0.32156863808631897, 0.05882352963089943,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-2.303956846379265, 88.65866881531161],
		},
	],
	"<": [
		{
			id: "U8u6ujRSvRsZpTLij5rIL",
			type: "freedraw",
			x: 247.00701466240577,
			y: 236.53781935460057,
			width: 21.9674003104451,
			height: 33.92990566184187,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1380014771,
			version: 32,
			versionNonce: 1422742845,
			isDeleted: false,
			boundElements: null,
			updated: 1751812121694,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, 0.7890675735312129],
				[-0.3945337867656349, 1.554041480695048],
				[-1.1504725690417104, 3.1050712530941382],
				[-2.3039568463793216, 5.791515053055377],
				[-4.635019067421865, 8.872492639782195],
				[-7.333509700566765, 12.736514383448366],
				[-9.242932760180452, 15.42596989170545],
				[-11.182472902753318, 16.976999664104596],
				[-12.727479258560606, 18.506947478432267],
				[-13.877951827602317, 19.666455172361736],
				[-15.02842439664397, 20.057977250831414],
				[-15.820503678471084, 20.819939449699348],
				[-16.57343075245126, 21.214473236464926],
				[-16.18190867398158, 20.819939449699348],
				[-15.422958183409605, 20.819939449699348],
				[-14.636902318174293, 20.819939449699348],
				[-13.483418040836682, 20.819939449699348],
				[-11.573994981222995, 21.587925065159084],
				[-9.634454838650129, 22.373980930394396],
				[-6.93897591380113, 24.295450823191743],
				[-4.243496988952188, 26.611454502754725],
				[-1.5450063558072884, 28.532924395552072],
				[0.39453378676557804, 30.851939783410955],
				[1.9395401425728664, 32.378875889442725],
				[3.090012711614577, 33.16794346297394],
				[4.243496988952188, 33.53838358337214],
				[4.9994357712282635, 33.92990566184187],
				[5.393969557993842, 33.92990566184187],
				[5.393969557993842, 33.53838358337214],
				[5.393969557993842, 33.53838358337214],
			],
			pressures: [
				0.0784313753247261, 0.15294118225574493, 0.1882352977991104, 0.2235294133424759,
				0.24705882370471954, 0.26274511218070984, 0.25882354378700256,
				0.24705882370471954, 0.23529411852359772, 0.21568627655506134, 0.2078431397676468,
				0.1882352977991104, 0.1725490242242813, 0.16078431904315948, 0.1411764770746231,
				0.1764705926179886, 0.22745098173618317, 0.2705882489681244, 0.3019607961177826,
				0.3333333432674408, 0.3686274588108063, 0.40392157435417175, 0.43921568989753723,
				0.47058823704719543, 0.49803921580314636, 0.5176470875740051, 0.4941176474094391,
				0.48235294222831726, 0.34117648005485535, 0.20000000298023224, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [5.393969557993842, 33.53838358337214],
		},
	],
	">": [
		{
			id: "yuRzq7Bi29d7dRRyROlWt",
			type: "freedraw",
			x: 243.1580514602192,
			y: 238.4833829137653,
			width: 16.20901404864486,
			height: 25.430864850753835,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1132232787,
			version: 32,
			versionNonce: 1151529373,
			isDeleted: false,
			boundElements: null,
			updated: 1751812125003,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.786055865235312, 0],
				[-0.786055865235312, 0.3704401203982002],
				[0, 1.159507693929413],
				[1.5450063558072316, 3.080977586726817],
				[3.4544294154209183, 5.005459187820065],
				[4.999435771228207, 6.9269290806174695],
				[6.93897591380113, 8.47795885301656],
				[8.848398973414817, 10.00790666734423],
				[10.028988625415707, 10.790950824283641],
				[11.54688960655966, 11.950458518213054],
				[13.091895962366948, 12.323910346907212],
				[13.87795182760226, 12.718444133672847],
				[14.636902318174236, 12.718444133672847],
				[15.031436104939871, 12.718444133672847],
				[15.422958183409548, 12.718444133672847],
				[15.031436104939871, 12.718444133672847],
				[14.242368531408658, 13.088884254071047],
				[13.091895962366948, 13.871928411010401],
				[11.54688960655966, 14.639914026470194],
				[9.63746654694603, 15.793398303807805],
				[7.697926404373106, 17.347439784502853],
				[5.78850334475942, 19.2689096773002],
				[4.243496988952131, 21.190379570097548],
				[3.09001271161452, 22.744421050792596],
				[2.698490633144843, 23.50939495795643],
				[1.90942305961363, 24.271357156824365],
				[1.5450063558072316, 24.66589094359],
				[1.5450063558072316, 25.0363310639882],
				[1.1534842773375544, 25.430864850753835],
				[1.1534842773375544, 25.430864850753835],
			],
			pressures: [
				0.0784313753247261, 0.0784313753247261, 0.21960784494876862, 0.24705882370471954,
				0.2823529541492462, 0.2980392277240753, 0.29019609093666077, 0.27843138575553894,
				0.27843138575553894, 0.27843138575553894, 0.27450981736183167, 0.2549019753932953,
				0.24313725531101227, 0.23529411852359772, 0.23137255012989044, 0.239215686917305,
				0.250980406999588, 0.25882354378700256, 0.2666666805744171, 0.2705882489681244,
				0.2823529541492462, 0.30588236451148987, 0.3137255012989044, 0.3294117748737335,
				0.33725491166114807, 0.34117648005485535, 0.3333333432674408, 0.3333333432674408,
				0.3176470696926117, 0.2862745225429535, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [1.1534842773375544, 25.430864850753835],
		},
	],
	"+": [
		{
			id: "6BO9bA5pPBesOm_cnDsYG",
			type: "freedraw",
			x: 248.15748723144742,
			y: 239.24835682092913,
			width: 1.5450063558072884,
			height: 27.746868530316817,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 946543293,
			version: 17,
			versionNonce: 1536666611,
			isDeleted: false,
			boundElements: null,
			updated: 1751812128332,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.3915220784696771, 0.7649739071638351],
				[-0.3915220784696771, 1.159507693929413],
				[-0.3915220784696771, 3.4755113734923953],
				[-0.3915220784696771, 6.161955173453634],
				[-0.3915220784696771, 11.185484611049219],
				[-0.3915220784696771, 14.639914026470194],
				[0, 19.2689096773002],
				[0, 22.744421050792596],
				[0.3945337867656349, 25.430864850753835],
				[0.7890675735312129, 27.37642840991856],
				[1.1534842773376113, 27.746868530316817],
				[1.1534842773376113, 27.37642840991856],
				[0.7890675735312129, 26.981894623152982],
				[0.3945337867656349, 26.981894623152982],
				[0, 26.587360836387347],
			],
			pressures: [
				0.0784313753247261, 0.2078431397676468, 0.23137255012989044, 0.27843138575553894,
				0.3137255012989044, 0.364705890417099, 0.3960784375667572, 0.4274509847164154,
				0.45490196347236633, 0.46666666865348816, 0.45490196347236633, 0.4274509847164154,
				0.30588236451148987, 0.20000000298023224, 0.09803921729326248, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [0, 26.587360836387347],
		},
		{
			id: "N_w3cDydFjxCxm1tDbkLF",
			type: "freedraw",
			x: 233.88500161707958,
			y: 253.88827084739933,
			width: 29.695443797777443,
			height: 2.6864437999611823,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1576897331,
			version: 18,
			versionNonce: 394337149,
			isDeleted: false,
			boundElements: null,
			updated: 1751812128971,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.39453378676557804, -0.7649739071638351],
				[1.183601360296791, -1.15950769392947],
				[2.7286077161040794, -1.532959522623628],
				[5.032564562483344, -1.532959522623628],
				[8.48699397790432, -1.924481601093305],
				[15.817491970175126, -1.924481601093305],
				[16.60655954370634, -1.924481601093305],
				[19.666455172361736, -1.924481601093305],
				[21.605995314934603, -1.924481601093305],
				[24.304485948079503, -1.924481601093305],
				[26.241014382356468, -1.924481601093305],
				[28.544971228735733, -2.316003679562982],
				[29.303921719307766, -2.6864437999611823],
				[29.695443797777443, -2.6864437999611823],
				[28.939505015501368, -2.6864437999611823],
				[27.39449865969408, -1.924481601093305],
			],
			pressures: [
				0.0784313753247261, 0.1882352977991104, 0.24705882370471954, 0.3019607961177826,
				0.3450980484485626, 0.3843137323856354, 0.45098039507865906, 0.45490196347236633,
				0.46666666865348816, 0.4745098054409027, 0.4745098054409027, 0.4901960790157318,
				0.501960813999176, 0.4941176474094391, 0.45098039507865906, 0.21176470816135406,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [27.39449865969408, -1.924481601093305],
		},
	],
	"-": [
		{
			id: "ifP5uPH-mlIHhCYd7Zcto",
			type: "freedraw",
			x: 241.2185113176463,
			y: 251.57226716783634,
			width: 18.877387598830524,
			height: 1.1564959856335122,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1085984275,
			version: 17,
			versionNonce: 2069726781,
			isDeleted: false,
			boundElements: null,
			updated: 1751812131992,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7559387822760755, 0.3915220784696771],
				[-0.3915220784696771, 0.3915220784696771],
				[0.7890675735312129, 0.3915220784696771],
				[2.3340739293385013, 0],
				[4.243496988952188, 0],
				[6.1830371315250545, -0.3704401203982002],
				[8.092460191138741, -0.3704401203982002],
				[10.032000333711665, -0.3704401203982002],
				[11.96852876798863, -0.3704401203982002],
				[14.272485614367895, -0.3704401203982002],
				[16.18190867398158, -0.7649739071638351],
				[17.36249832598247, -0.7649739071638351],
				[18.121448816554448, -0.7649739071638351],
				[17.72691502978887, -0.3704401203982002],
				[16.970976247512795, 0.3915220784696771],
			],
			pressures: [
				0.0784313753247261, 0.1568627506494522, 0.250980406999588, 0.2980392277240753,
				0.33725491166114807, 0.3686274588108063, 0.3960784375667572, 0.4274509847164154,
				0.4274509847164154, 0.4313725531101227, 0.4313725531101227, 0.4274509847164154,
				0.40784314274787903, 0.35686275362968445, 0.11764705926179886, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [16.970976247512795, 0.3915220784696771],
		},
	],
	"*": [
		{
			id: "W8a-C9e8wlrqZz-hnh0OY",
			type: "freedraw",
			x: 246.24806417183373,
			y: 240.40786451485855,
			width: 1.9094230596136867,
			height: 20.425405662933713,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 570342643,
			version: 11,
			versionNonce: 1328108317,
			isDeleted: false,
			boundElements: null,
			updated: 1751812138050,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, -0.39453378676557804],
				[0, 1.921469892797404],
				[0.36441670380639835, 5.767421386688056],
				[0.36441670380639835, 9.23992105188455],
				[1.1534842773376113, 13.480406332540781],
				[1.1534842773376113, 16.949894289441374],
				[1.5179009811440096, 19.2658979690043],
				[1.9094230596136867, 20.030871876168135],
				[1.9094230596136867, 18.109401983370788],
			],
			pressures: [
				0.0784313753247261, 0.30588236451148987, 0.3137255012989044, 0.3686274588108063,
				0.3803921639919281, 0.3843137323856354, 0.3803921639919281, 0.364705890417099,
				0.2862745225429535, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [1.9094230596136867, 18.109401983370788],
		},
		{
			id: "Nvod9uyFGGFP3123fr7mx",
			type: "freedraw",
			x: 233.88500161707958,
			y: 251.96378924630602,
			width: 27.39449865969408,
			height: 1.9214698927973473,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 2046237395,
			version: 13,
			versionNonce: 723661821,
			isDeleted: false,
			boundElements: null,
			updated: 1751812138487,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, 0.3915220784696771],
				[1.9395401425728664, 0],
				[5.78850334475942, -0.7619621988678773],
				[11.182472902753261, -1.1564959856335122],
				[15.817491970175126, -1.5299478143276701],
				[19.302038468555338, -1.5299478143276701],
				[22.36494580550658, -1.1564959856335122],
				[25.060424730355578, -1.1564959856335122],
				[26.999964872928444, -1.1564959856335122],
				[27.39449865969408, -1.1564959856335122],
				[26.999964872928444, -1.5299478143276701],
			],
			pressures: [
				0.0784313753247261, 0.21960784494876862, 0.25882354378700256, 0.3176470696926117,
				0.3803921639919281, 0.4156862795352936, 0.4470588266849518, 0.4588235318660736,
				0.4470588266849518, 0.3921568691730499, 0.250980406999588, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [26.999964872928444, -1.5299478143276701],
		},
		{
			id: "tKqMpnzLGe1m57JMqIFyi",
			type: "freedraw",
			x: 253.55145678944132,
			y: 243.48884210158536,
			width: 15.422958183409605,
			height: 14.263450489480135,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1780519923,
			version: 12,
			versionNonce: 1150992509,
			isDeleted: false,
			boundElements: null,
			updated: 1751812138876,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7559387822760755, 0],
				[-1.5450063558072884, 1.1564959856335122],
				[-3.454429415420975, 3.4724996651964943],
				[-6.149908340269974, 6.5534772519233115],
				[-9.634454838650129, 9.634454838650129],
				[-12.332945471795028, 11.947446809917153],
				[-14.242368531408715, 13.106954503846623],
				[-15.422958183409605, 13.868916702714557],
				[-15.02842439664397, 14.263450489480135],
				[-14.242368531408715, 14.263450489480135],
			],
			pressures: [
				0.0784313753247261, 0.19607843458652496, 0.21960784494876862, 0.24313725531101227,
				0.25882354378700256, 0.2823529541492462, 0.29019609093666077, 0.30980393290519714,
				0.29019609093666077, 0.03529411926865578, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-14.242368531408715, 14.263450489480135],
		},
		{
			id: "1ec8sf2nGjohKoBLJni-t",
			type: "freedraw",
			x: 236.61360933318366,
			y: 246.1752859015466,
			width: 23.51240666625239,
			height: 13.893010369081878,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 210345843,
			version: 13,
			versionNonce: 1878254941,
			isDeleted: false,
			boundElements: null,
			updated: 1751812139279,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[1.1504725690416535, 0],
				[3.454429415420975, 0.7860558652352552],
				[7.697926404373106, 2.3160036795629253],
				[12.332945471794972, 4.632007359125907],
				[16.57343075245126, 7.339533117158567],
				[19.6363380894025, 9.655536796721549],
				[21.575878231975423, 11.577006689518896],
				[22.726350801017077, 13.109966212142524],
				[23.12088458778271, 13.893010369081878],
				[23.51240666625239, 13.893010369081878],
				[23.12088458778271, 13.498476582316243],
			],
			pressures: [
				0.0784313753247261, 0.24705882370471954, 0.2862745225429535, 0.32549020648002625,
				0.364705890417099, 0.3843137323856354, 0.3803921639919281, 0.3803921639919281,
				0.3686274588108063, 0.32549020648002625, 0.10588235408067703, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [23.12088458778271, 13.498476582316243],
		},
	],
	"/": [
		{
			id: "Xdjp5Lzj1f_X_qkp25EBC",
			type: "freedraw",
			x: 259.7344939209664,
			y: 232.30034578224024,
			width: 28.15043744197021,
			height: 40.09186083529545,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1363912317,
			version: 18,
			versionNonce: 973751763,
			isDeleted: false,
			boundElements: null,
			updated: 1751812143419,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7890675735312129, 0.7860558652352552],
				[-3.84896320218661, 5.026541145891542],
				[-4.638030775717766, 5.791515053055377],
				[-6.1830371315250545, 7.712984945852725],
				[-8.092460191138741, 10.793962532579542],
				[-11.96852876798863, 16.190943798869284],
				[-14.272485614367895, 20.054965542535456],
				[-16.57644246074716, 23.530476916027908],
				[-21.60599531493466, 29.692432089481485],
				[-24.3014742397836, 33.53537187507624],
				[-26.21089729939729, 36.2459093414048],
				[-27.3643815767349, 38.1673792342022],
				[-28.15043744197021, 39.72142071489725],
				[-28.15043744197021, 40.09186083529545],
				[-27.755903655204577, 39.326886928131614],
				[-26.9999648729285, 37.77585715573247],
			],
			pressures: [
				0.0784313753247261, 0.21568627655506134, 0.23137255012989044, 0.3137255012989044,
				0.33725491166114807, 0.3764705955982208, 0.40392157435417175, 0.41960784792900085,
				0.43529412150382996, 0.4431372582912445, 0.43921568989753723, 0.4313725531101227,
				0.42352941632270813, 0.3960784375667572, 0.32156863808631897, 0.125490203499794,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-26.9999648729285, 37.77585715573247],
		},
	],
	"=": [
		{
			id: "_DdiOtetN3ClCOjsHmmln",
			type: "freedraw",
			x: 234.67406919061074,
			y: 244.64533808721887,
			width: 20.030871876168135,
			height: 0.7649739071638351,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1143480733,
			version: 13,
			versionNonce: 504072339,
			isDeleted: false,
			boundElements: null,
			updated: 1751812146532,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.7589504905720332, -0.39453378676557804],
				[1.1504725690417104, -0.39453378676557804],
				[3.454429415420975, -0.39453378676557804],
				[5.7885033447594765, -0.7649739071638351],
				[10.028988625415707, -0.7649739071638351],
				[13.483418040836682, -0.7649739071638351],
				[16.576442460747217, -0.7649739071638351],
				[18.512970895024182, -0.39453378676557804],
				[19.666455172361736, 0],
				[20.030871876168135, 0],
				[19.666455172361736, 0],
			],
			pressures: [
				0.0784313753247261, 0.23529411852359772, 0.2705882489681244, 0.32549020648002625,
				0.35686275362968445, 0.3960784375667572, 0.42352941632270813, 0.41960784792900085,
				0.4000000059604645, 0.3803921639919281, 0.2980392277240753, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [19.666455172361736, 0],
		},
		{
			id: "DoNI-YR7p4eeB56w2oZU3",
			type: "freedraw",
			x: 233.88500161707958,
			y: 257.7522925910655,
			width: 20.81692774140339,
			height: 1.5480180641031893,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 772371069,
			version: 15,
			versionNonce: 1943561149,
			isDeleted: false,
			boundElements: null,
			updated: 1751812147095,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.36140499551049743, -0.7649739071638351],
				[0, -0.7649739071638351],
				[1.183601360296791, -1.1564959856335122],
				[3.4875582066760558, -1.1564959856335122],
				[5.78850334475942, -1.1564959856335122],
				[10.818056198946863, -1.5480180641031893],
				[14.272485614367838, -1.5480180641031893],
				[15.42596989170545, -1.5480180641031893],
				[18.515982603320026, -1.5480180641031893],
				[19.666455172361736, -1.1564959856335122],
				[20.060988959127315, -1.1564959856335122],
				[20.455522745892893, -1.1564959856335122],
				[20.455522745892893, -1.1564959856335122],
			],
			pressures: [
				0.0784313753247261, 0.18431372940540314, 0.2549019753932953, 0.3176470696926117,
				0.3764705955982208, 0.41960784792900085, 0.4588235318660736, 0.47843137383461,
				0.48235294222831726, 0.47058823704719543, 0.4431372582912445, 0.3960784375667572,
				0.3294117748737335, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [20.455522745892893, -1.1564959856335122],
		},
	],
	_: [
		{
			id: "iQ5nuN2H4F-Z-ywGdmm2e",
			type: "freedraw",
			x: 233.12906283480345,
			y: 282.0266614561858,
			width: 33.93592907843373,
			height: 1.5299478143276701,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 437272797,
			version: 29,
			versionNonce: 1421078355,
			isDeleted: false,
			boundElements: null,
			updated: 1751812153597,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[1.1504725690417104, 0],
				[2.6954789248489988, 0],
				[4.243496988952188, 0],
				[5.7885033447594765, 0],
				[8.08944848284284, -0.370440120398257],
				[11.182472902753318, -0.370440120398257],
				[12.332945471795028, -0.370440120398257],
				[14.636902318174293, -0.370440120398257],
				[16.18190867398158, -0.370440120398257],
				[18.121448816554505, -0.370440120398257],
				[19.666455172361793, -0.370440120398257],
				[20.816927741403447, -0.370440120398257],
				[22.361934097210735, -0.370440120398257],
				[23.906940453018024, 0],
				[25.451946808825312, 0.39453378676557804],
				[26.605431086162923, 0.39453378676557804],
				[27.755903655204577, 0.7860558652352552],
				[29.300910011011865, 0.7860558652352552],
				[30.0598605015839, 1.159507693929413],
				[31.210333070625552, 1.159507693929413],
				[31.999400644156765, 1.159507693929413],
				[32.75533942643284, 1.159507693929413],
				[33.149873213198475, 1.159507693929413],
				[33.54440699996405, 1.159507693929413],
				[33.93592907843373, 1.159507693929413],
				[33.149873213198475, 1.159507693929413],
				[32.75533942643284, 1.159507693929413],
			],
			pressures: [
				0.0784313753247261, 0.22745098173618317, 0.2705882489681244, 0.29019609093666077,
				0.3137255012989044, 0.3333333432674408, 0.32549020648002625, 0.3333333432674408,
				0.3294117748737335, 0.3333333432674408, 0.3490196168422699, 0.364705890417099,
				0.3803921639919281, 0.38823530077934265, 0.3921568691730499, 0.3921568691730499,
				0.38823530077934265, 0.3843137323856354, 0.3960784375667572, 0.3960784375667572,
				0.3960784375667572, 0.3921568691730499, 0.3764705955982208, 0.3607843220233917,
				0.34117648005485535, 0.30980393290519714, 0.11764705926179886, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [32.75533942643284, 1.159507693929413],
		},
	],
	"%": [
		{
			id: "TB6ki-voAHCx41ln6gijN",
			type: "freedraw",
			x: 255.0964631452486,
			y: 229.98434210267726,
			width: 25.421829725866075,
			height: 46.64533808721876,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 858664989,
			version: 17,
			versionNonce: 891252883,
			isDeleted: false,
			boundElements: null,
			updated: 1751812156695,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7559387822761323, 0.3915220784696771],
				[-1.5450063558072884, 1.1564959856335122],
				[-3.090012711614577, 4.237473572360329],
				[-4.9994357712282635, 8.10751873261836],
				[-7.694914696077262, 13.89602207737778],
				[-10.393405329222162, 20.057977250831414],
				[-12.724467550264706, 25.060424730355578],
				[-17.332381243023292, 33.16493175467804],
				[-20.816927741403447, 37.796939113803944],
				[-23.512406666252446, 42.03742439446023],
				[-24.6628792352941, 44.723868194421414],
				[-25.421829725866075, 46.27489796682056],
				[-25.421829725866075, 46.64533808721876],
				[-24.271357156824422, 45.48884210158525],
				[-23.909952161313925, 45.11840198118699],
			],
			pressures: [
				0.0784313753247261, 0.11764705926179886, 0.14901961386203766, 0.18039216101169586,
				0.19607843458652496, 0.21176470816135406, 0.21960784494876862, 0.2235294133424759,
				0.239215686917305, 0.24313725531101227, 0.24705882370471954, 0.250980406999588,
				0.23529411852359772, 0.1882352977991104, 0.07058823853731155, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-23.909952161313925, 45.11840198118699],
		},
		{
			id: "iQkRC5mgmGFYYdqOPRBi5",
			type: "freedraw",
			x: 252.4009842203996,
			y: 250.43384143197835,
			width: 11.179461194457417,
			height: 13.477394624244823,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 351603325,
			version: 21,
			versionNonce: 1306216957,
			isDeleted: false,
			boundElements: null,
			updated: 1751812157308,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7589504905719764, 0.37345182869415794],
				[-1.1504725690416535, 1.5299478143276701],
				[-1.1504725690416535, 3.454429415420975],
				[-1.1504725690416535, 5.396981266289799],
				[0, 7.318451159087147],
				[1.9395401425728664, 8.083425066250982],
				[3.484546498380155, 7.6919029877813045],
				[6.544442127035552, 5.0024474795241645],
				[7.333509700566765, 3.8429397855947514],
				[8.08944848284284, 0.7679856154597928],
				[8.08944848284284, -1.159507693929413],
				[6.93897591380113, -3.1020595447982373],
				[5.7885033447594765, -4.6289956508300065],
				[3.848963202186553, -5.393969557993842],
				[1.1504725690417104, -5.023529437595585],
				[-1.5450063558072884, -2.7075257580326593],
				[-3.090012711614577, 0],
				[0, 0],
			],
			pressures: [
				0.0784313753247261, 0.1764705926179886, 0.20392157137393951, 0.23137255012989044,
				0.239215686917305, 0.23529411852359772, 0.2235294133424759, 0.20000000298023224,
				0.1764705926179886, 0.1568627506494522, 0.1568627506494522, 0.18039216101169586,
				0.2078431397676468, 0.22745098173618317, 0.250980406999588, 0.25882354378700256,
				0.23137255012989044, 0.14509804546833038, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-3.454429415420975, 1.138425735857993],
		},
		{
			id: "AJeQ-LVh5awhXW3xcurOL",
			type: "freedraw",
			x: 229.2800996326169,
			y: 252.3553113247757,
			width: 10.787939115987683,
			height: 11.164402652977742,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1068670451,
			version: 25,
			versionNonce: 74988381,
			isDeleted: false,
			boundElements: null,
			updated: 1751812158052,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0, -0.7830441569393543],
				[0, -1.1534842773375544],
				[0, -1.5480180641031893],
				[0.3945337867656349, -1.5480180641031893],
				[0.3945337867656349, -1.9214698927973473],
				[0, -1.5480180641031893],
				[-0.7890675735312129, -0.3915220784696771],
				[-1.5450063558072884, 1.15950769392947],
				[-2.3340739293385013, 3.080977586726817],
				[-2.695478924848942, 5.770433094983957],
				[-2.695478924848942, 6.929940788913427],
				[-0.39453378676557804, 8.083425066250982],
				[1.9064113513177858, 7.7129849458527815],
				[3.848963202186553, 6.556488960219269],
				[6.544442127035552, 3.475511373492452],
				[7.697926404373163, 0.7679856154597928],
				[8.092460191138741, -0.7830441569393543],
				[6.544442127035552, -2.3129919712670244],
				[4.243496988952188, -2.7075257580326024],
				[1.9064113513177858, -3.0809775867267604],
				[0, -3.0809775867267604],
				[0, 0],
			],
			pressures: [
				0.0784313753247261, 0.0784313753247261, 0.0784313753247261, 0.07058823853731155,
				0.12156862765550613, 0.16078431904315948, 0.1882352977991104, 0.20000000298023224,
				0.2078431397676468, 0.20392157137393951, 0.19607843458652496, 0.1882352977991104,
				0.1921568661928177, 0.1921568661928177, 0.18039216101169586, 0.15294118225574493,
				0.1411764770746231, 0.1411764770746231, 0.1568627506494522, 0.18431372940540314,
				0.1921568661928177, 0.1921568661928177, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-1.5450063558072884, -0.7830441569393543],
		},
	],
	"&": [
		{
			id: "TgbAg0KQdNrCdtbIMm2T2",
			type: "freedraw",
			x: 262.03543905904974,
			y: 276.629680189896,
			width: 33.90882370377045,
			height: 54.337241075000065,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 29940691,
			version: 80,
			versionNonce: 384252979,
			isDeleted: false,
			boundElements: null,
			updated: 1751812206467,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7559387822760755, -0.7649739071638351],
				[-1.5450063558072884, -1.5269361060317692],
				[-2.6954789248489988, -2.2919100131956043],
				[-3.8459514938906523, -4.237473572360329],
				[-5.785491636463576, -6.5534772519233115],
				[-8.08944848284284, -8.848398973414817],
				[-10.028988625415707, -11.164402652977799],
				[-11.938411685029394, -13.480406332540724],
				[-13.483418040836682, -15.401876225338128],
				[-14.633890609878392, -17.717879904901054],
				[-15.787374887216004, -20.425405662933713],
				[-16.57343075245126, -22.35289897232292],
				[-17.72390332149297, -25.057413022059677],
				[-18.877387598830524, -26.981894623152925],
				[-19.663443464065836, -28.138390608786494],
				[-20.816927741403447, -30.062872209879743],
				[-21.572866523679522, -31.984342102677147],
				[-22.361934097210735, -33.53537187507624],
				[-23.11787287948681, -35.45985347616954],
				[-23.906940453018024, -37.38132336896689],
				[-24.6628792352941, -38.932353141366036],
				[-25.057413022059677, -40.856834742459284],
				[-25.421829725866075, -42.40786451485843],
				[-25.81636351263171, -44.32933440765578],
				[-25.81636351263171, -45.48884210158525],
				[-25.81636351263171, -47.01577820761702],
				[-25.057413022059677, -48.569819688312066],
				[-24.271357156824422, -49.72631567394558],
				[-22.726350801017134, -50.88582336787505],
				[-20.027860167872234, -52.41275947390676],
				[-18.482853812064945, -53.19881533914207],
				[-16.17889696568568, -53.96378924630591],
				[-14.633890609878392, -54.337241075000065],
				[-10.784927407691782, -40.09186083529545],
				[-11.543877898263815, -38.5378193546004],
				[-12.332945471795028, -37.38132336896689],
				[-13.088884254071104, -36.221815675037476],
				[-13.877951827602317, -34.69487956900571],
				[-14.633890609878392, -33.14083808831066],
				[-15.787374887216004, -31.219368195513255],
				[-16.57343075245126, -29.668338423114164],
				[-17.72390332149297, -28.138390608786494],
				[-18.877387598830524, -26.587360836387347],
				[-20.027860167872234, -25.057413022059677],
				[-21.572866523679522, -23.50638324966053],
				[-23.11787287948681, -21.95836518555734],
				[-24.271357156824422, -21.193391278393506],
				[-25.421829725866075, -20.425405662933713],
				[-26.602419377866966, -19.64236150599436],
				[-27.361369868439, -18.877387598830524],
				[-28.150437441970155, -18.11241369166669],
				[-28.906376224246287, -16.955917706033176],
				[-29.300910011011865, -15.796410012103706],
				[-30.05684879328794, -14.24538023970456],
				[-30.451382580053576, -12.71543242537689],
				[-30.848928075115055, -11.164402652977799],
				[-31.210333070625552, -9.239921051884494],
				[-31.210333070625552, -8.083425066250982],
				[-31.210333070625552, -6.161955173453578],
				[-30.848928075115055, -5.3969812662897425],
				[-29.665326714818264, -4.60791369275853],
				[-28.150437441970155, -4.237473572360329],
				[-26.21089729939729, -4.237473572360329],
				[-23.906940453018024, -5.0024474795241645],
				[-21.208449819873124, -6.5534772519233115],
				[-17.72390332149297, -8.848398973414817],
				[-15.422958183409605, -11.164402652977799],
				[-13.483418040836682, -13.480406332540724],
				[-11.543877898263815, -15.031436104939871],
				[-10.028988625415707, -16.56138391926754],
				[-7.694914696077262, -18.11241369166669],
				[-4.9994357712282635, -19.64236150599436],
				[-3.454429415420975, -20.79885749162787],
				[-1.5450063558072884, -21.95836518555734],
				[0.39453378676557804, -23.50638324966053],
				[2.303956846379265, -25.057413022059677],
				[2.6984906331448997, -25.822386929223512],
				[2.303956846379265, -25.822386929223512],
			],
			pressures: [
				0.0784313753247261, 0.18431372940540314, 0.22745098173618317, 0.25882354378700256,
				0.27450981736183167, 0.2980392277240753, 0.3019607961177826, 0.30980393290519714,
				0.3176470696926117, 0.30980393290519714, 0.30588236451148987, 0.3019607961177826,
				0.3019607961177826, 0.30588236451148987, 0.30588236451148987, 0.30588236451148987,
				0.30588236451148987, 0.30588236451148987, 0.30588236451148987, 0.3019607961177826,
				0.29019609093666077, 0.2823529541492462, 0.27843138575553894, 0.27450981736183167,
				0.27450981736183167, 0.27450981736183167, 0.2666666805744171, 0.26274511218070984,
				0.25882354378700256, 0.25882354378700256, 0.26274511218070984,
				0.26274511218070984, 0.26274511218070984, 0.26274511218070984,
				0.30980393290519714, 0.3137255012989044, 0.32156863808631897, 0.32156863808631897,
				0.32156863808631897, 0.3176470696926117, 0.3176470696926117, 0.32156863808631897,
				0.32549020648002625, 0.3294117748737335, 0.3333333432674408, 0.3333333432674408,
				0.32156863808631897, 0.3176470696926117, 0.3137255012989044, 0.30588236451148987,
				0.2980392277240753, 0.29019609093666077, 0.2862745225429535, 0.2862745225429535,
				0.2862745225429535, 0.2823529541492462, 0.2862745225429535, 0.2823529541492462,
				0.2823529541492462, 0.2862745225429535, 0.29019609093666077, 0.29411765933036804,
				0.2980392277240753, 0.3137255012989044, 0.32549020648002625, 0.3294117748737335,
				0.33725491166114807, 0.3450980484485626, 0.35686275362968445, 0.364705890417099,
				0.38823530077934265, 0.40392157435417175, 0.40392157435417175, 0.3921568691730499,
				0.3764705955982208, 0.3607843220233917, 0.3176470696926117, 0.27450981736183167,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [2.303956846379265, -25.822386929223512],
		},
	],
	"|": [
		{
			id: "IgMJJYubUX3tP54KpcK31",
			type: "freedraw",
			x: 219.64263308567087,
			y: 233.85137555463933,
			width: 0.7890675735312129,
			height: 44.33234611595174,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1426728211,
			version: 22,
			versionNonce: 257956125,
			isDeleted: false,
			boundElements: null,
			updated: 1751812213940,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.39453378676557804, 0.7649739071638351],
				[-0.39453378676557804, 1.5299478143276701],
				[-0.39453378676557804, 2.686443799961239],
				[-0.39453378676557804, 5.791515053055377],
				[-0.39453378676557804, 8.477958853016617],
				[-0.39453378676557804, 12.323910346907269],
				[-0.39453378676557804, 16.19094379886934],
				[-0.39453378676557804, 20.036895292759993],
				[-0.39453378676557804, 23.900917036426165],
				[-0.39453378676557804, 28.141402317082395],
				[0, 30.827846117043634],
				[0.3945337867656349, 33.538383583372195],
				[0.3945337867656349, 35.85438726293518],
				[0.3945337867656349, 38.17039094249816],
				[0, 40.486394622061084],
				[0, 42.40786451485849],
				[0, 43.5673722087879],
				[0, 44.33234611595174],
				[0, 43.17283842202232],
				[-0.39453378676557804, 42.40786451485849],
			],
			pressures: [
				0.0784313753247261, 0.13333334028720856, 0.1568627506494522, 0.1725490242242813,
				0.1921568661928177, 0.19607843458652496, 0.2078431397676468, 0.23137255012989044,
				0.25882354378700256, 0.27843138575553894, 0.2980392277240753, 0.29411765933036804,
				0.27843138575553894, 0.2705882489681244, 0.2666666805744171, 0.2705882489681244,
				0.2705882489681244, 0.2705882489681244, 0.2666666805744171, 0.03529411926865578,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-0.39453378676557804, 42.40786451485849],
		},
	],
	"^": [
		{
			id: "prARNw8N2xP5p-8tOXa2W",
			type: "freedraw",
			x: 238.52303239279735,
			y: 238.09186083529562,
			width: 19.663443464065836,
			height: 16.187932090573383,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1219781235,
			version: 26,
			versionNonce: 848040723,
			isDeleted: false,
			boundElements: null,
			updated: 1751812217959,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7589504905720332, 0.3915220784696771],
				[-1.1504725690417104, 0.3915220784696771],
				[-0.3945337867656349, 0],
				[0.39453378676557804, -0.7649739071638351],
				[1.5450063558072884, -1.554041480695048],
				[3.090012711614577, -3.475511373492452],
				[5.393969557993842, -6.161955173453634],
				[6.544442127035495, -8.477958853016617],
				[7.333509700566708, -10.032000333711665],
				[8.089448482842784, -12.348004013274647],
				[8.483982269608418, -13.112977920438482],
				[8.483982269608418, -13.501488290612201],
				[8.483982269608418, -13.112977920438482],
				[8.878516056373996, -12.348004013274647],
				[9.242932760180395, -10.793962532579599],
				[10.423522412181285, -8.477958853016617],
				[11.17946119445736, -6.5564889602192125],
				[13.483418040836682, -2.319015387858883],
				[15.817491970175126, 0.3915220784696771],
				[17.362498325982415, 1.9214698927973473],
				[18.118437108258547, 2.3160036795629253],
				[18.512970895024125, 2.6864437999611823],
				[18.512970895024125, 2.3160036795629253],
				[18.512970895024125, 2.3160036795629253],
			],
			pressures: [
				0.0784313753247261, 0.0941176488995552, 0.15294118225574493, 0.25882354378700256,
				0.2862745225429535, 0.29411765933036804, 0.30588236451148987, 0.2980392277240753,
				0.27843138575553894, 0.2549019753932953, 0.24313725531101227, 0.239215686917305,
				0.250980406999588, 0.2666666805744171, 0.2980392277240753, 0.3333333432674408,
				0.3764705955982208, 0.38823530077934265, 0.4156862795352936, 0.40392157435417175,
				0.4156862795352936, 0.4000000059604645, 0.34117648005485535, 0.16078431904315948,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [18.512970895024125, 2.3160036795629253],
		},
	],
	"~": [
		{
			id: "zXT81tqTfO7WrC52FN_-9",
			type: "freedraw",
			x: 231.9785902657618,
			y: 254.2767812175731,
			width: 26.9969531646326,
			height: 10.025976917119806,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 603592797,
			version: 29,
			versionNonce: 1941387997,
			isDeleted: false,
			boundElements: null,
			updated: 1751812221566,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.3945337867656349, -0.7619621988679341],
				[0, -1.1534842773376113],
				[0.7559387822760755, -2.3129919712670812],
				[2.300945138083364, -3.8429397855947514],
				[3.8459514938906523, -5.0024474795241645],
				[6.149908340269917, -5.785491636463576],
				[7.6949146960772055, -5.785491636463576],
				[9.239921051884494, -5.390957849697941],
				[10.393405329222105, -5.0024474795241645],
				[11.179461194457417, -4.2344618640644285],
				[11.938411685029394, -3.0749541701349585],
				[12.332945471794972, -2.3129919712670812],
				[12.724467550264649, -0.7619621988679341],
				[12.724467550264649, 0.39453378676557804],
				[13.088884254071047, 1.159507693929413],
				[13.483418040836682, 2.319015387858883],
				[13.87795182760226, 3.080977586726817],
				[15.02842439664397, 3.848963202186553],
				[16.178896965685624, 4.24048528065623],
				[17.723903321492912, 4.24048528065623],
				[19.27192138559616, 4.24048528065623],
				[21.208449819873124, 3.848963202186553],
				[22.726350801017077, 2.71053746632856],
				[24.271357156824365, 1.554041480695048],
				[25.421829725866075, 0],
				[26.21089729939729, -1.1534842773376113],
				[26.602419377866966, -2.3129919712670812],
			],
			pressures: [
				0.0784313753247261, 0.2235294133424759, 0.22745098173618317, 0.21960784494876862,
				0.21960784494876862, 0.23137255012989044, 0.23137255012989044,
				0.23529411852359772, 0.24705882370471954, 0.250980406999588, 0.2549019753932953,
				0.29019609093666077, 0.2980392277240753, 0.3176470696926117, 0.32549020648002625,
				0.32549020648002625, 0.32549020648002625, 0.32549020648002625, 0.3176470696926117,
				0.3176470696926117, 0.3176470696926117, 0.32156863808631897, 0.32156863808631897,
				0.32156863808631897, 0.29019609093666077, 0.24313725531101227,
				0.16862745583057404, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [26.602419377866966, -2.3129919712670812],
		},
	],
	"#": [
		{
			id: "KtiuI5RQ98crra4K9Ut0e",
			type: "freedraw",
			x: 245.85654209336406,
			y: 234.61634946180317,
			width: 14.670031109429374,
			height: 37.775857155732524,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 635940019,
			version: 16,
			versionNonce: 2054241597,
			isDeleted: false,
			boundElements: null,
			updated: 1751812224486,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.39453378676557804, 0.7649739071638351],
				[-1.5450063558072884, 3.475511373492452],
				[-3.484546498380155, 8.10751873261836],
				[-5.78850334475942, 14.269473906071994],
				[-8.483982269608418, 20.054965542535513],
				[-10.423522412181285, 25.451946808825312],
				[-12.332945471794972, 30.0628722098798],
				[-13.486429749132583, 33.92990566184187],
				[-14.272485614367895, 36.61634946180311],
				[-14.670031109429374, 37.775857155732524],
				[-14.670031109429374, 37.405417035334324],
				[-13.122013045326185, 34.69487956900571],
				[-11.971540476284474, 32.37887588944278],
				[-11.182472902753318, 31.613901982278946],
			],
			pressures: [
				0.0784313753247261, 0.21568627655506134, 0.2666666805744171, 0.30588236451148987,
				0.3294117748737335, 0.33725491166114807, 0.3450980484485626, 0.33725491166114807,
				0.33725491166114807, 0.3529411852359772, 0.3450980484485626, 0.24705882370471954,
				0.14509804546833038, 0.0313725508749485, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-11.182472902753318, 31.613901982278946],
		},
		{
			id: "34ehNrmQHH5x2_gBBislP",
			type: "freedraw",
			x: 259.7344939209664,
			y: 234.2218156750376,
			width: 15.422958183409605,
			height: 39.326886928131614,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1746822835,
			version: 17,
			versionNonce: 1544762269,
			isDeleted: false,
			boundElements: null,
			updated: 1751812224995,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7890675735312129, 0],
				[-1.1534842773376113, 0.7890675735312129],
				[-1.9395401425729233, 3.105071253094195],
				[-2.6984906331448997, 5.42107493265712],
				[-4.638030775717766, 9.65854850501745],
				[-6.93897591380113, 14.664007692837572],
				[-9.242932760180452, 19.666455172361736],
				[-11.182472902753318, 24.689984609957378],
				[-12.332945471795028, 29.297898302715907],
				[-13.48642974913264, 33.16794346297394],
				[-14.66701940113353, 36.245909341404854],
				[-15.031436104939928, 38.1703909424981],
				[-15.422958183409605, 39.326886928131614],
				[-15.031436104939928, 36.245909341404854],
				[-15.031436104939928, 35.48394714253692],
			],
			pressures: [
				0.0784313753247261, 0.12156862765550613, 0.1568627506494522, 0.2078431397676468,
				0.239215686917305, 0.27450981736183167, 0.30980393290519714, 0.3333333432674408,
				0.3529411852359772, 0.3529411852359772, 0.32549020648002625, 0.2980392277240753,
				0.2705882489681244, 0.2078431397676468, 0.003921568859368563, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [-15.031436104939928, 35.48394714253692],
		},
		{
			id: "BSqGAOCxoSD0XqaIAkGS0",
			type: "freedraw",
			x: 227.7350932768096,
			y: 245.0398718739845,
			width: 39.72744413148911,
			height: 3.080977586726817,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1409724509,
			version: 18,
			versionNonce: 1395198451,
			isDeleted: false,
			boundElements: null,
			updated: 1751812225508,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.3975454950615358, -0.7890675735312129],
				[0, -0.7890675735312129],
				[2.300945138083364, -0.7890675735312129],
				[6.149908340269974, -0.3945337867656349],
				[11.938411685029394, -0.3945337867656349],
				[18.121448816554448, 0],
				[23.12088458778271, 0.370440120398257],
				[27.755903655204577, 0.370440120398257],
				[33.14987321319842, 1.135414027562092],
				[35.84535213804742, 1.9214698927973473],
				[37.784892280620284, 2.2919100131956043],
				[38.938376557957895, 2.2919100131956043],
				[39.32989863642757, 2.2919100131956043],
				[39.32989863642757, 1.9214698927973473],
				[38.14930898442668, 1.5269361060317692],
				[37.39337020215061, 1.5269361060317692],
			],
			pressures: [
				0.0784313753247261, 0.1411764770746231, 0.1921568661928177, 0.27450981736183167,
				0.32549020648002625, 0.3529411852359772, 0.3686274588108063, 0.3960784375667572,
				0.3960784375667572, 0.4156862795352936, 0.4117647111415863, 0.3843137323856354,
				0.3529411852359772, 0.2862745225429535, 0.2078431397676468, 0.07058823853731155,
				0,
			],
			simulatePressure: false,
			lastCommittedPoint: [37.39337020215061, 1.5269361060317692],
		},
		{
			id: "VAIs0rcdOqcNi5yPWyD1L",
			type: "freedraw",
			x: 223.48858457956152,
			y: 258.51726649822933,
			width: 37.00184812368093,
			height: 3.080977586726817,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1168483101,
			version: 15,
			versionNonce: 1515947603,
			isDeleted: false,
			boundElements: null,
			updated: 1751812226000,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.7589504905720332, -0.3915220784696771],
				[1.9425518508688242, -0.7649739071638351],
				[5.0024474795241645, -1.159507693929413],
				[8.881527764669954, -1.5299478143276701],
				[14.275497322663796, -1.5299478143276701],
				[20.064000667423272, -1.159507693929413],
				[24.6689026518859, -0.3915220784696771],
				[28.91239964083809, 0],
				[33.152884921494376, 0.3945337867656349],
				[35.45684176787364, 0.7679856154597928],
				[36.63743141987453, 1.1564959856335122],
				[37.00184812368093, 1.551029772399147],
				[37.00184812368093, 0.7679856154597928],
			],
			pressures: [
				0.0784313753247261, 0.10588235408067703, 0.1725490242242813, 0.250980406999588,
				0.2980392277240753, 0.3529411852359772, 0.38823530077934265, 0.4156862795352936,
				0.45490196347236633, 0.4588235318660736, 0.43529412150382996, 0.3960784375667572,
				0.34117648005485535, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [37.00184812368093, 0.7679856154597928],
		},
	],
	"@": [
		{
			id: "1vQ75z80-jpWwEf6Pqty6",
			type: "freedraw",
			x: 238.52303239279735,
			y: 249.6477855667431,
			width: 42.38979426508291,
			height: 41.642890607694596,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 1855337651,
			version: 138,
			versionNonce: 955593555,
			isDeleted: false,
			boundElements: null,
			updated: 1751812253243,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[-0.7589504905720332, 0.39453378676557804],
				[-1.1504725690417104, 1.159507693929413],
				[-1.5450063558072884, 1.9244816010932482],
				[-1.9094230596136867, 3.0809775867267604],
				[-1.9094230596136867, 5.023529437595585],
				[-1.9094230596136867, 7.339533117158567],
				[-1.1504725690417104, 9.264014718251872],
				[0.39453378676557804, 11.185484611049219],
				[2.303956846379265, 12.344992304978632],
				[4.635019067421865, 12.736514383448366],
				[6.180025423229097, 12.736514383448366],
				[8.878516056373996, 12.736514383448366],
				[10.423522412181285, 11.580018397814797],
				[12.332945471794972, 9.63746654694603],
				[13.87795182760226, 7.709973237556824],
				[14.664007692837572, 5.78850334475942],
				[15.422958183409548, 3.8670334519620724],
				[15.422958183409548, 1.554041480695048],
				[14.664007692837572, -0.37345182869415794],
				[13.483418040836682, -2.316003679562982],
				[12.332945471794972, -3.8429397855947514],
				[11.573994981222995, -4.607913692758586],
				[10.028988625415707, -5.396981266289799],
				[8.483982269608418, -5.396981266289799],
				[6.93897591380113, -5.002447479524221],
				[5.78850334475942, -4.607913692758586],
				[3.848963202186553, -3.4724996651964943],
				[1.1504725690416535, -1.5269361060317692],
				[0, -0.37345182869415794],
				[-0.7589504905720332, 0.7860558652352552],
				[-1.1504725690417104, 1.554041480695048],
				[-1.5450063558072884, 2.7075257580326024],
				[-1.5450063558072884, 3.4755113734923953],
				[-1.5450063558072884, 5.023529437595585],
				[-1.5450063558072884, 6.1830371315250545],
				[-1.5450063558072884, 7.709973237556824],
				[-0.7589504905720332, 8.869480931486237],
				[0.7860558652352552, 10.420510703885384],
				[2.303956846379265, 11.185484611049219],
				[5.029552854187443, 11.950458518213054],
				[5.393969557993842, 11.950458518213054],
				[7.725031779036385, 11.950458518213054],
				[9.242932760180395, 11.950458518213054],
				[10.787939115987683, 11.580018397814797],
				[11.968528767988573, 10.790950824283584],
				[13.119001337030284, 9.264014718251872],
				[13.87795182760226, 7.709973237556824],
				[14.664007692837572, 5.78850334475942],
				[14.664007692837572, 4.24048528065623],
				[15.02842439664397, 1.9244816010932482],
				[14.664007692837572, 0.7860558652352552],
				[14.664007692837572, -0.37345182869415794],
				[14.664007692837572, -1.156495985633569],
				[14.664007692837572, -1.5269361060317692],
				[14.664007692837572, -1.921469892797404],
				[14.664007692837572, -1.156495985633569],
				[14.664007692837572, -0.7619621988679341],
				[14.664007692837572, 0],
				[14.664007692837572, 0.7860558652352552],
				[14.272485614367895, 1.554041480695048],
				[14.272485614367895, 2.7075257580326024],
				[14.272485614367895, 3.8670334519620724],
				[14.272485614367895, 5.023529437595585],
				[14.272485614367895, 6.1830371315250545],
				[14.664007692837572, 7.709973237556824],
				[14.664007692837572, 8.47795885301656],
				[15.02842439664397, 9.63746654694603],
				[15.02842439664397, 10.420510703885384],
				[15.422958183409548, 11.185484611049219],
				[16.181908673981525, 11.580018397814797],
				[16.967964539216837, 11.580018397814797],
				[18.118437108258547, 11.950458518213054],
				[19.2719213855961, 11.950458518213054],
				[20.422393954637812, 11.580018397814797],
				[22.36193409721068, 10.790950824283584],
				[23.51240666625239, 10.025976917119749],
				[24.3014742397836, 9.63746654694603],
				[25.057413022059677, 8.47795885301656],
				[26.21089729939729, 6.94801103868889],
				[26.996953164632544, 5.023529437595585],
				[27.755903655204577, 2.7075257580326024],
				[28.541959520439832, 0.7860558652352552],
				[28.541959520439832, -1.156495985633569],
				[28.90637622424623, -3.080977586726817],
				[28.90637622424623, -5.396981266289799],
				[28.90637622424623, -7.318451159087147],
				[28.541959520439832, -8.869480931486294],
				[27.755903655204577, -10.793962532579599],
				[26.996953164632544, -11.950458518213111],
				[25.057413022059677, -13.109966212142524],
				[23.12088458778271, -14.636902318174293],
				[20.422393954637812, -15.425969891705506],
				[15.817491970175126, -16.5613839192676],
				[14.272485614367895, -16.952905997737275],
				[11.17946119445736, -16.952905997737275],
				[8.878516056373996, -16.952905997737275],
				[6.93897591380113, -16.5613839192676],
				[6.180025423229097, -16.5613839192676],
				[3.484546498380155, -15.425969891705506],
				[1.5450063558072884, -14.636902318174293],
				[-0.3945337867656349, -13.874940119306359],
				[-1.5450063558072884, -13.480406332540781],
				[-3.454429415420975, -12.715432425376946],
				[-4.9994357712282635, -11.555924731447476],
				[-6.938975913801187, -10.004894959048386],
				[-8.08944848284284, -7.7129849458527815],
				[-9.242932760180452, -5.396981266289799],
				[-10.393405329222105, -3.080977586726817],
				[-11.185484611049276, -0.7619621988679341],
				[-11.577006689518953, 1.554041480695048],
				[-11.938411685029394, 4.24048528065623],
				[-11.938411685029394, 6.94801103868889],
				[-11.185484611049276, 9.63746654694603],
				[-10.393405329222105, 11.580018397814797],
				[-8.848398973414817, 14.660995984541614],
				[-7.336521408862666, 16.58246587733902],
				[-5.7885033447594765, 18.503935770136366],
				[-4.638030775717766, 19.2689096773002],
				[-2.3039568463793216, 20.428417371229614],
				[-0.3945337867656349, 21.584913356863183],
				[1.9395401425728664, 22.744421050792596],
				[6.544442127035495, 23.900917036426108],
				[8.089448482842784, 24.295450823191743],
				[8.878516056373996, 24.295450823191743],
				[10.787939115987683, 24.68998460995732],
				[15.817491970175126, 24.295450823191743],
				[17.726915029788813, 23.530476916027908],
				[19.2719213855961, 22.373980930394396],
				[23.12088458778271, 20.057977250831414],
				[25.451946808825255, 17.74197357126843],
				[26.996953164632544, 15.422958183409548],
				[28.541959520439832, 13.501488290612201],
				[29.30091001101181, 11.950458518213054],
				[30.45138258005352, 10.025976917119749],
				[30.45138258005352, 9.63746654694603],
				[30.05986050158384, 10.025976917119749],
			],
			pressures: [
				0.0784313753247261, 0.10980392247438431, 0.16470588743686676, 0.18431372940540314,
				0.2078431397676468, 0.21960784494876862, 0.22745098173618317, 0.239215686917305,
				0.239215686917305, 0.24313725531101227, 0.24705882370471954, 0.250980406999588,
				0.2666666805744171, 0.27450981736183167, 0.27843138575553894, 0.26274511218070984,
				0.26274511218070984, 0.2549019753932953, 0.24705882370471954, 0.24705882370471954,
				0.239215686917305, 0.239215686917305, 0.239215686917305, 0.239215686917305,
				0.23529411852359772, 0.23137255012989044, 0.23137255012989044,
				0.23137255012989044, 0.23529411852359772, 0.239215686917305, 0.239215686917305,
				0.239215686917305, 0.239215686917305, 0.239215686917305, 0.239215686917305,
				0.239215686917305, 0.239215686917305, 0.239215686917305, 0.239215686917305,
				0.23137255012989044, 0.2235294133424759, 0.21568627655506134, 0.21960784494876862,
				0.21568627655506134, 0.21568627655506134, 0.21176470816135406,
				0.20392157137393951, 0.1882352977991104, 0.1725490242242813, 0.16078431904315948,
				0.15294118225574493, 0.14509804546833038, 0.15294118225574493,
				0.14901961386203766, 0.14901961386203766, 0.1568627506494522, 0.2705882489681244,
				0.2823529541492462, 0.29411765933036804, 0.29411765933036804, 0.30588236451148987,
				0.30588236451148987, 0.30980393290519714, 0.3176470696926117, 0.32549020648002625,
				0.3294117748737335, 0.3333333432674408, 0.3294117748737335, 0.3294117748737335,
				0.3333333432674408, 0.3333333432674408, 0.33725491166114807, 0.3333333432674408,
				0.33725491166114807, 0.32156863808631897, 0.3176470696926117, 0.30980393290519714,
				0.30980393290519714, 0.30980393290519714, 0.2980392277240753, 0.2705882489681244,
				0.2666666805744171, 0.25882354378700256, 0.25882354378700256, 0.26274511218070984,
				0.26274511218070984, 0.26274511218070984, 0.2705882489681244, 0.27843138575553894,
				0.2862745225429535, 0.30588236451148987, 0.32156863808631897, 0.3450980484485626,
				0.35686275362968445, 0.3607843220233917, 0.35686275362968445, 0.3529411852359772,
				0.3450980484485626, 0.34117648005485535, 0.3490196168422699, 0.3529411852359772,
				0.3607843220233917, 0.35686275362968445, 0.35686275362968445, 0.3529411852359772,
				0.3450980484485626, 0.34117648005485535, 0.32549020648002625, 0.32156863808631897,
				0.3176470696926117, 0.3137255012989044, 0.3176470696926117, 0.3294117748737335,
				0.34117648005485535, 0.3450980484485626, 0.3490196168422699, 0.3607843220233917,
				0.3764705955982208, 0.3803921639919281, 0.4156862795352936, 0.4313725531101227,
				0.4470588266849518, 0.45098039507865906, 0.45098039507865906, 0.45098039507865906,
				0.4627451002597809, 0.4745098054409027, 0.4745098054409027, 0.4745098054409027,
				0.45490196347236633, 0.43921568989753723, 0.42352941632270813, 0.4156862795352936,
				0.4117647111415863, 0.3607843220233917, 0.3019607961177826, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [30.05986050158384, 10.025976917119749],
		},
	],
	"\\": [
		{
			id: "IE1JaUAZQ0SaL9GGQROzc",
			type: "freedraw",
			x: 232.73452904803787,
			y: 233.85137555463933,
			width: 26.21089729939729,
			height: 37.775857155732524,
			angle: 0,
			strokeColor: "#1e1e1e",
			backgroundColor: "transparent",
			fillStyle: "solid",
			strokeWidth: 1,
			strokeStyle: "solid",
			roughness: 1,
			opacity: 100,
			groupIds: [],
			frameId: null,
			roundness: null,
			seed: 423227443,
			version: 24,
			versionNonce: 1644020925,
			isDeleted: false,
			boundElements: null,
			updated: 1751812257307,
			link: null,
			locked: false,
			points: [
				[0, 0],
				[0.7890675735312129, 0.7649739071638351],
				[1.5450063558072884, 2.316003679562982],
				[3.090012711614577, 4.632007359125964],
				[5.029552854187443, 7.7129849458527815],
				[6.93897591380113, 10.793962532579542],
				[8.878516056374053, 13.874940119306359],
				[10.423522412181342, 16.19094379886934],
				[12.332945471794972, 18.877387598830524],
				[14.272485614367895, 21.584913356863183],
				[15.817491970175183, 23.900917036426165],
				[17.36249832598247, 26.587360836387347],
				[19.27192138559616, 28.90336451595033],
				[20.816927741403447, 30.827846117043634],
				[21.970412018741, 31.984342102677147],
				[23.906940453018024, 33.92990566184187],
				[25.060424730355578, 35.065319689403964],
				[25.84648059559089, 36.22482738333338],
				[25.84648059559089, 37.01088324856869],
				[26.21089729939729, 37.381323368966946],
				[26.21089729939729, 37.775857155732524],
				[25.454958517121213, 37.775857155732524],
				[25.060424730355578, 37.775857155732524],
			],
			pressures: [
				0.0784313753247261, 0.33725491166114807, 0.364705890417099, 0.3960784375667572,
				0.42352941632270813, 0.43529412150382996, 0.4313725531101227, 0.4470588266849518,
				0.45098039507865906, 0.4627451002597809, 0.4588235318660736, 0.4431372582912445,
				0.4470588266849518, 0.4470588266849518, 0.4470588266849518, 0.46666666865348816,
				0.47058823704719543, 0.4627451002597809, 0.43529412150382996, 0.35686275362968445,
				0.2549019753932953, 0.1725490242242813, 0,
			],
			simulatePressure: false,
			lastCommittedPoint: [25.060424730355578, 37.775857155732524],
		},
	],
};
